/* tslint:disable */
/* eslint-disable */
//  This file was automatically generated and should not be edited.

export type Post = {
  __typename: "Post",
  id: string,
  ownerSub: string,
  author: User,
  createdAt: string,
  text: string,
  footnote?: string | null,
  replyingToPost?: Post | null,
  replyingToPost_id?: string | null,
  threadRootPost?: Post | null,
  threadRootPost_id?: string | null,
  repostedPost?: Post | null,
  repostedPost_id?: string | null,
  repostedTimeRange?: ClipTimeRange | null,
  associatedTawk_localId?: string | null,
  associatedTawk_tawkVersion?: string | null,
  associatedTawk?: TawkCandidate | null,
  associatedExternalTawk_id?: string | null,
  associatedExternalTawk?: ExternalTawk | null,
  replies?: ModelPostConnection | null,
  repliesCount: number,
  reposts?: ModelPostConnection | null,
  likes?: ModelPostLikeConnection | null,
  likesCount: number,
  claps?: ModelPostClapConnection | null,
  associatedColorHue?: number | null,
  updatedAt: string,
};

export type User = {
  __typename: "User",
  sub: string,
  phoneNumber?: string | null,
  identityId?: string | null,
  lastMigrationNumber?: number | null,
  name?: string | null,
  bio?: string | null,
  profilePhoto: CloudinaryResource,
  userHandle?: UserHandle | null,
  userHandle_standardForm?: string | null,
  posts?: ModelPostConnection | null,
  following?: ModelUserFollowConnection | null,
  followers?: ModelUserFollowConnection | null,
  postCollections?: ModelPostCollectionConnection | null,
  followedPostCollections?: ModelPostCollectionFollowRelationConnection | null,
  signupCodes?: ModelSignupCodeUserAssociationConnection | null,
  playEvents?: ModelPlayEventConnection | null,
  blocked?: ModelUserBlockingRelationshipConnection | null,
  blockers?: ModelUserBlockingRelationshipConnection | null,
  automaticallyFollowedByNewMembersIn?: ModelSignupCodeUsersWhichNewMembersAutomaticallyFollowAssociationConnection | null,
  automaticallyFollowsNewMembersIn?: ModelSignupCodeUsersWhichAutomaticallyFollowNewMembersAssociationConnection | null,
  createdAt: string,
  updatedAt: string,
};

export type CloudinaryResource = {
  __typename: "CloudinaryResource",
  publicId: string,
};

export type UserHandle = {
  __typename: "UserHandle",
  ownerSub: string,
  owner: User,
  standardForm: string,
  renderedForm: string,
  createdAt: string,
  updatedAt: string,
};

export type ModelPostConnection = {
  __typename: "ModelPostConnection",
  items:  Array<Post | null >,
  nextToken?: string | null,
};

export type ModelUserFollowConnection = {
  __typename: "ModelUserFollowConnection",
  items:  Array<UserFollow | null >,
  nextToken?: string | null,
};

export type UserFollow = {
  __typename: "UserFollow",
  ownerSub: string,
  following: User,
  followed_sub: string,
  followed: User,
  createdAt: string,
  updatedAt: string,
};

export type ModelPostCollectionConnection = {
  __typename: "ModelPostCollectionConnection",
  items:  Array<PostCollection | null >,
  nextToken?: string | null,
};

export type PostCollection = {
  __typename: "PostCollection",
  id: string,
  ownerSub: string,
  author: User,
  name: string,
  description: string,
  emoji?: string | null,
  color?: Color | null,
  createdAt: string,
  updatedAt: string,
  memberships?: ModelPostCollectionMembershipConnection | null,
  followers?: ModelPostCollectionFollowRelationConnection | null,
  defaultSortOrder?: Playlist_SortOrder | null,
};

export type Color = {
  __typename: "Color",
  red: number,
  green: number,
  blue: number,
};

export type ModelPostCollectionMembershipConnection = {
  __typename: "ModelPostCollectionMembershipConnection",
  items:  Array<PostCollectionMembership | null >,
  nextToken?: string | null,
};

export type PostCollectionMembership = {
  __typename: "PostCollectionMembership",
  ownerSub: string,
  author: User,
  postCollection_id: string,
  postCollection: PostCollection,
  post_id: string,
  post?: Post | null,
  createdAt: string,
  rank: number,
  updatedAt: string,
};

export type ModelPostCollectionFollowRelationConnection = {
  __typename: "ModelPostCollectionFollowRelationConnection",
  items:  Array<PostCollectionFollowRelation | null >,
  nextToken?: string | null,
};

export type PostCollectionFollowRelation = {
  __typename: "PostCollectionFollowRelation",
  ownerSub: string,
  follower: User,
  postCollection_id: string,
  postCollection: PostCollection,
  createdAt: string,
  updatedAt: string,
};

export enum Playlist_SortOrder {
  LATEST = "LATEST",
  CUSTOM = "CUSTOM",
}


export type ModelSignupCodeUserAssociationConnection = {
  __typename: "ModelSignupCodeUserAssociationConnection",
  items:  Array<SignupCodeUserAssociation | null >,
  nextToken?: string | null,
};

export type SignupCodeUserAssociation = {
  __typename: "SignupCodeUserAssociation",
  ownerSub: string,
  user: User,
  code_codeName: string,
  code?: SignupCode | null,
  createdAt: string,
  updatedAt: string,
};

export type SignupCode = {
  __typename: "SignupCode",
  codeName: string,
  createdAt: string,
  users?: ModelSignupCodeUserAssociationConnection | null,
  stations?:  Array<SerializableRadioStation_Workaround | null > | null,
  usersToAutomaticallyFollow?: ModelSignupCodeUsersWhichNewMembersAutomaticallyFollowAssociationConnection | null,
  usersWhoAutomaticallyFollowNewMembers?: ModelSignupCodeUsersWhichAutomaticallyFollowNewMembersAssociationConnection | null,
  updatedAt: string,
};

export type SerializableRadioStation_Workaround = {
  __typename: "SerializableRadioStation_Workaround",
  expandedPostStation?: SerializableRadioStation_ExpandedPost | null,
  playlistStation?: SerializableRadioStation_Playlist | null,
  profileStation?: SerializableRadioStation_Profile | null,
  refreshId: string,
};

export type SerializableRadioStation_ExpandedPost = {
  __typename: "SerializableRadioStation_ExpandedPost",
  post_id: string,
  tabKind: ExpandedPost_TabKind,
};

export enum ExpandedPost_TabKind {
  ALL = "ALL",
  TAWKBACKS = "TAWKBACKS",
  REPLIES = "REPLIES",
  LIKES = "LIKES",
  PLAYLISTS = "PLAYLISTS",
  ECHOES = "ECHOES",
}


export type SerializableRadioStation_Playlist = {
  __typename: "SerializableRadioStation_Playlist",
  postCollection_id: string,
  sortOrder: Playlist_SortOrder,
};

export type SerializableRadioStation_Profile = {
  __typename: "SerializableRadioStation_Profile",
  user_sub: string,
  tab: Profile_TabKind,
};

export enum Profile_TabKind {
  TAWKS = "TAWKS",
  REPLIES = "REPLIES",
  LIKES = "LIKES",
  PLAYLISTS = "PLAYLISTS",
}


export type ModelSignupCodeUsersWhichNewMembersAutomaticallyFollowAssociationConnection = {
  __typename: "ModelSignupCodeUsersWhichNewMembersAutomaticallyFollowAssociationConnection",
  items:  Array<SignupCodeUsersWhichNewMembersAutomaticallyFollowAssociation | null >,
  nextToken?: string | null,
};

export type SignupCodeUsersWhichNewMembersAutomaticallyFollowAssociation = {
  __typename: "SignupCodeUsersWhichNewMembersAutomaticallyFollowAssociation",
  code_codeName: string,
  code?: SignupCode | null,
  user_sub: string,
  user: User,
  createdAt: string,
  updatedAt: string,
};

export type ModelSignupCodeUsersWhichAutomaticallyFollowNewMembersAssociationConnection = {
  __typename: "ModelSignupCodeUsersWhichAutomaticallyFollowNewMembersAssociationConnection",
  items:  Array<SignupCodeUsersWhichAutomaticallyFollowNewMembersAssociation | null >,
  nextToken?: string | null,
};

export type SignupCodeUsersWhichAutomaticallyFollowNewMembersAssociation = {
  __typename: "SignupCodeUsersWhichAutomaticallyFollowNewMembersAssociation",
  code_codeName: string,
  code?: SignupCode | null,
  user_sub: string,
  user: User,
  createdAt: string,
  updatedAt: string,
};

export type ModelPlayEventConnection = {
  __typename: "ModelPlayEventConnection",
  items:  Array<PlayEvent | null >,
  nextToken?: string | null,
};

export type PlayEvent = {
  __typename: "PlayEvent",
  id: string,
  ownerSub: string,
  playedBy: User,
  startTime: number,
  endTime: number,
  duration: number,
  contextPost_id?: string | null,
  contextPost?: Post | null,
  contextRssItem?: RssItemPlayingContext | null,
  createdAt: string,
  updatedAt: string,
};

export type RssItemPlayingContext = {
  __typename: "RssItemPlayingContext",
  audioUrl: string,
  title: string,
  originName: string,
  createdAt?: string | null,
  rssPageUrl: string,
  itemDurationInSeconds?: number | null,
  originProfileLikePictureUrl?: string | null,
};

export type ModelUserBlockingRelationshipConnection = {
  __typename: "ModelUserBlockingRelationshipConnection",
  items:  Array<UserBlockingRelationship | null >,
  nextToken?: string | null,
};

export type UserBlockingRelationship = {
  __typename: "UserBlockingRelationship",
  ownerSub: string,
  blocker: User,
  blocked_sub: string,
  blocked: User,
  createdAt: string,
  updatedAt: string,
};

export type ClipTimeRange = {
  __typename: "ClipTimeRange",
  startTime: number,
  endTime: number,
};

export type TawkCandidate = {
  __typename: "TawkCandidate",
  ownerSub: string,
  author: User,
  createdAt: string,
  localId: string,
  tawkVersion: string,
  title?: string | null,
  rawAudio: CloudinaryResource,
  processedAudio?: CloudinaryResource | null,
  generatedVideo?: CloudinaryResource | null,
  duration?: number | null,
  updatedAt: string,
};

export type ExternalTawk = {
  __typename: "ExternalTawk",
  id: string,
  inserter_sub: string,
  inserter: User,
  title: string,
  audioFileUrl: string,
  duration: number,
  originUrl: string,
  originKind: ExternalTawk_OriginKind,
  originName: string,
  originCreatedAt: string,
  picture: GenericImage,
  createdAt: string,
  updatedAt: string,
};

export enum ExternalTawk_OriginKind {
  URL = "URL",
  RSS = "RSS",
}


export type GenericImage = {
  __typename: "GenericImage",
  cloudinaryImage?: CloudinaryResource | null,
  imageUrl: string,
};

export type ModelPostLikeConnection = {
  __typename: "ModelPostLikeConnection",
  items:  Array<PostLike | null >,
  nextToken?: string | null,
};

export type PostLike = {
  __typename: "PostLike",
  ownerSub: string,
  actor: User,
  createdAt: string,
  postLiked_id: string,
  postLiked?: Post | null,
  updatedAt: string,
};

export type ModelPostClapConnection = {
  __typename: "ModelPostClapConnection",
  items:  Array<PostClap | null >,
  nextToken?: string | null,
};

export type PostClap = {
  __typename: "PostClap",
  id: string,
  ownerSub: string,
  actor: User,
  createdAt: string,
  timestampRelativeToContext: number,
  contextPost_id?: string | null,
  contextPost?: Post | null,
  contextRssItem?: RssItemPlayingContext | null,
  updatedAt: string,
};

export type SearchablePostConnection = {
  __typename: "SearchablePostConnection",
  items:  Array<Post | null >,
  nextToken?: string | null,
  total?: number | null,
  aggregateItems:  Array<SearchableAggregateResult | null >,
};

export type SearchableAggregateResult = {
  __typename: "SearchableAggregateResult",
  name: string,
  result?: SearchableAggregateGenericResult | null,
};

export type SearchableAggregateGenericResult = SearchableAggregateScalarResult | SearchableAggregateBucketResult


export type SearchableAggregateScalarResult = {
  __typename: "SearchableAggregateScalarResult",
  value: number,
};

export type SearchableAggregateBucketResult = {
  __typename: "SearchableAggregateBucketResult",
  buckets?:  Array<SearchableAggregateBucketResultItem | null > | null,
};

export type SearchableAggregateBucketResultItem = {
  __typename: "SearchableAggregateBucketResultItem",
  key: string,
  doc_count: number,
};

export type SearchablePostCollectionMembershipConnection = {
  __typename: "SearchablePostCollectionMembershipConnection",
  items:  Array<PostCollectionMembership | null >,
  nextToken?: string | null,
  total?: number | null,
  aggregateItems:  Array<SearchableAggregateResult | null >,
};

export type SearchableUserFollowConnection = {
  __typename: "SearchableUserFollowConnection",
  items:  Array<UserFollow | null >,
  nextToken?: string | null,
  total?: number | null,
  aggregateItems:  Array<SearchableAggregateResult | null >,
};

export type CreatePostSafelyInput = {
  text: string,
  replyingToPost_id?: string | null,
  associatedTawkArgs?: CreatePostSafelyInput_AssociatedTawkArgs | null,
  externalTawk_id?: string | null,
  authorIsRss?: boolean | null,
  repostArgs?: CreatePostSafelyInput_RepostArgs | null,
  associatedColorHue?: number | null,
  footnote?: string | null,
};

export type CreatePostSafelyInput_AssociatedTawkArgs = {
  associatedTawk_localId: string,
  associatedTawk_tawkVersion: string,
};

export type CreatePostSafelyInput_RepostArgs = {
  repostedPost_id: string,
  timeRange: CreatePostSafelyInput_RepostArgs_TimeRange,
};

export type CreatePostSafelyInput_RepostArgs_TimeRange = {
  startTime: number,
  endTime: number,
};

export type NewsfeedItem_Post = {
  __typename: "NewsfeedItem_Post",
  keyDict: string,
  post: Post,
};

export type UpdateUserHandleSafelyInput = {
  newHandleRenderedForm: string,
};

export type CreateUserInput = {
  sub: string,
  phoneNumber?: string | null,
  identityId?: string | null,
  lastMigrationNumber?: number | null,
  name?: string | null,
  bio?: string | null,
  profilePhoto: CloudinaryResourceInput,
  userHandle_standardForm?: string | null,
};

export type CloudinaryResourceInput = {
  publicId: string,
};

export type ModelUserConditionInput = {
  phoneNumber?: ModelStringInput | null,
  identityId?: ModelStringInput | null,
  lastMigrationNumber?: ModelIntInput | null,
  name?: ModelStringInput | null,
  bio?: ModelStringInput | null,
  userHandle_standardForm?: ModelStringInput | null,
  and?: Array< ModelUserConditionInput | null > | null,
  or?: Array< ModelUserConditionInput | null > | null,
  not?: ModelUserConditionInput | null,
};

export type ModelStringInput = {
  ne?: string | null,
  eq?: string | null,
  le?: string | null,
  lt?: string | null,
  ge?: string | null,
  gt?: string | null,
  contains?: string | null,
  notContains?: string | null,
  between?: Array< string | null > | null,
  beginsWith?: string | null,
  attributeExists?: boolean | null,
  attributeType?: ModelAttributeTypes | null,
  size?: ModelSizeInput | null,
};

export enum ModelAttributeTypes {
  binary = "binary",
  binarySet = "binarySet",
  bool = "bool",
  list = "list",
  map = "map",
  number = "number",
  numberSet = "numberSet",
  string = "string",
  stringSet = "stringSet",
  _null = "_null",
}


export type ModelSizeInput = {
  ne?: number | null,
  eq?: number | null,
  le?: number | null,
  lt?: number | null,
  ge?: number | null,
  gt?: number | null,
  between?: Array< number | null > | null,
};

export type ModelIntInput = {
  ne?: number | null,
  eq?: number | null,
  le?: number | null,
  lt?: number | null,
  ge?: number | null,
  gt?: number | null,
  between?: Array< number | null > | null,
  attributeExists?: boolean | null,
  attributeType?: ModelAttributeTypes | null,
};

export type UpdateUserInput = {
  sub: string,
  phoneNumber?: string | null,
  identityId?: string | null,
  lastMigrationNumber?: number | null,
  name?: string | null,
  bio?: string | null,
  profilePhoto?: CloudinaryResourceInput | null,
  userHandle_standardForm?: string | null,
};

export type DeleteUserInput = {
  sub: string,
};

export type CreateUserDisplayNameInput = {
  displayName: string,
  ownerSub: string,
  createdAt?: string | null,
};

export type ModelUserDisplayNameConditionInput = {
  ownerSub?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  and?: Array< ModelUserDisplayNameConditionInput | null > | null,
  or?: Array< ModelUserDisplayNameConditionInput | null > | null,
  not?: ModelUserDisplayNameConditionInput | null,
};

export type UserDisplayName = {
  __typename: "UserDisplayName",
  displayName: string,
  ownerSub: string,
  createdAt: string,
  updatedAt: string,
};

export type UpdateUserDisplayNameInput = {
  displayName: string,
  ownerSub?: string | null,
  createdAt?: string | null,
};

export type DeleteUserDisplayNameInput = {
  displayName: string,
};

export type CreateUserHandleInput = {
  ownerSub: string,
  standardForm: string,
  renderedForm: string,
  createdAt?: string | null,
};

export type ModelUserHandleConditionInput = {
  ownerSub?: ModelStringInput | null,
  renderedForm?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  and?: Array< ModelUserHandleConditionInput | null > | null,
  or?: Array< ModelUserHandleConditionInput | null > | null,
  not?: ModelUserHandleConditionInput | null,
};

export type UpdateUserHandleInput = {
  ownerSub?: string | null,
  standardForm: string,
  renderedForm?: string | null,
  createdAt?: string | null,
};

export type DeleteUserHandleInput = {
  standardForm: string,
};

export type CreatePostInput = {
  id?: string | null,
  ownerSub: string,
  createdAt?: string | null,
  text: string,
  footnote?: string | null,
  replyingToPost_id?: string | null,
  threadRootPost_id?: string | null,
  repostedPost_id?: string | null,
  repostedTimeRange?: ClipTimeRangeInput | null,
  associatedTawk_localId?: string | null,
  associatedTawk_tawkVersion?: string | null,
  associatedExternalTawk_id?: string | null,
  repliesCount: number,
  likesCount: number,
  associatedColorHue?: number | null,
};

export type ClipTimeRangeInput = {
  startTime: number,
  endTime: number,
};

export type ModelPostConditionInput = {
  ownerSub?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  text?: ModelStringInput | null,
  footnote?: ModelStringInput | null,
  replyingToPost_id?: ModelIDInput | null,
  threadRootPost_id?: ModelIDInput | null,
  repostedPost_id?: ModelIDInput | null,
  associatedTawk_localId?: ModelStringInput | null,
  associatedTawk_tawkVersion?: ModelStringInput | null,
  associatedExternalTawk_id?: ModelIDInput | null,
  repliesCount?: ModelIntInput | null,
  likesCount?: ModelIntInput | null,
  associatedColorHue?: ModelFloatInput | null,
  and?: Array< ModelPostConditionInput | null > | null,
  or?: Array< ModelPostConditionInput | null > | null,
  not?: ModelPostConditionInput | null,
};

export type ModelIDInput = {
  ne?: string | null,
  eq?: string | null,
  le?: string | null,
  lt?: string | null,
  ge?: string | null,
  gt?: string | null,
  contains?: string | null,
  notContains?: string | null,
  between?: Array< string | null > | null,
  beginsWith?: string | null,
  attributeExists?: boolean | null,
  attributeType?: ModelAttributeTypes | null,
  size?: ModelSizeInput | null,
};

export type ModelFloatInput = {
  ne?: number | null,
  eq?: number | null,
  le?: number | null,
  lt?: number | null,
  ge?: number | null,
  gt?: number | null,
  between?: Array< number | null > | null,
  attributeExists?: boolean | null,
  attributeType?: ModelAttributeTypes | null,
};

export type UpdatePostInput = {
  id: string,
  ownerSub?: string | null,
  createdAt?: string | null,
  text?: string | null,
  footnote?: string | null,
  replyingToPost_id?: string | null,
  threadRootPost_id?: string | null,
  repostedPost_id?: string | null,
  repostedTimeRange?: ClipTimeRangeInput | null,
  associatedTawk_localId?: string | null,
  associatedTawk_tawkVersion?: string | null,
  associatedExternalTawk_id?: string | null,
  repliesCount?: number | null,
  likesCount?: number | null,
  associatedColorHue?: number | null,
};

export type DeletePostInput = {
  id: string,
};

export type CreateExternalTawkInput = {
  id?: string | null,
  inserter_sub: string,
  title: string,
  audioFileUrl: string,
  duration: number,
  originUrl: string,
  originKind: ExternalTawk_OriginKind,
  originName: string,
  originCreatedAt: string,
  picture: GenericImageInput,
  createdAt?: string | null,
};

export type GenericImageInput = {
  cloudinaryImage?: CloudinaryResourceInput | null,
  imageUrl: string,
};

export type ModelExternalTawkConditionInput = {
  inserter_sub?: ModelStringInput | null,
  title?: ModelStringInput | null,
  audioFileUrl?: ModelStringInput | null,
  duration?: ModelIntInput | null,
  originUrl?: ModelStringInput | null,
  originKind?: ModelExternalTawk_OriginKindInput | null,
  originName?: ModelStringInput | null,
  originCreatedAt?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  and?: Array< ModelExternalTawkConditionInput | null > | null,
  or?: Array< ModelExternalTawkConditionInput | null > | null,
  not?: ModelExternalTawkConditionInput | null,
};

export type ModelExternalTawk_OriginKindInput = {
  eq?: ExternalTawk_OriginKind | null,
  ne?: ExternalTawk_OriginKind | null,
};

export type UpdateExternalTawkInput = {
  id: string,
  inserter_sub?: string | null,
  title?: string | null,
  audioFileUrl?: string | null,
  duration?: number | null,
  originUrl?: string | null,
  originKind?: ExternalTawk_OriginKind | null,
  originName?: string | null,
  originCreatedAt?: string | null,
  picture?: GenericImageInput | null,
  createdAt?: string | null,
};

export type DeleteExternalTawkInput = {
  id: string,
};

export type CreateSignupCodeInput = {
  codeName: string,
  createdAt?: string | null,
  stations?: Array< SerializableRadioStation_WorkaroundInput | null > | null,
};

export type SerializableRadioStation_WorkaroundInput = {
  expandedPostStation?: SerializableRadioStation_ExpandedPostInput | null,
  playlistStation?: SerializableRadioStation_PlaylistInput | null,
  profileStation?: SerializableRadioStation_ProfileInput | null,
  refreshId: string,
};

export type SerializableRadioStation_ExpandedPostInput = {
  post_id: string,
  tabKind: ExpandedPost_TabKind,
};

export type SerializableRadioStation_PlaylistInput = {
  postCollection_id: string,
  sortOrder: Playlist_SortOrder,
};

export type SerializableRadioStation_ProfileInput = {
  user_sub: string,
  tab: Profile_TabKind,
};

export type ModelSignupCodeConditionInput = {
  createdAt?: ModelStringInput | null,
  and?: Array< ModelSignupCodeConditionInput | null > | null,
  or?: Array< ModelSignupCodeConditionInput | null > | null,
  not?: ModelSignupCodeConditionInput | null,
};

export type UpdateSignupCodeInput = {
  codeName: string,
  createdAt?: string | null,
  stations?: Array< SerializableRadioStation_WorkaroundInput | null > | null,
};

export type DeleteSignupCodeInput = {
  codeName: string,
};

export type CreateSignupCodeUsersWhichNewMembersAutomaticallyFollowAssociationInput = {
  code_codeName: string,
  user_sub: string,
  createdAt?: string | null,
};

export type ModelSignupCodeUsersWhichNewMembersAutomaticallyFollowAssociationConditionInput = {
  createdAt?: ModelStringInput | null,
  and?: Array< ModelSignupCodeUsersWhichNewMembersAutomaticallyFollowAssociationConditionInput | null > | null,
  or?: Array< ModelSignupCodeUsersWhichNewMembersAutomaticallyFollowAssociationConditionInput | null > | null,
  not?: ModelSignupCodeUsersWhichNewMembersAutomaticallyFollowAssociationConditionInput | null,
};

export type UpdateSignupCodeUsersWhichNewMembersAutomaticallyFollowAssociationInput = {
  code_codeName: string,
  user_sub: string,
  createdAt?: string | null,
};

export type DeleteSignupCodeUsersWhichNewMembersAutomaticallyFollowAssociationInput = {
  code_codeName: string,
  user_sub: string,
};

export type CreateSignupCodeUsersWhichAutomaticallyFollowNewMembersAssociationInput = {
  code_codeName: string,
  user_sub: string,
  createdAt?: string | null,
};

export type ModelSignupCodeUsersWhichAutomaticallyFollowNewMembersAssociationConditionInput = {
  createdAt?: ModelStringInput | null,
  and?: Array< ModelSignupCodeUsersWhichAutomaticallyFollowNewMembersAssociationConditionInput | null > | null,
  or?: Array< ModelSignupCodeUsersWhichAutomaticallyFollowNewMembersAssociationConditionInput | null > | null,
  not?: ModelSignupCodeUsersWhichAutomaticallyFollowNewMembersAssociationConditionInput | null,
};

export type UpdateSignupCodeUsersWhichAutomaticallyFollowNewMembersAssociationInput = {
  code_codeName: string,
  user_sub: string,
  createdAt?: string | null,
};

export type DeleteSignupCodeUsersWhichAutomaticallyFollowNewMembersAssociationInput = {
  code_codeName: string,
  user_sub: string,
};

export type CreateSignupCodeUserAssociationInput = {
  ownerSub: string,
  code_codeName: string,
  createdAt?: string | null,
};

export type ModelSignupCodeUserAssociationConditionInput = {
  createdAt?: ModelStringInput | null,
  and?: Array< ModelSignupCodeUserAssociationConditionInput | null > | null,
  or?: Array< ModelSignupCodeUserAssociationConditionInput | null > | null,
  not?: ModelSignupCodeUserAssociationConditionInput | null,
};

export type UpdateSignupCodeUserAssociationInput = {
  ownerSub: string,
  code_codeName: string,
  createdAt?: string | null,
};

export type DeleteSignupCodeUserAssociationInput = {
  ownerSub: string,
  code_codeName: string,
};

export type CreateTawkCandidateInput = {
  ownerSub: string,
  createdAt?: string | null,
  localId: string,
  tawkVersion: string,
  title?: string | null,
  rawAudio: CloudinaryResourceInput,
  processedAudio?: CloudinaryResourceInput | null,
  generatedVideo?: CloudinaryResourceInput | null,
  duration?: number | null,
};

export type ModelTawkCandidateConditionInput = {
  createdAt?: ModelStringInput | null,
  title?: ModelStringInput | null,
  duration?: ModelIntInput | null,
  and?: Array< ModelTawkCandidateConditionInput | null > | null,
  or?: Array< ModelTawkCandidateConditionInput | null > | null,
  not?: ModelTawkCandidateConditionInput | null,
};

export type UpdateTawkCandidateInput = {
  ownerSub: string,
  createdAt?: string | null,
  localId: string,
  tawkVersion: string,
  title?: string | null,
  rawAudio?: CloudinaryResourceInput | null,
  processedAudio?: CloudinaryResourceInput | null,
  generatedVideo?: CloudinaryResourceInput | null,
  duration?: number | null,
};

export type DeleteTawkCandidateInput = {
  ownerSub: string,
  localId: string,
  tawkVersion: string,
};

export type CreatePostLikeInput = {
  ownerSub: string,
  createdAt?: string | null,
  postLiked_id: string,
};

export type ModelPostLikeConditionInput = {
  createdAt?: ModelStringInput | null,
  and?: Array< ModelPostLikeConditionInput | null > | null,
  or?: Array< ModelPostLikeConditionInput | null > | null,
  not?: ModelPostLikeConditionInput | null,
};

export type UpdatePostLikeInput = {
  ownerSub: string,
  createdAt?: string | null,
  postLiked_id: string,
};

export type DeletePostLikeInput = {
  ownerSub: string,
  postLiked_id: string,
};

export type CreatePostClapInput = {
  id?: string | null,
  ownerSub: string,
  createdAt?: string | null,
  timestampRelativeToContext: number,
  contextPost_id?: string | null,
  contextRssItem?: RssItemPlayingContextInput | null,
};

export type RssItemPlayingContextInput = {
  audioUrl: string,
  title: string,
  originName: string,
  createdAt?: string | null,
  rssPageUrl: string,
  itemDurationInSeconds?: number | null,
  originProfileLikePictureUrl?: string | null,
};

export type ModelPostClapConditionInput = {
  ownerSub?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  timestampRelativeToContext?: ModelFloatInput | null,
  contextPost_id?: ModelIDInput | null,
  and?: Array< ModelPostClapConditionInput | null > | null,
  or?: Array< ModelPostClapConditionInput | null > | null,
  not?: ModelPostClapConditionInput | null,
};

export type UpdatePostClapInput = {
  id: string,
  ownerSub?: string | null,
  createdAt?: string | null,
  timestampRelativeToContext?: number | null,
  contextPost_id?: string | null,
  contextRssItem?: RssItemPlayingContextInput | null,
};

export type DeletePostClapInput = {
  id: string,
};

export type CreatePostReportInput = {
  id?: string | null,
  ownerSub: string,
  text: string,
  kind: PostReport_Kind,
  reportedPost_id?: string | null,
  reportedPostCollection_id?: string | null,
  createdAt?: string | null,
};

export enum PostReport_Kind {
  COPYRIGHT = "COPYRIGHT",
  HATE = "HATE",
  MISINFORMATION = "MISINFORMATION",
  OTHER = "OTHER",
}


export type ModelPostReportConditionInput = {
  ownerSub?: ModelStringInput | null,
  text?: ModelStringInput | null,
  kind?: ModelPostReport_KindInput | null,
  reportedPost_id?: ModelIDInput | null,
  reportedPostCollection_id?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  and?: Array< ModelPostReportConditionInput | null > | null,
  or?: Array< ModelPostReportConditionInput | null > | null,
  not?: ModelPostReportConditionInput | null,
};

export type ModelPostReport_KindInput = {
  eq?: PostReport_Kind | null,
  ne?: PostReport_Kind | null,
};

export type PostReport = {
  __typename: "PostReport",
  id: string,
  ownerSub: string,
  reporter: User,
  text: string,
  kind: PostReport_Kind,
  reportedPost_id?: string | null,
  reportedPost?: Post | null,
  reportedPostCollection_id?: string | null,
  reportedPostCollection?: PostCollection | null,
  createdAt: string,
  updatedAt: string,
};

export type UpdatePostReportInput = {
  id: string,
  ownerSub?: string | null,
  text?: string | null,
  kind?: PostReport_Kind | null,
  reportedPost_id?: string | null,
  reportedPostCollection_id?: string | null,
  createdAt?: string | null,
};

export type DeletePostReportInput = {
  id: string,
};

export type CreateUserFollowInput = {
  ownerSub: string,
  followed_sub: string,
  createdAt?: string | null,
};

export type ModelUserFollowConditionInput = {
  createdAt?: ModelStringInput | null,
  and?: Array< ModelUserFollowConditionInput | null > | null,
  or?: Array< ModelUserFollowConditionInput | null > | null,
  not?: ModelUserFollowConditionInput | null,
};

export type UpdateUserFollowInput = {
  ownerSub: string,
  followed_sub: string,
  createdAt?: string | null,
};

export type DeleteUserFollowInput = {
  ownerSub: string,
  followed_sub: string,
};

export type CreateUserBlockingRelationshipInput = {
  ownerSub: string,
  blocked_sub: string,
  createdAt?: string | null,
};

export type ModelUserBlockingRelationshipConditionInput = {
  createdAt?: ModelStringInput | null,
  and?: Array< ModelUserBlockingRelationshipConditionInput | null > | null,
  or?: Array< ModelUserBlockingRelationshipConditionInput | null > | null,
  not?: ModelUserBlockingRelationshipConditionInput | null,
};

export type UpdateUserBlockingRelationshipInput = {
  ownerSub: string,
  blocked_sub: string,
  createdAt?: string | null,
};

export type DeleteUserBlockingRelationshipInput = {
  ownerSub: string,
  blocked_sub: string,
};

export type CreatePlayEventInput = {
  id?: string | null,
  ownerSub: string,
  startTime: number,
  endTime: number,
  duration: number,
  contextPost_id?: string | null,
  contextRssItem?: RssItemPlayingContextInput | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type ModelPlayEventConditionInput = {
  ownerSub?: ModelStringInput | null,
  startTime?: ModelFloatInput | null,
  endTime?: ModelFloatInput | null,
  duration?: ModelFloatInput | null,
  contextPost_id?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelPlayEventConditionInput | null > | null,
  or?: Array< ModelPlayEventConditionInput | null > | null,
  not?: ModelPlayEventConditionInput | null,
};

export type UpdatePlayEventInput = {
  id: string,
  ownerSub?: string | null,
  startTime?: number | null,
  endTime?: number | null,
  duration?: number | null,
  contextPost_id?: string | null,
  contextRssItem?: RssItemPlayingContextInput | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type DeletePlayEventInput = {
  id: string,
};

export type CreatePostCollectionInput = {
  id?: string | null,
  ownerSub: string,
  name: string,
  description: string,
  emoji?: string | null,
  color?: ColorInput | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  defaultSortOrder?: Playlist_SortOrder | null,
};

export type ColorInput = {
  red: number,
  green: number,
  blue: number,
};

export type ModelPostCollectionConditionInput = {
  ownerSub?: ModelStringInput | null,
  name?: ModelStringInput | null,
  description?: ModelStringInput | null,
  emoji?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  defaultSortOrder?: ModelPlaylist_SortOrderInput | null,
  and?: Array< ModelPostCollectionConditionInput | null > | null,
  or?: Array< ModelPostCollectionConditionInput | null > | null,
  not?: ModelPostCollectionConditionInput | null,
};

export type ModelPlaylist_SortOrderInput = {
  eq?: Playlist_SortOrder | null,
  ne?: Playlist_SortOrder | null,
};

export type UpdatePostCollectionInput = {
  id: string,
  ownerSub?: string | null,
  name?: string | null,
  description?: string | null,
  emoji?: string | null,
  color?: ColorInput | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  defaultSortOrder?: Playlist_SortOrder | null,
};

export type DeletePostCollectionInput = {
  id: string,
};

export type CreatePostCollectionMembershipInput = {
  ownerSub: string,
  postCollection_id: string,
  post_id: string,
  createdAt?: string | null,
  rank: number,
};

export type ModelPostCollectionMembershipConditionInput = {
  ownerSub?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  rank?: ModelFloatInput | null,
  and?: Array< ModelPostCollectionMembershipConditionInput | null > | null,
  or?: Array< ModelPostCollectionMembershipConditionInput | null > | null,
  not?: ModelPostCollectionMembershipConditionInput | null,
};

export type UpdatePostCollectionMembershipInput = {
  ownerSub?: string | null,
  postCollection_id: string,
  post_id: string,
  createdAt?: string | null,
  rank?: number | null,
};

export type DeletePostCollectionMembershipInput = {
  postCollection_id: string,
  post_id: string,
};

export type CreatePostCollectionFollowRelationInput = {
  ownerSub: string,
  postCollection_id: string,
  createdAt?: string | null,
};

export type ModelPostCollectionFollowRelationConditionInput = {
  createdAt?: ModelStringInput | null,
  and?: Array< ModelPostCollectionFollowRelationConditionInput | null > | null,
  or?: Array< ModelPostCollectionFollowRelationConditionInput | null > | null,
  not?: ModelPostCollectionFollowRelationConditionInput | null,
};

export type UpdatePostCollectionFollowRelationInput = {
  ownerSub: string,
  postCollection_id: string,
  createdAt?: string | null,
};

export type DeletePostCollectionFollowRelationInput = {
  postCollection_id: string,
  ownerSub: string,
};

export type CreateCommunityInput = {
  ownerSub: string,
  shortName: string,
};

export type ModelCommunityConditionInput = {
  ownerSub?: ModelStringInput | null,
  and?: Array< ModelCommunityConditionInput | null > | null,
  or?: Array< ModelCommunityConditionInput | null > | null,
  not?: ModelCommunityConditionInput | null,
};

export type Community = {
  __typename: "Community",
  ownerSub: string,
  creator: User,
  shortName: string,
  postAssociations?: ModelCommunityPostAssociationConnection | null,
  createdAt: string,
  updatedAt: string,
  creatorSub?: string | null,
};

export type ModelCommunityPostAssociationConnection = {
  __typename: "ModelCommunityPostAssociationConnection",
  items:  Array<CommunityPostAssociation | null >,
  nextToken?: string | null,
};

export type CommunityPostAssociation = {
  __typename: "CommunityPostAssociation",
  id: string,
  ownerSub: string,
  author: User,
  community_shortName: string,
  community: Community,
  associatedPost_id: string,
  associatedPost: Post,
  createdAt?: string | null,
  updatedAt?: string | null,
  communityPostAssociationsId: string,
};

export type UpdateCommunityInput = {
  ownerSub?: string | null,
  shortName: string,
};

export type DeleteCommunityInput = {
  shortName: string,
};

export type CreateCommunityPostAssociationInput = {
  id?: string | null,
  ownerSub: string,
  community_shortName: string,
  associatedPost_id: string,
  createdAt?: string | null,
  updatedAt?: string | null,
  communityPostAssociationsId: string,
};

export type ModelCommunityPostAssociationConditionInput = {
  ownerSub?: ModelStringInput | null,
  community_shortName?: ModelStringInput | null,
  associatedPost_id?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelCommunityPostAssociationConditionInput | null > | null,
  or?: Array< ModelCommunityPostAssociationConditionInput | null > | null,
  not?: ModelCommunityPostAssociationConditionInput | null,
  communityPostAssociationsId?: ModelIDInput | null,
};

export type UpdateCommunityPostAssociationInput = {
  id: string,
  ownerSub?: string | null,
  community_shortName?: string | null,
  associatedPost_id?: string | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  communityPostAssociationsId: string,
};

export type DeleteCommunityPostAssociationInput = {
  id: string,
};

export type NewsfeedItemsConnection = {
  __typename: "NewsfeedItemsConnection",
  items:  Array<NewsfeedItem | null >,
  nextToken?: string | null,
};

export type NewsfeedItem = NewsfeedItem_Post | NewsfeedItem_PostLike | NewsfeedItem_FeaturedPostCollections | NewsfeedItem_PostAggregation


export type NewsfeedItem_PostLike = {
  __typename: "NewsfeedItem_PostLike",
  keyDict: string,
  like: PostLike,
};

export type NewsfeedItem_FeaturedPostCollections = {
  __typename: "NewsfeedItem_FeaturedPostCollections",
  title: string,
  postCollections:  Array<NewsfeedItem_PostCollection | null >,
};

export type NewsfeedItem_PostCollection = {
  __typename: "NewsfeedItem_PostCollection",
  keyDict: string,
  postCollection: PostCollection,
};

export type NewsfeedItem_PostAggregation = {
  __typename: "NewsfeedItem_PostAggregation",
  threadRootPost: NewsfeedItem_Post,
  items:  Array<PostAggregatableNewsfeedItem | null >,
};

export type PostAggregatableNewsfeedItem = NewsfeedItem_Post | NewsfeedItem_PostLike


export type FeedItemsConnection_V2 = {
  __typename: "FeedItemsConnection_V2",
  items:  Array<ContextfulFeedItem_V2 | null >,
  nextToken?: string | null,
};

export type ContextfulFeedItem_V2 = {
  __typename: "ContextfulFeedItem_V2",
  context?: FeedItemContext | null,
  item: FeedItem_V2,
};

export type FeedItemContext = FeedItemContext_Social


export type FeedItemContext_Social = {
  __typename: "FeedItemContext_Social",
  likers:  Array<Ref_User | null >,
  comments:  Array<NewsfeedItem_Post | null >,
  playlists:  Array<NewsfeedItem_PostCollection | null >,
};

export type Ref_User = {
  __typename: "Ref_User",
  keyDict: string,
  user: User,
};

export type FeedItem_V2 = NewsfeedItem_Post | PostCollectionWithRepresentativeItem


export type PostCollectionWithRepresentativeItem = {
  __typename: "PostCollectionWithRepresentativeItem",
  postCollection: NewsfeedItem_PostCollection,
  representativeItem?: NewsfeedItem_Post | null,
};

export type UserNotificationConnection = {
  __typename: "UserNotificationConnection",
  items:  Array<UserNotificationItem | null >,
  nextToken?: string | null,
};

export type UserNotificationItem = NewsfeedItem_PostAggregation


export type ContactFinderInput = {
  phoneNumbers: Array< string >,
  implicitInternationalPrefix: string,
};

export type ModelUserFilterInput = {
  sub?: ModelStringInput | null,
  phoneNumber?: ModelStringInput | null,
  identityId?: ModelStringInput | null,
  lastMigrationNumber?: ModelIntInput | null,
  name?: ModelStringInput | null,
  bio?: ModelStringInput | null,
  userHandle_standardForm?: ModelStringInput | null,
  and?: Array< ModelUserFilterInput | null > | null,
  or?: Array< ModelUserFilterInput | null > | null,
  not?: ModelUserFilterInput | null,
};

export enum ModelSortDirection {
  ASC = "ASC",
  DESC = "DESC",
}


export type ModelUserConnection = {
  __typename: "ModelUserConnection",
  items:  Array<User | null >,
  nextToken?: string | null,
};

export type SearchableUserFilterInput = {
  sub?: SearchableStringFilterInput | null,
  phoneNumber?: SearchableStringFilterInput | null,
  identityId?: SearchableStringFilterInput | null,
  lastMigrationNumber?: SearchableIntFilterInput | null,
  name?: SearchableStringFilterInput | null,
  bio?: SearchableStringFilterInput | null,
  userHandle_standardForm?: SearchableStringFilterInput | null,
  createdAt?: SearchableStringFilterInput | null,
  updatedAt?: SearchableStringFilterInput | null,
  and?: Array< SearchableUserFilterInput | null > | null,
  or?: Array< SearchableUserFilterInput | null > | null,
  not?: SearchableUserFilterInput | null,
};

export type SearchableStringFilterInput = {
  ne?: string | null,
  gt?: string | null,
  lt?: string | null,
  gte?: string | null,
  lte?: string | null,
  eq?: string | null,
  match?: string | null,
  matchPhrase?: string | null,
  matchPhrasePrefix?: string | null,
  multiMatch?: string | null,
  exists?: boolean | null,
  wildcard?: string | null,
  regexp?: string | null,
  range?: Array< string | null > | null,
};

export type SearchableIntFilterInput = {
  ne?: number | null,
  gt?: number | null,
  lt?: number | null,
  gte?: number | null,
  lte?: number | null,
  eq?: number | null,
  range?: Array< number | null > | null,
};

export type SearchableUserSortInput = {
  field?: SearchableUserSortableFields | null,
  direction?: SearchableSortDirection | null,
};

export enum SearchableUserSortableFields {
  sub = "sub",
  phoneNumber = "phoneNumber",
  identityId = "identityId",
  lastMigrationNumber = "lastMigrationNumber",
  name = "name",
  bio = "bio",
  userHandle_standardForm = "userHandle_standardForm",
  createdAt = "createdAt",
  updatedAt = "updatedAt",
}


export enum SearchableSortDirection {
  asc = "asc",
  desc = "desc",
}


export type SearchableUserAggregationInput = {
  name: string,
  type: SearchableAggregateType,
  field: SearchableUserAggregateField,
};

export enum SearchableAggregateType {
  terms = "terms",
  avg = "avg",
  min = "min",
  max = "max",
  sum = "sum",
}


export enum SearchableUserAggregateField {
  sub = "sub",
  phoneNumber = "phoneNumber",
  identityId = "identityId",
  lastMigrationNumber = "lastMigrationNumber",
  name = "name",
  bio = "bio",
  userHandle_standardForm = "userHandle_standardForm",
  createdAt = "createdAt",
  updatedAt = "updatedAt",
}


export type SearchableUserConnection = {
  __typename: "SearchableUserConnection",
  items:  Array<User | null >,
  nextToken?: string | null,
  total?: number | null,
  aggregateItems:  Array<SearchableAggregateResult | null >,
};

export type ModelUserDisplayNameFilterInput = {
  displayName?: ModelStringInput | null,
  ownerSub?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  and?: Array< ModelUserDisplayNameFilterInput | null > | null,
  or?: Array< ModelUserDisplayNameFilterInput | null > | null,
  not?: ModelUserDisplayNameFilterInput | null,
};

export type ModelUserDisplayNameConnection = {
  __typename: "ModelUserDisplayNameConnection",
  items:  Array<UserDisplayName | null >,
  nextToken?: string | null,
};

export type ModelUserHandleFilterInput = {
  ownerSub?: ModelStringInput | null,
  standardForm?: ModelStringInput | null,
  renderedForm?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  and?: Array< ModelUserHandleFilterInput | null > | null,
  or?: Array< ModelUserHandleFilterInput | null > | null,
  not?: ModelUserHandleFilterInput | null,
};

export type ModelUserHandleConnection = {
  __typename: "ModelUserHandleConnection",
  items:  Array<UserHandle | null >,
  nextToken?: string | null,
};

export type SearchableUserHandleFilterInput = {
  ownerSub?: SearchableStringFilterInput | null,
  standardForm?: SearchableStringFilterInput | null,
  renderedForm?: SearchableStringFilterInput | null,
  createdAt?: SearchableStringFilterInput | null,
  updatedAt?: SearchableStringFilterInput | null,
  and?: Array< SearchableUserHandleFilterInput | null > | null,
  or?: Array< SearchableUserHandleFilterInput | null > | null,
  not?: SearchableUserHandleFilterInput | null,
};

export type SearchableUserHandleSortInput = {
  field?: SearchableUserHandleSortableFields | null,
  direction?: SearchableSortDirection | null,
};

export enum SearchableUserHandleSortableFields {
  ownerSub = "ownerSub",
  standardForm = "standardForm",
  renderedForm = "renderedForm",
  createdAt = "createdAt",
  updatedAt = "updatedAt",
}


export type SearchableUserHandleAggregationInput = {
  name: string,
  type: SearchableAggregateType,
  field: SearchableUserHandleAggregateField,
};

export enum SearchableUserHandleAggregateField {
  ownerSub = "ownerSub",
  standardForm = "standardForm",
  renderedForm = "renderedForm",
  createdAt = "createdAt",
  updatedAt = "updatedAt",
}


export type SearchableUserHandleConnection = {
  __typename: "SearchableUserHandleConnection",
  items:  Array<UserHandle | null >,
  nextToken?: string | null,
  total?: number | null,
  aggregateItems:  Array<SearchableAggregateResult | null >,
};

export type ModelPostFilterInput = {
  id?: ModelIDInput | null,
  ownerSub?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  text?: ModelStringInput | null,
  footnote?: ModelStringInput | null,
  replyingToPost_id?: ModelIDInput | null,
  threadRootPost_id?: ModelIDInput | null,
  repostedPost_id?: ModelIDInput | null,
  associatedTawk_localId?: ModelStringInput | null,
  associatedTawk_tawkVersion?: ModelStringInput | null,
  associatedExternalTawk_id?: ModelIDInput | null,
  repliesCount?: ModelIntInput | null,
  likesCount?: ModelIntInput | null,
  associatedColorHue?: ModelFloatInput | null,
  and?: Array< ModelPostFilterInput | null > | null,
  or?: Array< ModelPostFilterInput | null > | null,
  not?: ModelPostFilterInput | null,
};

export type SearchablePostFilterInput = {
  id?: SearchableIDFilterInput | null,
  ownerSub?: SearchableStringFilterInput | null,
  createdAt?: SearchableStringFilterInput | null,
  text?: SearchableStringFilterInput | null,
  footnote?: SearchableStringFilterInput | null,
  replyingToPost_id?: SearchableIDFilterInput | null,
  threadRootPost_id?: SearchableIDFilterInput | null,
  repostedPost_id?: SearchableIDFilterInput | null,
  associatedTawk_localId?: SearchableStringFilterInput | null,
  associatedTawk_tawkVersion?: SearchableStringFilterInput | null,
  associatedExternalTawk_id?: SearchableIDFilterInput | null,
  repliesCount?: SearchableIntFilterInput | null,
  likesCount?: SearchableIntFilterInput | null,
  associatedColorHue?: SearchableFloatFilterInput | null,
  updatedAt?: SearchableStringFilterInput | null,
  and?: Array< SearchablePostFilterInput | null > | null,
  or?: Array< SearchablePostFilterInput | null > | null,
  not?: SearchablePostFilterInput | null,
};

export type SearchableIDFilterInput = {
  ne?: string | null,
  gt?: string | null,
  lt?: string | null,
  gte?: string | null,
  lte?: string | null,
  eq?: string | null,
  match?: string | null,
  matchPhrase?: string | null,
  matchPhrasePrefix?: string | null,
  multiMatch?: string | null,
  exists?: boolean | null,
  wildcard?: string | null,
  regexp?: string | null,
  range?: Array< string | null > | null,
};

export type SearchableFloatFilterInput = {
  ne?: number | null,
  gt?: number | null,
  lt?: number | null,
  gte?: number | null,
  lte?: number | null,
  eq?: number | null,
  range?: Array< number | null > | null,
};

export type SearchablePostSortInput = {
  field?: SearchablePostSortableFields | null,
  direction?: SearchableSortDirection | null,
};

export enum SearchablePostSortableFields {
  id = "id",
  ownerSub = "ownerSub",
  createdAt = "createdAt",
  text = "text",
  footnote = "footnote",
  replyingToPost_id = "replyingToPost_id",
  threadRootPost_id = "threadRootPost_id",
  repostedPost_id = "repostedPost_id",
  associatedTawk_localId = "associatedTawk_localId",
  associatedTawk_tawkVersion = "associatedTawk_tawkVersion",
  associatedExternalTawk_id = "associatedExternalTawk_id",
  repliesCount = "repliesCount",
  likesCount = "likesCount",
  associatedColorHue = "associatedColorHue",
  updatedAt = "updatedAt",
}


export type SearchablePostAggregationInput = {
  name: string,
  type: SearchableAggregateType,
  field: SearchablePostAggregateField,
};

export enum SearchablePostAggregateField {
  id = "id",
  ownerSub = "ownerSub",
  createdAt = "createdAt",
  text = "text",
  footnote = "footnote",
  replyingToPost_id = "replyingToPost_id",
  threadRootPost_id = "threadRootPost_id",
  repostedPost_id = "repostedPost_id",
  associatedTawk_localId = "associatedTawk_localId",
  associatedTawk_tawkVersion = "associatedTawk_tawkVersion",
  associatedExternalTawk_id = "associatedExternalTawk_id",
  repliesCount = "repliesCount",
  likesCount = "likesCount",
  associatedColorHue = "associatedColorHue",
  updatedAt = "updatedAt",
}


export type ModelExternalTawkFilterInput = {
  id?: ModelIDInput | null,
  inserter_sub?: ModelStringInput | null,
  title?: ModelStringInput | null,
  audioFileUrl?: ModelStringInput | null,
  duration?: ModelIntInput | null,
  originUrl?: ModelStringInput | null,
  originKind?: ModelExternalTawk_OriginKindInput | null,
  originName?: ModelStringInput | null,
  originCreatedAt?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  and?: Array< ModelExternalTawkFilterInput | null > | null,
  or?: Array< ModelExternalTawkFilterInput | null > | null,
  not?: ModelExternalTawkFilterInput | null,
};

export type ModelExternalTawkConnection = {
  __typename: "ModelExternalTawkConnection",
  items:  Array<ExternalTawk | null >,
  nextToken?: string | null,
};

export type SearchableExternalTawkFilterInput = {
  id?: SearchableIDFilterInput | null,
  inserter_sub?: SearchableStringFilterInput | null,
  title?: SearchableStringFilterInput | null,
  audioFileUrl?: SearchableStringFilterInput | null,
  duration?: SearchableIntFilterInput | null,
  originUrl?: SearchableStringFilterInput | null,
  originName?: SearchableStringFilterInput | null,
  originCreatedAt?: SearchableStringFilterInput | null,
  createdAt?: SearchableStringFilterInput | null,
  updatedAt?: SearchableStringFilterInput | null,
  originKind?: SearchableStringFilterInput | null,
  and?: Array< SearchableExternalTawkFilterInput | null > | null,
  or?: Array< SearchableExternalTawkFilterInput | null > | null,
  not?: SearchableExternalTawkFilterInput | null,
};

export type SearchableExternalTawkSortInput = {
  field?: SearchableExternalTawkSortableFields | null,
  direction?: SearchableSortDirection | null,
};

export enum SearchableExternalTawkSortableFields {
  id = "id",
  inserter_sub = "inserter_sub",
  title = "title",
  audioFileUrl = "audioFileUrl",
  duration = "duration",
  originUrl = "originUrl",
  originName = "originName",
  originCreatedAt = "originCreatedAt",
  createdAt = "createdAt",
  updatedAt = "updatedAt",
}


export type SearchableExternalTawkAggregationInput = {
  name: string,
  type: SearchableAggregateType,
  field: SearchableExternalTawkAggregateField,
};

export enum SearchableExternalTawkAggregateField {
  id = "id",
  inserter_sub = "inserter_sub",
  title = "title",
  audioFileUrl = "audioFileUrl",
  duration = "duration",
  originUrl = "originUrl",
  originKind = "originKind",
  originName = "originName",
  originCreatedAt = "originCreatedAt",
  createdAt = "createdAt",
  updatedAt = "updatedAt",
}


export type SearchableExternalTawkConnection = {
  __typename: "SearchableExternalTawkConnection",
  items:  Array<ExternalTawk | null >,
  nextToken?: string | null,
  total?: number | null,
  aggregateItems:  Array<SearchableAggregateResult | null >,
};

export type ModelSignupCodeFilterInput = {
  codeName?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  and?: Array< ModelSignupCodeFilterInput | null > | null,
  or?: Array< ModelSignupCodeFilterInput | null > | null,
  not?: ModelSignupCodeFilterInput | null,
};

export type ModelSignupCodeConnection = {
  __typename: "ModelSignupCodeConnection",
  items:  Array<SignupCode | null >,
  nextToken?: string | null,
};

export type SearchableSignupCodeFilterInput = {
  codeName?: SearchableStringFilterInput | null,
  createdAt?: SearchableStringFilterInput | null,
  updatedAt?: SearchableStringFilterInput | null,
  and?: Array< SearchableSignupCodeFilterInput | null > | null,
  or?: Array< SearchableSignupCodeFilterInput | null > | null,
  not?: SearchableSignupCodeFilterInput | null,
};

export type SearchableSignupCodeSortInput = {
  field?: SearchableSignupCodeSortableFields | null,
  direction?: SearchableSortDirection | null,
};

export enum SearchableSignupCodeSortableFields {
  codeName = "codeName",
  createdAt = "createdAt",
  updatedAt = "updatedAt",
}


export type SearchableSignupCodeAggregationInput = {
  name: string,
  type: SearchableAggregateType,
  field: SearchableSignupCodeAggregateField,
};

export enum SearchableSignupCodeAggregateField {
  codeName = "codeName",
  createdAt = "createdAt",
  updatedAt = "updatedAt",
}


export type SearchableSignupCodeConnection = {
  __typename: "SearchableSignupCodeConnection",
  items:  Array<SignupCode | null >,
  nextToken?: string | null,
  total?: number | null,
  aggregateItems:  Array<SearchableAggregateResult | null >,
};

export type ModelStringKeyConditionInput = {
  eq?: string | null,
  le?: string | null,
  lt?: string | null,
  ge?: string | null,
  gt?: string | null,
  between?: Array< string | null > | null,
  beginsWith?: string | null,
};

export type ModelSignupCodeUsersWhichNewMembersAutomaticallyFollowAssociationFilterInput = {
  code_codeName?: ModelStringInput | null,
  user_sub?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  and?: Array< ModelSignupCodeUsersWhichNewMembersAutomaticallyFollowAssociationFilterInput | null > | null,
  or?: Array< ModelSignupCodeUsersWhichNewMembersAutomaticallyFollowAssociationFilterInput | null > | null,
  not?: ModelSignupCodeUsersWhichNewMembersAutomaticallyFollowAssociationFilterInput | null,
};

export type SearchableSignupCodeUsersWhichNewMembersAutomaticallyFollowAssociationFilterInput = {
  code_codeName?: SearchableStringFilterInput | null,
  user_sub?: SearchableStringFilterInput | null,
  createdAt?: SearchableStringFilterInput | null,
  updatedAt?: SearchableStringFilterInput | null,
  and?: Array< SearchableSignupCodeUsersWhichNewMembersAutomaticallyFollowAssociationFilterInput | null > | null,
  or?: Array< SearchableSignupCodeUsersWhichNewMembersAutomaticallyFollowAssociationFilterInput | null > | null,
  not?: SearchableSignupCodeUsersWhichNewMembersAutomaticallyFollowAssociationFilterInput | null,
};

export type SearchableSignupCodeUsersWhichNewMembersAutomaticallyFollowAssociationSortInput = {
  field?: SearchableSignupCodeUsersWhichNewMembersAutomaticallyFollowAssociationSortableFields | null,
  direction?: SearchableSortDirection | null,
};

export enum SearchableSignupCodeUsersWhichNewMembersAutomaticallyFollowAssociationSortableFields {
  code_codeName = "code_codeName",
  user_sub = "user_sub",
  createdAt = "createdAt",
  updatedAt = "updatedAt",
}


export type SearchableSignupCodeUsersWhichNewMembersAutomaticallyFollowAssociationAggregationInput = {
  name: string,
  type: SearchableAggregateType,
  field: SearchableSignupCodeUsersWhichNewMembersAutomaticallyFollowAssociationAggregateField,
};

export enum SearchableSignupCodeUsersWhichNewMembersAutomaticallyFollowAssociationAggregateField {
  code_codeName = "code_codeName",
  user_sub = "user_sub",
  createdAt = "createdAt",
  updatedAt = "updatedAt",
}


export type SearchableSignupCodeUsersWhichNewMembersAutomaticallyFollowAssociationConnection = {
  __typename: "SearchableSignupCodeUsersWhichNewMembersAutomaticallyFollowAssociationConnection",
  items:  Array<SignupCodeUsersWhichNewMembersAutomaticallyFollowAssociation | null >,
  nextToken?: string | null,
  total?: number | null,
  aggregateItems:  Array<SearchableAggregateResult | null >,
};

export type ModelSignupCodeUsersWhichAutomaticallyFollowNewMembersAssociationFilterInput = {
  code_codeName?: ModelStringInput | null,
  user_sub?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  and?: Array< ModelSignupCodeUsersWhichAutomaticallyFollowNewMembersAssociationFilterInput | null > | null,
  or?: Array< ModelSignupCodeUsersWhichAutomaticallyFollowNewMembersAssociationFilterInput | null > | null,
  not?: ModelSignupCodeUsersWhichAutomaticallyFollowNewMembersAssociationFilterInput | null,
};

export type SearchableSignupCodeUsersWhichAutomaticallyFollowNewMembersAssociationFilterInput = {
  code_codeName?: SearchableStringFilterInput | null,
  user_sub?: SearchableStringFilterInput | null,
  createdAt?: SearchableStringFilterInput | null,
  updatedAt?: SearchableStringFilterInput | null,
  and?: Array< SearchableSignupCodeUsersWhichAutomaticallyFollowNewMembersAssociationFilterInput | null > | null,
  or?: Array< SearchableSignupCodeUsersWhichAutomaticallyFollowNewMembersAssociationFilterInput | null > | null,
  not?: SearchableSignupCodeUsersWhichAutomaticallyFollowNewMembersAssociationFilterInput | null,
};

export type SearchableSignupCodeUsersWhichAutomaticallyFollowNewMembersAssociationSortInput = {
  field?: SearchableSignupCodeUsersWhichAutomaticallyFollowNewMembersAssociationSortableFields | null,
  direction?: SearchableSortDirection | null,
};

export enum SearchableSignupCodeUsersWhichAutomaticallyFollowNewMembersAssociationSortableFields {
  code_codeName = "code_codeName",
  user_sub = "user_sub",
  createdAt = "createdAt",
  updatedAt = "updatedAt",
}


export type SearchableSignupCodeUsersWhichAutomaticallyFollowNewMembersAssociationAggregationInput = {
  name: string,
  type: SearchableAggregateType,
  field: SearchableSignupCodeUsersWhichAutomaticallyFollowNewMembersAssociationAggregateField,
};

export enum SearchableSignupCodeUsersWhichAutomaticallyFollowNewMembersAssociationAggregateField {
  code_codeName = "code_codeName",
  user_sub = "user_sub",
  createdAt = "createdAt",
  updatedAt = "updatedAt",
}


export type SearchableSignupCodeUsersWhichAutomaticallyFollowNewMembersAssociationConnection = {
  __typename: "SearchableSignupCodeUsersWhichAutomaticallyFollowNewMembersAssociationConnection",
  items:  Array<SignupCodeUsersWhichAutomaticallyFollowNewMembersAssociation | null >,
  nextToken?: string | null,
  total?: number | null,
  aggregateItems:  Array<SearchableAggregateResult | null >,
};

export type ModelSignupCodeUserAssociationFilterInput = {
  ownerSub?: ModelStringInput | null,
  code_codeName?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  and?: Array< ModelSignupCodeUserAssociationFilterInput | null > | null,
  or?: Array< ModelSignupCodeUserAssociationFilterInput | null > | null,
  not?: ModelSignupCodeUserAssociationFilterInput | null,
};

export type SearchableSignupCodeUserAssociationFilterInput = {
  ownerSub?: SearchableStringFilterInput | null,
  code_codeName?: SearchableStringFilterInput | null,
  createdAt?: SearchableStringFilterInput | null,
  updatedAt?: SearchableStringFilterInput | null,
  and?: Array< SearchableSignupCodeUserAssociationFilterInput | null > | null,
  or?: Array< SearchableSignupCodeUserAssociationFilterInput | null > | null,
  not?: SearchableSignupCodeUserAssociationFilterInput | null,
};

export type SearchableSignupCodeUserAssociationSortInput = {
  field?: SearchableSignupCodeUserAssociationSortableFields | null,
  direction?: SearchableSortDirection | null,
};

export enum SearchableSignupCodeUserAssociationSortableFields {
  ownerSub = "ownerSub",
  code_codeName = "code_codeName",
  createdAt = "createdAt",
  updatedAt = "updatedAt",
}


export type SearchableSignupCodeUserAssociationAggregationInput = {
  name: string,
  type: SearchableAggregateType,
  field: SearchableSignupCodeUserAssociationAggregateField,
};

export enum SearchableSignupCodeUserAssociationAggregateField {
  ownerSub = "ownerSub",
  code_codeName = "code_codeName",
  createdAt = "createdAt",
  updatedAt = "updatedAt",
}


export type SearchableSignupCodeUserAssociationConnection = {
  __typename: "SearchableSignupCodeUserAssociationConnection",
  items:  Array<SignupCodeUserAssociation | null >,
  nextToken?: string | null,
  total?: number | null,
  aggregateItems:  Array<SearchableAggregateResult | null >,
};

export type ModelTawkCandidatePrimaryCompositeKeyConditionInput = {
  eq?: ModelTawkCandidatePrimaryCompositeKeyInput | null,
  le?: ModelTawkCandidatePrimaryCompositeKeyInput | null,
  lt?: ModelTawkCandidatePrimaryCompositeKeyInput | null,
  ge?: ModelTawkCandidatePrimaryCompositeKeyInput | null,
  gt?: ModelTawkCandidatePrimaryCompositeKeyInput | null,
  between?: Array< ModelTawkCandidatePrimaryCompositeKeyInput | null > | null,
  beginsWith?: ModelTawkCandidatePrimaryCompositeKeyInput | null,
};

export type ModelTawkCandidatePrimaryCompositeKeyInput = {
  localId?: string | null,
  tawkVersion?: string | null,
};

export type ModelTawkCandidateFilterInput = {
  ownerSub?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  localId?: ModelStringInput | null,
  tawkVersion?: ModelStringInput | null,
  title?: ModelStringInput | null,
  duration?: ModelIntInput | null,
  and?: Array< ModelTawkCandidateFilterInput | null > | null,
  or?: Array< ModelTawkCandidateFilterInput | null > | null,
  not?: ModelTawkCandidateFilterInput | null,
};

export type ModelTawkCandidateConnection = {
  __typename: "ModelTawkCandidateConnection",
  items:  Array<TawkCandidate | null >,
  nextToken?: string | null,
};

export type ModelIDKeyConditionInput = {
  eq?: string | null,
  le?: string | null,
  lt?: string | null,
  ge?: string | null,
  gt?: string | null,
  between?: Array< string | null > | null,
  beginsWith?: string | null,
};

export type ModelPostLikeFilterInput = {
  ownerSub?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  postLiked_id?: ModelIDInput | null,
  and?: Array< ModelPostLikeFilterInput | null > | null,
  or?: Array< ModelPostLikeFilterInput | null > | null,
  not?: ModelPostLikeFilterInput | null,
};

export type SearchablePostLikeFilterInput = {
  ownerSub?: SearchableStringFilterInput | null,
  createdAt?: SearchableStringFilterInput | null,
  postLiked_id?: SearchableIDFilterInput | null,
  updatedAt?: SearchableStringFilterInput | null,
  and?: Array< SearchablePostLikeFilterInput | null > | null,
  or?: Array< SearchablePostLikeFilterInput | null > | null,
  not?: SearchablePostLikeFilterInput | null,
};

export type SearchablePostLikeSortInput = {
  field?: SearchablePostLikeSortableFields | null,
  direction?: SearchableSortDirection | null,
};

export enum SearchablePostLikeSortableFields {
  ownerSub = "ownerSub",
  createdAt = "createdAt",
  postLiked_id = "postLiked_id",
  updatedAt = "updatedAt",
}


export type SearchablePostLikeAggregationInput = {
  name: string,
  type: SearchableAggregateType,
  field: SearchablePostLikeAggregateField,
};

export enum SearchablePostLikeAggregateField {
  ownerSub = "ownerSub",
  createdAt = "createdAt",
  postLiked_id = "postLiked_id",
  updatedAt = "updatedAt",
}


export type SearchablePostLikeConnection = {
  __typename: "SearchablePostLikeConnection",
  items:  Array<PostLike | null >,
  nextToken?: string | null,
  total?: number | null,
  aggregateItems:  Array<SearchableAggregateResult | null >,
};

export type ModelPostClapFilterInput = {
  id?: ModelIDInput | null,
  ownerSub?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  timestampRelativeToContext?: ModelFloatInput | null,
  contextPost_id?: ModelIDInput | null,
  and?: Array< ModelPostClapFilterInput | null > | null,
  or?: Array< ModelPostClapFilterInput | null > | null,
  not?: ModelPostClapFilterInput | null,
};

export type SearchablePostClapFilterInput = {
  id?: SearchableIDFilterInput | null,
  ownerSub?: SearchableStringFilterInput | null,
  createdAt?: SearchableStringFilterInput | null,
  timestampRelativeToContext?: SearchableFloatFilterInput | null,
  contextPost_id?: SearchableIDFilterInput | null,
  updatedAt?: SearchableStringFilterInput | null,
  and?: Array< SearchablePostClapFilterInput | null > | null,
  or?: Array< SearchablePostClapFilterInput | null > | null,
  not?: SearchablePostClapFilterInput | null,
};

export type SearchablePostClapSortInput = {
  field?: SearchablePostClapSortableFields | null,
  direction?: SearchableSortDirection | null,
};

export enum SearchablePostClapSortableFields {
  id = "id",
  ownerSub = "ownerSub",
  createdAt = "createdAt",
  timestampRelativeToContext = "timestampRelativeToContext",
  contextPost_id = "contextPost_id",
  updatedAt = "updatedAt",
}


export type SearchablePostClapAggregationInput = {
  name: string,
  type: SearchableAggregateType,
  field: SearchablePostClapAggregateField,
};

export enum SearchablePostClapAggregateField {
  id = "id",
  ownerSub = "ownerSub",
  createdAt = "createdAt",
  timestampRelativeToContext = "timestampRelativeToContext",
  contextPost_id = "contextPost_id",
  updatedAt = "updatedAt",
}


export type SearchablePostClapConnection = {
  __typename: "SearchablePostClapConnection",
  items:  Array<PostClap | null >,
  nextToken?: string | null,
  total?: number | null,
  aggregateItems:  Array<SearchableAggregateResult | null >,
};

export type ModelPostReportFilterInput = {
  id?: ModelIDInput | null,
  ownerSub?: ModelStringInput | null,
  text?: ModelStringInput | null,
  kind?: ModelPostReport_KindInput | null,
  reportedPost_id?: ModelIDInput | null,
  reportedPostCollection_id?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  and?: Array< ModelPostReportFilterInput | null > | null,
  or?: Array< ModelPostReportFilterInput | null > | null,
  not?: ModelPostReportFilterInput | null,
};

export type ModelPostReportConnection = {
  __typename: "ModelPostReportConnection",
  items:  Array<PostReport | null >,
  nextToken?: string | null,
};

export type SearchablePostReportFilterInput = {
  id?: SearchableIDFilterInput | null,
  ownerSub?: SearchableStringFilterInput | null,
  text?: SearchableStringFilterInput | null,
  reportedPost_id?: SearchableIDFilterInput | null,
  reportedPostCollection_id?: SearchableIDFilterInput | null,
  createdAt?: SearchableStringFilterInput | null,
  updatedAt?: SearchableStringFilterInput | null,
  kind?: SearchableStringFilterInput | null,
  and?: Array< SearchablePostReportFilterInput | null > | null,
  or?: Array< SearchablePostReportFilterInput | null > | null,
  not?: SearchablePostReportFilterInput | null,
};

export type SearchablePostReportSortInput = {
  field?: SearchablePostReportSortableFields | null,
  direction?: SearchableSortDirection | null,
};

export enum SearchablePostReportSortableFields {
  id = "id",
  ownerSub = "ownerSub",
  text = "text",
  reportedPost_id = "reportedPost_id",
  reportedPostCollection_id = "reportedPostCollection_id",
  createdAt = "createdAt",
  updatedAt = "updatedAt",
}


export type SearchablePostReportAggregationInput = {
  name: string,
  type: SearchableAggregateType,
  field: SearchablePostReportAggregateField,
};

export enum SearchablePostReportAggregateField {
  id = "id",
  ownerSub = "ownerSub",
  text = "text",
  kind = "kind",
  reportedPost_id = "reportedPost_id",
  reportedPostCollection_id = "reportedPostCollection_id",
  createdAt = "createdAt",
  updatedAt = "updatedAt",
}


export type SearchablePostReportConnection = {
  __typename: "SearchablePostReportConnection",
  items:  Array<PostReport | null >,
  nextToken?: string | null,
  total?: number | null,
  aggregateItems:  Array<SearchableAggregateResult | null >,
};

export type ModelUserFollowFilterInput = {
  ownerSub?: ModelStringInput | null,
  followed_sub?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  and?: Array< ModelUserFollowFilterInput | null > | null,
  or?: Array< ModelUserFollowFilterInput | null > | null,
  not?: ModelUserFollowFilterInput | null,
};

export type SearchableUserFollowFilterInput = {
  ownerSub?: SearchableStringFilterInput | null,
  followed_sub?: SearchableStringFilterInput | null,
  createdAt?: SearchableStringFilterInput | null,
  updatedAt?: SearchableStringFilterInput | null,
  and?: Array< SearchableUserFollowFilterInput | null > | null,
  or?: Array< SearchableUserFollowFilterInput | null > | null,
  not?: SearchableUserFollowFilterInput | null,
};

export type SearchableUserFollowSortInput = {
  field?: SearchableUserFollowSortableFields | null,
  direction?: SearchableSortDirection | null,
};

export enum SearchableUserFollowSortableFields {
  ownerSub = "ownerSub",
  followed_sub = "followed_sub",
  createdAt = "createdAt",
  updatedAt = "updatedAt",
}


export type SearchableUserFollowAggregationInput = {
  name: string,
  type: SearchableAggregateType,
  field: SearchableUserFollowAggregateField,
};

export enum SearchableUserFollowAggregateField {
  ownerSub = "ownerSub",
  followed_sub = "followed_sub",
  createdAt = "createdAt",
  updatedAt = "updatedAt",
}


export type ModelUserBlockingRelationshipFilterInput = {
  ownerSub?: ModelStringInput | null,
  blocked_sub?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  and?: Array< ModelUserBlockingRelationshipFilterInput | null > | null,
  or?: Array< ModelUserBlockingRelationshipFilterInput | null > | null,
  not?: ModelUserBlockingRelationshipFilterInput | null,
};

export type SearchableUserBlockingRelationshipFilterInput = {
  ownerSub?: SearchableStringFilterInput | null,
  blocked_sub?: SearchableStringFilterInput | null,
  createdAt?: SearchableStringFilterInput | null,
  updatedAt?: SearchableStringFilterInput | null,
  and?: Array< SearchableUserBlockingRelationshipFilterInput | null > | null,
  or?: Array< SearchableUserBlockingRelationshipFilterInput | null > | null,
  not?: SearchableUserBlockingRelationshipFilterInput | null,
};

export type SearchableUserBlockingRelationshipSortInput = {
  field?: SearchableUserBlockingRelationshipSortableFields | null,
  direction?: SearchableSortDirection | null,
};

export enum SearchableUserBlockingRelationshipSortableFields {
  ownerSub = "ownerSub",
  blocked_sub = "blocked_sub",
  createdAt = "createdAt",
  updatedAt = "updatedAt",
}


export type SearchableUserBlockingRelationshipAggregationInput = {
  name: string,
  type: SearchableAggregateType,
  field: SearchableUserBlockingRelationshipAggregateField,
};

export enum SearchableUserBlockingRelationshipAggregateField {
  ownerSub = "ownerSub",
  blocked_sub = "blocked_sub",
  createdAt = "createdAt",
  updatedAt = "updatedAt",
}


export type SearchableUserBlockingRelationshipConnection = {
  __typename: "SearchableUserBlockingRelationshipConnection",
  items:  Array<UserBlockingRelationship | null >,
  nextToken?: string | null,
  total?: number | null,
  aggregateItems:  Array<SearchableAggregateResult | null >,
};

export type ModelPlayEventFilterInput = {
  id?: ModelIDInput | null,
  ownerSub?: ModelStringInput | null,
  startTime?: ModelFloatInput | null,
  endTime?: ModelFloatInput | null,
  duration?: ModelFloatInput | null,
  contextPost_id?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelPlayEventFilterInput | null > | null,
  or?: Array< ModelPlayEventFilterInput | null > | null,
  not?: ModelPlayEventFilterInput | null,
};

export type SearchablePlayEventFilterInput = {
  id?: SearchableIDFilterInput | null,
  ownerSub?: SearchableStringFilterInput | null,
  startTime?: SearchableFloatFilterInput | null,
  endTime?: SearchableFloatFilterInput | null,
  duration?: SearchableFloatFilterInput | null,
  contextPost_id?: SearchableIDFilterInput | null,
  createdAt?: SearchableStringFilterInput | null,
  updatedAt?: SearchableStringFilterInput | null,
  and?: Array< SearchablePlayEventFilterInput | null > | null,
  or?: Array< SearchablePlayEventFilterInput | null > | null,
  not?: SearchablePlayEventFilterInput | null,
};

export type SearchablePlayEventSortInput = {
  field?: SearchablePlayEventSortableFields | null,
  direction?: SearchableSortDirection | null,
};

export enum SearchablePlayEventSortableFields {
  id = "id",
  ownerSub = "ownerSub",
  startTime = "startTime",
  endTime = "endTime",
  duration = "duration",
  contextPost_id = "contextPost_id",
  createdAt = "createdAt",
  updatedAt = "updatedAt",
}


export type SearchablePlayEventAggregationInput = {
  name: string,
  type: SearchableAggregateType,
  field: SearchablePlayEventAggregateField,
};

export enum SearchablePlayEventAggregateField {
  id = "id",
  ownerSub = "ownerSub",
  startTime = "startTime",
  endTime = "endTime",
  duration = "duration",
  contextPost_id = "contextPost_id",
  createdAt = "createdAt",
  updatedAt = "updatedAt",
}


export type SearchablePlayEventConnection = {
  __typename: "SearchablePlayEventConnection",
  items:  Array<PlayEvent | null >,
  nextToken?: string | null,
  total?: number | null,
  aggregateItems:  Array<SearchableAggregateResult | null >,
};

export type ModelPostCollectionFilterInput = {
  id?: ModelIDInput | null,
  ownerSub?: ModelStringInput | null,
  name?: ModelStringInput | null,
  description?: ModelStringInput | null,
  emoji?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  defaultSortOrder?: ModelPlaylist_SortOrderInput | null,
  and?: Array< ModelPostCollectionFilterInput | null > | null,
  or?: Array< ModelPostCollectionFilterInput | null > | null,
  not?: ModelPostCollectionFilterInput | null,
};

export type SearchablePostCollectionFilterInput = {
  id?: SearchableIDFilterInput | null,
  ownerSub?: SearchableStringFilterInput | null,
  name?: SearchableStringFilterInput | null,
  description?: SearchableStringFilterInput | null,
  emoji?: SearchableStringFilterInput | null,
  createdAt?: SearchableStringFilterInput | null,
  updatedAt?: SearchableStringFilterInput | null,
  defaultSortOrder?: SearchableStringFilterInput | null,
  and?: Array< SearchablePostCollectionFilterInput | null > | null,
  or?: Array< SearchablePostCollectionFilterInput | null > | null,
  not?: SearchablePostCollectionFilterInput | null,
};

export type SearchablePostCollectionSortInput = {
  field?: SearchablePostCollectionSortableFields | null,
  direction?: SearchableSortDirection | null,
};

export enum SearchablePostCollectionSortableFields {
  id = "id",
  ownerSub = "ownerSub",
  name = "name",
  description = "description",
  emoji = "emoji",
  createdAt = "createdAt",
  updatedAt = "updatedAt",
}


export type SearchablePostCollectionAggregationInput = {
  name: string,
  type: SearchableAggregateType,
  field: SearchablePostCollectionAggregateField,
};

export enum SearchablePostCollectionAggregateField {
  id = "id",
  ownerSub = "ownerSub",
  name = "name",
  description = "description",
  emoji = "emoji",
  createdAt = "createdAt",
  updatedAt = "updatedAt",
  defaultSortOrder = "defaultSortOrder",
}


export type SearchablePostCollectionConnection = {
  __typename: "SearchablePostCollectionConnection",
  items:  Array<PostCollection | null >,
  nextToken?: string | null,
  total?: number | null,
  aggregateItems:  Array<SearchableAggregateResult | null >,
};

export type ModelPostCollectionMembershipFilterInput = {
  ownerSub?: ModelStringInput | null,
  postCollection_id?: ModelIDInput | null,
  post_id?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  rank?: ModelFloatInput | null,
  and?: Array< ModelPostCollectionMembershipFilterInput | null > | null,
  or?: Array< ModelPostCollectionMembershipFilterInput | null > | null,
  not?: ModelPostCollectionMembershipFilterInput | null,
};

export type SearchablePostCollectionMembershipFilterInput = {
  ownerSub?: SearchableStringFilterInput | null,
  postCollection_id?: SearchableIDFilterInput | null,
  post_id?: SearchableIDFilterInput | null,
  createdAt?: SearchableStringFilterInput | null,
  rank?: SearchableFloatFilterInput | null,
  updatedAt?: SearchableStringFilterInput | null,
  and?: Array< SearchablePostCollectionMembershipFilterInput | null > | null,
  or?: Array< SearchablePostCollectionMembershipFilterInput | null > | null,
  not?: SearchablePostCollectionMembershipFilterInput | null,
};

export type SearchablePostCollectionMembershipSortInput = {
  field?: SearchablePostCollectionMembershipSortableFields | null,
  direction?: SearchableSortDirection | null,
};

export enum SearchablePostCollectionMembershipSortableFields {
  ownerSub = "ownerSub",
  postCollection_id = "postCollection_id",
  post_id = "post_id",
  createdAt = "createdAt",
  rank = "rank",
  updatedAt = "updatedAt",
}


export type SearchablePostCollectionMembershipAggregationInput = {
  name: string,
  type: SearchableAggregateType,
  field: SearchablePostCollectionMembershipAggregateField,
};

export enum SearchablePostCollectionMembershipAggregateField {
  ownerSub = "ownerSub",
  postCollection_id = "postCollection_id",
  post_id = "post_id",
  createdAt = "createdAt",
  rank = "rank",
  updatedAt = "updatedAt",
}


export type ModelPostCollectionFollowRelationFilterInput = {
  ownerSub?: ModelStringInput | null,
  postCollection_id?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  and?: Array< ModelPostCollectionFollowRelationFilterInput | null > | null,
  or?: Array< ModelPostCollectionFollowRelationFilterInput | null > | null,
  not?: ModelPostCollectionFollowRelationFilterInput | null,
};

export type SearchablePostCollectionFollowRelationFilterInput = {
  ownerSub?: SearchableStringFilterInput | null,
  postCollection_id?: SearchableIDFilterInput | null,
  createdAt?: SearchableStringFilterInput | null,
  updatedAt?: SearchableStringFilterInput | null,
  and?: Array< SearchablePostCollectionFollowRelationFilterInput | null > | null,
  or?: Array< SearchablePostCollectionFollowRelationFilterInput | null > | null,
  not?: SearchablePostCollectionFollowRelationFilterInput | null,
};

export type SearchablePostCollectionFollowRelationSortInput = {
  field?: SearchablePostCollectionFollowRelationSortableFields | null,
  direction?: SearchableSortDirection | null,
};

export enum SearchablePostCollectionFollowRelationSortableFields {
  ownerSub = "ownerSub",
  postCollection_id = "postCollection_id",
  createdAt = "createdAt",
  updatedAt = "updatedAt",
}


export type SearchablePostCollectionFollowRelationAggregationInput = {
  name: string,
  type: SearchableAggregateType,
  field: SearchablePostCollectionFollowRelationAggregateField,
};

export enum SearchablePostCollectionFollowRelationAggregateField {
  ownerSub = "ownerSub",
  postCollection_id = "postCollection_id",
  createdAt = "createdAt",
  updatedAt = "updatedAt",
}


export type SearchablePostCollectionFollowRelationConnection = {
  __typename: "SearchablePostCollectionFollowRelationConnection",
  items:  Array<PostCollectionFollowRelation | null >,
  nextToken?: string | null,
  total?: number | null,
  aggregateItems:  Array<SearchableAggregateResult | null >,
};

export type ModelCommunityFilterInput = {
  ownerSub?: ModelStringInput | null,
  shortName?: ModelStringInput | null,
  and?: Array< ModelCommunityFilterInput | null > | null,
  or?: Array< ModelCommunityFilterInput | null > | null,
  not?: ModelCommunityFilterInput | null,
};

export type ModelCommunityConnection = {
  __typename: "ModelCommunityConnection",
  items:  Array<Community | null >,
  nextToken?: string | null,
};

export type SearchableCommunityFilterInput = {
  ownerSub?: SearchableStringFilterInput | null,
  shortName?: SearchableStringFilterInput | null,
  createdAt?: SearchableStringFilterInput | null,
  updatedAt?: SearchableStringFilterInput | null,
  and?: Array< SearchableCommunityFilterInput | null > | null,
  or?: Array< SearchableCommunityFilterInput | null > | null,
  not?: SearchableCommunityFilterInput | null,
};

export type SearchableCommunitySortInput = {
  field?: SearchableCommunitySortableFields | null,
  direction?: SearchableSortDirection | null,
};

export enum SearchableCommunitySortableFields {
  ownerSub = "ownerSub",
  shortName = "shortName",
  createdAt = "createdAt",
  updatedAt = "updatedAt",
}


export type SearchableCommunityAggregationInput = {
  name: string,
  type: SearchableAggregateType,
  field: SearchableCommunityAggregateField,
};

export enum SearchableCommunityAggregateField {
  ownerSub = "ownerSub",
  shortName = "shortName",
  createdAt = "createdAt",
  updatedAt = "updatedAt",
}


export type SearchableCommunityConnection = {
  __typename: "SearchableCommunityConnection",
  items:  Array<Community | null >,
  nextToken?: string | null,
  total?: number | null,
  aggregateItems:  Array<SearchableAggregateResult | null >,
};

export type ModelCommunityPostAssociationFilterInput = {
  id?: ModelIDInput | null,
  ownerSub?: ModelStringInput | null,
  community_shortName?: ModelStringInput | null,
  associatedPost_id?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelCommunityPostAssociationFilterInput | null > | null,
  or?: Array< ModelCommunityPostAssociationFilterInput | null > | null,
  not?: ModelCommunityPostAssociationFilterInput | null,
  communityPostAssociationsId?: ModelIDInput | null,
};

export type SearchableCommunityPostAssociationFilterInput = {
  id?: SearchableIDFilterInput | null,
  ownerSub?: SearchableStringFilterInput | null,
  community_shortName?: SearchableStringFilterInput | null,
  associatedPost_id?: SearchableIDFilterInput | null,
  createdAt?: SearchableStringFilterInput | null,
  updatedAt?: SearchableStringFilterInput | null,
  communityPostAssociationsId?: SearchableIDFilterInput | null,
  and?: Array< SearchableCommunityPostAssociationFilterInput | null > | null,
  or?: Array< SearchableCommunityPostAssociationFilterInput | null > | null,
  not?: SearchableCommunityPostAssociationFilterInput | null,
};

export type SearchableCommunityPostAssociationSortInput = {
  field?: SearchableCommunityPostAssociationSortableFields | null,
  direction?: SearchableSortDirection | null,
};

export enum SearchableCommunityPostAssociationSortableFields {
  id = "id",
  ownerSub = "ownerSub",
  community_shortName = "community_shortName",
  associatedPost_id = "associatedPost_id",
  createdAt = "createdAt",
  updatedAt = "updatedAt",
  communityPostAssociationsId = "communityPostAssociationsId",
}


export type SearchableCommunityPostAssociationAggregationInput = {
  name: string,
  type: SearchableAggregateType,
  field: SearchableCommunityPostAssociationAggregateField,
};

export enum SearchableCommunityPostAssociationAggregateField {
  id = "id",
  ownerSub = "ownerSub",
  community_shortName = "community_shortName",
  associatedPost_id = "associatedPost_id",
  createdAt = "createdAt",
  updatedAt = "updatedAt",
  communityPostAssociationsId = "communityPostAssociationsId",
}


export type SearchableCommunityPostAssociationConnection = {
  __typename: "SearchableCommunityPostAssociationConnection",
  items:  Array<CommunityPostAssociation | null >,
  nextToken?: string | null,
  total?: number | null,
  aggregateItems:  Array<SearchableAggregateResult | null >,
};

export type Get_Post_V2QueryVariables = {
  postId: string,
};

export type Get_Post_V2Query = {
  getPost?:  {
    __typename: "Post",
    createdAt: string,
    text: string,
    associatedTawk?:  {
      __typename: "TawkCandidate",
      ownerSub: string,
      localId: string,
      tawkVersion: string,
      title?: string | null,
      createdAt: string,
      author:  {
        __typename: "User",
        sub: string,
        name?: string | null,
        bio?: string | null,
        userHandle?:  {
          __typename: "UserHandle",
          standardForm: string,
          renderedForm: string,
        } | null,
        profilePhoto:  {
          __typename: "CloudinaryResource",
          publicId: string,
        },
      },
      duration?: number | null,
      rawAudio:  {
        __typename: "CloudinaryResource",
        publicId: string,
      },
      processedAudio?:  {
        __typename: "CloudinaryResource",
        publicId: string,
      } | null,
      generatedVideo?:  {
        __typename: "CloudinaryResource",
        publicId: string,
      } | null,
    } | null,
    associatedExternalTawk?:  {
      __typename: "ExternalTawk",
      id: string,
      inserter_sub: string,
      inserter:  {
        __typename: "User",
        sub: string,
        name?: string | null,
        bio?: string | null,
        userHandle?:  {
          __typename: "UserHandle",
          standardForm: string,
          renderedForm: string,
        } | null,
        profilePhoto:  {
          __typename: "CloudinaryResource",
          publicId: string,
        },
      },
      title: string,
      audioFileUrl: string,
      duration: number,
      originUrl: string,
      originKind: ExternalTawk_OriginKind,
      originName: string,
      originCreatedAt: string,
      picture:  {
        __typename: "GenericImage",
        imageUrl: string,
        cloudinaryImage?:  {
          __typename: "CloudinaryResource",
          publicId: string,
        } | null,
      },
      createdAt: string,
    } | null,
    author:  {
      __typename: "User",
      name?: string | null,
      sub: string,
      userHandle?:  {
        __typename: "UserHandle",
        renderedForm: string,
      } | null,
      profilePhoto:  {
        __typename: "CloudinaryResource",
        publicId: string,
      },
    },
    likesCount: number,
    repliesCount: number,
    id: string,
    repostedPost_id?: string | null,
    repostedTimeRange?:  {
      __typename: "ClipTimeRange",
      endTime: number,
      startTime: number,
    } | null,
    repostedPost?:  {
      __typename: "Post",
      id: string,
      createdAt: string,
      text: string,
      author:  {
        __typename: "User",
        name?: string | null,
        sub: string,
        userHandle?:  {
          __typename: "UserHandle",
          renderedForm: string,
        } | null,
        profilePhoto:  {
          __typename: "CloudinaryResource",
          publicId: string,
        },
      },
      associatedTawk?:  {
        __typename: "TawkCandidate",
        title?: string | null,
        generatedVideo?:  {
          __typename: "CloudinaryResource",
          publicId: string,
        } | null,
        ownerSub: string,
        localId: string,
        tawkVersion: string,
        createdAt: string,
        author:  {
          __typename: "User",
          sub: string,
          name?: string | null,
          bio?: string | null,
          userHandle?:  {
            __typename: "UserHandle",
            standardForm: string,
            renderedForm: string,
          } | null,
          profilePhoto:  {
            __typename: "CloudinaryResource",
            publicId: string,
          },
        },
        duration?: number | null,
        rawAudio:  {
          __typename: "CloudinaryResource",
          publicId: string,
        },
        processedAudio?:  {
          __typename: "CloudinaryResource",
          publicId: string,
        } | null,
      } | null,
      associatedExternalTawk?:  {
        __typename: "ExternalTawk",
        id: string,
        inserter_sub: string,
        inserter:  {
          __typename: "User",
          sub: string,
          name?: string | null,
          bio?: string | null,
          userHandle?:  {
            __typename: "UserHandle",
            standardForm: string,
            renderedForm: string,
          } | null,
          profilePhoto:  {
            __typename: "CloudinaryResource",
            publicId: string,
          },
        },
        title: string,
        audioFileUrl: string,
        duration: number,
        originUrl: string,
        originKind: ExternalTawk_OriginKind,
        originName: string,
        originCreatedAt: string,
        picture:  {
          __typename: "GenericImage",
          imageUrl: string,
          cloudinaryImage?:  {
            __typename: "CloudinaryResource",
            publicId: string,
          } | null,
        },
        createdAt: string,
      } | null,
      likesCount: number,
      repliesCount: number,
      repostedPost_id?: string | null,
      repostedTimeRange?:  {
        __typename: "ClipTimeRange",
        endTime: number,
        startTime: number,
      } | null,
      repostedPost?:  {
        __typename: "Post",
        id: string,
        createdAt: string,
        text: string,
        author:  {
          __typename: "User",
          name?: string | null,
          sub: string,
          userHandle?:  {
            __typename: "UserHandle",
            renderedForm: string,
          } | null,
          profilePhoto:  {
            __typename: "CloudinaryResource",
            publicId: string,
          },
        },
        associatedTawk?:  {
          __typename: "TawkCandidate",
          title?: string | null,
          generatedVideo?:  {
            __typename: "CloudinaryResource",
            publicId: string,
          } | null,
        } | null,
      } | null,
      associatedColorHue?: number | null,
      footnote?: string | null,
    } | null,
    associatedColorHue?: number | null,
    footnote?: string | null,
    replies?:  {
      __typename: "ModelPostConnection",
      items:  Array< {
        __typename: "Post",
        createdAt: string,
        text: string,
        associatedTawk?:  {
          __typename: "TawkCandidate",
          ownerSub: string,
          localId: string,
          tawkVersion: string,
          title?: string | null,
          createdAt: string,
          author:  {
            __typename: "User",
            sub: string,
            name?: string | null,
            bio?: string | null,
            userHandle?:  {
              __typename: "UserHandle",
              standardForm: string,
              renderedForm: string,
            } | null,
            profilePhoto:  {
              __typename: "CloudinaryResource",
              publicId: string,
            },
          },
          duration?: number | null,
          rawAudio:  {
            __typename: "CloudinaryResource",
            publicId: string,
          },
          processedAudio?:  {
            __typename: "CloudinaryResource",
            publicId: string,
          } | null,
          generatedVideo?:  {
            __typename: "CloudinaryResource",
            publicId: string,
          } | null,
        } | null,
        associatedExternalTawk?:  {
          __typename: "ExternalTawk",
          id: string,
          inserter_sub: string,
          inserter:  {
            __typename: "User",
            sub: string,
            name?: string | null,
            bio?: string | null,
            userHandle?:  {
              __typename: "UserHandle",
              standardForm: string,
              renderedForm: string,
            } | null,
            profilePhoto:  {
              __typename: "CloudinaryResource",
              publicId: string,
            },
          },
          title: string,
          audioFileUrl: string,
          duration: number,
          originUrl: string,
          originKind: ExternalTawk_OriginKind,
          originName: string,
          originCreatedAt: string,
          picture:  {
            __typename: "GenericImage",
            imageUrl: string,
            cloudinaryImage?:  {
              __typename: "CloudinaryResource",
              publicId: string,
            } | null,
          },
          createdAt: string,
        } | null,
        author:  {
          __typename: "User",
          name?: string | null,
          sub: string,
          userHandle?:  {
            __typename: "UserHandle",
            renderedForm: string,
          } | null,
          profilePhoto:  {
            __typename: "CloudinaryResource",
            publicId: string,
          },
        },
        likesCount: number,
        repliesCount: number,
        id: string,
        repostedPost_id?: string | null,
        repostedTimeRange?:  {
          __typename: "ClipTimeRange",
          endTime: number,
          startTime: number,
        } | null,
        repostedPost?:  {
          __typename: "Post",
          id: string,
          createdAt: string,
          text: string,
          author:  {
            __typename: "User",
            name?: string | null,
            sub: string,
            userHandle?:  {
              __typename: "UserHandle",
              renderedForm: string,
            } | null,
            profilePhoto:  {
              __typename: "CloudinaryResource",
              publicId: string,
            },
          },
          associatedTawk?:  {
            __typename: "TawkCandidate",
            title?: string | null,
            generatedVideo?:  {
              __typename: "CloudinaryResource",
              publicId: string,
            } | null,
            ownerSub: string,
            localId: string,
            tawkVersion: string,
            createdAt: string,
            author:  {
              __typename: "User",
              sub: string,
              name?: string | null,
              bio?: string | null,
              userHandle?:  {
                __typename: "UserHandle",
                standardForm: string,
                renderedForm: string,
              } | null,
              profilePhoto:  {
                __typename: "CloudinaryResource",
                publicId: string,
              },
            },
            duration?: number | null,
            rawAudio:  {
              __typename: "CloudinaryResource",
              publicId: string,
            },
            processedAudio?:  {
              __typename: "CloudinaryResource",
              publicId: string,
            } | null,
          } | null,
          associatedExternalTawk?:  {
            __typename: "ExternalTawk",
            id: string,
            inserter_sub: string,
            inserter:  {
              __typename: "User",
              sub: string,
              name?: string | null,
              bio?: string | null,
              userHandle?:  {
                __typename: "UserHandle",
                standardForm: string,
                renderedForm: string,
              } | null,
              profilePhoto:  {
                __typename: "CloudinaryResource",
                publicId: string,
              },
            },
            title: string,
            audioFileUrl: string,
            duration: number,
            originUrl: string,
            originKind: ExternalTawk_OriginKind,
            originName: string,
            originCreatedAt: string,
            picture:  {
              __typename: "GenericImage",
              imageUrl: string,
              cloudinaryImage?:  {
                __typename: "CloudinaryResource",
                publicId: string,
              } | null,
            },
            createdAt: string,
          } | null,
          likesCount: number,
          repliesCount: number,
          repostedPost_id?: string | null,
          repostedTimeRange?:  {
            __typename: "ClipTimeRange",
            endTime: number,
            startTime: number,
          } | null,
          repostedPost?:  {
            __typename: "Post",
            id: string,
            createdAt: string,
            text: string,
            author:  {
              __typename: "User",
              name?: string | null,
              sub: string,
              userHandle?:  {
                __typename: "UserHandle",
                renderedForm: string,
              } | null,
              profilePhoto:  {
                __typename: "CloudinaryResource",
                publicId: string,
              },
            },
            associatedTawk?:  {
              __typename: "TawkCandidate",
              title?: string | null,
              generatedVideo?:  {
                __typename: "CloudinaryResource",
                publicId: string,
              } | null,
            } | null,
          } | null,
          associatedColorHue?: number | null,
          footnote?: string | null,
        } | null,
        associatedColorHue?: number | null,
        footnote?: string | null,
      } | null >,
    } | null,
    reposts?:  {
      __typename: "ModelPostConnection",
      items:  Array< {
        __typename: "Post",
        createdAt: string,
        text: string,
        associatedTawk?:  {
          __typename: "TawkCandidate",
          ownerSub: string,
          localId: string,
          tawkVersion: string,
          title?: string | null,
          createdAt: string,
          author:  {
            __typename: "User",
            sub: string,
            name?: string | null,
            bio?: string | null,
            userHandle?:  {
              __typename: "UserHandle",
              standardForm: string,
              renderedForm: string,
            } | null,
            profilePhoto:  {
              __typename: "CloudinaryResource",
              publicId: string,
            },
          },
          duration?: number | null,
          rawAudio:  {
            __typename: "CloudinaryResource",
            publicId: string,
          },
          processedAudio?:  {
            __typename: "CloudinaryResource",
            publicId: string,
          } | null,
          generatedVideo?:  {
            __typename: "CloudinaryResource",
            publicId: string,
          } | null,
        } | null,
        associatedExternalTawk?:  {
          __typename: "ExternalTawk",
          id: string,
          inserter_sub: string,
          inserter:  {
            __typename: "User",
            sub: string,
            name?: string | null,
            bio?: string | null,
            userHandle?:  {
              __typename: "UserHandle",
              standardForm: string,
              renderedForm: string,
            } | null,
            profilePhoto:  {
              __typename: "CloudinaryResource",
              publicId: string,
            },
          },
          title: string,
          audioFileUrl: string,
          duration: number,
          originUrl: string,
          originKind: ExternalTawk_OriginKind,
          originName: string,
          originCreatedAt: string,
          picture:  {
            __typename: "GenericImage",
            imageUrl: string,
            cloudinaryImage?:  {
              __typename: "CloudinaryResource",
              publicId: string,
            } | null,
          },
          createdAt: string,
        } | null,
        author:  {
          __typename: "User",
          name?: string | null,
          sub: string,
          userHandle?:  {
            __typename: "UserHandle",
            renderedForm: string,
          } | null,
          profilePhoto:  {
            __typename: "CloudinaryResource",
            publicId: string,
          },
        },
        likesCount: number,
        repliesCount: number,
        id: string,
        repostedPost_id?: string | null,
        repostedTimeRange?:  {
          __typename: "ClipTimeRange",
          endTime: number,
          startTime: number,
        } | null,
        repostedPost?:  {
          __typename: "Post",
          id: string,
          createdAt: string,
          text: string,
          author:  {
            __typename: "User",
            name?: string | null,
            sub: string,
            userHandle?:  {
              __typename: "UserHandle",
              renderedForm: string,
            } | null,
            profilePhoto:  {
              __typename: "CloudinaryResource",
              publicId: string,
            },
          },
          associatedTawk?:  {
            __typename: "TawkCandidate",
            title?: string | null,
            generatedVideo?:  {
              __typename: "CloudinaryResource",
              publicId: string,
            } | null,
            ownerSub: string,
            localId: string,
            tawkVersion: string,
            createdAt: string,
            author:  {
              __typename: "User",
              sub: string,
              name?: string | null,
              bio?: string | null,
              userHandle?:  {
                __typename: "UserHandle",
                standardForm: string,
                renderedForm: string,
              } | null,
              profilePhoto:  {
                __typename: "CloudinaryResource",
                publicId: string,
              },
            },
            duration?: number | null,
            rawAudio:  {
              __typename: "CloudinaryResource",
              publicId: string,
            },
            processedAudio?:  {
              __typename: "CloudinaryResource",
              publicId: string,
            } | null,
          } | null,
          associatedExternalTawk?:  {
            __typename: "ExternalTawk",
            id: string,
            inserter_sub: string,
            inserter:  {
              __typename: "User",
              sub: string,
              name?: string | null,
              bio?: string | null,
              userHandle?:  {
                __typename: "UserHandle",
                standardForm: string,
                renderedForm: string,
              } | null,
              profilePhoto:  {
                __typename: "CloudinaryResource",
                publicId: string,
              },
            },
            title: string,
            audioFileUrl: string,
            duration: number,
            originUrl: string,
            originKind: ExternalTawk_OriginKind,
            originName: string,
            originCreatedAt: string,
            picture:  {
              __typename: "GenericImage",
              imageUrl: string,
              cloudinaryImage?:  {
                __typename: "CloudinaryResource",
                publicId: string,
              } | null,
            },
            createdAt: string,
          } | null,
          likesCount: number,
          repliesCount: number,
          repostedPost_id?: string | null,
          repostedTimeRange?:  {
            __typename: "ClipTimeRange",
            endTime: number,
            startTime: number,
          } | null,
          repostedPost?:  {
            __typename: "Post",
            id: string,
            createdAt: string,
            text: string,
            author:  {
              __typename: "User",
              name?: string | null,
              sub: string,
              userHandle?:  {
                __typename: "UserHandle",
                renderedForm: string,
              } | null,
              profilePhoto:  {
                __typename: "CloudinaryResource",
                publicId: string,
              },
            },
            associatedTawk?:  {
              __typename: "TawkCandidate",
              title?: string | null,
              generatedVideo?:  {
                __typename: "CloudinaryResource",
                publicId: string,
              } | null,
            } | null,
          } | null,
          associatedColorHue?: number | null,
          footnote?: string | null,
        } | null,
        associatedColorHue?: number | null,
        footnote?: string | null,
      } | null >,
    } | null,
  } | null,
};

export type GetPostRepliesPaginatedQueryVariables = {
  postId: string,
  nextPageToken?: string | null,
};

export type GetPostRepliesPaginatedQuery = {
  getPost?:  {
    __typename: "Post",
    replies?:  {
      __typename: "ModelPostConnection",
      nextToken?: string | null,
      items:  Array< {
        __typename: "Post",
        createdAt: string,
        text: string,
        associatedTawk?:  {
          __typename: "TawkCandidate",
          ownerSub: string,
          localId: string,
          tawkVersion: string,
          title?: string | null,
          createdAt: string,
          author:  {
            __typename: "User",
            sub: string,
            name?: string | null,
            bio?: string | null,
            userHandle?:  {
              __typename: "UserHandle",
              standardForm: string,
              renderedForm: string,
            } | null,
            profilePhoto:  {
              __typename: "CloudinaryResource",
              publicId: string,
            },
          },
          duration?: number | null,
          rawAudio:  {
            __typename: "CloudinaryResource",
            publicId: string,
          },
          processedAudio?:  {
            __typename: "CloudinaryResource",
            publicId: string,
          } | null,
          generatedVideo?:  {
            __typename: "CloudinaryResource",
            publicId: string,
          } | null,
        } | null,
        associatedExternalTawk?:  {
          __typename: "ExternalTawk",
          id: string,
          inserter_sub: string,
          inserter:  {
            __typename: "User",
            sub: string,
            name?: string | null,
            bio?: string | null,
            userHandle?:  {
              __typename: "UserHandle",
              standardForm: string,
              renderedForm: string,
            } | null,
            profilePhoto:  {
              __typename: "CloudinaryResource",
              publicId: string,
            },
          },
          title: string,
          audioFileUrl: string,
          duration: number,
          originUrl: string,
          originKind: ExternalTawk_OriginKind,
          originName: string,
          originCreatedAt: string,
          picture:  {
            __typename: "GenericImage",
            imageUrl: string,
            cloudinaryImage?:  {
              __typename: "CloudinaryResource",
              publicId: string,
            } | null,
          },
          createdAt: string,
        } | null,
        author:  {
          __typename: "User",
          name?: string | null,
          sub: string,
          userHandle?:  {
            __typename: "UserHandle",
            renderedForm: string,
          } | null,
          profilePhoto:  {
            __typename: "CloudinaryResource",
            publicId: string,
          },
        },
        likesCount: number,
        repliesCount: number,
        id: string,
        repostedPost_id?: string | null,
        repostedTimeRange?:  {
          __typename: "ClipTimeRange",
          endTime: number,
          startTime: number,
        } | null,
        repostedPost?:  {
          __typename: "Post",
          id: string,
          createdAt: string,
          text: string,
          author:  {
            __typename: "User",
            name?: string | null,
            sub: string,
            userHandle?:  {
              __typename: "UserHandle",
              renderedForm: string,
            } | null,
            profilePhoto:  {
              __typename: "CloudinaryResource",
              publicId: string,
            },
          },
          associatedTawk?:  {
            __typename: "TawkCandidate",
            title?: string | null,
            generatedVideo?:  {
              __typename: "CloudinaryResource",
              publicId: string,
            } | null,
            ownerSub: string,
            localId: string,
            tawkVersion: string,
            createdAt: string,
            author:  {
              __typename: "User",
              sub: string,
              name?: string | null,
              bio?: string | null,
              userHandle?:  {
                __typename: "UserHandle",
                standardForm: string,
                renderedForm: string,
              } | null,
              profilePhoto:  {
                __typename: "CloudinaryResource",
                publicId: string,
              },
            },
            duration?: number | null,
            rawAudio:  {
              __typename: "CloudinaryResource",
              publicId: string,
            },
            processedAudio?:  {
              __typename: "CloudinaryResource",
              publicId: string,
            } | null,
          } | null,
          associatedExternalTawk?:  {
            __typename: "ExternalTawk",
            id: string,
            inserter_sub: string,
            inserter:  {
              __typename: "User",
              sub: string,
              name?: string | null,
              bio?: string | null,
              userHandle?:  {
                __typename: "UserHandle",
                standardForm: string,
                renderedForm: string,
              } | null,
              profilePhoto:  {
                __typename: "CloudinaryResource",
                publicId: string,
              },
            },
            title: string,
            audioFileUrl: string,
            duration: number,
            originUrl: string,
            originKind: ExternalTawk_OriginKind,
            originName: string,
            originCreatedAt: string,
            picture:  {
              __typename: "GenericImage",
              imageUrl: string,
              cloudinaryImage?:  {
                __typename: "CloudinaryResource",
                publicId: string,
              } | null,
            },
            createdAt: string,
          } | null,
          likesCount: number,
          repliesCount: number,
          repostedPost_id?: string | null,
          repostedTimeRange?:  {
            __typename: "ClipTimeRange",
            endTime: number,
            startTime: number,
          } | null,
          repostedPost?:  {
            __typename: "Post",
            id: string,
            createdAt: string,
            text: string,
            author:  {
              __typename: "User",
              name?: string | null,
              sub: string,
              userHandle?:  {
                __typename: "UserHandle",
                renderedForm: string,
              } | null,
              profilePhoto:  {
                __typename: "CloudinaryResource",
                publicId: string,
              },
            },
            associatedTawk?:  {
              __typename: "TawkCandidate",
              title?: string | null,
              generatedVideo?:  {
                __typename: "CloudinaryResource",
                publicId: string,
              } | null,
            } | null,
          } | null,
          associatedColorHue?: number | null,
          footnote?: string | null,
        } | null,
        associatedColorHue?: number | null,
        footnote?: string | null,
        replies?:  {
          __typename: "ModelPostConnection",
          items:  Array< {
            __typename: "Post",
            createdAt: string,
            text: string,
            associatedTawk?:  {
              __typename: "TawkCandidate",
              ownerSub: string,
              localId: string,
              tawkVersion: string,
              title?: string | null,
              createdAt: string,
              author:  {
                __typename: "User",
                sub: string,
                name?: string | null,
                bio?: string | null,
                userHandle?:  {
                  __typename: "UserHandle",
                  standardForm: string,
                  renderedForm: string,
                } | null,
                profilePhoto:  {
                  __typename: "CloudinaryResource",
                  publicId: string,
                },
              },
              duration?: number | null,
              rawAudio:  {
                __typename: "CloudinaryResource",
                publicId: string,
              },
              processedAudio?:  {
                __typename: "CloudinaryResource",
                publicId: string,
              } | null,
              generatedVideo?:  {
                __typename: "CloudinaryResource",
                publicId: string,
              } | null,
            } | null,
            associatedExternalTawk?:  {
              __typename: "ExternalTawk",
              id: string,
              inserter_sub: string,
              inserter:  {
                __typename: "User",
                sub: string,
                name?: string | null,
                bio?: string | null,
                userHandle?:  {
                  __typename: "UserHandle",
                  standardForm: string,
                  renderedForm: string,
                } | null,
                profilePhoto:  {
                  __typename: "CloudinaryResource",
                  publicId: string,
                },
              },
              title: string,
              audioFileUrl: string,
              duration: number,
              originUrl: string,
              originKind: ExternalTawk_OriginKind,
              originName: string,
              originCreatedAt: string,
              picture:  {
                __typename: "GenericImage",
                imageUrl: string,
                cloudinaryImage?:  {
                  __typename: "CloudinaryResource",
                  publicId: string,
                } | null,
              },
              createdAt: string,
            } | null,
            author:  {
              __typename: "User",
              name?: string | null,
              sub: string,
              userHandle?:  {
                __typename: "UserHandle",
                renderedForm: string,
              } | null,
              profilePhoto:  {
                __typename: "CloudinaryResource",
                publicId: string,
              },
            },
            likesCount: number,
            repliesCount: number,
            id: string,
            repostedPost_id?: string | null,
            repostedTimeRange?:  {
              __typename: "ClipTimeRange",
              endTime: number,
              startTime: number,
            } | null,
            repostedPost?:  {
              __typename: "Post",
              id: string,
              createdAt: string,
              text: string,
              author:  {
                __typename: "User",
                name?: string | null,
                sub: string,
                userHandle?:  {
                  __typename: "UserHandle",
                  renderedForm: string,
                } | null,
                profilePhoto:  {
                  __typename: "CloudinaryResource",
                  publicId: string,
                },
              },
              associatedTawk?:  {
                __typename: "TawkCandidate",
                title?: string | null,
                generatedVideo?:  {
                  __typename: "CloudinaryResource",
                  publicId: string,
                } | null,
                ownerSub: string,
                localId: string,
                tawkVersion: string,
                createdAt: string,
                author:  {
                  __typename: "User",
                  sub: string,
                  name?: string | null,
                  bio?: string | null,
                  userHandle?:  {
                    __typename: "UserHandle",
                    standardForm: string,
                    renderedForm: string,
                  } | null,
                  profilePhoto:  {
                    __typename: "CloudinaryResource",
                    publicId: string,
                  },
                },
                duration?: number | null,
                rawAudio:  {
                  __typename: "CloudinaryResource",
                  publicId: string,
                },
                processedAudio?:  {
                  __typename: "CloudinaryResource",
                  publicId: string,
                } | null,
              } | null,
              associatedExternalTawk?:  {
                __typename: "ExternalTawk",
                id: string,
                inserter_sub: string,
                inserter:  {
                  __typename: "User",
                  sub: string,
                  name?: string | null,
                  bio?: string | null,
                  userHandle?:  {
                    __typename: "UserHandle",
                    standardForm: string,
                    renderedForm: string,
                  } | null,
                  profilePhoto:  {
                    __typename: "CloudinaryResource",
                    publicId: string,
                  },
                },
                title: string,
                audioFileUrl: string,
                duration: number,
                originUrl: string,
                originKind: ExternalTawk_OriginKind,
                originName: string,
                originCreatedAt: string,
                picture:  {
                  __typename: "GenericImage",
                  imageUrl: string,
                  cloudinaryImage?:  {
                    __typename: "CloudinaryResource",
                    publicId: string,
                  } | null,
                },
                createdAt: string,
              } | null,
              likesCount: number,
              repliesCount: number,
              repostedPost_id?: string | null,
              repostedTimeRange?:  {
                __typename: "ClipTimeRange",
                endTime: number,
                startTime: number,
              } | null,
              repostedPost?:  {
                __typename: "Post",
                id: string,
                createdAt: string,
                text: string,
                author:  {
                  __typename: "User",
                  name?: string | null,
                  sub: string,
                  userHandle?:  {
                    __typename: "UserHandle",
                    renderedForm: string,
                  } | null,
                  profilePhoto:  {
                    __typename: "CloudinaryResource",
                    publicId: string,
                  },
                },
                associatedTawk?:  {
                  __typename: "TawkCandidate",
                  title?: string | null,
                  generatedVideo?:  {
                    __typename: "CloudinaryResource",
                    publicId: string,
                  } | null,
                } | null,
              } | null,
              associatedColorHue?: number | null,
              footnote?: string | null,
            } | null,
            associatedColorHue?: number | null,
            footnote?: string | null,
          } | null >,
        } | null,
        reposts?:  {
          __typename: "ModelPostConnection",
          items:  Array< {
            __typename: "Post",
            createdAt: string,
            text: string,
            associatedTawk?:  {
              __typename: "TawkCandidate",
              ownerSub: string,
              localId: string,
              tawkVersion: string,
              title?: string | null,
              createdAt: string,
              author:  {
                __typename: "User",
                sub: string,
                name?: string | null,
                bio?: string | null,
                userHandle?:  {
                  __typename: "UserHandle",
                  standardForm: string,
                  renderedForm: string,
                } | null,
                profilePhoto:  {
                  __typename: "CloudinaryResource",
                  publicId: string,
                },
              },
              duration?: number | null,
              rawAudio:  {
                __typename: "CloudinaryResource",
                publicId: string,
              },
              processedAudio?:  {
                __typename: "CloudinaryResource",
                publicId: string,
              } | null,
              generatedVideo?:  {
                __typename: "CloudinaryResource",
                publicId: string,
              } | null,
            } | null,
            associatedExternalTawk?:  {
              __typename: "ExternalTawk",
              id: string,
              inserter_sub: string,
              inserter:  {
                __typename: "User",
                sub: string,
                name?: string | null,
                bio?: string | null,
                userHandle?:  {
                  __typename: "UserHandle",
                  standardForm: string,
                  renderedForm: string,
                } | null,
                profilePhoto:  {
                  __typename: "CloudinaryResource",
                  publicId: string,
                },
              },
              title: string,
              audioFileUrl: string,
              duration: number,
              originUrl: string,
              originKind: ExternalTawk_OriginKind,
              originName: string,
              originCreatedAt: string,
              picture:  {
                __typename: "GenericImage",
                imageUrl: string,
                cloudinaryImage?:  {
                  __typename: "CloudinaryResource",
                  publicId: string,
                } | null,
              },
              createdAt: string,
            } | null,
            author:  {
              __typename: "User",
              name?: string | null,
              sub: string,
              userHandle?:  {
                __typename: "UserHandle",
                renderedForm: string,
              } | null,
              profilePhoto:  {
                __typename: "CloudinaryResource",
                publicId: string,
              },
            },
            likesCount: number,
            repliesCount: number,
            id: string,
            repostedPost_id?: string | null,
            repostedTimeRange?:  {
              __typename: "ClipTimeRange",
              endTime: number,
              startTime: number,
            } | null,
            repostedPost?:  {
              __typename: "Post",
              id: string,
              createdAt: string,
              text: string,
              author:  {
                __typename: "User",
                name?: string | null,
                sub: string,
                userHandle?:  {
                  __typename: "UserHandle",
                  renderedForm: string,
                } | null,
                profilePhoto:  {
                  __typename: "CloudinaryResource",
                  publicId: string,
                },
              },
              associatedTawk?:  {
                __typename: "TawkCandidate",
                title?: string | null,
                generatedVideo?:  {
                  __typename: "CloudinaryResource",
                  publicId: string,
                } | null,
                ownerSub: string,
                localId: string,
                tawkVersion: string,
                createdAt: string,
                author:  {
                  __typename: "User",
                  sub: string,
                  name?: string | null,
                  bio?: string | null,
                  userHandle?:  {
                    __typename: "UserHandle",
                    standardForm: string,
                    renderedForm: string,
                  } | null,
                  profilePhoto:  {
                    __typename: "CloudinaryResource",
                    publicId: string,
                  },
                },
                duration?: number | null,
                rawAudio:  {
                  __typename: "CloudinaryResource",
                  publicId: string,
                },
                processedAudio?:  {
                  __typename: "CloudinaryResource",
                  publicId: string,
                } | null,
              } | null,
              associatedExternalTawk?:  {
                __typename: "ExternalTawk",
                id: string,
                inserter_sub: string,
                inserter:  {
                  __typename: "User",
                  sub: string,
                  name?: string | null,
                  bio?: string | null,
                  userHandle?:  {
                    __typename: "UserHandle",
                    standardForm: string,
                    renderedForm: string,
                  } | null,
                  profilePhoto:  {
                    __typename: "CloudinaryResource",
                    publicId: string,
                  },
                },
                title: string,
                audioFileUrl: string,
                duration: number,
                originUrl: string,
                originKind: ExternalTawk_OriginKind,
                originName: string,
                originCreatedAt: string,
                picture:  {
                  __typename: "GenericImage",
                  imageUrl: string,
                  cloudinaryImage?:  {
                    __typename: "CloudinaryResource",
                    publicId: string,
                  } | null,
                },
                createdAt: string,
              } | null,
              likesCount: number,
              repliesCount: number,
              repostedPost_id?: string | null,
              repostedTimeRange?:  {
                __typename: "ClipTimeRange",
                endTime: number,
                startTime: number,
              } | null,
              repostedPost?:  {
                __typename: "Post",
                id: string,
                createdAt: string,
                text: string,
                author:  {
                  __typename: "User",
                  name?: string | null,
                  sub: string,
                  userHandle?:  {
                    __typename: "UserHandle",
                    renderedForm: string,
                  } | null,
                  profilePhoto:  {
                    __typename: "CloudinaryResource",
                    publicId: string,
                  },
                },
                associatedTawk?:  {
                  __typename: "TawkCandidate",
                  title?: string | null,
                  generatedVideo?:  {
                    __typename: "CloudinaryResource",
                    publicId: string,
                  } | null,
                } | null,
              } | null,
              associatedColorHue?: number | null,
              footnote?: string | null,
            } | null,
            associatedColorHue?: number | null,
            footnote?: string | null,
          } | null >,
        } | null,
      } | null >,
    } | null,
  } | null,
};

export type GetPostEchoesPaginatedQueryVariables = {
  postId: string,
  nextPageToken?: string | null,
};

export type GetPostEchoesPaginatedQuery = {
  searchPosts?:  {
    __typename: "SearchablePostConnection",
    nextToken?: string | null,
    items:  Array< {
      __typename: "Post",
      createdAt: string,
      text: string,
      associatedTawk?:  {
        __typename: "TawkCandidate",
        ownerSub: string,
        localId: string,
        tawkVersion: string,
        title?: string | null,
        createdAt: string,
        author:  {
          __typename: "User",
          sub: string,
          name?: string | null,
          bio?: string | null,
          userHandle?:  {
            __typename: "UserHandle",
            standardForm: string,
            renderedForm: string,
          } | null,
          profilePhoto:  {
            __typename: "CloudinaryResource",
            publicId: string,
          },
        },
        duration?: number | null,
        rawAudio:  {
          __typename: "CloudinaryResource",
          publicId: string,
        },
        processedAudio?:  {
          __typename: "CloudinaryResource",
          publicId: string,
        } | null,
        generatedVideo?:  {
          __typename: "CloudinaryResource",
          publicId: string,
        } | null,
      } | null,
      associatedExternalTawk?:  {
        __typename: "ExternalTawk",
        id: string,
        inserter_sub: string,
        inserter:  {
          __typename: "User",
          sub: string,
          name?: string | null,
          bio?: string | null,
          userHandle?:  {
            __typename: "UserHandle",
            standardForm: string,
            renderedForm: string,
          } | null,
          profilePhoto:  {
            __typename: "CloudinaryResource",
            publicId: string,
          },
        },
        title: string,
        audioFileUrl: string,
        duration: number,
        originUrl: string,
        originKind: ExternalTawk_OriginKind,
        originName: string,
        originCreatedAt: string,
        picture:  {
          __typename: "GenericImage",
          imageUrl: string,
          cloudinaryImage?:  {
            __typename: "CloudinaryResource",
            publicId: string,
          } | null,
        },
        createdAt: string,
      } | null,
      author:  {
        __typename: "User",
        name?: string | null,
        sub: string,
        userHandle?:  {
          __typename: "UserHandle",
          renderedForm: string,
        } | null,
        profilePhoto:  {
          __typename: "CloudinaryResource",
          publicId: string,
        },
      },
      likesCount: number,
      repliesCount: number,
      id: string,
      repostedPost_id?: string | null,
      repostedTimeRange?:  {
        __typename: "ClipTimeRange",
        endTime: number,
        startTime: number,
      } | null,
      repostedPost?:  {
        __typename: "Post",
        id: string,
        createdAt: string,
        text: string,
        author:  {
          __typename: "User",
          name?: string | null,
          sub: string,
          userHandle?:  {
            __typename: "UserHandle",
            renderedForm: string,
          } | null,
          profilePhoto:  {
            __typename: "CloudinaryResource",
            publicId: string,
          },
        },
        associatedTawk?:  {
          __typename: "TawkCandidate",
          title?: string | null,
          generatedVideo?:  {
            __typename: "CloudinaryResource",
            publicId: string,
          } | null,
          ownerSub: string,
          localId: string,
          tawkVersion: string,
          createdAt: string,
          author:  {
            __typename: "User",
            sub: string,
            name?: string | null,
            bio?: string | null,
            userHandle?:  {
              __typename: "UserHandle",
              standardForm: string,
              renderedForm: string,
            } | null,
            profilePhoto:  {
              __typename: "CloudinaryResource",
              publicId: string,
            },
          },
          duration?: number | null,
          rawAudio:  {
            __typename: "CloudinaryResource",
            publicId: string,
          },
          processedAudio?:  {
            __typename: "CloudinaryResource",
            publicId: string,
          } | null,
        } | null,
        associatedExternalTawk?:  {
          __typename: "ExternalTawk",
          id: string,
          inserter_sub: string,
          inserter:  {
            __typename: "User",
            sub: string,
            name?: string | null,
            bio?: string | null,
            userHandle?:  {
              __typename: "UserHandle",
              standardForm: string,
              renderedForm: string,
            } | null,
            profilePhoto:  {
              __typename: "CloudinaryResource",
              publicId: string,
            },
          },
          title: string,
          audioFileUrl: string,
          duration: number,
          originUrl: string,
          originKind: ExternalTawk_OriginKind,
          originName: string,
          originCreatedAt: string,
          picture:  {
            __typename: "GenericImage",
            imageUrl: string,
            cloudinaryImage?:  {
              __typename: "CloudinaryResource",
              publicId: string,
            } | null,
          },
          createdAt: string,
        } | null,
        likesCount: number,
        repliesCount: number,
        repostedPost_id?: string | null,
        repostedTimeRange?:  {
          __typename: "ClipTimeRange",
          endTime: number,
          startTime: number,
        } | null,
        repostedPost?:  {
          __typename: "Post",
          id: string,
          createdAt: string,
          text: string,
          author:  {
            __typename: "User",
            name?: string | null,
            sub: string,
            userHandle?:  {
              __typename: "UserHandle",
              renderedForm: string,
            } | null,
            profilePhoto:  {
              __typename: "CloudinaryResource",
              publicId: string,
            },
          },
          associatedTawk?:  {
            __typename: "TawkCandidate",
            title?: string | null,
            generatedVideo?:  {
              __typename: "CloudinaryResource",
              publicId: string,
            } | null,
          } | null,
        } | null,
        associatedColorHue?: number | null,
        footnote?: string | null,
      } | null,
      associatedColorHue?: number | null,
      footnote?: string | null,
      replies?:  {
        __typename: "ModelPostConnection",
        items:  Array< {
          __typename: "Post",
          createdAt: string,
          text: string,
          associatedTawk?:  {
            __typename: "TawkCandidate",
            ownerSub: string,
            localId: string,
            tawkVersion: string,
            title?: string | null,
            createdAt: string,
            author:  {
              __typename: "User",
              sub: string,
              name?: string | null,
              bio?: string | null,
              userHandle?:  {
                __typename: "UserHandle",
                standardForm: string,
                renderedForm: string,
              } | null,
              profilePhoto:  {
                __typename: "CloudinaryResource",
                publicId: string,
              },
            },
            duration?: number | null,
            rawAudio:  {
              __typename: "CloudinaryResource",
              publicId: string,
            },
            processedAudio?:  {
              __typename: "CloudinaryResource",
              publicId: string,
            } | null,
            generatedVideo?:  {
              __typename: "CloudinaryResource",
              publicId: string,
            } | null,
          } | null,
          associatedExternalTawk?:  {
            __typename: "ExternalTawk",
            id: string,
            inserter_sub: string,
            inserter:  {
              __typename: "User",
              sub: string,
              name?: string | null,
              bio?: string | null,
              userHandle?:  {
                __typename: "UserHandle",
                standardForm: string,
                renderedForm: string,
              } | null,
              profilePhoto:  {
                __typename: "CloudinaryResource",
                publicId: string,
              },
            },
            title: string,
            audioFileUrl: string,
            duration: number,
            originUrl: string,
            originKind: ExternalTawk_OriginKind,
            originName: string,
            originCreatedAt: string,
            picture:  {
              __typename: "GenericImage",
              imageUrl: string,
              cloudinaryImage?:  {
                __typename: "CloudinaryResource",
                publicId: string,
              } | null,
            },
            createdAt: string,
          } | null,
          author:  {
            __typename: "User",
            name?: string | null,
            sub: string,
            userHandle?:  {
              __typename: "UserHandle",
              renderedForm: string,
            } | null,
            profilePhoto:  {
              __typename: "CloudinaryResource",
              publicId: string,
            },
          },
          likesCount: number,
          repliesCount: number,
          id: string,
          repostedPost_id?: string | null,
          repostedTimeRange?:  {
            __typename: "ClipTimeRange",
            endTime: number,
            startTime: number,
          } | null,
          repostedPost?:  {
            __typename: "Post",
            id: string,
            createdAt: string,
            text: string,
            author:  {
              __typename: "User",
              name?: string | null,
              sub: string,
              userHandle?:  {
                __typename: "UserHandle",
                renderedForm: string,
              } | null,
              profilePhoto:  {
                __typename: "CloudinaryResource",
                publicId: string,
              },
            },
            associatedTawk?:  {
              __typename: "TawkCandidate",
              title?: string | null,
              generatedVideo?:  {
                __typename: "CloudinaryResource",
                publicId: string,
              } | null,
              ownerSub: string,
              localId: string,
              tawkVersion: string,
              createdAt: string,
              author:  {
                __typename: "User",
                sub: string,
                name?: string | null,
                bio?: string | null,
                userHandle?:  {
                  __typename: "UserHandle",
                  standardForm: string,
                  renderedForm: string,
                } | null,
                profilePhoto:  {
                  __typename: "CloudinaryResource",
                  publicId: string,
                },
              },
              duration?: number | null,
              rawAudio:  {
                __typename: "CloudinaryResource",
                publicId: string,
              },
              processedAudio?:  {
                __typename: "CloudinaryResource",
                publicId: string,
              } | null,
            } | null,
            associatedExternalTawk?:  {
              __typename: "ExternalTawk",
              id: string,
              inserter_sub: string,
              inserter:  {
                __typename: "User",
                sub: string,
                name?: string | null,
                bio?: string | null,
                userHandle?:  {
                  __typename: "UserHandle",
                  standardForm: string,
                  renderedForm: string,
                } | null,
                profilePhoto:  {
                  __typename: "CloudinaryResource",
                  publicId: string,
                },
              },
              title: string,
              audioFileUrl: string,
              duration: number,
              originUrl: string,
              originKind: ExternalTawk_OriginKind,
              originName: string,
              originCreatedAt: string,
              picture:  {
                __typename: "GenericImage",
                imageUrl: string,
                cloudinaryImage?:  {
                  __typename: "CloudinaryResource",
                  publicId: string,
                } | null,
              },
              createdAt: string,
            } | null,
            likesCount: number,
            repliesCount: number,
            repostedPost_id?: string | null,
            repostedTimeRange?:  {
              __typename: "ClipTimeRange",
              endTime: number,
              startTime: number,
            } | null,
            repostedPost?:  {
              __typename: "Post",
              id: string,
              createdAt: string,
              text: string,
              author:  {
                __typename: "User",
                name?: string | null,
                sub: string,
                userHandle?:  {
                  __typename: "UserHandle",
                  renderedForm: string,
                } | null,
                profilePhoto:  {
                  __typename: "CloudinaryResource",
                  publicId: string,
                },
              },
              associatedTawk?:  {
                __typename: "TawkCandidate",
                title?: string | null,
                generatedVideo?:  {
                  __typename: "CloudinaryResource",
                  publicId: string,
                } | null,
              } | null,
            } | null,
            associatedColorHue?: number | null,
            footnote?: string | null,
          } | null,
          associatedColorHue?: number | null,
          footnote?: string | null,
        } | null >,
      } | null,
      reposts?:  {
        __typename: "ModelPostConnection",
        items:  Array< {
          __typename: "Post",
          createdAt: string,
          text: string,
          associatedTawk?:  {
            __typename: "TawkCandidate",
            ownerSub: string,
            localId: string,
            tawkVersion: string,
            title?: string | null,
            createdAt: string,
            author:  {
              __typename: "User",
              sub: string,
              name?: string | null,
              bio?: string | null,
              userHandle?:  {
                __typename: "UserHandle",
                standardForm: string,
                renderedForm: string,
              } | null,
              profilePhoto:  {
                __typename: "CloudinaryResource",
                publicId: string,
              },
            },
            duration?: number | null,
            rawAudio:  {
              __typename: "CloudinaryResource",
              publicId: string,
            },
            processedAudio?:  {
              __typename: "CloudinaryResource",
              publicId: string,
            } | null,
            generatedVideo?:  {
              __typename: "CloudinaryResource",
              publicId: string,
            } | null,
          } | null,
          associatedExternalTawk?:  {
            __typename: "ExternalTawk",
            id: string,
            inserter_sub: string,
            inserter:  {
              __typename: "User",
              sub: string,
              name?: string | null,
              bio?: string | null,
              userHandle?:  {
                __typename: "UserHandle",
                standardForm: string,
                renderedForm: string,
              } | null,
              profilePhoto:  {
                __typename: "CloudinaryResource",
                publicId: string,
              },
            },
            title: string,
            audioFileUrl: string,
            duration: number,
            originUrl: string,
            originKind: ExternalTawk_OriginKind,
            originName: string,
            originCreatedAt: string,
            picture:  {
              __typename: "GenericImage",
              imageUrl: string,
              cloudinaryImage?:  {
                __typename: "CloudinaryResource",
                publicId: string,
              } | null,
            },
            createdAt: string,
          } | null,
          author:  {
            __typename: "User",
            name?: string | null,
            sub: string,
            userHandle?:  {
              __typename: "UserHandle",
              renderedForm: string,
            } | null,
            profilePhoto:  {
              __typename: "CloudinaryResource",
              publicId: string,
            },
          },
          likesCount: number,
          repliesCount: number,
          id: string,
          repostedPost_id?: string | null,
          repostedTimeRange?:  {
            __typename: "ClipTimeRange",
            endTime: number,
            startTime: number,
          } | null,
          repostedPost?:  {
            __typename: "Post",
            id: string,
            createdAt: string,
            text: string,
            author:  {
              __typename: "User",
              name?: string | null,
              sub: string,
              userHandle?:  {
                __typename: "UserHandle",
                renderedForm: string,
              } | null,
              profilePhoto:  {
                __typename: "CloudinaryResource",
                publicId: string,
              },
            },
            associatedTawk?:  {
              __typename: "TawkCandidate",
              title?: string | null,
              generatedVideo?:  {
                __typename: "CloudinaryResource",
                publicId: string,
              } | null,
              ownerSub: string,
              localId: string,
              tawkVersion: string,
              createdAt: string,
              author:  {
                __typename: "User",
                sub: string,
                name?: string | null,
                bio?: string | null,
                userHandle?:  {
                  __typename: "UserHandle",
                  standardForm: string,
                  renderedForm: string,
                } | null,
                profilePhoto:  {
                  __typename: "CloudinaryResource",
                  publicId: string,
                },
              },
              duration?: number | null,
              rawAudio:  {
                __typename: "CloudinaryResource",
                publicId: string,
              },
              processedAudio?:  {
                __typename: "CloudinaryResource",
                publicId: string,
              } | null,
            } | null,
            associatedExternalTawk?:  {
              __typename: "ExternalTawk",
              id: string,
              inserter_sub: string,
              inserter:  {
                __typename: "User",
                sub: string,
                name?: string | null,
                bio?: string | null,
                userHandle?:  {
                  __typename: "UserHandle",
                  standardForm: string,
                  renderedForm: string,
                } | null,
                profilePhoto:  {
                  __typename: "CloudinaryResource",
                  publicId: string,
                },
              },
              title: string,
              audioFileUrl: string,
              duration: number,
              originUrl: string,
              originKind: ExternalTawk_OriginKind,
              originName: string,
              originCreatedAt: string,
              picture:  {
                __typename: "GenericImage",
                imageUrl: string,
                cloudinaryImage?:  {
                  __typename: "CloudinaryResource",
                  publicId: string,
                } | null,
              },
              createdAt: string,
            } | null,
            likesCount: number,
            repliesCount: number,
            repostedPost_id?: string | null,
            repostedTimeRange?:  {
              __typename: "ClipTimeRange",
              endTime: number,
              startTime: number,
            } | null,
            repostedPost?:  {
              __typename: "Post",
              id: string,
              createdAt: string,
              text: string,
              author:  {
                __typename: "User",
                name?: string | null,
                sub: string,
                userHandle?:  {
                  __typename: "UserHandle",
                  renderedForm: string,
                } | null,
                profilePhoto:  {
                  __typename: "CloudinaryResource",
                  publicId: string,
                },
              },
              associatedTawk?:  {
                __typename: "TawkCandidate",
                title?: string | null,
                generatedVideo?:  {
                  __typename: "CloudinaryResource",
                  publicId: string,
                } | null,
              } | null,
            } | null,
            associatedColorHue?: number | null,
            footnote?: string | null,
          } | null,
          associatedColorHue?: number | null,
          footnote?: string | null,
        } | null >,
      } | null,
    } | null >,
  } | null,
};

export type Get_Homepage_PostsQueryVariables = {
  post1: string,
  post2: string,
  post3: string,
  post4: string,
  post5: string,
  post6: string,
  post7: string,
  post8: string,
  post9: string,
  post10: string,
  post11: string,
  post12: string,
  post13: string,
  post14: string,
  post15: string,
  post16: string,
  post17: string,
  post18: string,
  post19: string,
  post20: string,
  post21: string,
  post22: string,
  post23: string,
};

export type Get_Homepage_PostsQuery = {
  post1?:  {
    __typename: "Post",
    createdAt: string,
    text: string,
    associatedTawk?:  {
      __typename: "TawkCandidate",
      ownerSub: string,
      localId: string,
      tawkVersion: string,
      title?: string | null,
      createdAt: string,
      author:  {
        __typename: "User",
        sub: string,
        name?: string | null,
        bio?: string | null,
        userHandle?:  {
          __typename: "UserHandle",
          standardForm: string,
          renderedForm: string,
        } | null,
        profilePhoto:  {
          __typename: "CloudinaryResource",
          publicId: string,
        },
      },
      duration?: number | null,
      rawAudio:  {
        __typename: "CloudinaryResource",
        publicId: string,
      },
      processedAudio?:  {
        __typename: "CloudinaryResource",
        publicId: string,
      } | null,
      generatedVideo?:  {
        __typename: "CloudinaryResource",
        publicId: string,
      } | null,
    } | null,
    associatedExternalTawk?:  {
      __typename: "ExternalTawk",
      id: string,
      inserter_sub: string,
      inserter:  {
        __typename: "User",
        sub: string,
        name?: string | null,
        bio?: string | null,
        userHandle?:  {
          __typename: "UserHandle",
          standardForm: string,
          renderedForm: string,
        } | null,
        profilePhoto:  {
          __typename: "CloudinaryResource",
          publicId: string,
        },
      },
      title: string,
      audioFileUrl: string,
      duration: number,
      originUrl: string,
      originKind: ExternalTawk_OriginKind,
      originName: string,
      originCreatedAt: string,
      picture:  {
        __typename: "GenericImage",
        imageUrl: string,
        cloudinaryImage?:  {
          __typename: "CloudinaryResource",
          publicId: string,
        } | null,
      },
      createdAt: string,
    } | null,
    author:  {
      __typename: "User",
      name?: string | null,
      sub: string,
      userHandle?:  {
        __typename: "UserHandle",
        renderedForm: string,
      } | null,
      profilePhoto:  {
        __typename: "CloudinaryResource",
        publicId: string,
      },
    },
    likesCount: number,
    repliesCount: number,
    id: string,
    repostedPost_id?: string | null,
    repostedTimeRange?:  {
      __typename: "ClipTimeRange",
      endTime: number,
      startTime: number,
    } | null,
    repostedPost?:  {
      __typename: "Post",
      id: string,
      createdAt: string,
      text: string,
      author:  {
        __typename: "User",
        name?: string | null,
        sub: string,
        userHandle?:  {
          __typename: "UserHandle",
          renderedForm: string,
        } | null,
        profilePhoto:  {
          __typename: "CloudinaryResource",
          publicId: string,
        },
      },
      associatedTawk?:  {
        __typename: "TawkCandidate",
        title?: string | null,
        generatedVideo?:  {
          __typename: "CloudinaryResource",
          publicId: string,
        } | null,
        ownerSub: string,
        localId: string,
        tawkVersion: string,
        createdAt: string,
        author:  {
          __typename: "User",
          sub: string,
          name?: string | null,
          bio?: string | null,
          userHandle?:  {
            __typename: "UserHandle",
            standardForm: string,
            renderedForm: string,
          } | null,
          profilePhoto:  {
            __typename: "CloudinaryResource",
            publicId: string,
          },
        },
        duration?: number | null,
        rawAudio:  {
          __typename: "CloudinaryResource",
          publicId: string,
        },
        processedAudio?:  {
          __typename: "CloudinaryResource",
          publicId: string,
        } | null,
      } | null,
      associatedExternalTawk?:  {
        __typename: "ExternalTawk",
        id: string,
        inserter_sub: string,
        inserter:  {
          __typename: "User",
          sub: string,
          name?: string | null,
          bio?: string | null,
          userHandle?:  {
            __typename: "UserHandle",
            standardForm: string,
            renderedForm: string,
          } | null,
          profilePhoto:  {
            __typename: "CloudinaryResource",
            publicId: string,
          },
        },
        title: string,
        audioFileUrl: string,
        duration: number,
        originUrl: string,
        originKind: ExternalTawk_OriginKind,
        originName: string,
        originCreatedAt: string,
        picture:  {
          __typename: "GenericImage",
          imageUrl: string,
          cloudinaryImage?:  {
            __typename: "CloudinaryResource",
            publicId: string,
          } | null,
        },
        createdAt: string,
      } | null,
      likesCount: number,
      repliesCount: number,
      repostedPost_id?: string | null,
      repostedTimeRange?:  {
        __typename: "ClipTimeRange",
        endTime: number,
        startTime: number,
      } | null,
      repostedPost?:  {
        __typename: "Post",
        id: string,
        createdAt: string,
        text: string,
        author:  {
          __typename: "User",
          name?: string | null,
          sub: string,
          userHandle?:  {
            __typename: "UserHandle",
            renderedForm: string,
          } | null,
          profilePhoto:  {
            __typename: "CloudinaryResource",
            publicId: string,
          },
        },
        associatedTawk?:  {
          __typename: "TawkCandidate",
          title?: string | null,
          generatedVideo?:  {
            __typename: "CloudinaryResource",
            publicId: string,
          } | null,
        } | null,
      } | null,
      associatedColorHue?: number | null,
      footnote?: string | null,
    } | null,
    associatedColorHue?: number | null,
    footnote?: string | null,
  } | null,
  post2?:  {
    __typename: "Post",
    createdAt: string,
    text: string,
    associatedTawk?:  {
      __typename: "TawkCandidate",
      ownerSub: string,
      localId: string,
      tawkVersion: string,
      title?: string | null,
      createdAt: string,
      author:  {
        __typename: "User",
        sub: string,
        name?: string | null,
        bio?: string | null,
        userHandle?:  {
          __typename: "UserHandle",
          standardForm: string,
          renderedForm: string,
        } | null,
        profilePhoto:  {
          __typename: "CloudinaryResource",
          publicId: string,
        },
      },
      duration?: number | null,
      rawAudio:  {
        __typename: "CloudinaryResource",
        publicId: string,
      },
      processedAudio?:  {
        __typename: "CloudinaryResource",
        publicId: string,
      } | null,
      generatedVideo?:  {
        __typename: "CloudinaryResource",
        publicId: string,
      } | null,
    } | null,
    associatedExternalTawk?:  {
      __typename: "ExternalTawk",
      id: string,
      inserter_sub: string,
      inserter:  {
        __typename: "User",
        sub: string,
        name?: string | null,
        bio?: string | null,
        userHandle?:  {
          __typename: "UserHandle",
          standardForm: string,
          renderedForm: string,
        } | null,
        profilePhoto:  {
          __typename: "CloudinaryResource",
          publicId: string,
        },
      },
      title: string,
      audioFileUrl: string,
      duration: number,
      originUrl: string,
      originKind: ExternalTawk_OriginKind,
      originName: string,
      originCreatedAt: string,
      picture:  {
        __typename: "GenericImage",
        imageUrl: string,
        cloudinaryImage?:  {
          __typename: "CloudinaryResource",
          publicId: string,
        } | null,
      },
      createdAt: string,
    } | null,
    author:  {
      __typename: "User",
      name?: string | null,
      sub: string,
      userHandle?:  {
        __typename: "UserHandle",
        renderedForm: string,
      } | null,
      profilePhoto:  {
        __typename: "CloudinaryResource",
        publicId: string,
      },
    },
    likesCount: number,
    repliesCount: number,
    id: string,
    repostedPost_id?: string | null,
    repostedTimeRange?:  {
      __typename: "ClipTimeRange",
      endTime: number,
      startTime: number,
    } | null,
    repostedPost?:  {
      __typename: "Post",
      id: string,
      createdAt: string,
      text: string,
      author:  {
        __typename: "User",
        name?: string | null,
        sub: string,
        userHandle?:  {
          __typename: "UserHandle",
          renderedForm: string,
        } | null,
        profilePhoto:  {
          __typename: "CloudinaryResource",
          publicId: string,
        },
      },
      associatedTawk?:  {
        __typename: "TawkCandidate",
        title?: string | null,
        generatedVideo?:  {
          __typename: "CloudinaryResource",
          publicId: string,
        } | null,
        ownerSub: string,
        localId: string,
        tawkVersion: string,
        createdAt: string,
        author:  {
          __typename: "User",
          sub: string,
          name?: string | null,
          bio?: string | null,
          userHandle?:  {
            __typename: "UserHandle",
            standardForm: string,
            renderedForm: string,
          } | null,
          profilePhoto:  {
            __typename: "CloudinaryResource",
            publicId: string,
          },
        },
        duration?: number | null,
        rawAudio:  {
          __typename: "CloudinaryResource",
          publicId: string,
        },
        processedAudio?:  {
          __typename: "CloudinaryResource",
          publicId: string,
        } | null,
      } | null,
      associatedExternalTawk?:  {
        __typename: "ExternalTawk",
        id: string,
        inserter_sub: string,
        inserter:  {
          __typename: "User",
          sub: string,
          name?: string | null,
          bio?: string | null,
          userHandle?:  {
            __typename: "UserHandle",
            standardForm: string,
            renderedForm: string,
          } | null,
          profilePhoto:  {
            __typename: "CloudinaryResource",
            publicId: string,
          },
        },
        title: string,
        audioFileUrl: string,
        duration: number,
        originUrl: string,
        originKind: ExternalTawk_OriginKind,
        originName: string,
        originCreatedAt: string,
        picture:  {
          __typename: "GenericImage",
          imageUrl: string,
          cloudinaryImage?:  {
            __typename: "CloudinaryResource",
            publicId: string,
          } | null,
        },
        createdAt: string,
      } | null,
      likesCount: number,
      repliesCount: number,
      repostedPost_id?: string | null,
      repostedTimeRange?:  {
        __typename: "ClipTimeRange",
        endTime: number,
        startTime: number,
      } | null,
      repostedPost?:  {
        __typename: "Post",
        id: string,
        createdAt: string,
        text: string,
        author:  {
          __typename: "User",
          name?: string | null,
          sub: string,
          userHandle?:  {
            __typename: "UserHandle",
            renderedForm: string,
          } | null,
          profilePhoto:  {
            __typename: "CloudinaryResource",
            publicId: string,
          },
        },
        associatedTawk?:  {
          __typename: "TawkCandidate",
          title?: string | null,
          generatedVideo?:  {
            __typename: "CloudinaryResource",
            publicId: string,
          } | null,
        } | null,
      } | null,
      associatedColorHue?: number | null,
      footnote?: string | null,
    } | null,
    associatedColorHue?: number | null,
    footnote?: string | null,
  } | null,
  post3?:  {
    __typename: "Post",
    createdAt: string,
    text: string,
    associatedTawk?:  {
      __typename: "TawkCandidate",
      ownerSub: string,
      localId: string,
      tawkVersion: string,
      title?: string | null,
      createdAt: string,
      author:  {
        __typename: "User",
        sub: string,
        name?: string | null,
        bio?: string | null,
        userHandle?:  {
          __typename: "UserHandle",
          standardForm: string,
          renderedForm: string,
        } | null,
        profilePhoto:  {
          __typename: "CloudinaryResource",
          publicId: string,
        },
      },
      duration?: number | null,
      rawAudio:  {
        __typename: "CloudinaryResource",
        publicId: string,
      },
      processedAudio?:  {
        __typename: "CloudinaryResource",
        publicId: string,
      } | null,
      generatedVideo?:  {
        __typename: "CloudinaryResource",
        publicId: string,
      } | null,
    } | null,
    associatedExternalTawk?:  {
      __typename: "ExternalTawk",
      id: string,
      inserter_sub: string,
      inserter:  {
        __typename: "User",
        sub: string,
        name?: string | null,
        bio?: string | null,
        userHandle?:  {
          __typename: "UserHandle",
          standardForm: string,
          renderedForm: string,
        } | null,
        profilePhoto:  {
          __typename: "CloudinaryResource",
          publicId: string,
        },
      },
      title: string,
      audioFileUrl: string,
      duration: number,
      originUrl: string,
      originKind: ExternalTawk_OriginKind,
      originName: string,
      originCreatedAt: string,
      picture:  {
        __typename: "GenericImage",
        imageUrl: string,
        cloudinaryImage?:  {
          __typename: "CloudinaryResource",
          publicId: string,
        } | null,
      },
      createdAt: string,
    } | null,
    author:  {
      __typename: "User",
      name?: string | null,
      sub: string,
      userHandle?:  {
        __typename: "UserHandle",
        renderedForm: string,
      } | null,
      profilePhoto:  {
        __typename: "CloudinaryResource",
        publicId: string,
      },
    },
    likesCount: number,
    repliesCount: number,
    id: string,
    repostedPost_id?: string | null,
    repostedTimeRange?:  {
      __typename: "ClipTimeRange",
      endTime: number,
      startTime: number,
    } | null,
    repostedPost?:  {
      __typename: "Post",
      id: string,
      createdAt: string,
      text: string,
      author:  {
        __typename: "User",
        name?: string | null,
        sub: string,
        userHandle?:  {
          __typename: "UserHandle",
          renderedForm: string,
        } | null,
        profilePhoto:  {
          __typename: "CloudinaryResource",
          publicId: string,
        },
      },
      associatedTawk?:  {
        __typename: "TawkCandidate",
        title?: string | null,
        generatedVideo?:  {
          __typename: "CloudinaryResource",
          publicId: string,
        } | null,
        ownerSub: string,
        localId: string,
        tawkVersion: string,
        createdAt: string,
        author:  {
          __typename: "User",
          sub: string,
          name?: string | null,
          bio?: string | null,
          userHandle?:  {
            __typename: "UserHandle",
            standardForm: string,
            renderedForm: string,
          } | null,
          profilePhoto:  {
            __typename: "CloudinaryResource",
            publicId: string,
          },
        },
        duration?: number | null,
        rawAudio:  {
          __typename: "CloudinaryResource",
          publicId: string,
        },
        processedAudio?:  {
          __typename: "CloudinaryResource",
          publicId: string,
        } | null,
      } | null,
      associatedExternalTawk?:  {
        __typename: "ExternalTawk",
        id: string,
        inserter_sub: string,
        inserter:  {
          __typename: "User",
          sub: string,
          name?: string | null,
          bio?: string | null,
          userHandle?:  {
            __typename: "UserHandle",
            standardForm: string,
            renderedForm: string,
          } | null,
          profilePhoto:  {
            __typename: "CloudinaryResource",
            publicId: string,
          },
        },
        title: string,
        audioFileUrl: string,
        duration: number,
        originUrl: string,
        originKind: ExternalTawk_OriginKind,
        originName: string,
        originCreatedAt: string,
        picture:  {
          __typename: "GenericImage",
          imageUrl: string,
          cloudinaryImage?:  {
            __typename: "CloudinaryResource",
            publicId: string,
          } | null,
        },
        createdAt: string,
      } | null,
      likesCount: number,
      repliesCount: number,
      repostedPost_id?: string | null,
      repostedTimeRange?:  {
        __typename: "ClipTimeRange",
        endTime: number,
        startTime: number,
      } | null,
      repostedPost?:  {
        __typename: "Post",
        id: string,
        createdAt: string,
        text: string,
        author:  {
          __typename: "User",
          name?: string | null,
          sub: string,
          userHandle?:  {
            __typename: "UserHandle",
            renderedForm: string,
          } | null,
          profilePhoto:  {
            __typename: "CloudinaryResource",
            publicId: string,
          },
        },
        associatedTawk?:  {
          __typename: "TawkCandidate",
          title?: string | null,
          generatedVideo?:  {
            __typename: "CloudinaryResource",
            publicId: string,
          } | null,
        } | null,
      } | null,
      associatedColorHue?: number | null,
      footnote?: string | null,
    } | null,
    associatedColorHue?: number | null,
    footnote?: string | null,
  } | null,
  post4?:  {
    __typename: "Post",
    createdAt: string,
    text: string,
    associatedTawk?:  {
      __typename: "TawkCandidate",
      ownerSub: string,
      localId: string,
      tawkVersion: string,
      title?: string | null,
      createdAt: string,
      author:  {
        __typename: "User",
        sub: string,
        name?: string | null,
        bio?: string | null,
        userHandle?:  {
          __typename: "UserHandle",
          standardForm: string,
          renderedForm: string,
        } | null,
        profilePhoto:  {
          __typename: "CloudinaryResource",
          publicId: string,
        },
      },
      duration?: number | null,
      rawAudio:  {
        __typename: "CloudinaryResource",
        publicId: string,
      },
      processedAudio?:  {
        __typename: "CloudinaryResource",
        publicId: string,
      } | null,
      generatedVideo?:  {
        __typename: "CloudinaryResource",
        publicId: string,
      } | null,
    } | null,
    associatedExternalTawk?:  {
      __typename: "ExternalTawk",
      id: string,
      inserter_sub: string,
      inserter:  {
        __typename: "User",
        sub: string,
        name?: string | null,
        bio?: string | null,
        userHandle?:  {
          __typename: "UserHandle",
          standardForm: string,
          renderedForm: string,
        } | null,
        profilePhoto:  {
          __typename: "CloudinaryResource",
          publicId: string,
        },
      },
      title: string,
      audioFileUrl: string,
      duration: number,
      originUrl: string,
      originKind: ExternalTawk_OriginKind,
      originName: string,
      originCreatedAt: string,
      picture:  {
        __typename: "GenericImage",
        imageUrl: string,
        cloudinaryImage?:  {
          __typename: "CloudinaryResource",
          publicId: string,
        } | null,
      },
      createdAt: string,
    } | null,
    author:  {
      __typename: "User",
      name?: string | null,
      sub: string,
      userHandle?:  {
        __typename: "UserHandle",
        renderedForm: string,
      } | null,
      profilePhoto:  {
        __typename: "CloudinaryResource",
        publicId: string,
      },
    },
    likesCount: number,
    repliesCount: number,
    id: string,
    repostedPost_id?: string | null,
    repostedTimeRange?:  {
      __typename: "ClipTimeRange",
      endTime: number,
      startTime: number,
    } | null,
    repostedPost?:  {
      __typename: "Post",
      id: string,
      createdAt: string,
      text: string,
      author:  {
        __typename: "User",
        name?: string | null,
        sub: string,
        userHandle?:  {
          __typename: "UserHandle",
          renderedForm: string,
        } | null,
        profilePhoto:  {
          __typename: "CloudinaryResource",
          publicId: string,
        },
      },
      associatedTawk?:  {
        __typename: "TawkCandidate",
        title?: string | null,
        generatedVideo?:  {
          __typename: "CloudinaryResource",
          publicId: string,
        } | null,
        ownerSub: string,
        localId: string,
        tawkVersion: string,
        createdAt: string,
        author:  {
          __typename: "User",
          sub: string,
          name?: string | null,
          bio?: string | null,
          userHandle?:  {
            __typename: "UserHandle",
            standardForm: string,
            renderedForm: string,
          } | null,
          profilePhoto:  {
            __typename: "CloudinaryResource",
            publicId: string,
          },
        },
        duration?: number | null,
        rawAudio:  {
          __typename: "CloudinaryResource",
          publicId: string,
        },
        processedAudio?:  {
          __typename: "CloudinaryResource",
          publicId: string,
        } | null,
      } | null,
      associatedExternalTawk?:  {
        __typename: "ExternalTawk",
        id: string,
        inserter_sub: string,
        inserter:  {
          __typename: "User",
          sub: string,
          name?: string | null,
          bio?: string | null,
          userHandle?:  {
            __typename: "UserHandle",
            standardForm: string,
            renderedForm: string,
          } | null,
          profilePhoto:  {
            __typename: "CloudinaryResource",
            publicId: string,
          },
        },
        title: string,
        audioFileUrl: string,
        duration: number,
        originUrl: string,
        originKind: ExternalTawk_OriginKind,
        originName: string,
        originCreatedAt: string,
        picture:  {
          __typename: "GenericImage",
          imageUrl: string,
          cloudinaryImage?:  {
            __typename: "CloudinaryResource",
            publicId: string,
          } | null,
        },
        createdAt: string,
      } | null,
      likesCount: number,
      repliesCount: number,
      repostedPost_id?: string | null,
      repostedTimeRange?:  {
        __typename: "ClipTimeRange",
        endTime: number,
        startTime: number,
      } | null,
      repostedPost?:  {
        __typename: "Post",
        id: string,
        createdAt: string,
        text: string,
        author:  {
          __typename: "User",
          name?: string | null,
          sub: string,
          userHandle?:  {
            __typename: "UserHandle",
            renderedForm: string,
          } | null,
          profilePhoto:  {
            __typename: "CloudinaryResource",
            publicId: string,
          },
        },
        associatedTawk?:  {
          __typename: "TawkCandidate",
          title?: string | null,
          generatedVideo?:  {
            __typename: "CloudinaryResource",
            publicId: string,
          } | null,
        } | null,
      } | null,
      associatedColorHue?: number | null,
      footnote?: string | null,
    } | null,
    associatedColorHue?: number | null,
    footnote?: string | null,
  } | null,
  post5?:  {
    __typename: "Post",
    createdAt: string,
    text: string,
    associatedTawk?:  {
      __typename: "TawkCandidate",
      ownerSub: string,
      localId: string,
      tawkVersion: string,
      title?: string | null,
      createdAt: string,
      author:  {
        __typename: "User",
        sub: string,
        name?: string | null,
        bio?: string | null,
        userHandle?:  {
          __typename: "UserHandle",
          standardForm: string,
          renderedForm: string,
        } | null,
        profilePhoto:  {
          __typename: "CloudinaryResource",
          publicId: string,
        },
      },
      duration?: number | null,
      rawAudio:  {
        __typename: "CloudinaryResource",
        publicId: string,
      },
      processedAudio?:  {
        __typename: "CloudinaryResource",
        publicId: string,
      } | null,
      generatedVideo?:  {
        __typename: "CloudinaryResource",
        publicId: string,
      } | null,
    } | null,
    associatedExternalTawk?:  {
      __typename: "ExternalTawk",
      id: string,
      inserter_sub: string,
      inserter:  {
        __typename: "User",
        sub: string,
        name?: string | null,
        bio?: string | null,
        userHandle?:  {
          __typename: "UserHandle",
          standardForm: string,
          renderedForm: string,
        } | null,
        profilePhoto:  {
          __typename: "CloudinaryResource",
          publicId: string,
        },
      },
      title: string,
      audioFileUrl: string,
      duration: number,
      originUrl: string,
      originKind: ExternalTawk_OriginKind,
      originName: string,
      originCreatedAt: string,
      picture:  {
        __typename: "GenericImage",
        imageUrl: string,
        cloudinaryImage?:  {
          __typename: "CloudinaryResource",
          publicId: string,
        } | null,
      },
      createdAt: string,
    } | null,
    author:  {
      __typename: "User",
      name?: string | null,
      sub: string,
      userHandle?:  {
        __typename: "UserHandle",
        renderedForm: string,
      } | null,
      profilePhoto:  {
        __typename: "CloudinaryResource",
        publicId: string,
      },
    },
    likesCount: number,
    repliesCount: number,
    id: string,
    repostedPost_id?: string | null,
    repostedTimeRange?:  {
      __typename: "ClipTimeRange",
      endTime: number,
      startTime: number,
    } | null,
    repostedPost?:  {
      __typename: "Post",
      id: string,
      createdAt: string,
      text: string,
      author:  {
        __typename: "User",
        name?: string | null,
        sub: string,
        userHandle?:  {
          __typename: "UserHandle",
          renderedForm: string,
        } | null,
        profilePhoto:  {
          __typename: "CloudinaryResource",
          publicId: string,
        },
      },
      associatedTawk?:  {
        __typename: "TawkCandidate",
        title?: string | null,
        generatedVideo?:  {
          __typename: "CloudinaryResource",
          publicId: string,
        } | null,
        ownerSub: string,
        localId: string,
        tawkVersion: string,
        createdAt: string,
        author:  {
          __typename: "User",
          sub: string,
          name?: string | null,
          bio?: string | null,
          userHandle?:  {
            __typename: "UserHandle",
            standardForm: string,
            renderedForm: string,
          } | null,
          profilePhoto:  {
            __typename: "CloudinaryResource",
            publicId: string,
          },
        },
        duration?: number | null,
        rawAudio:  {
          __typename: "CloudinaryResource",
          publicId: string,
        },
        processedAudio?:  {
          __typename: "CloudinaryResource",
          publicId: string,
        } | null,
      } | null,
      associatedExternalTawk?:  {
        __typename: "ExternalTawk",
        id: string,
        inserter_sub: string,
        inserter:  {
          __typename: "User",
          sub: string,
          name?: string | null,
          bio?: string | null,
          userHandle?:  {
            __typename: "UserHandle",
            standardForm: string,
            renderedForm: string,
          } | null,
          profilePhoto:  {
            __typename: "CloudinaryResource",
            publicId: string,
          },
        },
        title: string,
        audioFileUrl: string,
        duration: number,
        originUrl: string,
        originKind: ExternalTawk_OriginKind,
        originName: string,
        originCreatedAt: string,
        picture:  {
          __typename: "GenericImage",
          imageUrl: string,
          cloudinaryImage?:  {
            __typename: "CloudinaryResource",
            publicId: string,
          } | null,
        },
        createdAt: string,
      } | null,
      likesCount: number,
      repliesCount: number,
      repostedPost_id?: string | null,
      repostedTimeRange?:  {
        __typename: "ClipTimeRange",
        endTime: number,
        startTime: number,
      } | null,
      repostedPost?:  {
        __typename: "Post",
        id: string,
        createdAt: string,
        text: string,
        author:  {
          __typename: "User",
          name?: string | null,
          sub: string,
          userHandle?:  {
            __typename: "UserHandle",
            renderedForm: string,
          } | null,
          profilePhoto:  {
            __typename: "CloudinaryResource",
            publicId: string,
          },
        },
        associatedTawk?:  {
          __typename: "TawkCandidate",
          title?: string | null,
          generatedVideo?:  {
            __typename: "CloudinaryResource",
            publicId: string,
          } | null,
        } | null,
      } | null,
      associatedColorHue?: number | null,
      footnote?: string | null,
    } | null,
    associatedColorHue?: number | null,
    footnote?: string | null,
  } | null,
  post6?:  {
    __typename: "Post",
    createdAt: string,
    text: string,
    associatedTawk?:  {
      __typename: "TawkCandidate",
      ownerSub: string,
      localId: string,
      tawkVersion: string,
      title?: string | null,
      createdAt: string,
      author:  {
        __typename: "User",
        sub: string,
        name?: string | null,
        bio?: string | null,
        userHandle?:  {
          __typename: "UserHandle",
          standardForm: string,
          renderedForm: string,
        } | null,
        profilePhoto:  {
          __typename: "CloudinaryResource",
          publicId: string,
        },
      },
      duration?: number | null,
      rawAudio:  {
        __typename: "CloudinaryResource",
        publicId: string,
      },
      processedAudio?:  {
        __typename: "CloudinaryResource",
        publicId: string,
      } | null,
      generatedVideo?:  {
        __typename: "CloudinaryResource",
        publicId: string,
      } | null,
    } | null,
    associatedExternalTawk?:  {
      __typename: "ExternalTawk",
      id: string,
      inserter_sub: string,
      inserter:  {
        __typename: "User",
        sub: string,
        name?: string | null,
        bio?: string | null,
        userHandle?:  {
          __typename: "UserHandle",
          standardForm: string,
          renderedForm: string,
        } | null,
        profilePhoto:  {
          __typename: "CloudinaryResource",
          publicId: string,
        },
      },
      title: string,
      audioFileUrl: string,
      duration: number,
      originUrl: string,
      originKind: ExternalTawk_OriginKind,
      originName: string,
      originCreatedAt: string,
      picture:  {
        __typename: "GenericImage",
        imageUrl: string,
        cloudinaryImage?:  {
          __typename: "CloudinaryResource",
          publicId: string,
        } | null,
      },
      createdAt: string,
    } | null,
    author:  {
      __typename: "User",
      name?: string | null,
      sub: string,
      userHandle?:  {
        __typename: "UserHandle",
        renderedForm: string,
      } | null,
      profilePhoto:  {
        __typename: "CloudinaryResource",
        publicId: string,
      },
    },
    likesCount: number,
    repliesCount: number,
    id: string,
    repostedPost_id?: string | null,
    repostedTimeRange?:  {
      __typename: "ClipTimeRange",
      endTime: number,
      startTime: number,
    } | null,
    repostedPost?:  {
      __typename: "Post",
      id: string,
      createdAt: string,
      text: string,
      author:  {
        __typename: "User",
        name?: string | null,
        sub: string,
        userHandle?:  {
          __typename: "UserHandle",
          renderedForm: string,
        } | null,
        profilePhoto:  {
          __typename: "CloudinaryResource",
          publicId: string,
        },
      },
      associatedTawk?:  {
        __typename: "TawkCandidate",
        title?: string | null,
        generatedVideo?:  {
          __typename: "CloudinaryResource",
          publicId: string,
        } | null,
        ownerSub: string,
        localId: string,
        tawkVersion: string,
        createdAt: string,
        author:  {
          __typename: "User",
          sub: string,
          name?: string | null,
          bio?: string | null,
          userHandle?:  {
            __typename: "UserHandle",
            standardForm: string,
            renderedForm: string,
          } | null,
          profilePhoto:  {
            __typename: "CloudinaryResource",
            publicId: string,
          },
        },
        duration?: number | null,
        rawAudio:  {
          __typename: "CloudinaryResource",
          publicId: string,
        },
        processedAudio?:  {
          __typename: "CloudinaryResource",
          publicId: string,
        } | null,
      } | null,
      associatedExternalTawk?:  {
        __typename: "ExternalTawk",
        id: string,
        inserter_sub: string,
        inserter:  {
          __typename: "User",
          sub: string,
          name?: string | null,
          bio?: string | null,
          userHandle?:  {
            __typename: "UserHandle",
            standardForm: string,
            renderedForm: string,
          } | null,
          profilePhoto:  {
            __typename: "CloudinaryResource",
            publicId: string,
          },
        },
        title: string,
        audioFileUrl: string,
        duration: number,
        originUrl: string,
        originKind: ExternalTawk_OriginKind,
        originName: string,
        originCreatedAt: string,
        picture:  {
          __typename: "GenericImage",
          imageUrl: string,
          cloudinaryImage?:  {
            __typename: "CloudinaryResource",
            publicId: string,
          } | null,
        },
        createdAt: string,
      } | null,
      likesCount: number,
      repliesCount: number,
      repostedPost_id?: string | null,
      repostedTimeRange?:  {
        __typename: "ClipTimeRange",
        endTime: number,
        startTime: number,
      } | null,
      repostedPost?:  {
        __typename: "Post",
        id: string,
        createdAt: string,
        text: string,
        author:  {
          __typename: "User",
          name?: string | null,
          sub: string,
          userHandle?:  {
            __typename: "UserHandle",
            renderedForm: string,
          } | null,
          profilePhoto:  {
            __typename: "CloudinaryResource",
            publicId: string,
          },
        },
        associatedTawk?:  {
          __typename: "TawkCandidate",
          title?: string | null,
          generatedVideo?:  {
            __typename: "CloudinaryResource",
            publicId: string,
          } | null,
        } | null,
      } | null,
      associatedColorHue?: number | null,
      footnote?: string | null,
    } | null,
    associatedColorHue?: number | null,
    footnote?: string | null,
  } | null,
  post7?:  {
    __typename: "Post",
    createdAt: string,
    text: string,
    associatedTawk?:  {
      __typename: "TawkCandidate",
      ownerSub: string,
      localId: string,
      tawkVersion: string,
      title?: string | null,
      createdAt: string,
      author:  {
        __typename: "User",
        sub: string,
        name?: string | null,
        bio?: string | null,
        userHandle?:  {
          __typename: "UserHandle",
          standardForm: string,
          renderedForm: string,
        } | null,
        profilePhoto:  {
          __typename: "CloudinaryResource",
          publicId: string,
        },
      },
      duration?: number | null,
      rawAudio:  {
        __typename: "CloudinaryResource",
        publicId: string,
      },
      processedAudio?:  {
        __typename: "CloudinaryResource",
        publicId: string,
      } | null,
      generatedVideo?:  {
        __typename: "CloudinaryResource",
        publicId: string,
      } | null,
    } | null,
    associatedExternalTawk?:  {
      __typename: "ExternalTawk",
      id: string,
      inserter_sub: string,
      inserter:  {
        __typename: "User",
        sub: string,
        name?: string | null,
        bio?: string | null,
        userHandle?:  {
          __typename: "UserHandle",
          standardForm: string,
          renderedForm: string,
        } | null,
        profilePhoto:  {
          __typename: "CloudinaryResource",
          publicId: string,
        },
      },
      title: string,
      audioFileUrl: string,
      duration: number,
      originUrl: string,
      originKind: ExternalTawk_OriginKind,
      originName: string,
      originCreatedAt: string,
      picture:  {
        __typename: "GenericImage",
        imageUrl: string,
        cloudinaryImage?:  {
          __typename: "CloudinaryResource",
          publicId: string,
        } | null,
      },
      createdAt: string,
    } | null,
    author:  {
      __typename: "User",
      name?: string | null,
      sub: string,
      userHandle?:  {
        __typename: "UserHandle",
        renderedForm: string,
      } | null,
      profilePhoto:  {
        __typename: "CloudinaryResource",
        publicId: string,
      },
    },
    likesCount: number,
    repliesCount: number,
    id: string,
    repostedPost_id?: string | null,
    repostedTimeRange?:  {
      __typename: "ClipTimeRange",
      endTime: number,
      startTime: number,
    } | null,
    repostedPost?:  {
      __typename: "Post",
      id: string,
      createdAt: string,
      text: string,
      author:  {
        __typename: "User",
        name?: string | null,
        sub: string,
        userHandle?:  {
          __typename: "UserHandle",
          renderedForm: string,
        } | null,
        profilePhoto:  {
          __typename: "CloudinaryResource",
          publicId: string,
        },
      },
      associatedTawk?:  {
        __typename: "TawkCandidate",
        title?: string | null,
        generatedVideo?:  {
          __typename: "CloudinaryResource",
          publicId: string,
        } | null,
        ownerSub: string,
        localId: string,
        tawkVersion: string,
        createdAt: string,
        author:  {
          __typename: "User",
          sub: string,
          name?: string | null,
          bio?: string | null,
          userHandle?:  {
            __typename: "UserHandle",
            standardForm: string,
            renderedForm: string,
          } | null,
          profilePhoto:  {
            __typename: "CloudinaryResource",
            publicId: string,
          },
        },
        duration?: number | null,
        rawAudio:  {
          __typename: "CloudinaryResource",
          publicId: string,
        },
        processedAudio?:  {
          __typename: "CloudinaryResource",
          publicId: string,
        } | null,
      } | null,
      associatedExternalTawk?:  {
        __typename: "ExternalTawk",
        id: string,
        inserter_sub: string,
        inserter:  {
          __typename: "User",
          sub: string,
          name?: string | null,
          bio?: string | null,
          userHandle?:  {
            __typename: "UserHandle",
            standardForm: string,
            renderedForm: string,
          } | null,
          profilePhoto:  {
            __typename: "CloudinaryResource",
            publicId: string,
          },
        },
        title: string,
        audioFileUrl: string,
        duration: number,
        originUrl: string,
        originKind: ExternalTawk_OriginKind,
        originName: string,
        originCreatedAt: string,
        picture:  {
          __typename: "GenericImage",
          imageUrl: string,
          cloudinaryImage?:  {
            __typename: "CloudinaryResource",
            publicId: string,
          } | null,
        },
        createdAt: string,
      } | null,
      likesCount: number,
      repliesCount: number,
      repostedPost_id?: string | null,
      repostedTimeRange?:  {
        __typename: "ClipTimeRange",
        endTime: number,
        startTime: number,
      } | null,
      repostedPost?:  {
        __typename: "Post",
        id: string,
        createdAt: string,
        text: string,
        author:  {
          __typename: "User",
          name?: string | null,
          sub: string,
          userHandle?:  {
            __typename: "UserHandle",
            renderedForm: string,
          } | null,
          profilePhoto:  {
            __typename: "CloudinaryResource",
            publicId: string,
          },
        },
        associatedTawk?:  {
          __typename: "TawkCandidate",
          title?: string | null,
          generatedVideo?:  {
            __typename: "CloudinaryResource",
            publicId: string,
          } | null,
        } | null,
      } | null,
      associatedColorHue?: number | null,
      footnote?: string | null,
    } | null,
    associatedColorHue?: number | null,
    footnote?: string | null,
  } | null,
  post8?:  {
    __typename: "Post",
    createdAt: string,
    text: string,
    associatedTawk?:  {
      __typename: "TawkCandidate",
      ownerSub: string,
      localId: string,
      tawkVersion: string,
      title?: string | null,
      createdAt: string,
      author:  {
        __typename: "User",
        sub: string,
        name?: string | null,
        bio?: string | null,
        userHandle?:  {
          __typename: "UserHandle",
          standardForm: string,
          renderedForm: string,
        } | null,
        profilePhoto:  {
          __typename: "CloudinaryResource",
          publicId: string,
        },
      },
      duration?: number | null,
      rawAudio:  {
        __typename: "CloudinaryResource",
        publicId: string,
      },
      processedAudio?:  {
        __typename: "CloudinaryResource",
        publicId: string,
      } | null,
      generatedVideo?:  {
        __typename: "CloudinaryResource",
        publicId: string,
      } | null,
    } | null,
    associatedExternalTawk?:  {
      __typename: "ExternalTawk",
      id: string,
      inserter_sub: string,
      inserter:  {
        __typename: "User",
        sub: string,
        name?: string | null,
        bio?: string | null,
        userHandle?:  {
          __typename: "UserHandle",
          standardForm: string,
          renderedForm: string,
        } | null,
        profilePhoto:  {
          __typename: "CloudinaryResource",
          publicId: string,
        },
      },
      title: string,
      audioFileUrl: string,
      duration: number,
      originUrl: string,
      originKind: ExternalTawk_OriginKind,
      originName: string,
      originCreatedAt: string,
      picture:  {
        __typename: "GenericImage",
        imageUrl: string,
        cloudinaryImage?:  {
          __typename: "CloudinaryResource",
          publicId: string,
        } | null,
      },
      createdAt: string,
    } | null,
    author:  {
      __typename: "User",
      name?: string | null,
      sub: string,
      userHandle?:  {
        __typename: "UserHandle",
        renderedForm: string,
      } | null,
      profilePhoto:  {
        __typename: "CloudinaryResource",
        publicId: string,
      },
    },
    likesCount: number,
    repliesCount: number,
    id: string,
    repostedPost_id?: string | null,
    repostedTimeRange?:  {
      __typename: "ClipTimeRange",
      endTime: number,
      startTime: number,
    } | null,
    repostedPost?:  {
      __typename: "Post",
      id: string,
      createdAt: string,
      text: string,
      author:  {
        __typename: "User",
        name?: string | null,
        sub: string,
        userHandle?:  {
          __typename: "UserHandle",
          renderedForm: string,
        } | null,
        profilePhoto:  {
          __typename: "CloudinaryResource",
          publicId: string,
        },
      },
      associatedTawk?:  {
        __typename: "TawkCandidate",
        title?: string | null,
        generatedVideo?:  {
          __typename: "CloudinaryResource",
          publicId: string,
        } | null,
        ownerSub: string,
        localId: string,
        tawkVersion: string,
        createdAt: string,
        author:  {
          __typename: "User",
          sub: string,
          name?: string | null,
          bio?: string | null,
          userHandle?:  {
            __typename: "UserHandle",
            standardForm: string,
            renderedForm: string,
          } | null,
          profilePhoto:  {
            __typename: "CloudinaryResource",
            publicId: string,
          },
        },
        duration?: number | null,
        rawAudio:  {
          __typename: "CloudinaryResource",
          publicId: string,
        },
        processedAudio?:  {
          __typename: "CloudinaryResource",
          publicId: string,
        } | null,
      } | null,
      associatedExternalTawk?:  {
        __typename: "ExternalTawk",
        id: string,
        inserter_sub: string,
        inserter:  {
          __typename: "User",
          sub: string,
          name?: string | null,
          bio?: string | null,
          userHandle?:  {
            __typename: "UserHandle",
            standardForm: string,
            renderedForm: string,
          } | null,
          profilePhoto:  {
            __typename: "CloudinaryResource",
            publicId: string,
          },
        },
        title: string,
        audioFileUrl: string,
        duration: number,
        originUrl: string,
        originKind: ExternalTawk_OriginKind,
        originName: string,
        originCreatedAt: string,
        picture:  {
          __typename: "GenericImage",
          imageUrl: string,
          cloudinaryImage?:  {
            __typename: "CloudinaryResource",
            publicId: string,
          } | null,
        },
        createdAt: string,
      } | null,
      likesCount: number,
      repliesCount: number,
      repostedPost_id?: string | null,
      repostedTimeRange?:  {
        __typename: "ClipTimeRange",
        endTime: number,
        startTime: number,
      } | null,
      repostedPost?:  {
        __typename: "Post",
        id: string,
        createdAt: string,
        text: string,
        author:  {
          __typename: "User",
          name?: string | null,
          sub: string,
          userHandle?:  {
            __typename: "UserHandle",
            renderedForm: string,
          } | null,
          profilePhoto:  {
            __typename: "CloudinaryResource",
            publicId: string,
          },
        },
        associatedTawk?:  {
          __typename: "TawkCandidate",
          title?: string | null,
          generatedVideo?:  {
            __typename: "CloudinaryResource",
            publicId: string,
          } | null,
        } | null,
      } | null,
      associatedColorHue?: number | null,
      footnote?: string | null,
    } | null,
    associatedColorHue?: number | null,
    footnote?: string | null,
  } | null,
  post9?:  {
    __typename: "Post",
    createdAt: string,
    text: string,
    associatedTawk?:  {
      __typename: "TawkCandidate",
      ownerSub: string,
      localId: string,
      tawkVersion: string,
      title?: string | null,
      createdAt: string,
      author:  {
        __typename: "User",
        sub: string,
        name?: string | null,
        bio?: string | null,
        userHandle?:  {
          __typename: "UserHandle",
          standardForm: string,
          renderedForm: string,
        } | null,
        profilePhoto:  {
          __typename: "CloudinaryResource",
          publicId: string,
        },
      },
      duration?: number | null,
      rawAudio:  {
        __typename: "CloudinaryResource",
        publicId: string,
      },
      processedAudio?:  {
        __typename: "CloudinaryResource",
        publicId: string,
      } | null,
      generatedVideo?:  {
        __typename: "CloudinaryResource",
        publicId: string,
      } | null,
    } | null,
    associatedExternalTawk?:  {
      __typename: "ExternalTawk",
      id: string,
      inserter_sub: string,
      inserter:  {
        __typename: "User",
        sub: string,
        name?: string | null,
        bio?: string | null,
        userHandle?:  {
          __typename: "UserHandle",
          standardForm: string,
          renderedForm: string,
        } | null,
        profilePhoto:  {
          __typename: "CloudinaryResource",
          publicId: string,
        },
      },
      title: string,
      audioFileUrl: string,
      duration: number,
      originUrl: string,
      originKind: ExternalTawk_OriginKind,
      originName: string,
      originCreatedAt: string,
      picture:  {
        __typename: "GenericImage",
        imageUrl: string,
        cloudinaryImage?:  {
          __typename: "CloudinaryResource",
          publicId: string,
        } | null,
      },
      createdAt: string,
    } | null,
    author:  {
      __typename: "User",
      name?: string | null,
      sub: string,
      userHandle?:  {
        __typename: "UserHandle",
        renderedForm: string,
      } | null,
      profilePhoto:  {
        __typename: "CloudinaryResource",
        publicId: string,
      },
    },
    likesCount: number,
    repliesCount: number,
    id: string,
    repostedPost_id?: string | null,
    repostedTimeRange?:  {
      __typename: "ClipTimeRange",
      endTime: number,
      startTime: number,
    } | null,
    repostedPost?:  {
      __typename: "Post",
      id: string,
      createdAt: string,
      text: string,
      author:  {
        __typename: "User",
        name?: string | null,
        sub: string,
        userHandle?:  {
          __typename: "UserHandle",
          renderedForm: string,
        } | null,
        profilePhoto:  {
          __typename: "CloudinaryResource",
          publicId: string,
        },
      },
      associatedTawk?:  {
        __typename: "TawkCandidate",
        title?: string | null,
        generatedVideo?:  {
          __typename: "CloudinaryResource",
          publicId: string,
        } | null,
        ownerSub: string,
        localId: string,
        tawkVersion: string,
        createdAt: string,
        author:  {
          __typename: "User",
          sub: string,
          name?: string | null,
          bio?: string | null,
          userHandle?:  {
            __typename: "UserHandle",
            standardForm: string,
            renderedForm: string,
          } | null,
          profilePhoto:  {
            __typename: "CloudinaryResource",
            publicId: string,
          },
        },
        duration?: number | null,
        rawAudio:  {
          __typename: "CloudinaryResource",
          publicId: string,
        },
        processedAudio?:  {
          __typename: "CloudinaryResource",
          publicId: string,
        } | null,
      } | null,
      associatedExternalTawk?:  {
        __typename: "ExternalTawk",
        id: string,
        inserter_sub: string,
        inserter:  {
          __typename: "User",
          sub: string,
          name?: string | null,
          bio?: string | null,
          userHandle?:  {
            __typename: "UserHandle",
            standardForm: string,
            renderedForm: string,
          } | null,
          profilePhoto:  {
            __typename: "CloudinaryResource",
            publicId: string,
          },
        },
        title: string,
        audioFileUrl: string,
        duration: number,
        originUrl: string,
        originKind: ExternalTawk_OriginKind,
        originName: string,
        originCreatedAt: string,
        picture:  {
          __typename: "GenericImage",
          imageUrl: string,
          cloudinaryImage?:  {
            __typename: "CloudinaryResource",
            publicId: string,
          } | null,
        },
        createdAt: string,
      } | null,
      likesCount: number,
      repliesCount: number,
      repostedPost_id?: string | null,
      repostedTimeRange?:  {
        __typename: "ClipTimeRange",
        endTime: number,
        startTime: number,
      } | null,
      repostedPost?:  {
        __typename: "Post",
        id: string,
        createdAt: string,
        text: string,
        author:  {
          __typename: "User",
          name?: string | null,
          sub: string,
          userHandle?:  {
            __typename: "UserHandle",
            renderedForm: string,
          } | null,
          profilePhoto:  {
            __typename: "CloudinaryResource",
            publicId: string,
          },
        },
        associatedTawk?:  {
          __typename: "TawkCandidate",
          title?: string | null,
          generatedVideo?:  {
            __typename: "CloudinaryResource",
            publicId: string,
          } | null,
        } | null,
      } | null,
      associatedColorHue?: number | null,
      footnote?: string | null,
    } | null,
    associatedColorHue?: number | null,
    footnote?: string | null,
  } | null,
  post10?:  {
    __typename: "Post",
    createdAt: string,
    text: string,
    associatedTawk?:  {
      __typename: "TawkCandidate",
      ownerSub: string,
      localId: string,
      tawkVersion: string,
      title?: string | null,
      createdAt: string,
      author:  {
        __typename: "User",
        sub: string,
        name?: string | null,
        bio?: string | null,
        userHandle?:  {
          __typename: "UserHandle",
          standardForm: string,
          renderedForm: string,
        } | null,
        profilePhoto:  {
          __typename: "CloudinaryResource",
          publicId: string,
        },
      },
      duration?: number | null,
      rawAudio:  {
        __typename: "CloudinaryResource",
        publicId: string,
      },
      processedAudio?:  {
        __typename: "CloudinaryResource",
        publicId: string,
      } | null,
      generatedVideo?:  {
        __typename: "CloudinaryResource",
        publicId: string,
      } | null,
    } | null,
    associatedExternalTawk?:  {
      __typename: "ExternalTawk",
      id: string,
      inserter_sub: string,
      inserter:  {
        __typename: "User",
        sub: string,
        name?: string | null,
        bio?: string | null,
        userHandle?:  {
          __typename: "UserHandle",
          standardForm: string,
          renderedForm: string,
        } | null,
        profilePhoto:  {
          __typename: "CloudinaryResource",
          publicId: string,
        },
      },
      title: string,
      audioFileUrl: string,
      duration: number,
      originUrl: string,
      originKind: ExternalTawk_OriginKind,
      originName: string,
      originCreatedAt: string,
      picture:  {
        __typename: "GenericImage",
        imageUrl: string,
        cloudinaryImage?:  {
          __typename: "CloudinaryResource",
          publicId: string,
        } | null,
      },
      createdAt: string,
    } | null,
    author:  {
      __typename: "User",
      name?: string | null,
      sub: string,
      userHandle?:  {
        __typename: "UserHandle",
        renderedForm: string,
      } | null,
      profilePhoto:  {
        __typename: "CloudinaryResource",
        publicId: string,
      },
    },
    likesCount: number,
    repliesCount: number,
    id: string,
    repostedPost_id?: string | null,
    repostedTimeRange?:  {
      __typename: "ClipTimeRange",
      endTime: number,
      startTime: number,
    } | null,
    repostedPost?:  {
      __typename: "Post",
      id: string,
      createdAt: string,
      text: string,
      author:  {
        __typename: "User",
        name?: string | null,
        sub: string,
        userHandle?:  {
          __typename: "UserHandle",
          renderedForm: string,
        } | null,
        profilePhoto:  {
          __typename: "CloudinaryResource",
          publicId: string,
        },
      },
      associatedTawk?:  {
        __typename: "TawkCandidate",
        title?: string | null,
        generatedVideo?:  {
          __typename: "CloudinaryResource",
          publicId: string,
        } | null,
        ownerSub: string,
        localId: string,
        tawkVersion: string,
        createdAt: string,
        author:  {
          __typename: "User",
          sub: string,
          name?: string | null,
          bio?: string | null,
          userHandle?:  {
            __typename: "UserHandle",
            standardForm: string,
            renderedForm: string,
          } | null,
          profilePhoto:  {
            __typename: "CloudinaryResource",
            publicId: string,
          },
        },
        duration?: number | null,
        rawAudio:  {
          __typename: "CloudinaryResource",
          publicId: string,
        },
        processedAudio?:  {
          __typename: "CloudinaryResource",
          publicId: string,
        } | null,
      } | null,
      associatedExternalTawk?:  {
        __typename: "ExternalTawk",
        id: string,
        inserter_sub: string,
        inserter:  {
          __typename: "User",
          sub: string,
          name?: string | null,
          bio?: string | null,
          userHandle?:  {
            __typename: "UserHandle",
            standardForm: string,
            renderedForm: string,
          } | null,
          profilePhoto:  {
            __typename: "CloudinaryResource",
            publicId: string,
          },
        },
        title: string,
        audioFileUrl: string,
        duration: number,
        originUrl: string,
        originKind: ExternalTawk_OriginKind,
        originName: string,
        originCreatedAt: string,
        picture:  {
          __typename: "GenericImage",
          imageUrl: string,
          cloudinaryImage?:  {
            __typename: "CloudinaryResource",
            publicId: string,
          } | null,
        },
        createdAt: string,
      } | null,
      likesCount: number,
      repliesCount: number,
      repostedPost_id?: string | null,
      repostedTimeRange?:  {
        __typename: "ClipTimeRange",
        endTime: number,
        startTime: number,
      } | null,
      repostedPost?:  {
        __typename: "Post",
        id: string,
        createdAt: string,
        text: string,
        author:  {
          __typename: "User",
          name?: string | null,
          sub: string,
          userHandle?:  {
            __typename: "UserHandle",
            renderedForm: string,
          } | null,
          profilePhoto:  {
            __typename: "CloudinaryResource",
            publicId: string,
          },
        },
        associatedTawk?:  {
          __typename: "TawkCandidate",
          title?: string | null,
          generatedVideo?:  {
            __typename: "CloudinaryResource",
            publicId: string,
          } | null,
        } | null,
      } | null,
      associatedColorHue?: number | null,
      footnote?: string | null,
    } | null,
    associatedColorHue?: number | null,
    footnote?: string | null,
  } | null,
  post11?:  {
    __typename: "Post",
    createdAt: string,
    text: string,
    associatedTawk?:  {
      __typename: "TawkCandidate",
      ownerSub: string,
      localId: string,
      tawkVersion: string,
      title?: string | null,
      createdAt: string,
      author:  {
        __typename: "User",
        sub: string,
        name?: string | null,
        bio?: string | null,
        userHandle?:  {
          __typename: "UserHandle",
          standardForm: string,
          renderedForm: string,
        } | null,
        profilePhoto:  {
          __typename: "CloudinaryResource",
          publicId: string,
        },
      },
      duration?: number | null,
      rawAudio:  {
        __typename: "CloudinaryResource",
        publicId: string,
      },
      processedAudio?:  {
        __typename: "CloudinaryResource",
        publicId: string,
      } | null,
      generatedVideo?:  {
        __typename: "CloudinaryResource",
        publicId: string,
      } | null,
    } | null,
    associatedExternalTawk?:  {
      __typename: "ExternalTawk",
      id: string,
      inserter_sub: string,
      inserter:  {
        __typename: "User",
        sub: string,
        name?: string | null,
        bio?: string | null,
        userHandle?:  {
          __typename: "UserHandle",
          standardForm: string,
          renderedForm: string,
        } | null,
        profilePhoto:  {
          __typename: "CloudinaryResource",
          publicId: string,
        },
      },
      title: string,
      audioFileUrl: string,
      duration: number,
      originUrl: string,
      originKind: ExternalTawk_OriginKind,
      originName: string,
      originCreatedAt: string,
      picture:  {
        __typename: "GenericImage",
        imageUrl: string,
        cloudinaryImage?:  {
          __typename: "CloudinaryResource",
          publicId: string,
        } | null,
      },
      createdAt: string,
    } | null,
    author:  {
      __typename: "User",
      name?: string | null,
      sub: string,
      userHandle?:  {
        __typename: "UserHandle",
        renderedForm: string,
      } | null,
      profilePhoto:  {
        __typename: "CloudinaryResource",
        publicId: string,
      },
    },
    likesCount: number,
    repliesCount: number,
    id: string,
    repostedPost_id?: string | null,
    repostedTimeRange?:  {
      __typename: "ClipTimeRange",
      endTime: number,
      startTime: number,
    } | null,
    repostedPost?:  {
      __typename: "Post",
      id: string,
      createdAt: string,
      text: string,
      author:  {
        __typename: "User",
        name?: string | null,
        sub: string,
        userHandle?:  {
          __typename: "UserHandle",
          renderedForm: string,
        } | null,
        profilePhoto:  {
          __typename: "CloudinaryResource",
          publicId: string,
        },
      },
      associatedTawk?:  {
        __typename: "TawkCandidate",
        title?: string | null,
        generatedVideo?:  {
          __typename: "CloudinaryResource",
          publicId: string,
        } | null,
        ownerSub: string,
        localId: string,
        tawkVersion: string,
        createdAt: string,
        author:  {
          __typename: "User",
          sub: string,
          name?: string | null,
          bio?: string | null,
          userHandle?:  {
            __typename: "UserHandle",
            standardForm: string,
            renderedForm: string,
          } | null,
          profilePhoto:  {
            __typename: "CloudinaryResource",
            publicId: string,
          },
        },
        duration?: number | null,
        rawAudio:  {
          __typename: "CloudinaryResource",
          publicId: string,
        },
        processedAudio?:  {
          __typename: "CloudinaryResource",
          publicId: string,
        } | null,
      } | null,
      associatedExternalTawk?:  {
        __typename: "ExternalTawk",
        id: string,
        inserter_sub: string,
        inserter:  {
          __typename: "User",
          sub: string,
          name?: string | null,
          bio?: string | null,
          userHandle?:  {
            __typename: "UserHandle",
            standardForm: string,
            renderedForm: string,
          } | null,
          profilePhoto:  {
            __typename: "CloudinaryResource",
            publicId: string,
          },
        },
        title: string,
        audioFileUrl: string,
        duration: number,
        originUrl: string,
        originKind: ExternalTawk_OriginKind,
        originName: string,
        originCreatedAt: string,
        picture:  {
          __typename: "GenericImage",
          imageUrl: string,
          cloudinaryImage?:  {
            __typename: "CloudinaryResource",
            publicId: string,
          } | null,
        },
        createdAt: string,
      } | null,
      likesCount: number,
      repliesCount: number,
      repostedPost_id?: string | null,
      repostedTimeRange?:  {
        __typename: "ClipTimeRange",
        endTime: number,
        startTime: number,
      } | null,
      repostedPost?:  {
        __typename: "Post",
        id: string,
        createdAt: string,
        text: string,
        author:  {
          __typename: "User",
          name?: string | null,
          sub: string,
          userHandle?:  {
            __typename: "UserHandle",
            renderedForm: string,
          } | null,
          profilePhoto:  {
            __typename: "CloudinaryResource",
            publicId: string,
          },
        },
        associatedTawk?:  {
          __typename: "TawkCandidate",
          title?: string | null,
          generatedVideo?:  {
            __typename: "CloudinaryResource",
            publicId: string,
          } | null,
        } | null,
      } | null,
      associatedColorHue?: number | null,
      footnote?: string | null,
    } | null,
    associatedColorHue?: number | null,
    footnote?: string | null,
  } | null,
  post12?:  {
    __typename: "Post",
    createdAt: string,
    text: string,
    associatedTawk?:  {
      __typename: "TawkCandidate",
      ownerSub: string,
      localId: string,
      tawkVersion: string,
      title?: string | null,
      createdAt: string,
      author:  {
        __typename: "User",
        sub: string,
        name?: string | null,
        bio?: string | null,
        userHandle?:  {
          __typename: "UserHandle",
          standardForm: string,
          renderedForm: string,
        } | null,
        profilePhoto:  {
          __typename: "CloudinaryResource",
          publicId: string,
        },
      },
      duration?: number | null,
      rawAudio:  {
        __typename: "CloudinaryResource",
        publicId: string,
      },
      processedAudio?:  {
        __typename: "CloudinaryResource",
        publicId: string,
      } | null,
      generatedVideo?:  {
        __typename: "CloudinaryResource",
        publicId: string,
      } | null,
    } | null,
    associatedExternalTawk?:  {
      __typename: "ExternalTawk",
      id: string,
      inserter_sub: string,
      inserter:  {
        __typename: "User",
        sub: string,
        name?: string | null,
        bio?: string | null,
        userHandle?:  {
          __typename: "UserHandle",
          standardForm: string,
          renderedForm: string,
        } | null,
        profilePhoto:  {
          __typename: "CloudinaryResource",
          publicId: string,
        },
      },
      title: string,
      audioFileUrl: string,
      duration: number,
      originUrl: string,
      originKind: ExternalTawk_OriginKind,
      originName: string,
      originCreatedAt: string,
      picture:  {
        __typename: "GenericImage",
        imageUrl: string,
        cloudinaryImage?:  {
          __typename: "CloudinaryResource",
          publicId: string,
        } | null,
      },
      createdAt: string,
    } | null,
    author:  {
      __typename: "User",
      name?: string | null,
      sub: string,
      userHandle?:  {
        __typename: "UserHandle",
        renderedForm: string,
      } | null,
      profilePhoto:  {
        __typename: "CloudinaryResource",
        publicId: string,
      },
    },
    likesCount: number,
    repliesCount: number,
    id: string,
    repostedPost_id?: string | null,
    repostedTimeRange?:  {
      __typename: "ClipTimeRange",
      endTime: number,
      startTime: number,
    } | null,
    repostedPost?:  {
      __typename: "Post",
      id: string,
      createdAt: string,
      text: string,
      author:  {
        __typename: "User",
        name?: string | null,
        sub: string,
        userHandle?:  {
          __typename: "UserHandle",
          renderedForm: string,
        } | null,
        profilePhoto:  {
          __typename: "CloudinaryResource",
          publicId: string,
        },
      },
      associatedTawk?:  {
        __typename: "TawkCandidate",
        title?: string | null,
        generatedVideo?:  {
          __typename: "CloudinaryResource",
          publicId: string,
        } | null,
        ownerSub: string,
        localId: string,
        tawkVersion: string,
        createdAt: string,
        author:  {
          __typename: "User",
          sub: string,
          name?: string | null,
          bio?: string | null,
          userHandle?:  {
            __typename: "UserHandle",
            standardForm: string,
            renderedForm: string,
          } | null,
          profilePhoto:  {
            __typename: "CloudinaryResource",
            publicId: string,
          },
        },
        duration?: number | null,
        rawAudio:  {
          __typename: "CloudinaryResource",
          publicId: string,
        },
        processedAudio?:  {
          __typename: "CloudinaryResource",
          publicId: string,
        } | null,
      } | null,
      associatedExternalTawk?:  {
        __typename: "ExternalTawk",
        id: string,
        inserter_sub: string,
        inserter:  {
          __typename: "User",
          sub: string,
          name?: string | null,
          bio?: string | null,
          userHandle?:  {
            __typename: "UserHandle",
            standardForm: string,
            renderedForm: string,
          } | null,
          profilePhoto:  {
            __typename: "CloudinaryResource",
            publicId: string,
          },
        },
        title: string,
        audioFileUrl: string,
        duration: number,
        originUrl: string,
        originKind: ExternalTawk_OriginKind,
        originName: string,
        originCreatedAt: string,
        picture:  {
          __typename: "GenericImage",
          imageUrl: string,
          cloudinaryImage?:  {
            __typename: "CloudinaryResource",
            publicId: string,
          } | null,
        },
        createdAt: string,
      } | null,
      likesCount: number,
      repliesCount: number,
      repostedPost_id?: string | null,
      repostedTimeRange?:  {
        __typename: "ClipTimeRange",
        endTime: number,
        startTime: number,
      } | null,
      repostedPost?:  {
        __typename: "Post",
        id: string,
        createdAt: string,
        text: string,
        author:  {
          __typename: "User",
          name?: string | null,
          sub: string,
          userHandle?:  {
            __typename: "UserHandle",
            renderedForm: string,
          } | null,
          profilePhoto:  {
            __typename: "CloudinaryResource",
            publicId: string,
          },
        },
        associatedTawk?:  {
          __typename: "TawkCandidate",
          title?: string | null,
          generatedVideo?:  {
            __typename: "CloudinaryResource",
            publicId: string,
          } | null,
        } | null,
      } | null,
      associatedColorHue?: number | null,
      footnote?: string | null,
    } | null,
    associatedColorHue?: number | null,
    footnote?: string | null,
  } | null,
  post13?:  {
    __typename: "Post",
    createdAt: string,
    text: string,
    associatedTawk?:  {
      __typename: "TawkCandidate",
      ownerSub: string,
      localId: string,
      tawkVersion: string,
      title?: string | null,
      createdAt: string,
      author:  {
        __typename: "User",
        sub: string,
        name?: string | null,
        bio?: string | null,
        userHandle?:  {
          __typename: "UserHandle",
          standardForm: string,
          renderedForm: string,
        } | null,
        profilePhoto:  {
          __typename: "CloudinaryResource",
          publicId: string,
        },
      },
      duration?: number | null,
      rawAudio:  {
        __typename: "CloudinaryResource",
        publicId: string,
      },
      processedAudio?:  {
        __typename: "CloudinaryResource",
        publicId: string,
      } | null,
      generatedVideo?:  {
        __typename: "CloudinaryResource",
        publicId: string,
      } | null,
    } | null,
    associatedExternalTawk?:  {
      __typename: "ExternalTawk",
      id: string,
      inserter_sub: string,
      inserter:  {
        __typename: "User",
        sub: string,
        name?: string | null,
        bio?: string | null,
        userHandle?:  {
          __typename: "UserHandle",
          standardForm: string,
          renderedForm: string,
        } | null,
        profilePhoto:  {
          __typename: "CloudinaryResource",
          publicId: string,
        },
      },
      title: string,
      audioFileUrl: string,
      duration: number,
      originUrl: string,
      originKind: ExternalTawk_OriginKind,
      originName: string,
      originCreatedAt: string,
      picture:  {
        __typename: "GenericImage",
        imageUrl: string,
        cloudinaryImage?:  {
          __typename: "CloudinaryResource",
          publicId: string,
        } | null,
      },
      createdAt: string,
    } | null,
    author:  {
      __typename: "User",
      name?: string | null,
      sub: string,
      userHandle?:  {
        __typename: "UserHandle",
        renderedForm: string,
      } | null,
      profilePhoto:  {
        __typename: "CloudinaryResource",
        publicId: string,
      },
    },
    likesCount: number,
    repliesCount: number,
    id: string,
    repostedPost_id?: string | null,
    repostedTimeRange?:  {
      __typename: "ClipTimeRange",
      endTime: number,
      startTime: number,
    } | null,
    repostedPost?:  {
      __typename: "Post",
      id: string,
      createdAt: string,
      text: string,
      author:  {
        __typename: "User",
        name?: string | null,
        sub: string,
        userHandle?:  {
          __typename: "UserHandle",
          renderedForm: string,
        } | null,
        profilePhoto:  {
          __typename: "CloudinaryResource",
          publicId: string,
        },
      },
      associatedTawk?:  {
        __typename: "TawkCandidate",
        title?: string | null,
        generatedVideo?:  {
          __typename: "CloudinaryResource",
          publicId: string,
        } | null,
        ownerSub: string,
        localId: string,
        tawkVersion: string,
        createdAt: string,
        author:  {
          __typename: "User",
          sub: string,
          name?: string | null,
          bio?: string | null,
          userHandle?:  {
            __typename: "UserHandle",
            standardForm: string,
            renderedForm: string,
          } | null,
          profilePhoto:  {
            __typename: "CloudinaryResource",
            publicId: string,
          },
        },
        duration?: number | null,
        rawAudio:  {
          __typename: "CloudinaryResource",
          publicId: string,
        },
        processedAudio?:  {
          __typename: "CloudinaryResource",
          publicId: string,
        } | null,
      } | null,
      associatedExternalTawk?:  {
        __typename: "ExternalTawk",
        id: string,
        inserter_sub: string,
        inserter:  {
          __typename: "User",
          sub: string,
          name?: string | null,
          bio?: string | null,
          userHandle?:  {
            __typename: "UserHandle",
            standardForm: string,
            renderedForm: string,
          } | null,
          profilePhoto:  {
            __typename: "CloudinaryResource",
            publicId: string,
          },
        },
        title: string,
        audioFileUrl: string,
        duration: number,
        originUrl: string,
        originKind: ExternalTawk_OriginKind,
        originName: string,
        originCreatedAt: string,
        picture:  {
          __typename: "GenericImage",
          imageUrl: string,
          cloudinaryImage?:  {
            __typename: "CloudinaryResource",
            publicId: string,
          } | null,
        },
        createdAt: string,
      } | null,
      likesCount: number,
      repliesCount: number,
      repostedPost_id?: string | null,
      repostedTimeRange?:  {
        __typename: "ClipTimeRange",
        endTime: number,
        startTime: number,
      } | null,
      repostedPost?:  {
        __typename: "Post",
        id: string,
        createdAt: string,
        text: string,
        author:  {
          __typename: "User",
          name?: string | null,
          sub: string,
          userHandle?:  {
            __typename: "UserHandle",
            renderedForm: string,
          } | null,
          profilePhoto:  {
            __typename: "CloudinaryResource",
            publicId: string,
          },
        },
        associatedTawk?:  {
          __typename: "TawkCandidate",
          title?: string | null,
          generatedVideo?:  {
            __typename: "CloudinaryResource",
            publicId: string,
          } | null,
        } | null,
      } | null,
      associatedColorHue?: number | null,
      footnote?: string | null,
    } | null,
    associatedColorHue?: number | null,
    footnote?: string | null,
  } | null,
  post14?:  {
    __typename: "Post",
    createdAt: string,
    text: string,
    associatedTawk?:  {
      __typename: "TawkCandidate",
      ownerSub: string,
      localId: string,
      tawkVersion: string,
      title?: string | null,
      createdAt: string,
      author:  {
        __typename: "User",
        sub: string,
        name?: string | null,
        bio?: string | null,
        userHandle?:  {
          __typename: "UserHandle",
          standardForm: string,
          renderedForm: string,
        } | null,
        profilePhoto:  {
          __typename: "CloudinaryResource",
          publicId: string,
        },
      },
      duration?: number | null,
      rawAudio:  {
        __typename: "CloudinaryResource",
        publicId: string,
      },
      processedAudio?:  {
        __typename: "CloudinaryResource",
        publicId: string,
      } | null,
      generatedVideo?:  {
        __typename: "CloudinaryResource",
        publicId: string,
      } | null,
    } | null,
    associatedExternalTawk?:  {
      __typename: "ExternalTawk",
      id: string,
      inserter_sub: string,
      inserter:  {
        __typename: "User",
        sub: string,
        name?: string | null,
        bio?: string | null,
        userHandle?:  {
          __typename: "UserHandle",
          standardForm: string,
          renderedForm: string,
        } | null,
        profilePhoto:  {
          __typename: "CloudinaryResource",
          publicId: string,
        },
      },
      title: string,
      audioFileUrl: string,
      duration: number,
      originUrl: string,
      originKind: ExternalTawk_OriginKind,
      originName: string,
      originCreatedAt: string,
      picture:  {
        __typename: "GenericImage",
        imageUrl: string,
        cloudinaryImage?:  {
          __typename: "CloudinaryResource",
          publicId: string,
        } | null,
      },
      createdAt: string,
    } | null,
    author:  {
      __typename: "User",
      name?: string | null,
      sub: string,
      userHandle?:  {
        __typename: "UserHandle",
        renderedForm: string,
      } | null,
      profilePhoto:  {
        __typename: "CloudinaryResource",
        publicId: string,
      },
    },
    likesCount: number,
    repliesCount: number,
    id: string,
    repostedPost_id?: string | null,
    repostedTimeRange?:  {
      __typename: "ClipTimeRange",
      endTime: number,
      startTime: number,
    } | null,
    repostedPost?:  {
      __typename: "Post",
      id: string,
      createdAt: string,
      text: string,
      author:  {
        __typename: "User",
        name?: string | null,
        sub: string,
        userHandle?:  {
          __typename: "UserHandle",
          renderedForm: string,
        } | null,
        profilePhoto:  {
          __typename: "CloudinaryResource",
          publicId: string,
        },
      },
      associatedTawk?:  {
        __typename: "TawkCandidate",
        title?: string | null,
        generatedVideo?:  {
          __typename: "CloudinaryResource",
          publicId: string,
        } | null,
        ownerSub: string,
        localId: string,
        tawkVersion: string,
        createdAt: string,
        author:  {
          __typename: "User",
          sub: string,
          name?: string | null,
          bio?: string | null,
          userHandle?:  {
            __typename: "UserHandle",
            standardForm: string,
            renderedForm: string,
          } | null,
          profilePhoto:  {
            __typename: "CloudinaryResource",
            publicId: string,
          },
        },
        duration?: number | null,
        rawAudio:  {
          __typename: "CloudinaryResource",
          publicId: string,
        },
        processedAudio?:  {
          __typename: "CloudinaryResource",
          publicId: string,
        } | null,
      } | null,
      associatedExternalTawk?:  {
        __typename: "ExternalTawk",
        id: string,
        inserter_sub: string,
        inserter:  {
          __typename: "User",
          sub: string,
          name?: string | null,
          bio?: string | null,
          userHandle?:  {
            __typename: "UserHandle",
            standardForm: string,
            renderedForm: string,
          } | null,
          profilePhoto:  {
            __typename: "CloudinaryResource",
            publicId: string,
          },
        },
        title: string,
        audioFileUrl: string,
        duration: number,
        originUrl: string,
        originKind: ExternalTawk_OriginKind,
        originName: string,
        originCreatedAt: string,
        picture:  {
          __typename: "GenericImage",
          imageUrl: string,
          cloudinaryImage?:  {
            __typename: "CloudinaryResource",
            publicId: string,
          } | null,
        },
        createdAt: string,
      } | null,
      likesCount: number,
      repliesCount: number,
      repostedPost_id?: string | null,
      repostedTimeRange?:  {
        __typename: "ClipTimeRange",
        endTime: number,
        startTime: number,
      } | null,
      repostedPost?:  {
        __typename: "Post",
        id: string,
        createdAt: string,
        text: string,
        author:  {
          __typename: "User",
          name?: string | null,
          sub: string,
          userHandle?:  {
            __typename: "UserHandle",
            renderedForm: string,
          } | null,
          profilePhoto:  {
            __typename: "CloudinaryResource",
            publicId: string,
          },
        },
        associatedTawk?:  {
          __typename: "TawkCandidate",
          title?: string | null,
          generatedVideo?:  {
            __typename: "CloudinaryResource",
            publicId: string,
          } | null,
        } | null,
      } | null,
      associatedColorHue?: number | null,
      footnote?: string | null,
    } | null,
    associatedColorHue?: number | null,
    footnote?: string | null,
  } | null,
  post15?:  {
    __typename: "Post",
    createdAt: string,
    text: string,
    associatedTawk?:  {
      __typename: "TawkCandidate",
      ownerSub: string,
      localId: string,
      tawkVersion: string,
      title?: string | null,
      createdAt: string,
      author:  {
        __typename: "User",
        sub: string,
        name?: string | null,
        bio?: string | null,
        userHandle?:  {
          __typename: "UserHandle",
          standardForm: string,
          renderedForm: string,
        } | null,
        profilePhoto:  {
          __typename: "CloudinaryResource",
          publicId: string,
        },
      },
      duration?: number | null,
      rawAudio:  {
        __typename: "CloudinaryResource",
        publicId: string,
      },
      processedAudio?:  {
        __typename: "CloudinaryResource",
        publicId: string,
      } | null,
      generatedVideo?:  {
        __typename: "CloudinaryResource",
        publicId: string,
      } | null,
    } | null,
    associatedExternalTawk?:  {
      __typename: "ExternalTawk",
      id: string,
      inserter_sub: string,
      inserter:  {
        __typename: "User",
        sub: string,
        name?: string | null,
        bio?: string | null,
        userHandle?:  {
          __typename: "UserHandle",
          standardForm: string,
          renderedForm: string,
        } | null,
        profilePhoto:  {
          __typename: "CloudinaryResource",
          publicId: string,
        },
      },
      title: string,
      audioFileUrl: string,
      duration: number,
      originUrl: string,
      originKind: ExternalTawk_OriginKind,
      originName: string,
      originCreatedAt: string,
      picture:  {
        __typename: "GenericImage",
        imageUrl: string,
        cloudinaryImage?:  {
          __typename: "CloudinaryResource",
          publicId: string,
        } | null,
      },
      createdAt: string,
    } | null,
    author:  {
      __typename: "User",
      name?: string | null,
      sub: string,
      userHandle?:  {
        __typename: "UserHandle",
        renderedForm: string,
      } | null,
      profilePhoto:  {
        __typename: "CloudinaryResource",
        publicId: string,
      },
    },
    likesCount: number,
    repliesCount: number,
    id: string,
    repostedPost_id?: string | null,
    repostedTimeRange?:  {
      __typename: "ClipTimeRange",
      endTime: number,
      startTime: number,
    } | null,
    repostedPost?:  {
      __typename: "Post",
      id: string,
      createdAt: string,
      text: string,
      author:  {
        __typename: "User",
        name?: string | null,
        sub: string,
        userHandle?:  {
          __typename: "UserHandle",
          renderedForm: string,
        } | null,
        profilePhoto:  {
          __typename: "CloudinaryResource",
          publicId: string,
        },
      },
      associatedTawk?:  {
        __typename: "TawkCandidate",
        title?: string | null,
        generatedVideo?:  {
          __typename: "CloudinaryResource",
          publicId: string,
        } | null,
        ownerSub: string,
        localId: string,
        tawkVersion: string,
        createdAt: string,
        author:  {
          __typename: "User",
          sub: string,
          name?: string | null,
          bio?: string | null,
          userHandle?:  {
            __typename: "UserHandle",
            standardForm: string,
            renderedForm: string,
          } | null,
          profilePhoto:  {
            __typename: "CloudinaryResource",
            publicId: string,
          },
        },
        duration?: number | null,
        rawAudio:  {
          __typename: "CloudinaryResource",
          publicId: string,
        },
        processedAudio?:  {
          __typename: "CloudinaryResource",
          publicId: string,
        } | null,
      } | null,
      associatedExternalTawk?:  {
        __typename: "ExternalTawk",
        id: string,
        inserter_sub: string,
        inserter:  {
          __typename: "User",
          sub: string,
          name?: string | null,
          bio?: string | null,
          userHandle?:  {
            __typename: "UserHandle",
            standardForm: string,
            renderedForm: string,
          } | null,
          profilePhoto:  {
            __typename: "CloudinaryResource",
            publicId: string,
          },
        },
        title: string,
        audioFileUrl: string,
        duration: number,
        originUrl: string,
        originKind: ExternalTawk_OriginKind,
        originName: string,
        originCreatedAt: string,
        picture:  {
          __typename: "GenericImage",
          imageUrl: string,
          cloudinaryImage?:  {
            __typename: "CloudinaryResource",
            publicId: string,
          } | null,
        },
        createdAt: string,
      } | null,
      likesCount: number,
      repliesCount: number,
      repostedPost_id?: string | null,
      repostedTimeRange?:  {
        __typename: "ClipTimeRange",
        endTime: number,
        startTime: number,
      } | null,
      repostedPost?:  {
        __typename: "Post",
        id: string,
        createdAt: string,
        text: string,
        author:  {
          __typename: "User",
          name?: string | null,
          sub: string,
          userHandle?:  {
            __typename: "UserHandle",
            renderedForm: string,
          } | null,
          profilePhoto:  {
            __typename: "CloudinaryResource",
            publicId: string,
          },
        },
        associatedTawk?:  {
          __typename: "TawkCandidate",
          title?: string | null,
          generatedVideo?:  {
            __typename: "CloudinaryResource",
            publicId: string,
          } | null,
        } | null,
      } | null,
      associatedColorHue?: number | null,
      footnote?: string | null,
    } | null,
    associatedColorHue?: number | null,
    footnote?: string | null,
  } | null,
  post16?:  {
    __typename: "Post",
    createdAt: string,
    text: string,
    associatedTawk?:  {
      __typename: "TawkCandidate",
      ownerSub: string,
      localId: string,
      tawkVersion: string,
      title?: string | null,
      createdAt: string,
      author:  {
        __typename: "User",
        sub: string,
        name?: string | null,
        bio?: string | null,
        userHandle?:  {
          __typename: "UserHandle",
          standardForm: string,
          renderedForm: string,
        } | null,
        profilePhoto:  {
          __typename: "CloudinaryResource",
          publicId: string,
        },
      },
      duration?: number | null,
      rawAudio:  {
        __typename: "CloudinaryResource",
        publicId: string,
      },
      processedAudio?:  {
        __typename: "CloudinaryResource",
        publicId: string,
      } | null,
      generatedVideo?:  {
        __typename: "CloudinaryResource",
        publicId: string,
      } | null,
    } | null,
    associatedExternalTawk?:  {
      __typename: "ExternalTawk",
      id: string,
      inserter_sub: string,
      inserter:  {
        __typename: "User",
        sub: string,
        name?: string | null,
        bio?: string | null,
        userHandle?:  {
          __typename: "UserHandle",
          standardForm: string,
          renderedForm: string,
        } | null,
        profilePhoto:  {
          __typename: "CloudinaryResource",
          publicId: string,
        },
      },
      title: string,
      audioFileUrl: string,
      duration: number,
      originUrl: string,
      originKind: ExternalTawk_OriginKind,
      originName: string,
      originCreatedAt: string,
      picture:  {
        __typename: "GenericImage",
        imageUrl: string,
        cloudinaryImage?:  {
          __typename: "CloudinaryResource",
          publicId: string,
        } | null,
      },
      createdAt: string,
    } | null,
    author:  {
      __typename: "User",
      name?: string | null,
      sub: string,
      userHandle?:  {
        __typename: "UserHandle",
        renderedForm: string,
      } | null,
      profilePhoto:  {
        __typename: "CloudinaryResource",
        publicId: string,
      },
    },
    likesCount: number,
    repliesCount: number,
    id: string,
    repostedPost_id?: string | null,
    repostedTimeRange?:  {
      __typename: "ClipTimeRange",
      endTime: number,
      startTime: number,
    } | null,
    repostedPost?:  {
      __typename: "Post",
      id: string,
      createdAt: string,
      text: string,
      author:  {
        __typename: "User",
        name?: string | null,
        sub: string,
        userHandle?:  {
          __typename: "UserHandle",
          renderedForm: string,
        } | null,
        profilePhoto:  {
          __typename: "CloudinaryResource",
          publicId: string,
        },
      },
      associatedTawk?:  {
        __typename: "TawkCandidate",
        title?: string | null,
        generatedVideo?:  {
          __typename: "CloudinaryResource",
          publicId: string,
        } | null,
        ownerSub: string,
        localId: string,
        tawkVersion: string,
        createdAt: string,
        author:  {
          __typename: "User",
          sub: string,
          name?: string | null,
          bio?: string | null,
          userHandle?:  {
            __typename: "UserHandle",
            standardForm: string,
            renderedForm: string,
          } | null,
          profilePhoto:  {
            __typename: "CloudinaryResource",
            publicId: string,
          },
        },
        duration?: number | null,
        rawAudio:  {
          __typename: "CloudinaryResource",
          publicId: string,
        },
        processedAudio?:  {
          __typename: "CloudinaryResource",
          publicId: string,
        } | null,
      } | null,
      associatedExternalTawk?:  {
        __typename: "ExternalTawk",
        id: string,
        inserter_sub: string,
        inserter:  {
          __typename: "User",
          sub: string,
          name?: string | null,
          bio?: string | null,
          userHandle?:  {
            __typename: "UserHandle",
            standardForm: string,
            renderedForm: string,
          } | null,
          profilePhoto:  {
            __typename: "CloudinaryResource",
            publicId: string,
          },
        },
        title: string,
        audioFileUrl: string,
        duration: number,
        originUrl: string,
        originKind: ExternalTawk_OriginKind,
        originName: string,
        originCreatedAt: string,
        picture:  {
          __typename: "GenericImage",
          imageUrl: string,
          cloudinaryImage?:  {
            __typename: "CloudinaryResource",
            publicId: string,
          } | null,
        },
        createdAt: string,
      } | null,
      likesCount: number,
      repliesCount: number,
      repostedPost_id?: string | null,
      repostedTimeRange?:  {
        __typename: "ClipTimeRange",
        endTime: number,
        startTime: number,
      } | null,
      repostedPost?:  {
        __typename: "Post",
        id: string,
        createdAt: string,
        text: string,
        author:  {
          __typename: "User",
          name?: string | null,
          sub: string,
          userHandle?:  {
            __typename: "UserHandle",
            renderedForm: string,
          } | null,
          profilePhoto:  {
            __typename: "CloudinaryResource",
            publicId: string,
          },
        },
        associatedTawk?:  {
          __typename: "TawkCandidate",
          title?: string | null,
          generatedVideo?:  {
            __typename: "CloudinaryResource",
            publicId: string,
          } | null,
        } | null,
      } | null,
      associatedColorHue?: number | null,
      footnote?: string | null,
    } | null,
    associatedColorHue?: number | null,
    footnote?: string | null,
  } | null,
  post17?:  {
    __typename: "Post",
    createdAt: string,
    text: string,
    associatedTawk?:  {
      __typename: "TawkCandidate",
      ownerSub: string,
      localId: string,
      tawkVersion: string,
      title?: string | null,
      createdAt: string,
      author:  {
        __typename: "User",
        sub: string,
        name?: string | null,
        bio?: string | null,
        userHandle?:  {
          __typename: "UserHandle",
          standardForm: string,
          renderedForm: string,
        } | null,
        profilePhoto:  {
          __typename: "CloudinaryResource",
          publicId: string,
        },
      },
      duration?: number | null,
      rawAudio:  {
        __typename: "CloudinaryResource",
        publicId: string,
      },
      processedAudio?:  {
        __typename: "CloudinaryResource",
        publicId: string,
      } | null,
      generatedVideo?:  {
        __typename: "CloudinaryResource",
        publicId: string,
      } | null,
    } | null,
    associatedExternalTawk?:  {
      __typename: "ExternalTawk",
      id: string,
      inserter_sub: string,
      inserter:  {
        __typename: "User",
        sub: string,
        name?: string | null,
        bio?: string | null,
        userHandle?:  {
          __typename: "UserHandle",
          standardForm: string,
          renderedForm: string,
        } | null,
        profilePhoto:  {
          __typename: "CloudinaryResource",
          publicId: string,
        },
      },
      title: string,
      audioFileUrl: string,
      duration: number,
      originUrl: string,
      originKind: ExternalTawk_OriginKind,
      originName: string,
      originCreatedAt: string,
      picture:  {
        __typename: "GenericImage",
        imageUrl: string,
        cloudinaryImage?:  {
          __typename: "CloudinaryResource",
          publicId: string,
        } | null,
      },
      createdAt: string,
    } | null,
    author:  {
      __typename: "User",
      name?: string | null,
      sub: string,
      userHandle?:  {
        __typename: "UserHandle",
        renderedForm: string,
      } | null,
      profilePhoto:  {
        __typename: "CloudinaryResource",
        publicId: string,
      },
    },
    likesCount: number,
    repliesCount: number,
    id: string,
    repostedPost_id?: string | null,
    repostedTimeRange?:  {
      __typename: "ClipTimeRange",
      endTime: number,
      startTime: number,
    } | null,
    repostedPost?:  {
      __typename: "Post",
      id: string,
      createdAt: string,
      text: string,
      author:  {
        __typename: "User",
        name?: string | null,
        sub: string,
        userHandle?:  {
          __typename: "UserHandle",
          renderedForm: string,
        } | null,
        profilePhoto:  {
          __typename: "CloudinaryResource",
          publicId: string,
        },
      },
      associatedTawk?:  {
        __typename: "TawkCandidate",
        title?: string | null,
        generatedVideo?:  {
          __typename: "CloudinaryResource",
          publicId: string,
        } | null,
        ownerSub: string,
        localId: string,
        tawkVersion: string,
        createdAt: string,
        author:  {
          __typename: "User",
          sub: string,
          name?: string | null,
          bio?: string | null,
          userHandle?:  {
            __typename: "UserHandle",
            standardForm: string,
            renderedForm: string,
          } | null,
          profilePhoto:  {
            __typename: "CloudinaryResource",
            publicId: string,
          },
        },
        duration?: number | null,
        rawAudio:  {
          __typename: "CloudinaryResource",
          publicId: string,
        },
        processedAudio?:  {
          __typename: "CloudinaryResource",
          publicId: string,
        } | null,
      } | null,
      associatedExternalTawk?:  {
        __typename: "ExternalTawk",
        id: string,
        inserter_sub: string,
        inserter:  {
          __typename: "User",
          sub: string,
          name?: string | null,
          bio?: string | null,
          userHandle?:  {
            __typename: "UserHandle",
            standardForm: string,
            renderedForm: string,
          } | null,
          profilePhoto:  {
            __typename: "CloudinaryResource",
            publicId: string,
          },
        },
        title: string,
        audioFileUrl: string,
        duration: number,
        originUrl: string,
        originKind: ExternalTawk_OriginKind,
        originName: string,
        originCreatedAt: string,
        picture:  {
          __typename: "GenericImage",
          imageUrl: string,
          cloudinaryImage?:  {
            __typename: "CloudinaryResource",
            publicId: string,
          } | null,
        },
        createdAt: string,
      } | null,
      likesCount: number,
      repliesCount: number,
      repostedPost_id?: string | null,
      repostedTimeRange?:  {
        __typename: "ClipTimeRange",
        endTime: number,
        startTime: number,
      } | null,
      repostedPost?:  {
        __typename: "Post",
        id: string,
        createdAt: string,
        text: string,
        author:  {
          __typename: "User",
          name?: string | null,
          sub: string,
          userHandle?:  {
            __typename: "UserHandle",
            renderedForm: string,
          } | null,
          profilePhoto:  {
            __typename: "CloudinaryResource",
            publicId: string,
          },
        },
        associatedTawk?:  {
          __typename: "TawkCandidate",
          title?: string | null,
          generatedVideo?:  {
            __typename: "CloudinaryResource",
            publicId: string,
          } | null,
        } | null,
      } | null,
      associatedColorHue?: number | null,
      footnote?: string | null,
    } | null,
    associatedColorHue?: number | null,
    footnote?: string | null,
  } | null,
  post18?:  {
    __typename: "Post",
    createdAt: string,
    text: string,
    associatedTawk?:  {
      __typename: "TawkCandidate",
      ownerSub: string,
      localId: string,
      tawkVersion: string,
      title?: string | null,
      createdAt: string,
      author:  {
        __typename: "User",
        sub: string,
        name?: string | null,
        bio?: string | null,
        userHandle?:  {
          __typename: "UserHandle",
          standardForm: string,
          renderedForm: string,
        } | null,
        profilePhoto:  {
          __typename: "CloudinaryResource",
          publicId: string,
        },
      },
      duration?: number | null,
      rawAudio:  {
        __typename: "CloudinaryResource",
        publicId: string,
      },
      processedAudio?:  {
        __typename: "CloudinaryResource",
        publicId: string,
      } | null,
      generatedVideo?:  {
        __typename: "CloudinaryResource",
        publicId: string,
      } | null,
    } | null,
    associatedExternalTawk?:  {
      __typename: "ExternalTawk",
      id: string,
      inserter_sub: string,
      inserter:  {
        __typename: "User",
        sub: string,
        name?: string | null,
        bio?: string | null,
        userHandle?:  {
          __typename: "UserHandle",
          standardForm: string,
          renderedForm: string,
        } | null,
        profilePhoto:  {
          __typename: "CloudinaryResource",
          publicId: string,
        },
      },
      title: string,
      audioFileUrl: string,
      duration: number,
      originUrl: string,
      originKind: ExternalTawk_OriginKind,
      originName: string,
      originCreatedAt: string,
      picture:  {
        __typename: "GenericImage",
        imageUrl: string,
        cloudinaryImage?:  {
          __typename: "CloudinaryResource",
          publicId: string,
        } | null,
      },
      createdAt: string,
    } | null,
    author:  {
      __typename: "User",
      name?: string | null,
      sub: string,
      userHandle?:  {
        __typename: "UserHandle",
        renderedForm: string,
      } | null,
      profilePhoto:  {
        __typename: "CloudinaryResource",
        publicId: string,
      },
    },
    likesCount: number,
    repliesCount: number,
    id: string,
    repostedPost_id?: string | null,
    repostedTimeRange?:  {
      __typename: "ClipTimeRange",
      endTime: number,
      startTime: number,
    } | null,
    repostedPost?:  {
      __typename: "Post",
      id: string,
      createdAt: string,
      text: string,
      author:  {
        __typename: "User",
        name?: string | null,
        sub: string,
        userHandle?:  {
          __typename: "UserHandle",
          renderedForm: string,
        } | null,
        profilePhoto:  {
          __typename: "CloudinaryResource",
          publicId: string,
        },
      },
      associatedTawk?:  {
        __typename: "TawkCandidate",
        title?: string | null,
        generatedVideo?:  {
          __typename: "CloudinaryResource",
          publicId: string,
        } | null,
        ownerSub: string,
        localId: string,
        tawkVersion: string,
        createdAt: string,
        author:  {
          __typename: "User",
          sub: string,
          name?: string | null,
          bio?: string | null,
          userHandle?:  {
            __typename: "UserHandle",
            standardForm: string,
            renderedForm: string,
          } | null,
          profilePhoto:  {
            __typename: "CloudinaryResource",
            publicId: string,
          },
        },
        duration?: number | null,
        rawAudio:  {
          __typename: "CloudinaryResource",
          publicId: string,
        },
        processedAudio?:  {
          __typename: "CloudinaryResource",
          publicId: string,
        } | null,
      } | null,
      associatedExternalTawk?:  {
        __typename: "ExternalTawk",
        id: string,
        inserter_sub: string,
        inserter:  {
          __typename: "User",
          sub: string,
          name?: string | null,
          bio?: string | null,
          userHandle?:  {
            __typename: "UserHandle",
            standardForm: string,
            renderedForm: string,
          } | null,
          profilePhoto:  {
            __typename: "CloudinaryResource",
            publicId: string,
          },
        },
        title: string,
        audioFileUrl: string,
        duration: number,
        originUrl: string,
        originKind: ExternalTawk_OriginKind,
        originName: string,
        originCreatedAt: string,
        picture:  {
          __typename: "GenericImage",
          imageUrl: string,
          cloudinaryImage?:  {
            __typename: "CloudinaryResource",
            publicId: string,
          } | null,
        },
        createdAt: string,
      } | null,
      likesCount: number,
      repliesCount: number,
      repostedPost_id?: string | null,
      repostedTimeRange?:  {
        __typename: "ClipTimeRange",
        endTime: number,
        startTime: number,
      } | null,
      repostedPost?:  {
        __typename: "Post",
        id: string,
        createdAt: string,
        text: string,
        author:  {
          __typename: "User",
          name?: string | null,
          sub: string,
          userHandle?:  {
            __typename: "UserHandle",
            renderedForm: string,
          } | null,
          profilePhoto:  {
            __typename: "CloudinaryResource",
            publicId: string,
          },
        },
        associatedTawk?:  {
          __typename: "TawkCandidate",
          title?: string | null,
          generatedVideo?:  {
            __typename: "CloudinaryResource",
            publicId: string,
          } | null,
        } | null,
      } | null,
      associatedColorHue?: number | null,
      footnote?: string | null,
    } | null,
    associatedColorHue?: number | null,
    footnote?: string | null,
  } | null,
  post19?:  {
    __typename: "Post",
    createdAt: string,
    text: string,
    associatedTawk?:  {
      __typename: "TawkCandidate",
      ownerSub: string,
      localId: string,
      tawkVersion: string,
      title?: string | null,
      createdAt: string,
      author:  {
        __typename: "User",
        sub: string,
        name?: string | null,
        bio?: string | null,
        userHandle?:  {
          __typename: "UserHandle",
          standardForm: string,
          renderedForm: string,
        } | null,
        profilePhoto:  {
          __typename: "CloudinaryResource",
          publicId: string,
        },
      },
      duration?: number | null,
      rawAudio:  {
        __typename: "CloudinaryResource",
        publicId: string,
      },
      processedAudio?:  {
        __typename: "CloudinaryResource",
        publicId: string,
      } | null,
      generatedVideo?:  {
        __typename: "CloudinaryResource",
        publicId: string,
      } | null,
    } | null,
    associatedExternalTawk?:  {
      __typename: "ExternalTawk",
      id: string,
      inserter_sub: string,
      inserter:  {
        __typename: "User",
        sub: string,
        name?: string | null,
        bio?: string | null,
        userHandle?:  {
          __typename: "UserHandle",
          standardForm: string,
          renderedForm: string,
        } | null,
        profilePhoto:  {
          __typename: "CloudinaryResource",
          publicId: string,
        },
      },
      title: string,
      audioFileUrl: string,
      duration: number,
      originUrl: string,
      originKind: ExternalTawk_OriginKind,
      originName: string,
      originCreatedAt: string,
      picture:  {
        __typename: "GenericImage",
        imageUrl: string,
        cloudinaryImage?:  {
          __typename: "CloudinaryResource",
          publicId: string,
        } | null,
      },
      createdAt: string,
    } | null,
    author:  {
      __typename: "User",
      name?: string | null,
      sub: string,
      userHandle?:  {
        __typename: "UserHandle",
        renderedForm: string,
      } | null,
      profilePhoto:  {
        __typename: "CloudinaryResource",
        publicId: string,
      },
    },
    likesCount: number,
    repliesCount: number,
    id: string,
    repostedPost_id?: string | null,
    repostedTimeRange?:  {
      __typename: "ClipTimeRange",
      endTime: number,
      startTime: number,
    } | null,
    repostedPost?:  {
      __typename: "Post",
      id: string,
      createdAt: string,
      text: string,
      author:  {
        __typename: "User",
        name?: string | null,
        sub: string,
        userHandle?:  {
          __typename: "UserHandle",
          renderedForm: string,
        } | null,
        profilePhoto:  {
          __typename: "CloudinaryResource",
          publicId: string,
        },
      },
      associatedTawk?:  {
        __typename: "TawkCandidate",
        title?: string | null,
        generatedVideo?:  {
          __typename: "CloudinaryResource",
          publicId: string,
        } | null,
        ownerSub: string,
        localId: string,
        tawkVersion: string,
        createdAt: string,
        author:  {
          __typename: "User",
          sub: string,
          name?: string | null,
          bio?: string | null,
          userHandle?:  {
            __typename: "UserHandle",
            standardForm: string,
            renderedForm: string,
          } | null,
          profilePhoto:  {
            __typename: "CloudinaryResource",
            publicId: string,
          },
        },
        duration?: number | null,
        rawAudio:  {
          __typename: "CloudinaryResource",
          publicId: string,
        },
        processedAudio?:  {
          __typename: "CloudinaryResource",
          publicId: string,
        } | null,
      } | null,
      associatedExternalTawk?:  {
        __typename: "ExternalTawk",
        id: string,
        inserter_sub: string,
        inserter:  {
          __typename: "User",
          sub: string,
          name?: string | null,
          bio?: string | null,
          userHandle?:  {
            __typename: "UserHandle",
            standardForm: string,
            renderedForm: string,
          } | null,
          profilePhoto:  {
            __typename: "CloudinaryResource",
            publicId: string,
          },
        },
        title: string,
        audioFileUrl: string,
        duration: number,
        originUrl: string,
        originKind: ExternalTawk_OriginKind,
        originName: string,
        originCreatedAt: string,
        picture:  {
          __typename: "GenericImage",
          imageUrl: string,
          cloudinaryImage?:  {
            __typename: "CloudinaryResource",
            publicId: string,
          } | null,
        },
        createdAt: string,
      } | null,
      likesCount: number,
      repliesCount: number,
      repostedPost_id?: string | null,
      repostedTimeRange?:  {
        __typename: "ClipTimeRange",
        endTime: number,
        startTime: number,
      } | null,
      repostedPost?:  {
        __typename: "Post",
        id: string,
        createdAt: string,
        text: string,
        author:  {
          __typename: "User",
          name?: string | null,
          sub: string,
          userHandle?:  {
            __typename: "UserHandle",
            renderedForm: string,
          } | null,
          profilePhoto:  {
            __typename: "CloudinaryResource",
            publicId: string,
          },
        },
        associatedTawk?:  {
          __typename: "TawkCandidate",
          title?: string | null,
          generatedVideo?:  {
            __typename: "CloudinaryResource",
            publicId: string,
          } | null,
        } | null,
      } | null,
      associatedColorHue?: number | null,
      footnote?: string | null,
    } | null,
    associatedColorHue?: number | null,
    footnote?: string | null,
  } | null,
  post20?:  {
    __typename: "Post",
    createdAt: string,
    text: string,
    associatedTawk?:  {
      __typename: "TawkCandidate",
      ownerSub: string,
      localId: string,
      tawkVersion: string,
      title?: string | null,
      createdAt: string,
      author:  {
        __typename: "User",
        sub: string,
        name?: string | null,
        bio?: string | null,
        userHandle?:  {
          __typename: "UserHandle",
          standardForm: string,
          renderedForm: string,
        } | null,
        profilePhoto:  {
          __typename: "CloudinaryResource",
          publicId: string,
        },
      },
      duration?: number | null,
      rawAudio:  {
        __typename: "CloudinaryResource",
        publicId: string,
      },
      processedAudio?:  {
        __typename: "CloudinaryResource",
        publicId: string,
      } | null,
      generatedVideo?:  {
        __typename: "CloudinaryResource",
        publicId: string,
      } | null,
    } | null,
    associatedExternalTawk?:  {
      __typename: "ExternalTawk",
      id: string,
      inserter_sub: string,
      inserter:  {
        __typename: "User",
        sub: string,
        name?: string | null,
        bio?: string | null,
        userHandle?:  {
          __typename: "UserHandle",
          standardForm: string,
          renderedForm: string,
        } | null,
        profilePhoto:  {
          __typename: "CloudinaryResource",
          publicId: string,
        },
      },
      title: string,
      audioFileUrl: string,
      duration: number,
      originUrl: string,
      originKind: ExternalTawk_OriginKind,
      originName: string,
      originCreatedAt: string,
      picture:  {
        __typename: "GenericImage",
        imageUrl: string,
        cloudinaryImage?:  {
          __typename: "CloudinaryResource",
          publicId: string,
        } | null,
      },
      createdAt: string,
    } | null,
    author:  {
      __typename: "User",
      name?: string | null,
      sub: string,
      userHandle?:  {
        __typename: "UserHandle",
        renderedForm: string,
      } | null,
      profilePhoto:  {
        __typename: "CloudinaryResource",
        publicId: string,
      },
    },
    likesCount: number,
    repliesCount: number,
    id: string,
    repostedPost_id?: string | null,
    repostedTimeRange?:  {
      __typename: "ClipTimeRange",
      endTime: number,
      startTime: number,
    } | null,
    repostedPost?:  {
      __typename: "Post",
      id: string,
      createdAt: string,
      text: string,
      author:  {
        __typename: "User",
        name?: string | null,
        sub: string,
        userHandle?:  {
          __typename: "UserHandle",
          renderedForm: string,
        } | null,
        profilePhoto:  {
          __typename: "CloudinaryResource",
          publicId: string,
        },
      },
      associatedTawk?:  {
        __typename: "TawkCandidate",
        title?: string | null,
        generatedVideo?:  {
          __typename: "CloudinaryResource",
          publicId: string,
        } | null,
        ownerSub: string,
        localId: string,
        tawkVersion: string,
        createdAt: string,
        author:  {
          __typename: "User",
          sub: string,
          name?: string | null,
          bio?: string | null,
          userHandle?:  {
            __typename: "UserHandle",
            standardForm: string,
            renderedForm: string,
          } | null,
          profilePhoto:  {
            __typename: "CloudinaryResource",
            publicId: string,
          },
        },
        duration?: number | null,
        rawAudio:  {
          __typename: "CloudinaryResource",
          publicId: string,
        },
        processedAudio?:  {
          __typename: "CloudinaryResource",
          publicId: string,
        } | null,
      } | null,
      associatedExternalTawk?:  {
        __typename: "ExternalTawk",
        id: string,
        inserter_sub: string,
        inserter:  {
          __typename: "User",
          sub: string,
          name?: string | null,
          bio?: string | null,
          userHandle?:  {
            __typename: "UserHandle",
            standardForm: string,
            renderedForm: string,
          } | null,
          profilePhoto:  {
            __typename: "CloudinaryResource",
            publicId: string,
          },
        },
        title: string,
        audioFileUrl: string,
        duration: number,
        originUrl: string,
        originKind: ExternalTawk_OriginKind,
        originName: string,
        originCreatedAt: string,
        picture:  {
          __typename: "GenericImage",
          imageUrl: string,
          cloudinaryImage?:  {
            __typename: "CloudinaryResource",
            publicId: string,
          } | null,
        },
        createdAt: string,
      } | null,
      likesCount: number,
      repliesCount: number,
      repostedPost_id?: string | null,
      repostedTimeRange?:  {
        __typename: "ClipTimeRange",
        endTime: number,
        startTime: number,
      } | null,
      repostedPost?:  {
        __typename: "Post",
        id: string,
        createdAt: string,
        text: string,
        author:  {
          __typename: "User",
          name?: string | null,
          sub: string,
          userHandle?:  {
            __typename: "UserHandle",
            renderedForm: string,
          } | null,
          profilePhoto:  {
            __typename: "CloudinaryResource",
            publicId: string,
          },
        },
        associatedTawk?:  {
          __typename: "TawkCandidate",
          title?: string | null,
          generatedVideo?:  {
            __typename: "CloudinaryResource",
            publicId: string,
          } | null,
        } | null,
      } | null,
      associatedColorHue?: number | null,
      footnote?: string | null,
    } | null,
    associatedColorHue?: number | null,
    footnote?: string | null,
  } | null,
  post21?:  {
    __typename: "Post",
    createdAt: string,
    text: string,
    associatedTawk?:  {
      __typename: "TawkCandidate",
      ownerSub: string,
      localId: string,
      tawkVersion: string,
      title?: string | null,
      createdAt: string,
      author:  {
        __typename: "User",
        sub: string,
        name?: string | null,
        bio?: string | null,
        userHandle?:  {
          __typename: "UserHandle",
          standardForm: string,
          renderedForm: string,
        } | null,
        profilePhoto:  {
          __typename: "CloudinaryResource",
          publicId: string,
        },
      },
      duration?: number | null,
      rawAudio:  {
        __typename: "CloudinaryResource",
        publicId: string,
      },
      processedAudio?:  {
        __typename: "CloudinaryResource",
        publicId: string,
      } | null,
      generatedVideo?:  {
        __typename: "CloudinaryResource",
        publicId: string,
      } | null,
    } | null,
    associatedExternalTawk?:  {
      __typename: "ExternalTawk",
      id: string,
      inserter_sub: string,
      inserter:  {
        __typename: "User",
        sub: string,
        name?: string | null,
        bio?: string | null,
        userHandle?:  {
          __typename: "UserHandle",
          standardForm: string,
          renderedForm: string,
        } | null,
        profilePhoto:  {
          __typename: "CloudinaryResource",
          publicId: string,
        },
      },
      title: string,
      audioFileUrl: string,
      duration: number,
      originUrl: string,
      originKind: ExternalTawk_OriginKind,
      originName: string,
      originCreatedAt: string,
      picture:  {
        __typename: "GenericImage",
        imageUrl: string,
        cloudinaryImage?:  {
          __typename: "CloudinaryResource",
          publicId: string,
        } | null,
      },
      createdAt: string,
    } | null,
    author:  {
      __typename: "User",
      name?: string | null,
      sub: string,
      userHandle?:  {
        __typename: "UserHandle",
        renderedForm: string,
      } | null,
      profilePhoto:  {
        __typename: "CloudinaryResource",
        publicId: string,
      },
    },
    likesCount: number,
    repliesCount: number,
    id: string,
    repostedPost_id?: string | null,
    repostedTimeRange?:  {
      __typename: "ClipTimeRange",
      endTime: number,
      startTime: number,
    } | null,
    repostedPost?:  {
      __typename: "Post",
      id: string,
      createdAt: string,
      text: string,
      author:  {
        __typename: "User",
        name?: string | null,
        sub: string,
        userHandle?:  {
          __typename: "UserHandle",
          renderedForm: string,
        } | null,
        profilePhoto:  {
          __typename: "CloudinaryResource",
          publicId: string,
        },
      },
      associatedTawk?:  {
        __typename: "TawkCandidate",
        title?: string | null,
        generatedVideo?:  {
          __typename: "CloudinaryResource",
          publicId: string,
        } | null,
        ownerSub: string,
        localId: string,
        tawkVersion: string,
        createdAt: string,
        author:  {
          __typename: "User",
          sub: string,
          name?: string | null,
          bio?: string | null,
          userHandle?:  {
            __typename: "UserHandle",
            standardForm: string,
            renderedForm: string,
          } | null,
          profilePhoto:  {
            __typename: "CloudinaryResource",
            publicId: string,
          },
        },
        duration?: number | null,
        rawAudio:  {
          __typename: "CloudinaryResource",
          publicId: string,
        },
        processedAudio?:  {
          __typename: "CloudinaryResource",
          publicId: string,
        } | null,
      } | null,
      associatedExternalTawk?:  {
        __typename: "ExternalTawk",
        id: string,
        inserter_sub: string,
        inserter:  {
          __typename: "User",
          sub: string,
          name?: string | null,
          bio?: string | null,
          userHandle?:  {
            __typename: "UserHandle",
            standardForm: string,
            renderedForm: string,
          } | null,
          profilePhoto:  {
            __typename: "CloudinaryResource",
            publicId: string,
          },
        },
        title: string,
        audioFileUrl: string,
        duration: number,
        originUrl: string,
        originKind: ExternalTawk_OriginKind,
        originName: string,
        originCreatedAt: string,
        picture:  {
          __typename: "GenericImage",
          imageUrl: string,
          cloudinaryImage?:  {
            __typename: "CloudinaryResource",
            publicId: string,
          } | null,
        },
        createdAt: string,
      } | null,
      likesCount: number,
      repliesCount: number,
      repostedPost_id?: string | null,
      repostedTimeRange?:  {
        __typename: "ClipTimeRange",
        endTime: number,
        startTime: number,
      } | null,
      repostedPost?:  {
        __typename: "Post",
        id: string,
        createdAt: string,
        text: string,
        author:  {
          __typename: "User",
          name?: string | null,
          sub: string,
          userHandle?:  {
            __typename: "UserHandle",
            renderedForm: string,
          } | null,
          profilePhoto:  {
            __typename: "CloudinaryResource",
            publicId: string,
          },
        },
        associatedTawk?:  {
          __typename: "TawkCandidate",
          title?: string | null,
          generatedVideo?:  {
            __typename: "CloudinaryResource",
            publicId: string,
          } | null,
        } | null,
      } | null,
      associatedColorHue?: number | null,
      footnote?: string | null,
    } | null,
    associatedColorHue?: number | null,
    footnote?: string | null,
  } | null,
  post22?:  {
    __typename: "Post",
    createdAt: string,
    text: string,
    associatedTawk?:  {
      __typename: "TawkCandidate",
      ownerSub: string,
      localId: string,
      tawkVersion: string,
      title?: string | null,
      createdAt: string,
      author:  {
        __typename: "User",
        sub: string,
        name?: string | null,
        bio?: string | null,
        userHandle?:  {
          __typename: "UserHandle",
          standardForm: string,
          renderedForm: string,
        } | null,
        profilePhoto:  {
          __typename: "CloudinaryResource",
          publicId: string,
        },
      },
      duration?: number | null,
      rawAudio:  {
        __typename: "CloudinaryResource",
        publicId: string,
      },
      processedAudio?:  {
        __typename: "CloudinaryResource",
        publicId: string,
      } | null,
      generatedVideo?:  {
        __typename: "CloudinaryResource",
        publicId: string,
      } | null,
    } | null,
    associatedExternalTawk?:  {
      __typename: "ExternalTawk",
      id: string,
      inserter_sub: string,
      inserter:  {
        __typename: "User",
        sub: string,
        name?: string | null,
        bio?: string | null,
        userHandle?:  {
          __typename: "UserHandle",
          standardForm: string,
          renderedForm: string,
        } | null,
        profilePhoto:  {
          __typename: "CloudinaryResource",
          publicId: string,
        },
      },
      title: string,
      audioFileUrl: string,
      duration: number,
      originUrl: string,
      originKind: ExternalTawk_OriginKind,
      originName: string,
      originCreatedAt: string,
      picture:  {
        __typename: "GenericImage",
        imageUrl: string,
        cloudinaryImage?:  {
          __typename: "CloudinaryResource",
          publicId: string,
        } | null,
      },
      createdAt: string,
    } | null,
    author:  {
      __typename: "User",
      name?: string | null,
      sub: string,
      userHandle?:  {
        __typename: "UserHandle",
        renderedForm: string,
      } | null,
      profilePhoto:  {
        __typename: "CloudinaryResource",
        publicId: string,
      },
    },
    likesCount: number,
    repliesCount: number,
    id: string,
    repostedPost_id?: string | null,
    repostedTimeRange?:  {
      __typename: "ClipTimeRange",
      endTime: number,
      startTime: number,
    } | null,
    repostedPost?:  {
      __typename: "Post",
      id: string,
      createdAt: string,
      text: string,
      author:  {
        __typename: "User",
        name?: string | null,
        sub: string,
        userHandle?:  {
          __typename: "UserHandle",
          renderedForm: string,
        } | null,
        profilePhoto:  {
          __typename: "CloudinaryResource",
          publicId: string,
        },
      },
      associatedTawk?:  {
        __typename: "TawkCandidate",
        title?: string | null,
        generatedVideo?:  {
          __typename: "CloudinaryResource",
          publicId: string,
        } | null,
        ownerSub: string,
        localId: string,
        tawkVersion: string,
        createdAt: string,
        author:  {
          __typename: "User",
          sub: string,
          name?: string | null,
          bio?: string | null,
          userHandle?:  {
            __typename: "UserHandle",
            standardForm: string,
            renderedForm: string,
          } | null,
          profilePhoto:  {
            __typename: "CloudinaryResource",
            publicId: string,
          },
        },
        duration?: number | null,
        rawAudio:  {
          __typename: "CloudinaryResource",
          publicId: string,
        },
        processedAudio?:  {
          __typename: "CloudinaryResource",
          publicId: string,
        } | null,
      } | null,
      associatedExternalTawk?:  {
        __typename: "ExternalTawk",
        id: string,
        inserter_sub: string,
        inserter:  {
          __typename: "User",
          sub: string,
          name?: string | null,
          bio?: string | null,
          userHandle?:  {
            __typename: "UserHandle",
            standardForm: string,
            renderedForm: string,
          } | null,
          profilePhoto:  {
            __typename: "CloudinaryResource",
            publicId: string,
          },
        },
        title: string,
        audioFileUrl: string,
        duration: number,
        originUrl: string,
        originKind: ExternalTawk_OriginKind,
        originName: string,
        originCreatedAt: string,
        picture:  {
          __typename: "GenericImage",
          imageUrl: string,
          cloudinaryImage?:  {
            __typename: "CloudinaryResource",
            publicId: string,
          } | null,
        },
        createdAt: string,
      } | null,
      likesCount: number,
      repliesCount: number,
      repostedPost_id?: string | null,
      repostedTimeRange?:  {
        __typename: "ClipTimeRange",
        endTime: number,
        startTime: number,
      } | null,
      repostedPost?:  {
        __typename: "Post",
        id: string,
        createdAt: string,
        text: string,
        author:  {
          __typename: "User",
          name?: string | null,
          sub: string,
          userHandle?:  {
            __typename: "UserHandle",
            renderedForm: string,
          } | null,
          profilePhoto:  {
            __typename: "CloudinaryResource",
            publicId: string,
          },
        },
        associatedTawk?:  {
          __typename: "TawkCandidate",
          title?: string | null,
          generatedVideo?:  {
            __typename: "CloudinaryResource",
            publicId: string,
          } | null,
        } | null,
      } | null,
      associatedColorHue?: number | null,
      footnote?: string | null,
    } | null,
    associatedColorHue?: number | null,
    footnote?: string | null,
  } | null,
  post23?:  {
    __typename: "Post",
    createdAt: string,
    text: string,
    associatedTawk?:  {
      __typename: "TawkCandidate",
      ownerSub: string,
      localId: string,
      tawkVersion: string,
      title?: string | null,
      createdAt: string,
      author:  {
        __typename: "User",
        sub: string,
        name?: string | null,
        bio?: string | null,
        userHandle?:  {
          __typename: "UserHandle",
          standardForm: string,
          renderedForm: string,
        } | null,
        profilePhoto:  {
          __typename: "CloudinaryResource",
          publicId: string,
        },
      },
      duration?: number | null,
      rawAudio:  {
        __typename: "CloudinaryResource",
        publicId: string,
      },
      processedAudio?:  {
        __typename: "CloudinaryResource",
        publicId: string,
      } | null,
      generatedVideo?:  {
        __typename: "CloudinaryResource",
        publicId: string,
      } | null,
    } | null,
    associatedExternalTawk?:  {
      __typename: "ExternalTawk",
      id: string,
      inserter_sub: string,
      inserter:  {
        __typename: "User",
        sub: string,
        name?: string | null,
        bio?: string | null,
        userHandle?:  {
          __typename: "UserHandle",
          standardForm: string,
          renderedForm: string,
        } | null,
        profilePhoto:  {
          __typename: "CloudinaryResource",
          publicId: string,
        },
      },
      title: string,
      audioFileUrl: string,
      duration: number,
      originUrl: string,
      originKind: ExternalTawk_OriginKind,
      originName: string,
      originCreatedAt: string,
      picture:  {
        __typename: "GenericImage",
        imageUrl: string,
        cloudinaryImage?:  {
          __typename: "CloudinaryResource",
          publicId: string,
        } | null,
      },
      createdAt: string,
    } | null,
    author:  {
      __typename: "User",
      name?: string | null,
      sub: string,
      userHandle?:  {
        __typename: "UserHandle",
        renderedForm: string,
      } | null,
      profilePhoto:  {
        __typename: "CloudinaryResource",
        publicId: string,
      },
    },
    likesCount: number,
    repliesCount: number,
    id: string,
    repostedPost_id?: string | null,
    repostedTimeRange?:  {
      __typename: "ClipTimeRange",
      endTime: number,
      startTime: number,
    } | null,
    repostedPost?:  {
      __typename: "Post",
      id: string,
      createdAt: string,
      text: string,
      author:  {
        __typename: "User",
        name?: string | null,
        sub: string,
        userHandle?:  {
          __typename: "UserHandle",
          renderedForm: string,
        } | null,
        profilePhoto:  {
          __typename: "CloudinaryResource",
          publicId: string,
        },
      },
      associatedTawk?:  {
        __typename: "TawkCandidate",
        title?: string | null,
        generatedVideo?:  {
          __typename: "CloudinaryResource",
          publicId: string,
        } | null,
        ownerSub: string,
        localId: string,
        tawkVersion: string,
        createdAt: string,
        author:  {
          __typename: "User",
          sub: string,
          name?: string | null,
          bio?: string | null,
          userHandle?:  {
            __typename: "UserHandle",
            standardForm: string,
            renderedForm: string,
          } | null,
          profilePhoto:  {
            __typename: "CloudinaryResource",
            publicId: string,
          },
        },
        duration?: number | null,
        rawAudio:  {
          __typename: "CloudinaryResource",
          publicId: string,
        },
        processedAudio?:  {
          __typename: "CloudinaryResource",
          publicId: string,
        } | null,
      } | null,
      associatedExternalTawk?:  {
        __typename: "ExternalTawk",
        id: string,
        inserter_sub: string,
        inserter:  {
          __typename: "User",
          sub: string,
          name?: string | null,
          bio?: string | null,
          userHandle?:  {
            __typename: "UserHandle",
            standardForm: string,
            renderedForm: string,
          } | null,
          profilePhoto:  {
            __typename: "CloudinaryResource",
            publicId: string,
          },
        },
        title: string,
        audioFileUrl: string,
        duration: number,
        originUrl: string,
        originKind: ExternalTawk_OriginKind,
        originName: string,
        originCreatedAt: string,
        picture:  {
          __typename: "GenericImage",
          imageUrl: string,
          cloudinaryImage?:  {
            __typename: "CloudinaryResource",
            publicId: string,
          } | null,
        },
        createdAt: string,
      } | null,
      likesCount: number,
      repliesCount: number,
      repostedPost_id?: string | null,
      repostedTimeRange?:  {
        __typename: "ClipTimeRange",
        endTime: number,
        startTime: number,
      } | null,
      repostedPost?:  {
        __typename: "Post",
        id: string,
        createdAt: string,
        text: string,
        author:  {
          __typename: "User",
          name?: string | null,
          sub: string,
          userHandle?:  {
            __typename: "UserHandle",
            renderedForm: string,
          } | null,
          profilePhoto:  {
            __typename: "CloudinaryResource",
            publicId: string,
          },
        },
        associatedTawk?:  {
          __typename: "TawkCandidate",
          title?: string | null,
          generatedVideo?:  {
            __typename: "CloudinaryResource",
            publicId: string,
          } | null,
        } | null,
      } | null,
      associatedColorHue?: number | null,
      footnote?: string | null,
    } | null,
    associatedColorHue?: number | null,
    footnote?: string | null,
  } | null,
};

export type FetchPlaylistAllPostsPaginatedByRankQueryVariables = {
  postCollectionId: string,
  nextPageToken?: string | null,
};

export type FetchPlaylistAllPostsPaginatedByRankQuery = {
  searchPostCollectionMemberships?:  {
    __typename: "SearchablePostCollectionMembershipConnection",
    nextToken?: string | null,
    items:  Array< {
      __typename: "PostCollectionMembership",
      post?:  {
        __typename: "Post",
        createdAt: string,
        text: string,
        associatedTawk?:  {
          __typename: "TawkCandidate",
          ownerSub: string,
          localId: string,
          tawkVersion: string,
          title?: string | null,
          createdAt: string,
          author:  {
            __typename: "User",
            sub: string,
            name?: string | null,
            bio?: string | null,
            userHandle?:  {
              __typename: "UserHandle",
              standardForm: string,
              renderedForm: string,
            } | null,
            profilePhoto:  {
              __typename: "CloudinaryResource",
              publicId: string,
            },
          },
          duration?: number | null,
          rawAudio:  {
            __typename: "CloudinaryResource",
            publicId: string,
          },
          processedAudio?:  {
            __typename: "CloudinaryResource",
            publicId: string,
          } | null,
          generatedVideo?:  {
            __typename: "CloudinaryResource",
            publicId: string,
          } | null,
        } | null,
        associatedExternalTawk?:  {
          __typename: "ExternalTawk",
          id: string,
          inserter_sub: string,
          inserter:  {
            __typename: "User",
            sub: string,
            name?: string | null,
            bio?: string | null,
            userHandle?:  {
              __typename: "UserHandle",
              standardForm: string,
              renderedForm: string,
            } | null,
            profilePhoto:  {
              __typename: "CloudinaryResource",
              publicId: string,
            },
          },
          title: string,
          audioFileUrl: string,
          duration: number,
          originUrl: string,
          originKind: ExternalTawk_OriginKind,
          originName: string,
          originCreatedAt: string,
          picture:  {
            __typename: "GenericImage",
            imageUrl: string,
            cloudinaryImage?:  {
              __typename: "CloudinaryResource",
              publicId: string,
            } | null,
          },
          createdAt: string,
        } | null,
        author:  {
          __typename: "User",
          name?: string | null,
          sub: string,
          userHandle?:  {
            __typename: "UserHandle",
            renderedForm: string,
          } | null,
          profilePhoto:  {
            __typename: "CloudinaryResource",
            publicId: string,
          },
        },
        likesCount: number,
        repliesCount: number,
        id: string,
        repostedPost_id?: string | null,
        repostedTimeRange?:  {
          __typename: "ClipTimeRange",
          endTime: number,
          startTime: number,
        } | null,
        repostedPost?:  {
          __typename: "Post",
          id: string,
          createdAt: string,
          text: string,
          author:  {
            __typename: "User",
            name?: string | null,
            sub: string,
            userHandle?:  {
              __typename: "UserHandle",
              renderedForm: string,
            } | null,
            profilePhoto:  {
              __typename: "CloudinaryResource",
              publicId: string,
            },
          },
          associatedTawk?:  {
            __typename: "TawkCandidate",
            title?: string | null,
            generatedVideo?:  {
              __typename: "CloudinaryResource",
              publicId: string,
            } | null,
            ownerSub: string,
            localId: string,
            tawkVersion: string,
            createdAt: string,
            author:  {
              __typename: "User",
              sub: string,
              name?: string | null,
              bio?: string | null,
              userHandle?:  {
                __typename: "UserHandle",
                standardForm: string,
                renderedForm: string,
              } | null,
              profilePhoto:  {
                __typename: "CloudinaryResource",
                publicId: string,
              },
            },
            duration?: number | null,
            rawAudio:  {
              __typename: "CloudinaryResource",
              publicId: string,
            },
            processedAudio?:  {
              __typename: "CloudinaryResource",
              publicId: string,
            } | null,
          } | null,
          associatedExternalTawk?:  {
            __typename: "ExternalTawk",
            id: string,
            inserter_sub: string,
            inserter:  {
              __typename: "User",
              sub: string,
              name?: string | null,
              bio?: string | null,
              userHandle?:  {
                __typename: "UserHandle",
                standardForm: string,
                renderedForm: string,
              } | null,
              profilePhoto:  {
                __typename: "CloudinaryResource",
                publicId: string,
              },
            },
            title: string,
            audioFileUrl: string,
            duration: number,
            originUrl: string,
            originKind: ExternalTawk_OriginKind,
            originName: string,
            originCreatedAt: string,
            picture:  {
              __typename: "GenericImage",
              imageUrl: string,
              cloudinaryImage?:  {
                __typename: "CloudinaryResource",
                publicId: string,
              } | null,
            },
            createdAt: string,
          } | null,
          likesCount: number,
          repliesCount: number,
          repostedPost_id?: string | null,
          repostedTimeRange?:  {
            __typename: "ClipTimeRange",
            endTime: number,
            startTime: number,
          } | null,
          repostedPost?:  {
            __typename: "Post",
            id: string,
            createdAt: string,
            text: string,
            author:  {
              __typename: "User",
              name?: string | null,
              sub: string,
              userHandle?:  {
                __typename: "UserHandle",
                renderedForm: string,
              } | null,
              profilePhoto:  {
                __typename: "CloudinaryResource",
                publicId: string,
              },
            },
            associatedTawk?:  {
              __typename: "TawkCandidate",
              title?: string | null,
              generatedVideo?:  {
                __typename: "CloudinaryResource",
                publicId: string,
              } | null,
            } | null,
          } | null,
          associatedColorHue?: number | null,
          footnote?: string | null,
        } | null,
        associatedColorHue?: number | null,
        footnote?: string | null,
        replies?:  {
          __typename: "ModelPostConnection",
          items:  Array< {
            __typename: "Post",
            createdAt: string,
            text: string,
            associatedTawk?:  {
              __typename: "TawkCandidate",
              ownerSub: string,
              localId: string,
              tawkVersion: string,
              title?: string | null,
              createdAt: string,
              author:  {
                __typename: "User",
                sub: string,
                name?: string | null,
                bio?: string | null,
                userHandle?:  {
                  __typename: "UserHandle",
                  standardForm: string,
                  renderedForm: string,
                } | null,
                profilePhoto:  {
                  __typename: "CloudinaryResource",
                  publicId: string,
                },
              },
              duration?: number | null,
              rawAudio:  {
                __typename: "CloudinaryResource",
                publicId: string,
              },
              processedAudio?:  {
                __typename: "CloudinaryResource",
                publicId: string,
              } | null,
              generatedVideo?:  {
                __typename: "CloudinaryResource",
                publicId: string,
              } | null,
            } | null,
            associatedExternalTawk?:  {
              __typename: "ExternalTawk",
              id: string,
              inserter_sub: string,
              inserter:  {
                __typename: "User",
                sub: string,
                name?: string | null,
                bio?: string | null,
                userHandle?:  {
                  __typename: "UserHandle",
                  standardForm: string,
                  renderedForm: string,
                } | null,
                profilePhoto:  {
                  __typename: "CloudinaryResource",
                  publicId: string,
                },
              },
              title: string,
              audioFileUrl: string,
              duration: number,
              originUrl: string,
              originKind: ExternalTawk_OriginKind,
              originName: string,
              originCreatedAt: string,
              picture:  {
                __typename: "GenericImage",
                imageUrl: string,
                cloudinaryImage?:  {
                  __typename: "CloudinaryResource",
                  publicId: string,
                } | null,
              },
              createdAt: string,
            } | null,
            author:  {
              __typename: "User",
              name?: string | null,
              sub: string,
              userHandle?:  {
                __typename: "UserHandle",
                renderedForm: string,
              } | null,
              profilePhoto:  {
                __typename: "CloudinaryResource",
                publicId: string,
              },
            },
            likesCount: number,
            repliesCount: number,
            id: string,
            repostedPost_id?: string | null,
            repostedTimeRange?:  {
              __typename: "ClipTimeRange",
              endTime: number,
              startTime: number,
            } | null,
            repostedPost?:  {
              __typename: "Post",
              id: string,
              createdAt: string,
              text: string,
              author:  {
                __typename: "User",
                name?: string | null,
                sub: string,
                userHandle?:  {
                  __typename: "UserHandle",
                  renderedForm: string,
                } | null,
                profilePhoto:  {
                  __typename: "CloudinaryResource",
                  publicId: string,
                },
              },
              associatedTawk?:  {
                __typename: "TawkCandidate",
                title?: string | null,
                generatedVideo?:  {
                  __typename: "CloudinaryResource",
                  publicId: string,
                } | null,
                ownerSub: string,
                localId: string,
                tawkVersion: string,
                createdAt: string,
                author:  {
                  __typename: "User",
                  sub: string,
                  name?: string | null,
                  bio?: string | null,
                  userHandle?:  {
                    __typename: "UserHandle",
                    standardForm: string,
                    renderedForm: string,
                  } | null,
                  profilePhoto:  {
                    __typename: "CloudinaryResource",
                    publicId: string,
                  },
                },
                duration?: number | null,
                rawAudio:  {
                  __typename: "CloudinaryResource",
                  publicId: string,
                },
                processedAudio?:  {
                  __typename: "CloudinaryResource",
                  publicId: string,
                } | null,
              } | null,
              associatedExternalTawk?:  {
                __typename: "ExternalTawk",
                id: string,
                inserter_sub: string,
                inserter:  {
                  __typename: "User",
                  sub: string,
                  name?: string | null,
                  bio?: string | null,
                  userHandle?:  {
                    __typename: "UserHandle",
                    standardForm: string,
                    renderedForm: string,
                  } | null,
                  profilePhoto:  {
                    __typename: "CloudinaryResource",
                    publicId: string,
                  },
                },
                title: string,
                audioFileUrl: string,
                duration: number,
                originUrl: string,
                originKind: ExternalTawk_OriginKind,
                originName: string,
                originCreatedAt: string,
                picture:  {
                  __typename: "GenericImage",
                  imageUrl: string,
                  cloudinaryImage?:  {
                    __typename: "CloudinaryResource",
                    publicId: string,
                  } | null,
                },
                createdAt: string,
              } | null,
              likesCount: number,
              repliesCount: number,
              repostedPost_id?: string | null,
              repostedTimeRange?:  {
                __typename: "ClipTimeRange",
                endTime: number,
                startTime: number,
              } | null,
              repostedPost?:  {
                __typename: "Post",
                id: string,
                createdAt: string,
                text: string,
                author:  {
                  __typename: "User",
                  name?: string | null,
                  sub: string,
                  userHandle?:  {
                    __typename: "UserHandle",
                    renderedForm: string,
                  } | null,
                  profilePhoto:  {
                    __typename: "CloudinaryResource",
                    publicId: string,
                  },
                },
                associatedTawk?:  {
                  __typename: "TawkCandidate",
                  title?: string | null,
                  generatedVideo?:  {
                    __typename: "CloudinaryResource",
                    publicId: string,
                  } | null,
                } | null,
              } | null,
              associatedColorHue?: number | null,
              footnote?: string | null,
            } | null,
            associatedColorHue?: number | null,
            footnote?: string | null,
          } | null >,
        } | null,
        reposts?:  {
          __typename: "ModelPostConnection",
          items:  Array< {
            __typename: "Post",
            createdAt: string,
            text: string,
            associatedTawk?:  {
              __typename: "TawkCandidate",
              ownerSub: string,
              localId: string,
              tawkVersion: string,
              title?: string | null,
              createdAt: string,
              author:  {
                __typename: "User",
                sub: string,
                name?: string | null,
                bio?: string | null,
                userHandle?:  {
                  __typename: "UserHandle",
                  standardForm: string,
                  renderedForm: string,
                } | null,
                profilePhoto:  {
                  __typename: "CloudinaryResource",
                  publicId: string,
                },
              },
              duration?: number | null,
              rawAudio:  {
                __typename: "CloudinaryResource",
                publicId: string,
              },
              processedAudio?:  {
                __typename: "CloudinaryResource",
                publicId: string,
              } | null,
              generatedVideo?:  {
                __typename: "CloudinaryResource",
                publicId: string,
              } | null,
            } | null,
            associatedExternalTawk?:  {
              __typename: "ExternalTawk",
              id: string,
              inserter_sub: string,
              inserter:  {
                __typename: "User",
                sub: string,
                name?: string | null,
                bio?: string | null,
                userHandle?:  {
                  __typename: "UserHandle",
                  standardForm: string,
                  renderedForm: string,
                } | null,
                profilePhoto:  {
                  __typename: "CloudinaryResource",
                  publicId: string,
                },
              },
              title: string,
              audioFileUrl: string,
              duration: number,
              originUrl: string,
              originKind: ExternalTawk_OriginKind,
              originName: string,
              originCreatedAt: string,
              picture:  {
                __typename: "GenericImage",
                imageUrl: string,
                cloudinaryImage?:  {
                  __typename: "CloudinaryResource",
                  publicId: string,
                } | null,
              },
              createdAt: string,
            } | null,
            author:  {
              __typename: "User",
              name?: string | null,
              sub: string,
              userHandle?:  {
                __typename: "UserHandle",
                renderedForm: string,
              } | null,
              profilePhoto:  {
                __typename: "CloudinaryResource",
                publicId: string,
              },
            },
            likesCount: number,
            repliesCount: number,
            id: string,
            repostedPost_id?: string | null,
            repostedTimeRange?:  {
              __typename: "ClipTimeRange",
              endTime: number,
              startTime: number,
            } | null,
            repostedPost?:  {
              __typename: "Post",
              id: string,
              createdAt: string,
              text: string,
              author:  {
                __typename: "User",
                name?: string | null,
                sub: string,
                userHandle?:  {
                  __typename: "UserHandle",
                  renderedForm: string,
                } | null,
                profilePhoto:  {
                  __typename: "CloudinaryResource",
                  publicId: string,
                },
              },
              associatedTawk?:  {
                __typename: "TawkCandidate",
                title?: string | null,
                generatedVideo?:  {
                  __typename: "CloudinaryResource",
                  publicId: string,
                } | null,
                ownerSub: string,
                localId: string,
                tawkVersion: string,
                createdAt: string,
                author:  {
                  __typename: "User",
                  sub: string,
                  name?: string | null,
                  bio?: string | null,
                  userHandle?:  {
                    __typename: "UserHandle",
                    standardForm: string,
                    renderedForm: string,
                  } | null,
                  profilePhoto:  {
                    __typename: "CloudinaryResource",
                    publicId: string,
                  },
                },
                duration?: number | null,
                rawAudio:  {
                  __typename: "CloudinaryResource",
                  publicId: string,
                },
                processedAudio?:  {
                  __typename: "CloudinaryResource",
                  publicId: string,
                } | null,
              } | null,
              associatedExternalTawk?:  {
                __typename: "ExternalTawk",
                id: string,
                inserter_sub: string,
                inserter:  {
                  __typename: "User",
                  sub: string,
                  name?: string | null,
                  bio?: string | null,
                  userHandle?:  {
                    __typename: "UserHandle",
                    standardForm: string,
                    renderedForm: string,
                  } | null,
                  profilePhoto:  {
                    __typename: "CloudinaryResource",
                    publicId: string,
                  },
                },
                title: string,
                audioFileUrl: string,
                duration: number,
                originUrl: string,
                originKind: ExternalTawk_OriginKind,
                originName: string,
                originCreatedAt: string,
                picture:  {
                  __typename: "GenericImage",
                  imageUrl: string,
                  cloudinaryImage?:  {
                    __typename: "CloudinaryResource",
                    publicId: string,
                  } | null,
                },
                createdAt: string,
              } | null,
              likesCount: number,
              repliesCount: number,
              repostedPost_id?: string | null,
              repostedTimeRange?:  {
                __typename: "ClipTimeRange",
                endTime: number,
                startTime: number,
              } | null,
              repostedPost?:  {
                __typename: "Post",
                id: string,
                createdAt: string,
                text: string,
                author:  {
                  __typename: "User",
                  name?: string | null,
                  sub: string,
                  userHandle?:  {
                    __typename: "UserHandle",
                    renderedForm: string,
                  } | null,
                  profilePhoto:  {
                    __typename: "CloudinaryResource",
                    publicId: string,
                  },
                },
                associatedTawk?:  {
                  __typename: "TawkCandidate",
                  title?: string | null,
                  generatedVideo?:  {
                    __typename: "CloudinaryResource",
                    publicId: string,
                  } | null,
                } | null,
              } | null,
              associatedColorHue?: number | null,
              footnote?: string | null,
            } | null,
            associatedColorHue?: number | null,
            footnote?: string | null,
          } | null >,
        } | null,
      } | null,
    } | null >,
  } | null,
};

export type FetchPlaylistAllPostsPaginatedByLatestQueryVariables = {
  postCollectionId: string,
  nextPageToken?: string | null,
};

export type FetchPlaylistAllPostsPaginatedByLatestQuery = {
  searchPostCollectionMemberships?:  {
    __typename: "SearchablePostCollectionMembershipConnection",
    nextToken?: string | null,
    items:  Array< {
      __typename: "PostCollectionMembership",
      post?:  {
        __typename: "Post",
        createdAt: string,
        text: string,
        associatedTawk?:  {
          __typename: "TawkCandidate",
          ownerSub: string,
          localId: string,
          tawkVersion: string,
          title?: string | null,
          createdAt: string,
          author:  {
            __typename: "User",
            sub: string,
            name?: string | null,
            bio?: string | null,
            userHandle?:  {
              __typename: "UserHandle",
              standardForm: string,
              renderedForm: string,
            } | null,
            profilePhoto:  {
              __typename: "CloudinaryResource",
              publicId: string,
            },
          },
          duration?: number | null,
          rawAudio:  {
            __typename: "CloudinaryResource",
            publicId: string,
          },
          processedAudio?:  {
            __typename: "CloudinaryResource",
            publicId: string,
          } | null,
          generatedVideo?:  {
            __typename: "CloudinaryResource",
            publicId: string,
          } | null,
        } | null,
        associatedExternalTawk?:  {
          __typename: "ExternalTawk",
          id: string,
          inserter_sub: string,
          inserter:  {
            __typename: "User",
            sub: string,
            name?: string | null,
            bio?: string | null,
            userHandle?:  {
              __typename: "UserHandle",
              standardForm: string,
              renderedForm: string,
            } | null,
            profilePhoto:  {
              __typename: "CloudinaryResource",
              publicId: string,
            },
          },
          title: string,
          audioFileUrl: string,
          duration: number,
          originUrl: string,
          originKind: ExternalTawk_OriginKind,
          originName: string,
          originCreatedAt: string,
          picture:  {
            __typename: "GenericImage",
            imageUrl: string,
            cloudinaryImage?:  {
              __typename: "CloudinaryResource",
              publicId: string,
            } | null,
          },
          createdAt: string,
        } | null,
        author:  {
          __typename: "User",
          name?: string | null,
          sub: string,
          userHandle?:  {
            __typename: "UserHandle",
            renderedForm: string,
          } | null,
          profilePhoto:  {
            __typename: "CloudinaryResource",
            publicId: string,
          },
        },
        likesCount: number,
        repliesCount: number,
        id: string,
        repostedPost_id?: string | null,
        repostedTimeRange?:  {
          __typename: "ClipTimeRange",
          endTime: number,
          startTime: number,
        } | null,
        repostedPost?:  {
          __typename: "Post",
          id: string,
          createdAt: string,
          text: string,
          author:  {
            __typename: "User",
            name?: string | null,
            sub: string,
            userHandle?:  {
              __typename: "UserHandle",
              renderedForm: string,
            } | null,
            profilePhoto:  {
              __typename: "CloudinaryResource",
              publicId: string,
            },
          },
          associatedTawk?:  {
            __typename: "TawkCandidate",
            title?: string | null,
            generatedVideo?:  {
              __typename: "CloudinaryResource",
              publicId: string,
            } | null,
            ownerSub: string,
            localId: string,
            tawkVersion: string,
            createdAt: string,
            author:  {
              __typename: "User",
              sub: string,
              name?: string | null,
              bio?: string | null,
              userHandle?:  {
                __typename: "UserHandle",
                standardForm: string,
                renderedForm: string,
              } | null,
              profilePhoto:  {
                __typename: "CloudinaryResource",
                publicId: string,
              },
            },
            duration?: number | null,
            rawAudio:  {
              __typename: "CloudinaryResource",
              publicId: string,
            },
            processedAudio?:  {
              __typename: "CloudinaryResource",
              publicId: string,
            } | null,
          } | null,
          associatedExternalTawk?:  {
            __typename: "ExternalTawk",
            id: string,
            inserter_sub: string,
            inserter:  {
              __typename: "User",
              sub: string,
              name?: string | null,
              bio?: string | null,
              userHandle?:  {
                __typename: "UserHandle",
                standardForm: string,
                renderedForm: string,
              } | null,
              profilePhoto:  {
                __typename: "CloudinaryResource",
                publicId: string,
              },
            },
            title: string,
            audioFileUrl: string,
            duration: number,
            originUrl: string,
            originKind: ExternalTawk_OriginKind,
            originName: string,
            originCreatedAt: string,
            picture:  {
              __typename: "GenericImage",
              imageUrl: string,
              cloudinaryImage?:  {
                __typename: "CloudinaryResource",
                publicId: string,
              } | null,
            },
            createdAt: string,
          } | null,
          likesCount: number,
          repliesCount: number,
          repostedPost_id?: string | null,
          repostedTimeRange?:  {
            __typename: "ClipTimeRange",
            endTime: number,
            startTime: number,
          } | null,
          repostedPost?:  {
            __typename: "Post",
            id: string,
            createdAt: string,
            text: string,
            author:  {
              __typename: "User",
              name?: string | null,
              sub: string,
              userHandle?:  {
                __typename: "UserHandle",
                renderedForm: string,
              } | null,
              profilePhoto:  {
                __typename: "CloudinaryResource",
                publicId: string,
              },
            },
            associatedTawk?:  {
              __typename: "TawkCandidate",
              title?: string | null,
              generatedVideo?:  {
                __typename: "CloudinaryResource",
                publicId: string,
              } | null,
            } | null,
          } | null,
          associatedColorHue?: number | null,
          footnote?: string | null,
        } | null,
        associatedColorHue?: number | null,
        footnote?: string | null,
        replies?:  {
          __typename: "ModelPostConnection",
          items:  Array< {
            __typename: "Post",
            createdAt: string,
            text: string,
            associatedTawk?:  {
              __typename: "TawkCandidate",
              ownerSub: string,
              localId: string,
              tawkVersion: string,
              title?: string | null,
              createdAt: string,
              author:  {
                __typename: "User",
                sub: string,
                name?: string | null,
                bio?: string | null,
                userHandle?:  {
                  __typename: "UserHandle",
                  standardForm: string,
                  renderedForm: string,
                } | null,
                profilePhoto:  {
                  __typename: "CloudinaryResource",
                  publicId: string,
                },
              },
              duration?: number | null,
              rawAudio:  {
                __typename: "CloudinaryResource",
                publicId: string,
              },
              processedAudio?:  {
                __typename: "CloudinaryResource",
                publicId: string,
              } | null,
              generatedVideo?:  {
                __typename: "CloudinaryResource",
                publicId: string,
              } | null,
            } | null,
            associatedExternalTawk?:  {
              __typename: "ExternalTawk",
              id: string,
              inserter_sub: string,
              inserter:  {
                __typename: "User",
                sub: string,
                name?: string | null,
                bio?: string | null,
                userHandle?:  {
                  __typename: "UserHandle",
                  standardForm: string,
                  renderedForm: string,
                } | null,
                profilePhoto:  {
                  __typename: "CloudinaryResource",
                  publicId: string,
                },
              },
              title: string,
              audioFileUrl: string,
              duration: number,
              originUrl: string,
              originKind: ExternalTawk_OriginKind,
              originName: string,
              originCreatedAt: string,
              picture:  {
                __typename: "GenericImage",
                imageUrl: string,
                cloudinaryImage?:  {
                  __typename: "CloudinaryResource",
                  publicId: string,
                } | null,
              },
              createdAt: string,
            } | null,
            author:  {
              __typename: "User",
              name?: string | null,
              sub: string,
              userHandle?:  {
                __typename: "UserHandle",
                renderedForm: string,
              } | null,
              profilePhoto:  {
                __typename: "CloudinaryResource",
                publicId: string,
              },
            },
            likesCount: number,
            repliesCount: number,
            id: string,
            repostedPost_id?: string | null,
            repostedTimeRange?:  {
              __typename: "ClipTimeRange",
              endTime: number,
              startTime: number,
            } | null,
            repostedPost?:  {
              __typename: "Post",
              id: string,
              createdAt: string,
              text: string,
              author:  {
                __typename: "User",
                name?: string | null,
                sub: string,
                userHandle?:  {
                  __typename: "UserHandle",
                  renderedForm: string,
                } | null,
                profilePhoto:  {
                  __typename: "CloudinaryResource",
                  publicId: string,
                },
              },
              associatedTawk?:  {
                __typename: "TawkCandidate",
                title?: string | null,
                generatedVideo?:  {
                  __typename: "CloudinaryResource",
                  publicId: string,
                } | null,
                ownerSub: string,
                localId: string,
                tawkVersion: string,
                createdAt: string,
                author:  {
                  __typename: "User",
                  sub: string,
                  name?: string | null,
                  bio?: string | null,
                  userHandle?:  {
                    __typename: "UserHandle",
                    standardForm: string,
                    renderedForm: string,
                  } | null,
                  profilePhoto:  {
                    __typename: "CloudinaryResource",
                    publicId: string,
                  },
                },
                duration?: number | null,
                rawAudio:  {
                  __typename: "CloudinaryResource",
                  publicId: string,
                },
                processedAudio?:  {
                  __typename: "CloudinaryResource",
                  publicId: string,
                } | null,
              } | null,
              associatedExternalTawk?:  {
                __typename: "ExternalTawk",
                id: string,
                inserter_sub: string,
                inserter:  {
                  __typename: "User",
                  sub: string,
                  name?: string | null,
                  bio?: string | null,
                  userHandle?:  {
                    __typename: "UserHandle",
                    standardForm: string,
                    renderedForm: string,
                  } | null,
                  profilePhoto:  {
                    __typename: "CloudinaryResource",
                    publicId: string,
                  },
                },
                title: string,
                audioFileUrl: string,
                duration: number,
                originUrl: string,
                originKind: ExternalTawk_OriginKind,
                originName: string,
                originCreatedAt: string,
                picture:  {
                  __typename: "GenericImage",
                  imageUrl: string,
                  cloudinaryImage?:  {
                    __typename: "CloudinaryResource",
                    publicId: string,
                  } | null,
                },
                createdAt: string,
              } | null,
              likesCount: number,
              repliesCount: number,
              repostedPost_id?: string | null,
              repostedTimeRange?:  {
                __typename: "ClipTimeRange",
                endTime: number,
                startTime: number,
              } | null,
              repostedPost?:  {
                __typename: "Post",
                id: string,
                createdAt: string,
                text: string,
                author:  {
                  __typename: "User",
                  name?: string | null,
                  sub: string,
                  userHandle?:  {
                    __typename: "UserHandle",
                    renderedForm: string,
                  } | null,
                  profilePhoto:  {
                    __typename: "CloudinaryResource",
                    publicId: string,
                  },
                },
                associatedTawk?:  {
                  __typename: "TawkCandidate",
                  title?: string | null,
                  generatedVideo?:  {
                    __typename: "CloudinaryResource",
                    publicId: string,
                  } | null,
                } | null,
              } | null,
              associatedColorHue?: number | null,
              footnote?: string | null,
            } | null,
            associatedColorHue?: number | null,
            footnote?: string | null,
          } | null >,
        } | null,
        reposts?:  {
          __typename: "ModelPostConnection",
          items:  Array< {
            __typename: "Post",
            createdAt: string,
            text: string,
            associatedTawk?:  {
              __typename: "TawkCandidate",
              ownerSub: string,
              localId: string,
              tawkVersion: string,
              title?: string | null,
              createdAt: string,
              author:  {
                __typename: "User",
                sub: string,
                name?: string | null,
                bio?: string | null,
                userHandle?:  {
                  __typename: "UserHandle",
                  standardForm: string,
                  renderedForm: string,
                } | null,
                profilePhoto:  {
                  __typename: "CloudinaryResource",
                  publicId: string,
                },
              },
              duration?: number | null,
              rawAudio:  {
                __typename: "CloudinaryResource",
                publicId: string,
              },
              processedAudio?:  {
                __typename: "CloudinaryResource",
                publicId: string,
              } | null,
              generatedVideo?:  {
                __typename: "CloudinaryResource",
                publicId: string,
              } | null,
            } | null,
            associatedExternalTawk?:  {
              __typename: "ExternalTawk",
              id: string,
              inserter_sub: string,
              inserter:  {
                __typename: "User",
                sub: string,
                name?: string | null,
                bio?: string | null,
                userHandle?:  {
                  __typename: "UserHandle",
                  standardForm: string,
                  renderedForm: string,
                } | null,
                profilePhoto:  {
                  __typename: "CloudinaryResource",
                  publicId: string,
                },
              },
              title: string,
              audioFileUrl: string,
              duration: number,
              originUrl: string,
              originKind: ExternalTawk_OriginKind,
              originName: string,
              originCreatedAt: string,
              picture:  {
                __typename: "GenericImage",
                imageUrl: string,
                cloudinaryImage?:  {
                  __typename: "CloudinaryResource",
                  publicId: string,
                } | null,
              },
              createdAt: string,
            } | null,
            author:  {
              __typename: "User",
              name?: string | null,
              sub: string,
              userHandle?:  {
                __typename: "UserHandle",
                renderedForm: string,
              } | null,
              profilePhoto:  {
                __typename: "CloudinaryResource",
                publicId: string,
              },
            },
            likesCount: number,
            repliesCount: number,
            id: string,
            repostedPost_id?: string | null,
            repostedTimeRange?:  {
              __typename: "ClipTimeRange",
              endTime: number,
              startTime: number,
            } | null,
            repostedPost?:  {
              __typename: "Post",
              id: string,
              createdAt: string,
              text: string,
              author:  {
                __typename: "User",
                name?: string | null,
                sub: string,
                userHandle?:  {
                  __typename: "UserHandle",
                  renderedForm: string,
                } | null,
                profilePhoto:  {
                  __typename: "CloudinaryResource",
                  publicId: string,
                },
              },
              associatedTawk?:  {
                __typename: "TawkCandidate",
                title?: string | null,
                generatedVideo?:  {
                  __typename: "CloudinaryResource",
                  publicId: string,
                } | null,
                ownerSub: string,
                localId: string,
                tawkVersion: string,
                createdAt: string,
                author:  {
                  __typename: "User",
                  sub: string,
                  name?: string | null,
                  bio?: string | null,
                  userHandle?:  {
                    __typename: "UserHandle",
                    standardForm: string,
                    renderedForm: string,
                  } | null,
                  profilePhoto:  {
                    __typename: "CloudinaryResource",
                    publicId: string,
                  },
                },
                duration?: number | null,
                rawAudio:  {
                  __typename: "CloudinaryResource",
                  publicId: string,
                },
                processedAudio?:  {
                  __typename: "CloudinaryResource",
                  publicId: string,
                } | null,
              } | null,
              associatedExternalTawk?:  {
                __typename: "ExternalTawk",
                id: string,
                inserter_sub: string,
                inserter:  {
                  __typename: "User",
                  sub: string,
                  name?: string | null,
                  bio?: string | null,
                  userHandle?:  {
                    __typename: "UserHandle",
                    standardForm: string,
                    renderedForm: string,
                  } | null,
                  profilePhoto:  {
                    __typename: "CloudinaryResource",
                    publicId: string,
                  },
                },
                title: string,
                audioFileUrl: string,
                duration: number,
                originUrl: string,
                originKind: ExternalTawk_OriginKind,
                originName: string,
                originCreatedAt: string,
                picture:  {
                  __typename: "GenericImage",
                  imageUrl: string,
                  cloudinaryImage?:  {
                    __typename: "CloudinaryResource",
                    publicId: string,
                  } | null,
                },
                createdAt: string,
              } | null,
              likesCount: number,
              repliesCount: number,
              repostedPost_id?: string | null,
              repostedTimeRange?:  {
                __typename: "ClipTimeRange",
                endTime: number,
                startTime: number,
              } | null,
              repostedPost?:  {
                __typename: "Post",
                id: string,
                createdAt: string,
                text: string,
                author:  {
                  __typename: "User",
                  name?: string | null,
                  sub: string,
                  userHandle?:  {
                    __typename: "UserHandle",
                    renderedForm: string,
                  } | null,
                  profilePhoto:  {
                    __typename: "CloudinaryResource",
                    publicId: string,
                  },
                },
                associatedTawk?:  {
                  __typename: "TawkCandidate",
                  title?: string | null,
                  generatedVideo?:  {
                    __typename: "CloudinaryResource",
                    publicId: string,
                  } | null,
                } | null,
              } | null,
              associatedColorHue?: number | null,
              footnote?: string | null,
            } | null,
            associatedColorHue?: number | null,
            footnote?: string | null,
          } | null >,
        } | null,
      } | null,
    } | null >,
  } | null,
};

export type FetchPlaylistInfoQueryVariables = {
  postCollectionId: string,
};

export type FetchPlaylistInfoQuery = {
  getPostCollection?:  {
    __typename: "PostCollection",
    id: string,
    description: string,
    name: string,
    updatedAt: string,
    author:  {
      __typename: "User",
      sub: string,
      name?: string | null,
      bio?: string | null,
      userHandle?:  {
        __typename: "UserHandle",
        standardForm: string,
        renderedForm: string,
      } | null,
      profilePhoto:  {
        __typename: "CloudinaryResource",
        publicId: string,
      },
    },
    defaultSortOrder?: Playlist_SortOrder | null,
  } | null,
};

export type FetchUserTawkOnlyPostsPaginatedQueryVariables = {
  userSub: string,
  nextPageToken?: string | null,
};

export type FetchUserTawkOnlyPostsPaginatedQuery = {
  searchPosts?:  {
    __typename: "SearchablePostConnection",
    nextToken?: string | null,
    items:  Array< {
      __typename: "Post",
      createdAt: string,
      text: string,
      associatedTawk?:  {
        __typename: "TawkCandidate",
        ownerSub: string,
        localId: string,
        tawkVersion: string,
        title?: string | null,
        createdAt: string,
        author:  {
          __typename: "User",
          sub: string,
          name?: string | null,
          bio?: string | null,
          userHandle?:  {
            __typename: "UserHandle",
            standardForm: string,
            renderedForm: string,
          } | null,
          profilePhoto:  {
            __typename: "CloudinaryResource",
            publicId: string,
          },
        },
        duration?: number | null,
        rawAudio:  {
          __typename: "CloudinaryResource",
          publicId: string,
        },
        processedAudio?:  {
          __typename: "CloudinaryResource",
          publicId: string,
        } | null,
        generatedVideo?:  {
          __typename: "CloudinaryResource",
          publicId: string,
        } | null,
      } | null,
      associatedExternalTawk?:  {
        __typename: "ExternalTawk",
        id: string,
        inserter_sub: string,
        inserter:  {
          __typename: "User",
          sub: string,
          name?: string | null,
          bio?: string | null,
          userHandle?:  {
            __typename: "UserHandle",
            standardForm: string,
            renderedForm: string,
          } | null,
          profilePhoto:  {
            __typename: "CloudinaryResource",
            publicId: string,
          },
        },
        title: string,
        audioFileUrl: string,
        duration: number,
        originUrl: string,
        originKind: ExternalTawk_OriginKind,
        originName: string,
        originCreatedAt: string,
        picture:  {
          __typename: "GenericImage",
          imageUrl: string,
          cloudinaryImage?:  {
            __typename: "CloudinaryResource",
            publicId: string,
          } | null,
        },
        createdAt: string,
      } | null,
      author:  {
        __typename: "User",
        name?: string | null,
        sub: string,
        userHandle?:  {
          __typename: "UserHandle",
          renderedForm: string,
        } | null,
        profilePhoto:  {
          __typename: "CloudinaryResource",
          publicId: string,
        },
      },
      likesCount: number,
      repliesCount: number,
      id: string,
      repostedPost_id?: string | null,
      repostedTimeRange?:  {
        __typename: "ClipTimeRange",
        endTime: number,
        startTime: number,
      } | null,
      repostedPost?:  {
        __typename: "Post",
        id: string,
        createdAt: string,
        text: string,
        author:  {
          __typename: "User",
          name?: string | null,
          sub: string,
          userHandle?:  {
            __typename: "UserHandle",
            renderedForm: string,
          } | null,
          profilePhoto:  {
            __typename: "CloudinaryResource",
            publicId: string,
          },
        },
        associatedTawk?:  {
          __typename: "TawkCandidate",
          title?: string | null,
          generatedVideo?:  {
            __typename: "CloudinaryResource",
            publicId: string,
          } | null,
          ownerSub: string,
          localId: string,
          tawkVersion: string,
          createdAt: string,
          author:  {
            __typename: "User",
            sub: string,
            name?: string | null,
            bio?: string | null,
            userHandle?:  {
              __typename: "UserHandle",
              standardForm: string,
              renderedForm: string,
            } | null,
            profilePhoto:  {
              __typename: "CloudinaryResource",
              publicId: string,
            },
          },
          duration?: number | null,
          rawAudio:  {
            __typename: "CloudinaryResource",
            publicId: string,
          },
          processedAudio?:  {
            __typename: "CloudinaryResource",
            publicId: string,
          } | null,
        } | null,
        associatedExternalTawk?:  {
          __typename: "ExternalTawk",
          id: string,
          inserter_sub: string,
          inserter:  {
            __typename: "User",
            sub: string,
            name?: string | null,
            bio?: string | null,
            userHandle?:  {
              __typename: "UserHandle",
              standardForm: string,
              renderedForm: string,
            } | null,
            profilePhoto:  {
              __typename: "CloudinaryResource",
              publicId: string,
            },
          },
          title: string,
          audioFileUrl: string,
          duration: number,
          originUrl: string,
          originKind: ExternalTawk_OriginKind,
          originName: string,
          originCreatedAt: string,
          picture:  {
            __typename: "GenericImage",
            imageUrl: string,
            cloudinaryImage?:  {
              __typename: "CloudinaryResource",
              publicId: string,
            } | null,
          },
          createdAt: string,
        } | null,
        likesCount: number,
        repliesCount: number,
        repostedPost_id?: string | null,
        repostedTimeRange?:  {
          __typename: "ClipTimeRange",
          endTime: number,
          startTime: number,
        } | null,
        repostedPost?:  {
          __typename: "Post",
          id: string,
          createdAt: string,
          text: string,
          author:  {
            __typename: "User",
            name?: string | null,
            sub: string,
            userHandle?:  {
              __typename: "UserHandle",
              renderedForm: string,
            } | null,
            profilePhoto:  {
              __typename: "CloudinaryResource",
              publicId: string,
            },
          },
          associatedTawk?:  {
            __typename: "TawkCandidate",
            title?: string | null,
            generatedVideo?:  {
              __typename: "CloudinaryResource",
              publicId: string,
            } | null,
          } | null,
        } | null,
        associatedColorHue?: number | null,
        footnote?: string | null,
      } | null,
      associatedColorHue?: number | null,
      footnote?: string | null,
      replies?:  {
        __typename: "ModelPostConnection",
        items:  Array< {
          __typename: "Post",
          createdAt: string,
          text: string,
          associatedTawk?:  {
            __typename: "TawkCandidate",
            ownerSub: string,
            localId: string,
            tawkVersion: string,
            title?: string | null,
            createdAt: string,
            author:  {
              __typename: "User",
              sub: string,
              name?: string | null,
              bio?: string | null,
              userHandle?:  {
                __typename: "UserHandle",
                standardForm: string,
                renderedForm: string,
              } | null,
              profilePhoto:  {
                __typename: "CloudinaryResource",
                publicId: string,
              },
            },
            duration?: number | null,
            rawAudio:  {
              __typename: "CloudinaryResource",
              publicId: string,
            },
            processedAudio?:  {
              __typename: "CloudinaryResource",
              publicId: string,
            } | null,
            generatedVideo?:  {
              __typename: "CloudinaryResource",
              publicId: string,
            } | null,
          } | null,
          associatedExternalTawk?:  {
            __typename: "ExternalTawk",
            id: string,
            inserter_sub: string,
            inserter:  {
              __typename: "User",
              sub: string,
              name?: string | null,
              bio?: string | null,
              userHandle?:  {
                __typename: "UserHandle",
                standardForm: string,
                renderedForm: string,
              } | null,
              profilePhoto:  {
                __typename: "CloudinaryResource",
                publicId: string,
              },
            },
            title: string,
            audioFileUrl: string,
            duration: number,
            originUrl: string,
            originKind: ExternalTawk_OriginKind,
            originName: string,
            originCreatedAt: string,
            picture:  {
              __typename: "GenericImage",
              imageUrl: string,
              cloudinaryImage?:  {
                __typename: "CloudinaryResource",
                publicId: string,
              } | null,
            },
            createdAt: string,
          } | null,
          author:  {
            __typename: "User",
            name?: string | null,
            sub: string,
            userHandle?:  {
              __typename: "UserHandle",
              renderedForm: string,
            } | null,
            profilePhoto:  {
              __typename: "CloudinaryResource",
              publicId: string,
            },
          },
          likesCount: number,
          repliesCount: number,
          id: string,
          repostedPost_id?: string | null,
          repostedTimeRange?:  {
            __typename: "ClipTimeRange",
            endTime: number,
            startTime: number,
          } | null,
          repostedPost?:  {
            __typename: "Post",
            id: string,
            createdAt: string,
            text: string,
            author:  {
              __typename: "User",
              name?: string | null,
              sub: string,
              userHandle?:  {
                __typename: "UserHandle",
                renderedForm: string,
              } | null,
              profilePhoto:  {
                __typename: "CloudinaryResource",
                publicId: string,
              },
            },
            associatedTawk?:  {
              __typename: "TawkCandidate",
              title?: string | null,
              generatedVideo?:  {
                __typename: "CloudinaryResource",
                publicId: string,
              } | null,
              ownerSub: string,
              localId: string,
              tawkVersion: string,
              createdAt: string,
              author:  {
                __typename: "User",
                sub: string,
                name?: string | null,
                bio?: string | null,
                userHandle?:  {
                  __typename: "UserHandle",
                  standardForm: string,
                  renderedForm: string,
                } | null,
                profilePhoto:  {
                  __typename: "CloudinaryResource",
                  publicId: string,
                },
              },
              duration?: number | null,
              rawAudio:  {
                __typename: "CloudinaryResource",
                publicId: string,
              },
              processedAudio?:  {
                __typename: "CloudinaryResource",
                publicId: string,
              } | null,
            } | null,
            associatedExternalTawk?:  {
              __typename: "ExternalTawk",
              id: string,
              inserter_sub: string,
              inserter:  {
                __typename: "User",
                sub: string,
                name?: string | null,
                bio?: string | null,
                userHandle?:  {
                  __typename: "UserHandle",
                  standardForm: string,
                  renderedForm: string,
                } | null,
                profilePhoto:  {
                  __typename: "CloudinaryResource",
                  publicId: string,
                },
              },
              title: string,
              audioFileUrl: string,
              duration: number,
              originUrl: string,
              originKind: ExternalTawk_OriginKind,
              originName: string,
              originCreatedAt: string,
              picture:  {
                __typename: "GenericImage",
                imageUrl: string,
                cloudinaryImage?:  {
                  __typename: "CloudinaryResource",
                  publicId: string,
                } | null,
              },
              createdAt: string,
            } | null,
            likesCount: number,
            repliesCount: number,
            repostedPost_id?: string | null,
            repostedTimeRange?:  {
              __typename: "ClipTimeRange",
              endTime: number,
              startTime: number,
            } | null,
            repostedPost?:  {
              __typename: "Post",
              id: string,
              createdAt: string,
              text: string,
              author:  {
                __typename: "User",
                name?: string | null,
                sub: string,
                userHandle?:  {
                  __typename: "UserHandle",
                  renderedForm: string,
                } | null,
                profilePhoto:  {
                  __typename: "CloudinaryResource",
                  publicId: string,
                },
              },
              associatedTawk?:  {
                __typename: "TawkCandidate",
                title?: string | null,
                generatedVideo?:  {
                  __typename: "CloudinaryResource",
                  publicId: string,
                } | null,
              } | null,
            } | null,
            associatedColorHue?: number | null,
            footnote?: string | null,
          } | null,
          associatedColorHue?: number | null,
          footnote?: string | null,
        } | null >,
      } | null,
      reposts?:  {
        __typename: "ModelPostConnection",
        items:  Array< {
          __typename: "Post",
          createdAt: string,
          text: string,
          associatedTawk?:  {
            __typename: "TawkCandidate",
            ownerSub: string,
            localId: string,
            tawkVersion: string,
            title?: string | null,
            createdAt: string,
            author:  {
              __typename: "User",
              sub: string,
              name?: string | null,
              bio?: string | null,
              userHandle?:  {
                __typename: "UserHandle",
                standardForm: string,
                renderedForm: string,
              } | null,
              profilePhoto:  {
                __typename: "CloudinaryResource",
                publicId: string,
              },
            },
            duration?: number | null,
            rawAudio:  {
              __typename: "CloudinaryResource",
              publicId: string,
            },
            processedAudio?:  {
              __typename: "CloudinaryResource",
              publicId: string,
            } | null,
            generatedVideo?:  {
              __typename: "CloudinaryResource",
              publicId: string,
            } | null,
          } | null,
          associatedExternalTawk?:  {
            __typename: "ExternalTawk",
            id: string,
            inserter_sub: string,
            inserter:  {
              __typename: "User",
              sub: string,
              name?: string | null,
              bio?: string | null,
              userHandle?:  {
                __typename: "UserHandle",
                standardForm: string,
                renderedForm: string,
              } | null,
              profilePhoto:  {
                __typename: "CloudinaryResource",
                publicId: string,
              },
            },
            title: string,
            audioFileUrl: string,
            duration: number,
            originUrl: string,
            originKind: ExternalTawk_OriginKind,
            originName: string,
            originCreatedAt: string,
            picture:  {
              __typename: "GenericImage",
              imageUrl: string,
              cloudinaryImage?:  {
                __typename: "CloudinaryResource",
                publicId: string,
              } | null,
            },
            createdAt: string,
          } | null,
          author:  {
            __typename: "User",
            name?: string | null,
            sub: string,
            userHandle?:  {
              __typename: "UserHandle",
              renderedForm: string,
            } | null,
            profilePhoto:  {
              __typename: "CloudinaryResource",
              publicId: string,
            },
          },
          likesCount: number,
          repliesCount: number,
          id: string,
          repostedPost_id?: string | null,
          repostedTimeRange?:  {
            __typename: "ClipTimeRange",
            endTime: number,
            startTime: number,
          } | null,
          repostedPost?:  {
            __typename: "Post",
            id: string,
            createdAt: string,
            text: string,
            author:  {
              __typename: "User",
              name?: string | null,
              sub: string,
              userHandle?:  {
                __typename: "UserHandle",
                renderedForm: string,
              } | null,
              profilePhoto:  {
                __typename: "CloudinaryResource",
                publicId: string,
              },
            },
            associatedTawk?:  {
              __typename: "TawkCandidate",
              title?: string | null,
              generatedVideo?:  {
                __typename: "CloudinaryResource",
                publicId: string,
              } | null,
              ownerSub: string,
              localId: string,
              tawkVersion: string,
              createdAt: string,
              author:  {
                __typename: "User",
                sub: string,
                name?: string | null,
                bio?: string | null,
                userHandle?:  {
                  __typename: "UserHandle",
                  standardForm: string,
                  renderedForm: string,
                } | null,
                profilePhoto:  {
                  __typename: "CloudinaryResource",
                  publicId: string,
                },
              },
              duration?: number | null,
              rawAudio:  {
                __typename: "CloudinaryResource",
                publicId: string,
              },
              processedAudio?:  {
                __typename: "CloudinaryResource",
                publicId: string,
              } | null,
            } | null,
            associatedExternalTawk?:  {
              __typename: "ExternalTawk",
              id: string,
              inserter_sub: string,
              inserter:  {
                __typename: "User",
                sub: string,
                name?: string | null,
                bio?: string | null,
                userHandle?:  {
                  __typename: "UserHandle",
                  standardForm: string,
                  renderedForm: string,
                } | null,
                profilePhoto:  {
                  __typename: "CloudinaryResource",
                  publicId: string,
                },
              },
              title: string,
              audioFileUrl: string,
              duration: number,
              originUrl: string,
              originKind: ExternalTawk_OriginKind,
              originName: string,
              originCreatedAt: string,
              picture:  {
                __typename: "GenericImage",
                imageUrl: string,
                cloudinaryImage?:  {
                  __typename: "CloudinaryResource",
                  publicId: string,
                } | null,
              },
              createdAt: string,
            } | null,
            likesCount: number,
            repliesCount: number,
            repostedPost_id?: string | null,
            repostedTimeRange?:  {
              __typename: "ClipTimeRange",
              endTime: number,
              startTime: number,
            } | null,
            repostedPost?:  {
              __typename: "Post",
              id: string,
              createdAt: string,
              text: string,
              author:  {
                __typename: "User",
                name?: string | null,
                sub: string,
                userHandle?:  {
                  __typename: "UserHandle",
                  renderedForm: string,
                } | null,
                profilePhoto:  {
                  __typename: "CloudinaryResource",
                  publicId: string,
                },
              },
              associatedTawk?:  {
                __typename: "TawkCandidate",
                title?: string | null,
                generatedVideo?:  {
                  __typename: "CloudinaryResource",
                  publicId: string,
                } | null,
              } | null,
            } | null,
            associatedColorHue?: number | null,
            footnote?: string | null,
          } | null,
          associatedColorHue?: number | null,
          footnote?: string | null,
        } | null >,
      } | null,
    } | null >,
  } | null,
};

export type FetchUserAllPostsPaginatedQueryVariables = {
  userSub: string,
  nextPageToken?: string | null,
};

export type FetchUserAllPostsPaginatedQuery = {
  searchPosts?:  {
    __typename: "SearchablePostConnection",
    nextToken?: string | null,
    items:  Array< {
      __typename: "Post",
      createdAt: string,
      text: string,
      associatedTawk?:  {
        __typename: "TawkCandidate",
        ownerSub: string,
        localId: string,
        tawkVersion: string,
        title?: string | null,
        createdAt: string,
        author:  {
          __typename: "User",
          sub: string,
          name?: string | null,
          bio?: string | null,
          userHandle?:  {
            __typename: "UserHandle",
            standardForm: string,
            renderedForm: string,
          } | null,
          profilePhoto:  {
            __typename: "CloudinaryResource",
            publicId: string,
          },
        },
        duration?: number | null,
        rawAudio:  {
          __typename: "CloudinaryResource",
          publicId: string,
        },
        processedAudio?:  {
          __typename: "CloudinaryResource",
          publicId: string,
        } | null,
        generatedVideo?:  {
          __typename: "CloudinaryResource",
          publicId: string,
        } | null,
      } | null,
      associatedExternalTawk?:  {
        __typename: "ExternalTawk",
        id: string,
        inserter_sub: string,
        inserter:  {
          __typename: "User",
          sub: string,
          name?: string | null,
          bio?: string | null,
          userHandle?:  {
            __typename: "UserHandle",
            standardForm: string,
            renderedForm: string,
          } | null,
          profilePhoto:  {
            __typename: "CloudinaryResource",
            publicId: string,
          },
        },
        title: string,
        audioFileUrl: string,
        duration: number,
        originUrl: string,
        originKind: ExternalTawk_OriginKind,
        originName: string,
        originCreatedAt: string,
        picture:  {
          __typename: "GenericImage",
          imageUrl: string,
          cloudinaryImage?:  {
            __typename: "CloudinaryResource",
            publicId: string,
          } | null,
        },
        createdAt: string,
      } | null,
      author:  {
        __typename: "User",
        name?: string | null,
        sub: string,
        userHandle?:  {
          __typename: "UserHandle",
          renderedForm: string,
        } | null,
        profilePhoto:  {
          __typename: "CloudinaryResource",
          publicId: string,
        },
      },
      likesCount: number,
      repliesCount: number,
      id: string,
      repostedPost_id?: string | null,
      repostedTimeRange?:  {
        __typename: "ClipTimeRange",
        endTime: number,
        startTime: number,
      } | null,
      repostedPost?:  {
        __typename: "Post",
        id: string,
        createdAt: string,
        text: string,
        author:  {
          __typename: "User",
          name?: string | null,
          sub: string,
          userHandle?:  {
            __typename: "UserHandle",
            renderedForm: string,
          } | null,
          profilePhoto:  {
            __typename: "CloudinaryResource",
            publicId: string,
          },
        },
        associatedTawk?:  {
          __typename: "TawkCandidate",
          title?: string | null,
          generatedVideo?:  {
            __typename: "CloudinaryResource",
            publicId: string,
          } | null,
          ownerSub: string,
          localId: string,
          tawkVersion: string,
          createdAt: string,
          author:  {
            __typename: "User",
            sub: string,
            name?: string | null,
            bio?: string | null,
            userHandle?:  {
              __typename: "UserHandle",
              standardForm: string,
              renderedForm: string,
            } | null,
            profilePhoto:  {
              __typename: "CloudinaryResource",
              publicId: string,
            },
          },
          duration?: number | null,
          rawAudio:  {
            __typename: "CloudinaryResource",
            publicId: string,
          },
          processedAudio?:  {
            __typename: "CloudinaryResource",
            publicId: string,
          } | null,
        } | null,
        associatedExternalTawk?:  {
          __typename: "ExternalTawk",
          id: string,
          inserter_sub: string,
          inserter:  {
            __typename: "User",
            sub: string,
            name?: string | null,
            bio?: string | null,
            userHandle?:  {
              __typename: "UserHandle",
              standardForm: string,
              renderedForm: string,
            } | null,
            profilePhoto:  {
              __typename: "CloudinaryResource",
              publicId: string,
            },
          },
          title: string,
          audioFileUrl: string,
          duration: number,
          originUrl: string,
          originKind: ExternalTawk_OriginKind,
          originName: string,
          originCreatedAt: string,
          picture:  {
            __typename: "GenericImage",
            imageUrl: string,
            cloudinaryImage?:  {
              __typename: "CloudinaryResource",
              publicId: string,
            } | null,
          },
          createdAt: string,
        } | null,
        likesCount: number,
        repliesCount: number,
        repostedPost_id?: string | null,
        repostedTimeRange?:  {
          __typename: "ClipTimeRange",
          endTime: number,
          startTime: number,
        } | null,
        repostedPost?:  {
          __typename: "Post",
          id: string,
          createdAt: string,
          text: string,
          author:  {
            __typename: "User",
            name?: string | null,
            sub: string,
            userHandle?:  {
              __typename: "UserHandle",
              renderedForm: string,
            } | null,
            profilePhoto:  {
              __typename: "CloudinaryResource",
              publicId: string,
            },
          },
          associatedTawk?:  {
            __typename: "TawkCandidate",
            title?: string | null,
            generatedVideo?:  {
              __typename: "CloudinaryResource",
              publicId: string,
            } | null,
          } | null,
        } | null,
        associatedColorHue?: number | null,
        footnote?: string | null,
      } | null,
      associatedColorHue?: number | null,
      footnote?: string | null,
      replies?:  {
        __typename: "ModelPostConnection",
        items:  Array< {
          __typename: "Post",
          createdAt: string,
          text: string,
          associatedTawk?:  {
            __typename: "TawkCandidate",
            ownerSub: string,
            localId: string,
            tawkVersion: string,
            title?: string | null,
            createdAt: string,
            author:  {
              __typename: "User",
              sub: string,
              name?: string | null,
              bio?: string | null,
              userHandle?:  {
                __typename: "UserHandle",
                standardForm: string,
                renderedForm: string,
              } | null,
              profilePhoto:  {
                __typename: "CloudinaryResource",
                publicId: string,
              },
            },
            duration?: number | null,
            rawAudio:  {
              __typename: "CloudinaryResource",
              publicId: string,
            },
            processedAudio?:  {
              __typename: "CloudinaryResource",
              publicId: string,
            } | null,
            generatedVideo?:  {
              __typename: "CloudinaryResource",
              publicId: string,
            } | null,
          } | null,
          associatedExternalTawk?:  {
            __typename: "ExternalTawk",
            id: string,
            inserter_sub: string,
            inserter:  {
              __typename: "User",
              sub: string,
              name?: string | null,
              bio?: string | null,
              userHandle?:  {
                __typename: "UserHandle",
                standardForm: string,
                renderedForm: string,
              } | null,
              profilePhoto:  {
                __typename: "CloudinaryResource",
                publicId: string,
              },
            },
            title: string,
            audioFileUrl: string,
            duration: number,
            originUrl: string,
            originKind: ExternalTawk_OriginKind,
            originName: string,
            originCreatedAt: string,
            picture:  {
              __typename: "GenericImage",
              imageUrl: string,
              cloudinaryImage?:  {
                __typename: "CloudinaryResource",
                publicId: string,
              } | null,
            },
            createdAt: string,
          } | null,
          author:  {
            __typename: "User",
            name?: string | null,
            sub: string,
            userHandle?:  {
              __typename: "UserHandle",
              renderedForm: string,
            } | null,
            profilePhoto:  {
              __typename: "CloudinaryResource",
              publicId: string,
            },
          },
          likesCount: number,
          repliesCount: number,
          id: string,
          repostedPost_id?: string | null,
          repostedTimeRange?:  {
            __typename: "ClipTimeRange",
            endTime: number,
            startTime: number,
          } | null,
          repostedPost?:  {
            __typename: "Post",
            id: string,
            createdAt: string,
            text: string,
            author:  {
              __typename: "User",
              name?: string | null,
              sub: string,
              userHandle?:  {
                __typename: "UserHandle",
                renderedForm: string,
              } | null,
              profilePhoto:  {
                __typename: "CloudinaryResource",
                publicId: string,
              },
            },
            associatedTawk?:  {
              __typename: "TawkCandidate",
              title?: string | null,
              generatedVideo?:  {
                __typename: "CloudinaryResource",
                publicId: string,
              } | null,
              ownerSub: string,
              localId: string,
              tawkVersion: string,
              createdAt: string,
              author:  {
                __typename: "User",
                sub: string,
                name?: string | null,
                bio?: string | null,
                userHandle?:  {
                  __typename: "UserHandle",
                  standardForm: string,
                  renderedForm: string,
                } | null,
                profilePhoto:  {
                  __typename: "CloudinaryResource",
                  publicId: string,
                },
              },
              duration?: number | null,
              rawAudio:  {
                __typename: "CloudinaryResource",
                publicId: string,
              },
              processedAudio?:  {
                __typename: "CloudinaryResource",
                publicId: string,
              } | null,
            } | null,
            associatedExternalTawk?:  {
              __typename: "ExternalTawk",
              id: string,
              inserter_sub: string,
              inserter:  {
                __typename: "User",
                sub: string,
                name?: string | null,
                bio?: string | null,
                userHandle?:  {
                  __typename: "UserHandle",
                  standardForm: string,
                  renderedForm: string,
                } | null,
                profilePhoto:  {
                  __typename: "CloudinaryResource",
                  publicId: string,
                },
              },
              title: string,
              audioFileUrl: string,
              duration: number,
              originUrl: string,
              originKind: ExternalTawk_OriginKind,
              originName: string,
              originCreatedAt: string,
              picture:  {
                __typename: "GenericImage",
                imageUrl: string,
                cloudinaryImage?:  {
                  __typename: "CloudinaryResource",
                  publicId: string,
                } | null,
              },
              createdAt: string,
            } | null,
            likesCount: number,
            repliesCount: number,
            repostedPost_id?: string | null,
            repostedTimeRange?:  {
              __typename: "ClipTimeRange",
              endTime: number,
              startTime: number,
            } | null,
            repostedPost?:  {
              __typename: "Post",
              id: string,
              createdAt: string,
              text: string,
              author:  {
                __typename: "User",
                name?: string | null,
                sub: string,
                userHandle?:  {
                  __typename: "UserHandle",
                  renderedForm: string,
                } | null,
                profilePhoto:  {
                  __typename: "CloudinaryResource",
                  publicId: string,
                },
              },
              associatedTawk?:  {
                __typename: "TawkCandidate",
                title?: string | null,
                generatedVideo?:  {
                  __typename: "CloudinaryResource",
                  publicId: string,
                } | null,
              } | null,
            } | null,
            associatedColorHue?: number | null,
            footnote?: string | null,
          } | null,
          associatedColorHue?: number | null,
          footnote?: string | null,
        } | null >,
      } | null,
      reposts?:  {
        __typename: "ModelPostConnection",
        items:  Array< {
          __typename: "Post",
          createdAt: string,
          text: string,
          associatedTawk?:  {
            __typename: "TawkCandidate",
            ownerSub: string,
            localId: string,
            tawkVersion: string,
            title?: string | null,
            createdAt: string,
            author:  {
              __typename: "User",
              sub: string,
              name?: string | null,
              bio?: string | null,
              userHandle?:  {
                __typename: "UserHandle",
                standardForm: string,
                renderedForm: string,
              } | null,
              profilePhoto:  {
                __typename: "CloudinaryResource",
                publicId: string,
              },
            },
            duration?: number | null,
            rawAudio:  {
              __typename: "CloudinaryResource",
              publicId: string,
            },
            processedAudio?:  {
              __typename: "CloudinaryResource",
              publicId: string,
            } | null,
            generatedVideo?:  {
              __typename: "CloudinaryResource",
              publicId: string,
            } | null,
          } | null,
          associatedExternalTawk?:  {
            __typename: "ExternalTawk",
            id: string,
            inserter_sub: string,
            inserter:  {
              __typename: "User",
              sub: string,
              name?: string | null,
              bio?: string | null,
              userHandle?:  {
                __typename: "UserHandle",
                standardForm: string,
                renderedForm: string,
              } | null,
              profilePhoto:  {
                __typename: "CloudinaryResource",
                publicId: string,
              },
            },
            title: string,
            audioFileUrl: string,
            duration: number,
            originUrl: string,
            originKind: ExternalTawk_OriginKind,
            originName: string,
            originCreatedAt: string,
            picture:  {
              __typename: "GenericImage",
              imageUrl: string,
              cloudinaryImage?:  {
                __typename: "CloudinaryResource",
                publicId: string,
              } | null,
            },
            createdAt: string,
          } | null,
          author:  {
            __typename: "User",
            name?: string | null,
            sub: string,
            userHandle?:  {
              __typename: "UserHandle",
              renderedForm: string,
            } | null,
            profilePhoto:  {
              __typename: "CloudinaryResource",
              publicId: string,
            },
          },
          likesCount: number,
          repliesCount: number,
          id: string,
          repostedPost_id?: string | null,
          repostedTimeRange?:  {
            __typename: "ClipTimeRange",
            endTime: number,
            startTime: number,
          } | null,
          repostedPost?:  {
            __typename: "Post",
            id: string,
            createdAt: string,
            text: string,
            author:  {
              __typename: "User",
              name?: string | null,
              sub: string,
              userHandle?:  {
                __typename: "UserHandle",
                renderedForm: string,
              } | null,
              profilePhoto:  {
                __typename: "CloudinaryResource",
                publicId: string,
              },
            },
            associatedTawk?:  {
              __typename: "TawkCandidate",
              title?: string | null,
              generatedVideo?:  {
                __typename: "CloudinaryResource",
                publicId: string,
              } | null,
              ownerSub: string,
              localId: string,
              tawkVersion: string,
              createdAt: string,
              author:  {
                __typename: "User",
                sub: string,
                name?: string | null,
                bio?: string | null,
                userHandle?:  {
                  __typename: "UserHandle",
                  standardForm: string,
                  renderedForm: string,
                } | null,
                profilePhoto:  {
                  __typename: "CloudinaryResource",
                  publicId: string,
                },
              },
              duration?: number | null,
              rawAudio:  {
                __typename: "CloudinaryResource",
                publicId: string,
              },
              processedAudio?:  {
                __typename: "CloudinaryResource",
                publicId: string,
              } | null,
            } | null,
            associatedExternalTawk?:  {
              __typename: "ExternalTawk",
              id: string,
              inserter_sub: string,
              inserter:  {
                __typename: "User",
                sub: string,
                name?: string | null,
                bio?: string | null,
                userHandle?:  {
                  __typename: "UserHandle",
                  standardForm: string,
                  renderedForm: string,
                } | null,
                profilePhoto:  {
                  __typename: "CloudinaryResource",
                  publicId: string,
                },
              },
              title: string,
              audioFileUrl: string,
              duration: number,
              originUrl: string,
              originKind: ExternalTawk_OriginKind,
              originName: string,
              originCreatedAt: string,
              picture:  {
                __typename: "GenericImage",
                imageUrl: string,
                cloudinaryImage?:  {
                  __typename: "CloudinaryResource",
                  publicId: string,
                } | null,
              },
              createdAt: string,
            } | null,
            likesCount: number,
            repliesCount: number,
            repostedPost_id?: string | null,
            repostedTimeRange?:  {
              __typename: "ClipTimeRange",
              endTime: number,
              startTime: number,
            } | null,
            repostedPost?:  {
              __typename: "Post",
              id: string,
              createdAt: string,
              text: string,
              author:  {
                __typename: "User",
                name?: string | null,
                sub: string,
                userHandle?:  {
                  __typename: "UserHandle",
                  renderedForm: string,
                } | null,
                profilePhoto:  {
                  __typename: "CloudinaryResource",
                  publicId: string,
                },
              },
              associatedTawk?:  {
                __typename: "TawkCandidate",
                title?: string | null,
                generatedVideo?:  {
                  __typename: "CloudinaryResource",
                  publicId: string,
                } | null,
              } | null,
            } | null,
            associatedColorHue?: number | null,
            footnote?: string | null,
          } | null,
          associatedColorHue?: number | null,
          footnote?: string | null,
        } | null >,
      } | null,
    } | null >,
  } | null,
};

export type FetchUserPlaylistsQueryVariables = {
  userSub: string,
  nextPageToken?: string | null,
};

export type FetchUserPlaylistsQuery = {
  getUser?:  {
    __typename: "User",
    postCollections?:  {
      __typename: "ModelPostCollectionConnection",
      items:  Array< {
        __typename: "PostCollection",
        id: string,
        description: string,
        name: string,
        updatedAt: string,
        author:  {
          __typename: "User",
          sub: string,
          name?: string | null,
          bio?: string | null,
          userHandle?:  {
            __typename: "UserHandle",
            standardForm: string,
            renderedForm: string,
          } | null,
          profilePhoto:  {
            __typename: "CloudinaryResource",
            publicId: string,
          },
        },
        defaultSortOrder?: Playlist_SortOrder | null,
      } | null >,
      nextToken?: string | null,
    } | null,
  } | null,
};

export type FetchUserFromUserHandleQueryVariables = {
  userHandleStandardForm: string,
};

export type FetchUserFromUserHandleQuery = {
  getUserHandle?:  {
    __typename: "UserHandle",
    owner:  {
      __typename: "User",
      sub: string,
      name?: string | null,
      bio?: string | null,
      userHandle?:  {
        __typename: "UserHandle",
        standardForm: string,
        renderedForm: string,
      } | null,
      profilePhoto:  {
        __typename: "CloudinaryResource",
        publicId: string,
      },
    },
  } | null,
};

export type GET_TAWKPOST_DATAQueryVariables = {
  id: string,
};

export type GET_TAWKPOST_DATAQuery = {
  getPost?:  {
    __typename: "Post",
    createdAt: string,
    text: string,
    repliesCount: number,
    likesCount: number,
    author:  {
      __typename: "User",
      name?: string | null,
      sub: string,
      userHandle?:  {
        __typename: "UserHandle",
        renderedForm: string,
      } | null,
      profilePhoto:  {
        __typename: "CloudinaryResource",
        publicId: string,
      },
    },
    associatedTawk?:  {
      __typename: "TawkCandidate",
      title?: string | null,
      generatedVideo?:  {
        __typename: "CloudinaryResource",
        publicId: string,
      } | null,
    } | null,
    replies?:  {
      __typename: "ModelPostConnection",
      items:  Array< {
        __typename: "Post",
        text: string,
        author:  {
          __typename: "User",
          name?: string | null,
          sub: string,
          userHandle?:  {
            __typename: "UserHandle",
            renderedForm: string,
          } | null,
          profilePhoto:  {
            __typename: "CloudinaryResource",
            publicId: string,
          },
        },
        likesCount: number,
        repliesCount: number,
        createdAt: string,
        associatedTawk?:  {
          __typename: "TawkCandidate",
          title?: string | null,
          generatedVideo?:  {
            __typename: "CloudinaryResource",
            publicId: string,
          } | null,
        } | null,
        id: string,
      } | null >,
    } | null,
  } | null,
};

export type getCollectionDataQueryVariables = {
  id: string,
};

export type getCollectionDataQuery = {
  getPostCollection?:  {
    __typename: "PostCollection",
    id: string,
    description: string,
    name: string,
    updatedAt: string,
    author:  {
      __typename: "User",
      name?: string | null,
      sub: string,
      userHandle?:  {
        __typename: "UserHandle",
        renderedForm: string,
      } | null,
      profilePhoto:  {
        __typename: "CloudinaryResource",
        publicId: string,
      },
    },
    color?:  {
      __typename: "Color",
      blue: number,
      green: number,
      red: number,
    } | null,
    emoji?: string | null,
    memberships?:  {
      __typename: "ModelPostCollectionMembershipConnection",
      items:  Array< {
        __typename: "PostCollectionMembership",
        post?:  {
          __typename: "Post",
          createdAt: string,
          text: string,
          associatedTawk?:  {
            __typename: "TawkCandidate",
            title?: string | null,
            createdAt: string,
            generatedVideo?:  {
              __typename: "CloudinaryResource",
              publicId: string,
            } | null,
            rawAudio:  {
              __typename: "CloudinaryResource",
              publicId: string,
            },
          } | null,
          author:  {
            __typename: "User",
            name?: string | null,
            sub: string,
            userHandle?:  {
              __typename: "UserHandle",
              renderedForm: string,
            } | null,
            profilePhoto:  {
              __typename: "CloudinaryResource",
              publicId: string,
            },
          },
          likesCount: number,
          repliesCount: number,
          id: string,
          repostedPost_id?: string | null,
          repostedTimeRange?:  {
            __typename: "ClipTimeRange",
            endTime: number,
            startTime: number,
          } | null,
          repostedPost?:  {
            __typename: "Post",
            id: string,
            createdAt: string,
            text: string,
            author:  {
              __typename: "User",
              name?: string | null,
              sub: string,
              userHandle?:  {
                __typename: "UserHandle",
                renderedForm: string,
              } | null,
              profilePhoto:  {
                __typename: "CloudinaryResource",
                publicId: string,
              },
            },
            associatedTawk?:  {
              __typename: "TawkCandidate",
              title?: string | null,
              generatedVideo?:  {
                __typename: "CloudinaryResource",
                publicId: string,
              } | null,
            } | null,
          } | null,
        } | null,
      } | null >,
    } | null,
  } | null,
};

export type GET_USERPROFILE_POSTSQueryVariables = {
  sub: string,
};

export type GET_USERPROFILE_POSTSQuery = {
  getUser?:  {
    __typename: "User",
    posts?:  {
      __typename: "ModelPostConnection",
      items:  Array< {
        __typename: "Post",
        text: string,
        createdAt: string,
        id: string,
        likesCount: number,
        repliesCount: number,
        author:  {
          __typename: "User",
          name?: string | null,
          sub: string,
          userHandle?:  {
            __typename: "UserHandle",
            renderedForm: string,
          } | null,
          profilePhoto:  {
            __typename: "CloudinaryResource",
            publicId: string,
          },
        },
        associatedTawk?:  {
          __typename: "TawkCandidate",
          title?: string | null,
          generatedVideo?:  {
            __typename: "CloudinaryResource",
            publicId: string,
          } | null,
        } | null,
      } | null >,
    } | null,
  } | null,
};

export type GET_USERPROFILE_CURATIONSQueryVariables = {
  sub: string,
};

export type GET_USERPROFILE_CURATIONSQuery = {
  listPostCollections?:  {
    __typename: "ModelPostCollectionConnection",
    items:  Array< {
      __typename: "PostCollection",
      id: string,
      description: string,
      name: string,
      updatedAt: string,
      author:  {
        __typename: "User",
        name?: string | null,
        sub: string,
        userHandle?:  {
          __typename: "UserHandle",
          renderedForm: string,
        } | null,
        profilePhoto:  {
          __typename: "CloudinaryResource",
          publicId: string,
        },
      },
      color?:  {
        __typename: "Color",
        blue: number,
        green: number,
        red: number,
      } | null,
      emoji?: string | null,
      memberships?:  {
        __typename: "ModelPostCollectionMembershipConnection",
        items:  Array< {
          __typename: "PostCollectionMembership",
          post?:  {
            __typename: "Post",
            createdAt: string,
            text: string,
            associatedTawk?:  {
              __typename: "TawkCandidate",
              title?: string | null,
              createdAt: string,
              generatedVideo?:  {
                __typename: "CloudinaryResource",
                publicId: string,
              } | null,
              rawAudio:  {
                __typename: "CloudinaryResource",
                publicId: string,
              },
            } | null,
            author:  {
              __typename: "User",
              name?: string | null,
              sub: string,
              userHandle?:  {
                __typename: "UserHandle",
                renderedForm: string,
              } | null,
              profilePhoto:  {
                __typename: "CloudinaryResource",
                publicId: string,
              },
            },
            likesCount: number,
            repliesCount: number,
            id: string,
            repostedPost_id?: string | null,
            repostedTimeRange?:  {
              __typename: "ClipTimeRange",
              endTime: number,
              startTime: number,
            } | null,
            repostedPost?:  {
              __typename: "Post",
              id: string,
              createdAt: string,
              text: string,
              author:  {
                __typename: "User",
                name?: string | null,
                sub: string,
                userHandle?:  {
                  __typename: "UserHandle",
                  renderedForm: string,
                } | null,
                profilePhoto:  {
                  __typename: "CloudinaryResource",
                  publicId: string,
                },
              },
              associatedTawk?:  {
                __typename: "TawkCandidate",
                title?: string | null,
                generatedVideo?:  {
                  __typename: "CloudinaryResource",
                  publicId: string,
                } | null,
              } | null,
            } | null,
          } | null,
        } | null >,
      } | null,
    } | null >,
  } | null,
};

export type GET_USERPROFILE_DATAQueryVariables = {
  userHandle: string,
};

export type GET_USERPROFILE_DATAQuery = {
  getUserHandle?:  {
    __typename: "UserHandle",
    owner:  {
      __typename: "User",
      name?: string | null,
      userHandle_standardForm?: string | null,
      profilePhoto:  {
        __typename: "CloudinaryResource",
        publicId: string,
      },
      sub: string,
      userHandle?:  {
        __typename: "UserHandle",
        renderedForm: string,
      } | null,
    },
  } | null,
};

export type GET_USERPROFILE_FOLLOWERSQueryVariables = {
  userSub: string,
};

export type GET_USERPROFILE_FOLLOWERSQuery = {
  searchUserFollows?:  {
    __typename: "SearchableUserFollowConnection",
    total?: number | null,
  } | null,
};

export type GET_USERPROFILE_FOLLOWINGQueryVariables = {
  userSub: string,
};

export type GET_USERPROFILE_FOLLOWINGQuery = {
  searchUserFollows?:  {
    __typename: "SearchableUserFollowConnection",
    total?: number | null,
  } | null,
};

export type AddPostToPostCollectionMutationVariables = {
  postCollection_id: string,
  post_id: string,
};

export type AddPostToPostCollectionMutation = {
  addPostToPostCollection:  {
    __typename: "PostCollectionMembership",
    ownerSub: string,
    author:  {
      __typename: "User",
      sub: string,
      phoneNumber?: string | null,
      identityId?: string | null,
      lastMigrationNumber?: number | null,
      name?: string | null,
      bio?: string | null,
      userHandle_standardForm?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    postCollection_id: string,
    postCollection:  {
      __typename: "PostCollection",
      id: string,
      ownerSub: string,
      name: string,
      description: string,
      emoji?: string | null,
      createdAt: string,
      updatedAt: string,
      defaultSortOrder?: Playlist_SortOrder | null,
    },
    post_id: string,
    post?:  {
      __typename: "Post",
      id: string,
      ownerSub: string,
      createdAt: string,
      text: string,
      footnote?: string | null,
      replyingToPost_id?: string | null,
      threadRootPost_id?: string | null,
      repostedPost_id?: string | null,
      associatedTawk_localId?: string | null,
      associatedTawk_tawkVersion?: string | null,
      associatedExternalTawk_id?: string | null,
      repliesCount: number,
      likesCount: number,
      associatedColorHue?: number | null,
      updatedAt: string,
    } | null,
    createdAt: string,
    rank: number,
    updatedAt: string,
  },
};

export type CreatePostSafelyMutationVariables = {
  input: CreatePostSafelyInput,
};

export type CreatePostSafelyMutation = {
  createPostSafely:  {
    __typename: "Post",
    id: string,
    ownerSub: string,
    author:  {
      __typename: "User",
      sub: string,
      phoneNumber?: string | null,
      identityId?: string | null,
      lastMigrationNumber?: number | null,
      name?: string | null,
      bio?: string | null,
      userHandle_standardForm?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    createdAt: string,
    text: string,
    footnote?: string | null,
    replyingToPost?:  {
      __typename: "Post",
      id: string,
      ownerSub: string,
      createdAt: string,
      text: string,
      footnote?: string | null,
      replyingToPost_id?: string | null,
      threadRootPost_id?: string | null,
      repostedPost_id?: string | null,
      associatedTawk_localId?: string | null,
      associatedTawk_tawkVersion?: string | null,
      associatedExternalTawk_id?: string | null,
      repliesCount: number,
      likesCount: number,
      associatedColorHue?: number | null,
      updatedAt: string,
    } | null,
    replyingToPost_id?: string | null,
    threadRootPost?:  {
      __typename: "Post",
      id: string,
      ownerSub: string,
      createdAt: string,
      text: string,
      footnote?: string | null,
      replyingToPost_id?: string | null,
      threadRootPost_id?: string | null,
      repostedPost_id?: string | null,
      associatedTawk_localId?: string | null,
      associatedTawk_tawkVersion?: string | null,
      associatedExternalTawk_id?: string | null,
      repliesCount: number,
      likesCount: number,
      associatedColorHue?: number | null,
      updatedAt: string,
    } | null,
    threadRootPost_id?: string | null,
    repostedPost?:  {
      __typename: "Post",
      id: string,
      ownerSub: string,
      createdAt: string,
      text: string,
      footnote?: string | null,
      replyingToPost_id?: string | null,
      threadRootPost_id?: string | null,
      repostedPost_id?: string | null,
      associatedTawk_localId?: string | null,
      associatedTawk_tawkVersion?: string | null,
      associatedExternalTawk_id?: string | null,
      repliesCount: number,
      likesCount: number,
      associatedColorHue?: number | null,
      updatedAt: string,
    } | null,
    repostedPost_id?: string | null,
    repostedTimeRange?:  {
      __typename: "ClipTimeRange",
      startTime: number,
      endTime: number,
    } | null,
    associatedTawk_localId?: string | null,
    associatedTawk_tawkVersion?: string | null,
    associatedTawk?:  {
      __typename: "TawkCandidate",
      ownerSub: string,
      createdAt: string,
      localId: string,
      tawkVersion: string,
      title?: string | null,
      duration?: number | null,
      updatedAt: string,
    } | null,
    associatedExternalTawk_id?: string | null,
    associatedExternalTawk?:  {
      __typename: "ExternalTawk",
      id: string,
      inserter_sub: string,
      title: string,
      audioFileUrl: string,
      duration: number,
      originUrl: string,
      originKind: ExternalTawk_OriginKind,
      originName: string,
      originCreatedAt: string,
      createdAt: string,
      updatedAt: string,
    } | null,
    replies?:  {
      __typename: "ModelPostConnection",
      nextToken?: string | null,
    } | null,
    repliesCount: number,
    reposts?:  {
      __typename: "ModelPostConnection",
      nextToken?: string | null,
    } | null,
    likes?:  {
      __typename: "ModelPostLikeConnection",
      nextToken?: string | null,
    } | null,
    likesCount: number,
    claps?:  {
      __typename: "ModelPostClapConnection",
      nextToken?: string | null,
    } | null,
    associatedColorHue?: number | null,
    updatedAt: string,
  },
};

export type CreatePostSafelyV2MutationVariables = {
  input: CreatePostSafelyInput,
};

export type CreatePostSafelyV2Mutation = {
  createPostSafelyV2:  {
    __typename: "NewsfeedItem_Post",
    keyDict: string,
    post:  {
      __typename: "Post",
      id: string,
      ownerSub: string,
      createdAt: string,
      text: string,
      footnote?: string | null,
      replyingToPost_id?: string | null,
      threadRootPost_id?: string | null,
      repostedPost_id?: string | null,
      associatedTawk_localId?: string | null,
      associatedTawk_tawkVersion?: string | null,
      associatedExternalTawk_id?: string | null,
      repliesCount: number,
      likesCount: number,
      associatedColorHue?: number | null,
      updatedAt: string,
    },
  },
};

export type UpdateUserHandleSafelyMutationVariables = {
  input: UpdateUserHandleSafelyInput,
};

export type UpdateUserHandleSafelyMutation = {
  updateUserHandleSafely:  {
    __typename: "User",
    sub: string,
    phoneNumber?: string | null,
    identityId?: string | null,
    lastMigrationNumber?: number | null,
    name?: string | null,
    bio?: string | null,
    profilePhoto:  {
      __typename: "CloudinaryResource",
      publicId: string,
    },
    userHandle?:  {
      __typename: "UserHandle",
      ownerSub: string,
      standardForm: string,
      renderedForm: string,
      createdAt: string,
      updatedAt: string,
    } | null,
    userHandle_standardForm?: string | null,
    posts?:  {
      __typename: "ModelPostConnection",
      nextToken?: string | null,
    } | null,
    following?:  {
      __typename: "ModelUserFollowConnection",
      nextToken?: string | null,
    } | null,
    followers?:  {
      __typename: "ModelUserFollowConnection",
      nextToken?: string | null,
    } | null,
    postCollections?:  {
      __typename: "ModelPostCollectionConnection",
      nextToken?: string | null,
    } | null,
    followedPostCollections?:  {
      __typename: "ModelPostCollectionFollowRelationConnection",
      nextToken?: string | null,
    } | null,
    signupCodes?:  {
      __typename: "ModelSignupCodeUserAssociationConnection",
      nextToken?: string | null,
    } | null,
    playEvents?:  {
      __typename: "ModelPlayEventConnection",
      nextToken?: string | null,
    } | null,
    blocked?:  {
      __typename: "ModelUserBlockingRelationshipConnection",
      nextToken?: string | null,
    } | null,
    blockers?:  {
      __typename: "ModelUserBlockingRelationshipConnection",
      nextToken?: string | null,
    } | null,
    automaticallyFollowedByNewMembersIn?:  {
      __typename: "ModelSignupCodeUsersWhichNewMembersAutomaticallyFollowAssociationConnection",
      nextToken?: string | null,
    } | null,
    automaticallyFollowsNewMembersIn?:  {
      __typename: "ModelSignupCodeUsersWhichAutomaticallyFollowNewMembersAssociationConnection",
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  },
};

export type CreateUserMutationVariables = {
  input: CreateUserInput,
  condition?: ModelUserConditionInput | null,
};

export type CreateUserMutation = {
  createUser?:  {
    __typename: "User",
    sub: string,
    phoneNumber?: string | null,
    identityId?: string | null,
    lastMigrationNumber?: number | null,
    name?: string | null,
    bio?: string | null,
    profilePhoto:  {
      __typename: "CloudinaryResource",
      publicId: string,
    },
    userHandle?:  {
      __typename: "UserHandle",
      ownerSub: string,
      standardForm: string,
      renderedForm: string,
      createdAt: string,
      updatedAt: string,
    } | null,
    userHandle_standardForm?: string | null,
    posts?:  {
      __typename: "ModelPostConnection",
      nextToken?: string | null,
    } | null,
    following?:  {
      __typename: "ModelUserFollowConnection",
      nextToken?: string | null,
    } | null,
    followers?:  {
      __typename: "ModelUserFollowConnection",
      nextToken?: string | null,
    } | null,
    postCollections?:  {
      __typename: "ModelPostCollectionConnection",
      nextToken?: string | null,
    } | null,
    followedPostCollections?:  {
      __typename: "ModelPostCollectionFollowRelationConnection",
      nextToken?: string | null,
    } | null,
    signupCodes?:  {
      __typename: "ModelSignupCodeUserAssociationConnection",
      nextToken?: string | null,
    } | null,
    playEvents?:  {
      __typename: "ModelPlayEventConnection",
      nextToken?: string | null,
    } | null,
    blocked?:  {
      __typename: "ModelUserBlockingRelationshipConnection",
      nextToken?: string | null,
    } | null,
    blockers?:  {
      __typename: "ModelUserBlockingRelationshipConnection",
      nextToken?: string | null,
    } | null,
    automaticallyFollowedByNewMembersIn?:  {
      __typename: "ModelSignupCodeUsersWhichNewMembersAutomaticallyFollowAssociationConnection",
      nextToken?: string | null,
    } | null,
    automaticallyFollowsNewMembersIn?:  {
      __typename: "ModelSignupCodeUsersWhichAutomaticallyFollowNewMembersAssociationConnection",
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateUserMutationVariables = {
  input: UpdateUserInput,
  condition?: ModelUserConditionInput | null,
};

export type UpdateUserMutation = {
  updateUser?:  {
    __typename: "User",
    sub: string,
    phoneNumber?: string | null,
    identityId?: string | null,
    lastMigrationNumber?: number | null,
    name?: string | null,
    bio?: string | null,
    profilePhoto:  {
      __typename: "CloudinaryResource",
      publicId: string,
    },
    userHandle?:  {
      __typename: "UserHandle",
      ownerSub: string,
      standardForm: string,
      renderedForm: string,
      createdAt: string,
      updatedAt: string,
    } | null,
    userHandle_standardForm?: string | null,
    posts?:  {
      __typename: "ModelPostConnection",
      nextToken?: string | null,
    } | null,
    following?:  {
      __typename: "ModelUserFollowConnection",
      nextToken?: string | null,
    } | null,
    followers?:  {
      __typename: "ModelUserFollowConnection",
      nextToken?: string | null,
    } | null,
    postCollections?:  {
      __typename: "ModelPostCollectionConnection",
      nextToken?: string | null,
    } | null,
    followedPostCollections?:  {
      __typename: "ModelPostCollectionFollowRelationConnection",
      nextToken?: string | null,
    } | null,
    signupCodes?:  {
      __typename: "ModelSignupCodeUserAssociationConnection",
      nextToken?: string | null,
    } | null,
    playEvents?:  {
      __typename: "ModelPlayEventConnection",
      nextToken?: string | null,
    } | null,
    blocked?:  {
      __typename: "ModelUserBlockingRelationshipConnection",
      nextToken?: string | null,
    } | null,
    blockers?:  {
      __typename: "ModelUserBlockingRelationshipConnection",
      nextToken?: string | null,
    } | null,
    automaticallyFollowedByNewMembersIn?:  {
      __typename: "ModelSignupCodeUsersWhichNewMembersAutomaticallyFollowAssociationConnection",
      nextToken?: string | null,
    } | null,
    automaticallyFollowsNewMembersIn?:  {
      __typename: "ModelSignupCodeUsersWhichAutomaticallyFollowNewMembersAssociationConnection",
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteUserMutationVariables = {
  input: DeleteUserInput,
  condition?: ModelUserConditionInput | null,
};

export type DeleteUserMutation = {
  deleteUser?:  {
    __typename: "User",
    sub: string,
    phoneNumber?: string | null,
    identityId?: string | null,
    lastMigrationNumber?: number | null,
    name?: string | null,
    bio?: string | null,
    profilePhoto:  {
      __typename: "CloudinaryResource",
      publicId: string,
    },
    userHandle?:  {
      __typename: "UserHandle",
      ownerSub: string,
      standardForm: string,
      renderedForm: string,
      createdAt: string,
      updatedAt: string,
    } | null,
    userHandle_standardForm?: string | null,
    posts?:  {
      __typename: "ModelPostConnection",
      nextToken?: string | null,
    } | null,
    following?:  {
      __typename: "ModelUserFollowConnection",
      nextToken?: string | null,
    } | null,
    followers?:  {
      __typename: "ModelUserFollowConnection",
      nextToken?: string | null,
    } | null,
    postCollections?:  {
      __typename: "ModelPostCollectionConnection",
      nextToken?: string | null,
    } | null,
    followedPostCollections?:  {
      __typename: "ModelPostCollectionFollowRelationConnection",
      nextToken?: string | null,
    } | null,
    signupCodes?:  {
      __typename: "ModelSignupCodeUserAssociationConnection",
      nextToken?: string | null,
    } | null,
    playEvents?:  {
      __typename: "ModelPlayEventConnection",
      nextToken?: string | null,
    } | null,
    blocked?:  {
      __typename: "ModelUserBlockingRelationshipConnection",
      nextToken?: string | null,
    } | null,
    blockers?:  {
      __typename: "ModelUserBlockingRelationshipConnection",
      nextToken?: string | null,
    } | null,
    automaticallyFollowedByNewMembersIn?:  {
      __typename: "ModelSignupCodeUsersWhichNewMembersAutomaticallyFollowAssociationConnection",
      nextToken?: string | null,
    } | null,
    automaticallyFollowsNewMembersIn?:  {
      __typename: "ModelSignupCodeUsersWhichAutomaticallyFollowNewMembersAssociationConnection",
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateUserDisplayNameMutationVariables = {
  input: CreateUserDisplayNameInput,
  condition?: ModelUserDisplayNameConditionInput | null,
};

export type CreateUserDisplayNameMutation = {
  createUserDisplayName?:  {
    __typename: "UserDisplayName",
    displayName: string,
    ownerSub: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateUserDisplayNameMutationVariables = {
  input: UpdateUserDisplayNameInput,
  condition?: ModelUserDisplayNameConditionInput | null,
};

export type UpdateUserDisplayNameMutation = {
  updateUserDisplayName?:  {
    __typename: "UserDisplayName",
    displayName: string,
    ownerSub: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteUserDisplayNameMutationVariables = {
  input: DeleteUserDisplayNameInput,
  condition?: ModelUserDisplayNameConditionInput | null,
};

export type DeleteUserDisplayNameMutation = {
  deleteUserDisplayName?:  {
    __typename: "UserDisplayName",
    displayName: string,
    ownerSub: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateUserHandleMutationVariables = {
  input: CreateUserHandleInput,
  condition?: ModelUserHandleConditionInput | null,
};

export type CreateUserHandleMutation = {
  createUserHandle?:  {
    __typename: "UserHandle",
    ownerSub: string,
    owner:  {
      __typename: "User",
      sub: string,
      phoneNumber?: string | null,
      identityId?: string | null,
      lastMigrationNumber?: number | null,
      name?: string | null,
      bio?: string | null,
      userHandle_standardForm?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    standardForm: string,
    renderedForm: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateUserHandleMutationVariables = {
  input: UpdateUserHandleInput,
  condition?: ModelUserHandleConditionInput | null,
};

export type UpdateUserHandleMutation = {
  updateUserHandle?:  {
    __typename: "UserHandle",
    ownerSub: string,
    owner:  {
      __typename: "User",
      sub: string,
      phoneNumber?: string | null,
      identityId?: string | null,
      lastMigrationNumber?: number | null,
      name?: string | null,
      bio?: string | null,
      userHandle_standardForm?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    standardForm: string,
    renderedForm: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteUserHandleMutationVariables = {
  input: DeleteUserHandleInput,
  condition?: ModelUserHandleConditionInput | null,
};

export type DeleteUserHandleMutation = {
  deleteUserHandle?:  {
    __typename: "UserHandle",
    ownerSub: string,
    owner:  {
      __typename: "User",
      sub: string,
      phoneNumber?: string | null,
      identityId?: string | null,
      lastMigrationNumber?: number | null,
      name?: string | null,
      bio?: string | null,
      userHandle_standardForm?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    standardForm: string,
    renderedForm: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreatePostMutationVariables = {
  input: CreatePostInput,
  condition?: ModelPostConditionInput | null,
};

export type CreatePostMutation = {
  createPost?:  {
    __typename: "Post",
    id: string,
    ownerSub: string,
    author:  {
      __typename: "User",
      sub: string,
      phoneNumber?: string | null,
      identityId?: string | null,
      lastMigrationNumber?: number | null,
      name?: string | null,
      bio?: string | null,
      userHandle_standardForm?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    createdAt: string,
    text: string,
    footnote?: string | null,
    replyingToPost?:  {
      __typename: "Post",
      id: string,
      ownerSub: string,
      createdAt: string,
      text: string,
      footnote?: string | null,
      replyingToPost_id?: string | null,
      threadRootPost_id?: string | null,
      repostedPost_id?: string | null,
      associatedTawk_localId?: string | null,
      associatedTawk_tawkVersion?: string | null,
      associatedExternalTawk_id?: string | null,
      repliesCount: number,
      likesCount: number,
      associatedColorHue?: number | null,
      updatedAt: string,
    } | null,
    replyingToPost_id?: string | null,
    threadRootPost?:  {
      __typename: "Post",
      id: string,
      ownerSub: string,
      createdAt: string,
      text: string,
      footnote?: string | null,
      replyingToPost_id?: string | null,
      threadRootPost_id?: string | null,
      repostedPost_id?: string | null,
      associatedTawk_localId?: string | null,
      associatedTawk_tawkVersion?: string | null,
      associatedExternalTawk_id?: string | null,
      repliesCount: number,
      likesCount: number,
      associatedColorHue?: number | null,
      updatedAt: string,
    } | null,
    threadRootPost_id?: string | null,
    repostedPost?:  {
      __typename: "Post",
      id: string,
      ownerSub: string,
      createdAt: string,
      text: string,
      footnote?: string | null,
      replyingToPost_id?: string | null,
      threadRootPost_id?: string | null,
      repostedPost_id?: string | null,
      associatedTawk_localId?: string | null,
      associatedTawk_tawkVersion?: string | null,
      associatedExternalTawk_id?: string | null,
      repliesCount: number,
      likesCount: number,
      associatedColorHue?: number | null,
      updatedAt: string,
    } | null,
    repostedPost_id?: string | null,
    repostedTimeRange?:  {
      __typename: "ClipTimeRange",
      startTime: number,
      endTime: number,
    } | null,
    associatedTawk_localId?: string | null,
    associatedTawk_tawkVersion?: string | null,
    associatedTawk?:  {
      __typename: "TawkCandidate",
      ownerSub: string,
      createdAt: string,
      localId: string,
      tawkVersion: string,
      title?: string | null,
      duration?: number | null,
      updatedAt: string,
    } | null,
    associatedExternalTawk_id?: string | null,
    associatedExternalTawk?:  {
      __typename: "ExternalTawk",
      id: string,
      inserter_sub: string,
      title: string,
      audioFileUrl: string,
      duration: number,
      originUrl: string,
      originKind: ExternalTawk_OriginKind,
      originName: string,
      originCreatedAt: string,
      createdAt: string,
      updatedAt: string,
    } | null,
    replies?:  {
      __typename: "ModelPostConnection",
      nextToken?: string | null,
    } | null,
    repliesCount: number,
    reposts?:  {
      __typename: "ModelPostConnection",
      nextToken?: string | null,
    } | null,
    likes?:  {
      __typename: "ModelPostLikeConnection",
      nextToken?: string | null,
    } | null,
    likesCount: number,
    claps?:  {
      __typename: "ModelPostClapConnection",
      nextToken?: string | null,
    } | null,
    associatedColorHue?: number | null,
    updatedAt: string,
  } | null,
};

export type UpdatePostMutationVariables = {
  input: UpdatePostInput,
  condition?: ModelPostConditionInput | null,
};

export type UpdatePostMutation = {
  updatePost?:  {
    __typename: "Post",
    id: string,
    ownerSub: string,
    author:  {
      __typename: "User",
      sub: string,
      phoneNumber?: string | null,
      identityId?: string | null,
      lastMigrationNumber?: number | null,
      name?: string | null,
      bio?: string | null,
      userHandle_standardForm?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    createdAt: string,
    text: string,
    footnote?: string | null,
    replyingToPost?:  {
      __typename: "Post",
      id: string,
      ownerSub: string,
      createdAt: string,
      text: string,
      footnote?: string | null,
      replyingToPost_id?: string | null,
      threadRootPost_id?: string | null,
      repostedPost_id?: string | null,
      associatedTawk_localId?: string | null,
      associatedTawk_tawkVersion?: string | null,
      associatedExternalTawk_id?: string | null,
      repliesCount: number,
      likesCount: number,
      associatedColorHue?: number | null,
      updatedAt: string,
    } | null,
    replyingToPost_id?: string | null,
    threadRootPost?:  {
      __typename: "Post",
      id: string,
      ownerSub: string,
      createdAt: string,
      text: string,
      footnote?: string | null,
      replyingToPost_id?: string | null,
      threadRootPost_id?: string | null,
      repostedPost_id?: string | null,
      associatedTawk_localId?: string | null,
      associatedTawk_tawkVersion?: string | null,
      associatedExternalTawk_id?: string | null,
      repliesCount: number,
      likesCount: number,
      associatedColorHue?: number | null,
      updatedAt: string,
    } | null,
    threadRootPost_id?: string | null,
    repostedPost?:  {
      __typename: "Post",
      id: string,
      ownerSub: string,
      createdAt: string,
      text: string,
      footnote?: string | null,
      replyingToPost_id?: string | null,
      threadRootPost_id?: string | null,
      repostedPost_id?: string | null,
      associatedTawk_localId?: string | null,
      associatedTawk_tawkVersion?: string | null,
      associatedExternalTawk_id?: string | null,
      repliesCount: number,
      likesCount: number,
      associatedColorHue?: number | null,
      updatedAt: string,
    } | null,
    repostedPost_id?: string | null,
    repostedTimeRange?:  {
      __typename: "ClipTimeRange",
      startTime: number,
      endTime: number,
    } | null,
    associatedTawk_localId?: string | null,
    associatedTawk_tawkVersion?: string | null,
    associatedTawk?:  {
      __typename: "TawkCandidate",
      ownerSub: string,
      createdAt: string,
      localId: string,
      tawkVersion: string,
      title?: string | null,
      duration?: number | null,
      updatedAt: string,
    } | null,
    associatedExternalTawk_id?: string | null,
    associatedExternalTawk?:  {
      __typename: "ExternalTawk",
      id: string,
      inserter_sub: string,
      title: string,
      audioFileUrl: string,
      duration: number,
      originUrl: string,
      originKind: ExternalTawk_OriginKind,
      originName: string,
      originCreatedAt: string,
      createdAt: string,
      updatedAt: string,
    } | null,
    replies?:  {
      __typename: "ModelPostConnection",
      nextToken?: string | null,
    } | null,
    repliesCount: number,
    reposts?:  {
      __typename: "ModelPostConnection",
      nextToken?: string | null,
    } | null,
    likes?:  {
      __typename: "ModelPostLikeConnection",
      nextToken?: string | null,
    } | null,
    likesCount: number,
    claps?:  {
      __typename: "ModelPostClapConnection",
      nextToken?: string | null,
    } | null,
    associatedColorHue?: number | null,
    updatedAt: string,
  } | null,
};

export type DeletePostMutationVariables = {
  input: DeletePostInput,
  condition?: ModelPostConditionInput | null,
};

export type DeletePostMutation = {
  deletePost?:  {
    __typename: "Post",
    id: string,
    ownerSub: string,
    author:  {
      __typename: "User",
      sub: string,
      phoneNumber?: string | null,
      identityId?: string | null,
      lastMigrationNumber?: number | null,
      name?: string | null,
      bio?: string | null,
      userHandle_standardForm?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    createdAt: string,
    text: string,
    footnote?: string | null,
    replyingToPost?:  {
      __typename: "Post",
      id: string,
      ownerSub: string,
      createdAt: string,
      text: string,
      footnote?: string | null,
      replyingToPost_id?: string | null,
      threadRootPost_id?: string | null,
      repostedPost_id?: string | null,
      associatedTawk_localId?: string | null,
      associatedTawk_tawkVersion?: string | null,
      associatedExternalTawk_id?: string | null,
      repliesCount: number,
      likesCount: number,
      associatedColorHue?: number | null,
      updatedAt: string,
    } | null,
    replyingToPost_id?: string | null,
    threadRootPost?:  {
      __typename: "Post",
      id: string,
      ownerSub: string,
      createdAt: string,
      text: string,
      footnote?: string | null,
      replyingToPost_id?: string | null,
      threadRootPost_id?: string | null,
      repostedPost_id?: string | null,
      associatedTawk_localId?: string | null,
      associatedTawk_tawkVersion?: string | null,
      associatedExternalTawk_id?: string | null,
      repliesCount: number,
      likesCount: number,
      associatedColorHue?: number | null,
      updatedAt: string,
    } | null,
    threadRootPost_id?: string | null,
    repostedPost?:  {
      __typename: "Post",
      id: string,
      ownerSub: string,
      createdAt: string,
      text: string,
      footnote?: string | null,
      replyingToPost_id?: string | null,
      threadRootPost_id?: string | null,
      repostedPost_id?: string | null,
      associatedTawk_localId?: string | null,
      associatedTawk_tawkVersion?: string | null,
      associatedExternalTawk_id?: string | null,
      repliesCount: number,
      likesCount: number,
      associatedColorHue?: number | null,
      updatedAt: string,
    } | null,
    repostedPost_id?: string | null,
    repostedTimeRange?:  {
      __typename: "ClipTimeRange",
      startTime: number,
      endTime: number,
    } | null,
    associatedTawk_localId?: string | null,
    associatedTawk_tawkVersion?: string | null,
    associatedTawk?:  {
      __typename: "TawkCandidate",
      ownerSub: string,
      createdAt: string,
      localId: string,
      tawkVersion: string,
      title?: string | null,
      duration?: number | null,
      updatedAt: string,
    } | null,
    associatedExternalTawk_id?: string | null,
    associatedExternalTawk?:  {
      __typename: "ExternalTawk",
      id: string,
      inserter_sub: string,
      title: string,
      audioFileUrl: string,
      duration: number,
      originUrl: string,
      originKind: ExternalTawk_OriginKind,
      originName: string,
      originCreatedAt: string,
      createdAt: string,
      updatedAt: string,
    } | null,
    replies?:  {
      __typename: "ModelPostConnection",
      nextToken?: string | null,
    } | null,
    repliesCount: number,
    reposts?:  {
      __typename: "ModelPostConnection",
      nextToken?: string | null,
    } | null,
    likes?:  {
      __typename: "ModelPostLikeConnection",
      nextToken?: string | null,
    } | null,
    likesCount: number,
    claps?:  {
      __typename: "ModelPostClapConnection",
      nextToken?: string | null,
    } | null,
    associatedColorHue?: number | null,
    updatedAt: string,
  } | null,
};

export type CreateExternalTawkMutationVariables = {
  input: CreateExternalTawkInput,
  condition?: ModelExternalTawkConditionInput | null,
};

export type CreateExternalTawkMutation = {
  createExternalTawk?:  {
    __typename: "ExternalTawk",
    id: string,
    inserter_sub: string,
    inserter:  {
      __typename: "User",
      sub: string,
      phoneNumber?: string | null,
      identityId?: string | null,
      lastMigrationNumber?: number | null,
      name?: string | null,
      bio?: string | null,
      userHandle_standardForm?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    title: string,
    audioFileUrl: string,
    duration: number,
    originUrl: string,
    originKind: ExternalTawk_OriginKind,
    originName: string,
    originCreatedAt: string,
    picture:  {
      __typename: "GenericImage",
      imageUrl: string,
    },
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateExternalTawkMutationVariables = {
  input: UpdateExternalTawkInput,
  condition?: ModelExternalTawkConditionInput | null,
};

export type UpdateExternalTawkMutation = {
  updateExternalTawk?:  {
    __typename: "ExternalTawk",
    id: string,
    inserter_sub: string,
    inserter:  {
      __typename: "User",
      sub: string,
      phoneNumber?: string | null,
      identityId?: string | null,
      lastMigrationNumber?: number | null,
      name?: string | null,
      bio?: string | null,
      userHandle_standardForm?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    title: string,
    audioFileUrl: string,
    duration: number,
    originUrl: string,
    originKind: ExternalTawk_OriginKind,
    originName: string,
    originCreatedAt: string,
    picture:  {
      __typename: "GenericImage",
      imageUrl: string,
    },
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteExternalTawkMutationVariables = {
  input: DeleteExternalTawkInput,
  condition?: ModelExternalTawkConditionInput | null,
};

export type DeleteExternalTawkMutation = {
  deleteExternalTawk?:  {
    __typename: "ExternalTawk",
    id: string,
    inserter_sub: string,
    inserter:  {
      __typename: "User",
      sub: string,
      phoneNumber?: string | null,
      identityId?: string | null,
      lastMigrationNumber?: number | null,
      name?: string | null,
      bio?: string | null,
      userHandle_standardForm?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    title: string,
    audioFileUrl: string,
    duration: number,
    originUrl: string,
    originKind: ExternalTawk_OriginKind,
    originName: string,
    originCreatedAt: string,
    picture:  {
      __typename: "GenericImage",
      imageUrl: string,
    },
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateSignupCodeMutationVariables = {
  input: CreateSignupCodeInput,
  condition?: ModelSignupCodeConditionInput | null,
};

export type CreateSignupCodeMutation = {
  createSignupCode?:  {
    __typename: "SignupCode",
    codeName: string,
    createdAt: string,
    users?:  {
      __typename: "ModelSignupCodeUserAssociationConnection",
      nextToken?: string | null,
    } | null,
    stations?:  Array< {
      __typename: "SerializableRadioStation_Workaround",
      refreshId: string,
    } | null > | null,
    usersToAutomaticallyFollow?:  {
      __typename: "ModelSignupCodeUsersWhichNewMembersAutomaticallyFollowAssociationConnection",
      nextToken?: string | null,
    } | null,
    usersWhoAutomaticallyFollowNewMembers?:  {
      __typename: "ModelSignupCodeUsersWhichAutomaticallyFollowNewMembersAssociationConnection",
      nextToken?: string | null,
    } | null,
    updatedAt: string,
  } | null,
};

export type UpdateSignupCodeMutationVariables = {
  input: UpdateSignupCodeInput,
  condition?: ModelSignupCodeConditionInput | null,
};

export type UpdateSignupCodeMutation = {
  updateSignupCode?:  {
    __typename: "SignupCode",
    codeName: string,
    createdAt: string,
    users?:  {
      __typename: "ModelSignupCodeUserAssociationConnection",
      nextToken?: string | null,
    } | null,
    stations?:  Array< {
      __typename: "SerializableRadioStation_Workaround",
      refreshId: string,
    } | null > | null,
    usersToAutomaticallyFollow?:  {
      __typename: "ModelSignupCodeUsersWhichNewMembersAutomaticallyFollowAssociationConnection",
      nextToken?: string | null,
    } | null,
    usersWhoAutomaticallyFollowNewMembers?:  {
      __typename: "ModelSignupCodeUsersWhichAutomaticallyFollowNewMembersAssociationConnection",
      nextToken?: string | null,
    } | null,
    updatedAt: string,
  } | null,
};

export type DeleteSignupCodeMutationVariables = {
  input: DeleteSignupCodeInput,
  condition?: ModelSignupCodeConditionInput | null,
};

export type DeleteSignupCodeMutation = {
  deleteSignupCode?:  {
    __typename: "SignupCode",
    codeName: string,
    createdAt: string,
    users?:  {
      __typename: "ModelSignupCodeUserAssociationConnection",
      nextToken?: string | null,
    } | null,
    stations?:  Array< {
      __typename: "SerializableRadioStation_Workaround",
      refreshId: string,
    } | null > | null,
    usersToAutomaticallyFollow?:  {
      __typename: "ModelSignupCodeUsersWhichNewMembersAutomaticallyFollowAssociationConnection",
      nextToken?: string | null,
    } | null,
    usersWhoAutomaticallyFollowNewMembers?:  {
      __typename: "ModelSignupCodeUsersWhichAutomaticallyFollowNewMembersAssociationConnection",
      nextToken?: string | null,
    } | null,
    updatedAt: string,
  } | null,
};

export type CreateSignupCodeUsersWhichNewMembersAutomaticallyFollowAssociationMutationVariables = {
  input: CreateSignupCodeUsersWhichNewMembersAutomaticallyFollowAssociationInput,
  condition?: ModelSignupCodeUsersWhichNewMembersAutomaticallyFollowAssociationConditionInput | null,
};

export type CreateSignupCodeUsersWhichNewMembersAutomaticallyFollowAssociationMutation = {
  createSignupCodeUsersWhichNewMembersAutomaticallyFollowAssociation?:  {
    __typename: "SignupCodeUsersWhichNewMembersAutomaticallyFollowAssociation",
    code_codeName: string,
    code?:  {
      __typename: "SignupCode",
      codeName: string,
      createdAt: string,
      updatedAt: string,
    } | null,
    user_sub: string,
    user:  {
      __typename: "User",
      sub: string,
      phoneNumber?: string | null,
      identityId?: string | null,
      lastMigrationNumber?: number | null,
      name?: string | null,
      bio?: string | null,
      userHandle_standardForm?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateSignupCodeUsersWhichNewMembersAutomaticallyFollowAssociationMutationVariables = {
  input: UpdateSignupCodeUsersWhichNewMembersAutomaticallyFollowAssociationInput,
  condition?: ModelSignupCodeUsersWhichNewMembersAutomaticallyFollowAssociationConditionInput | null,
};

export type UpdateSignupCodeUsersWhichNewMembersAutomaticallyFollowAssociationMutation = {
  updateSignupCodeUsersWhichNewMembersAutomaticallyFollowAssociation?:  {
    __typename: "SignupCodeUsersWhichNewMembersAutomaticallyFollowAssociation",
    code_codeName: string,
    code?:  {
      __typename: "SignupCode",
      codeName: string,
      createdAt: string,
      updatedAt: string,
    } | null,
    user_sub: string,
    user:  {
      __typename: "User",
      sub: string,
      phoneNumber?: string | null,
      identityId?: string | null,
      lastMigrationNumber?: number | null,
      name?: string | null,
      bio?: string | null,
      userHandle_standardForm?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteSignupCodeUsersWhichNewMembersAutomaticallyFollowAssociationMutationVariables = {
  input: DeleteSignupCodeUsersWhichNewMembersAutomaticallyFollowAssociationInput,
  condition?: ModelSignupCodeUsersWhichNewMembersAutomaticallyFollowAssociationConditionInput | null,
};

export type DeleteSignupCodeUsersWhichNewMembersAutomaticallyFollowAssociationMutation = {
  deleteSignupCodeUsersWhichNewMembersAutomaticallyFollowAssociation?:  {
    __typename: "SignupCodeUsersWhichNewMembersAutomaticallyFollowAssociation",
    code_codeName: string,
    code?:  {
      __typename: "SignupCode",
      codeName: string,
      createdAt: string,
      updatedAt: string,
    } | null,
    user_sub: string,
    user:  {
      __typename: "User",
      sub: string,
      phoneNumber?: string | null,
      identityId?: string | null,
      lastMigrationNumber?: number | null,
      name?: string | null,
      bio?: string | null,
      userHandle_standardForm?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateSignupCodeUsersWhichAutomaticallyFollowNewMembersAssociationMutationVariables = {
  input: CreateSignupCodeUsersWhichAutomaticallyFollowNewMembersAssociationInput,
  condition?: ModelSignupCodeUsersWhichAutomaticallyFollowNewMembersAssociationConditionInput | null,
};

export type CreateSignupCodeUsersWhichAutomaticallyFollowNewMembersAssociationMutation = {
  createSignupCodeUsersWhichAutomaticallyFollowNewMembersAssociation?:  {
    __typename: "SignupCodeUsersWhichAutomaticallyFollowNewMembersAssociation",
    code_codeName: string,
    code?:  {
      __typename: "SignupCode",
      codeName: string,
      createdAt: string,
      updatedAt: string,
    } | null,
    user_sub: string,
    user:  {
      __typename: "User",
      sub: string,
      phoneNumber?: string | null,
      identityId?: string | null,
      lastMigrationNumber?: number | null,
      name?: string | null,
      bio?: string | null,
      userHandle_standardForm?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateSignupCodeUsersWhichAutomaticallyFollowNewMembersAssociationMutationVariables = {
  input: UpdateSignupCodeUsersWhichAutomaticallyFollowNewMembersAssociationInput,
  condition?: ModelSignupCodeUsersWhichAutomaticallyFollowNewMembersAssociationConditionInput | null,
};

export type UpdateSignupCodeUsersWhichAutomaticallyFollowNewMembersAssociationMutation = {
  updateSignupCodeUsersWhichAutomaticallyFollowNewMembersAssociation?:  {
    __typename: "SignupCodeUsersWhichAutomaticallyFollowNewMembersAssociation",
    code_codeName: string,
    code?:  {
      __typename: "SignupCode",
      codeName: string,
      createdAt: string,
      updatedAt: string,
    } | null,
    user_sub: string,
    user:  {
      __typename: "User",
      sub: string,
      phoneNumber?: string | null,
      identityId?: string | null,
      lastMigrationNumber?: number | null,
      name?: string | null,
      bio?: string | null,
      userHandle_standardForm?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteSignupCodeUsersWhichAutomaticallyFollowNewMembersAssociationMutationVariables = {
  input: DeleteSignupCodeUsersWhichAutomaticallyFollowNewMembersAssociationInput,
  condition?: ModelSignupCodeUsersWhichAutomaticallyFollowNewMembersAssociationConditionInput | null,
};

export type DeleteSignupCodeUsersWhichAutomaticallyFollowNewMembersAssociationMutation = {
  deleteSignupCodeUsersWhichAutomaticallyFollowNewMembersAssociation?:  {
    __typename: "SignupCodeUsersWhichAutomaticallyFollowNewMembersAssociation",
    code_codeName: string,
    code?:  {
      __typename: "SignupCode",
      codeName: string,
      createdAt: string,
      updatedAt: string,
    } | null,
    user_sub: string,
    user:  {
      __typename: "User",
      sub: string,
      phoneNumber?: string | null,
      identityId?: string | null,
      lastMigrationNumber?: number | null,
      name?: string | null,
      bio?: string | null,
      userHandle_standardForm?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateSignupCodeUserAssociationMutationVariables = {
  input: CreateSignupCodeUserAssociationInput,
  condition?: ModelSignupCodeUserAssociationConditionInput | null,
};

export type CreateSignupCodeUserAssociationMutation = {
  createSignupCodeUserAssociation?:  {
    __typename: "SignupCodeUserAssociation",
    ownerSub: string,
    user:  {
      __typename: "User",
      sub: string,
      phoneNumber?: string | null,
      identityId?: string | null,
      lastMigrationNumber?: number | null,
      name?: string | null,
      bio?: string | null,
      userHandle_standardForm?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    code_codeName: string,
    code?:  {
      __typename: "SignupCode",
      codeName: string,
      createdAt: string,
      updatedAt: string,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateSignupCodeUserAssociationMutationVariables = {
  input: UpdateSignupCodeUserAssociationInput,
  condition?: ModelSignupCodeUserAssociationConditionInput | null,
};

export type UpdateSignupCodeUserAssociationMutation = {
  updateSignupCodeUserAssociation?:  {
    __typename: "SignupCodeUserAssociation",
    ownerSub: string,
    user:  {
      __typename: "User",
      sub: string,
      phoneNumber?: string | null,
      identityId?: string | null,
      lastMigrationNumber?: number | null,
      name?: string | null,
      bio?: string | null,
      userHandle_standardForm?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    code_codeName: string,
    code?:  {
      __typename: "SignupCode",
      codeName: string,
      createdAt: string,
      updatedAt: string,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteSignupCodeUserAssociationMutationVariables = {
  input: DeleteSignupCodeUserAssociationInput,
  condition?: ModelSignupCodeUserAssociationConditionInput | null,
};

export type DeleteSignupCodeUserAssociationMutation = {
  deleteSignupCodeUserAssociation?:  {
    __typename: "SignupCodeUserAssociation",
    ownerSub: string,
    user:  {
      __typename: "User",
      sub: string,
      phoneNumber?: string | null,
      identityId?: string | null,
      lastMigrationNumber?: number | null,
      name?: string | null,
      bio?: string | null,
      userHandle_standardForm?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    code_codeName: string,
    code?:  {
      __typename: "SignupCode",
      codeName: string,
      createdAt: string,
      updatedAt: string,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateTawkCandidateMutationVariables = {
  input: CreateTawkCandidateInput,
  condition?: ModelTawkCandidateConditionInput | null,
};

export type CreateTawkCandidateMutation = {
  createTawkCandidate?:  {
    __typename: "TawkCandidate",
    ownerSub: string,
    author:  {
      __typename: "User",
      sub: string,
      phoneNumber?: string | null,
      identityId?: string | null,
      lastMigrationNumber?: number | null,
      name?: string | null,
      bio?: string | null,
      userHandle_standardForm?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    createdAt: string,
    localId: string,
    tawkVersion: string,
    title?: string | null,
    rawAudio:  {
      __typename: "CloudinaryResource",
      publicId: string,
    },
    processedAudio?:  {
      __typename: "CloudinaryResource",
      publicId: string,
    } | null,
    generatedVideo?:  {
      __typename: "CloudinaryResource",
      publicId: string,
    } | null,
    duration?: number | null,
    updatedAt: string,
  } | null,
};

export type UpdateTawkCandidateMutationVariables = {
  input: UpdateTawkCandidateInput,
  condition?: ModelTawkCandidateConditionInput | null,
};

export type UpdateTawkCandidateMutation = {
  updateTawkCandidate?:  {
    __typename: "TawkCandidate",
    ownerSub: string,
    author:  {
      __typename: "User",
      sub: string,
      phoneNumber?: string | null,
      identityId?: string | null,
      lastMigrationNumber?: number | null,
      name?: string | null,
      bio?: string | null,
      userHandle_standardForm?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    createdAt: string,
    localId: string,
    tawkVersion: string,
    title?: string | null,
    rawAudio:  {
      __typename: "CloudinaryResource",
      publicId: string,
    },
    processedAudio?:  {
      __typename: "CloudinaryResource",
      publicId: string,
    } | null,
    generatedVideo?:  {
      __typename: "CloudinaryResource",
      publicId: string,
    } | null,
    duration?: number | null,
    updatedAt: string,
  } | null,
};

export type DeleteTawkCandidateMutationVariables = {
  input: DeleteTawkCandidateInput,
  condition?: ModelTawkCandidateConditionInput | null,
};

export type DeleteTawkCandidateMutation = {
  deleteTawkCandidate?:  {
    __typename: "TawkCandidate",
    ownerSub: string,
    author:  {
      __typename: "User",
      sub: string,
      phoneNumber?: string | null,
      identityId?: string | null,
      lastMigrationNumber?: number | null,
      name?: string | null,
      bio?: string | null,
      userHandle_standardForm?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    createdAt: string,
    localId: string,
    tawkVersion: string,
    title?: string | null,
    rawAudio:  {
      __typename: "CloudinaryResource",
      publicId: string,
    },
    processedAudio?:  {
      __typename: "CloudinaryResource",
      publicId: string,
    } | null,
    generatedVideo?:  {
      __typename: "CloudinaryResource",
      publicId: string,
    } | null,
    duration?: number | null,
    updatedAt: string,
  } | null,
};

export type CreatePostLikeMutationVariables = {
  input: CreatePostLikeInput,
  condition?: ModelPostLikeConditionInput | null,
};

export type CreatePostLikeMutation = {
  createPostLike?:  {
    __typename: "PostLike",
    ownerSub: string,
    actor:  {
      __typename: "User",
      sub: string,
      phoneNumber?: string | null,
      identityId?: string | null,
      lastMigrationNumber?: number | null,
      name?: string | null,
      bio?: string | null,
      userHandle_standardForm?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    createdAt: string,
    postLiked_id: string,
    postLiked?:  {
      __typename: "Post",
      id: string,
      ownerSub: string,
      createdAt: string,
      text: string,
      footnote?: string | null,
      replyingToPost_id?: string | null,
      threadRootPost_id?: string | null,
      repostedPost_id?: string | null,
      associatedTawk_localId?: string | null,
      associatedTawk_tawkVersion?: string | null,
      associatedExternalTawk_id?: string | null,
      repliesCount: number,
      likesCount: number,
      associatedColorHue?: number | null,
      updatedAt: string,
    } | null,
    updatedAt: string,
  } | null,
};

export type UpdatePostLikeMutationVariables = {
  input: UpdatePostLikeInput,
  condition?: ModelPostLikeConditionInput | null,
};

export type UpdatePostLikeMutation = {
  updatePostLike?:  {
    __typename: "PostLike",
    ownerSub: string,
    actor:  {
      __typename: "User",
      sub: string,
      phoneNumber?: string | null,
      identityId?: string | null,
      lastMigrationNumber?: number | null,
      name?: string | null,
      bio?: string | null,
      userHandle_standardForm?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    createdAt: string,
    postLiked_id: string,
    postLiked?:  {
      __typename: "Post",
      id: string,
      ownerSub: string,
      createdAt: string,
      text: string,
      footnote?: string | null,
      replyingToPost_id?: string | null,
      threadRootPost_id?: string | null,
      repostedPost_id?: string | null,
      associatedTawk_localId?: string | null,
      associatedTawk_tawkVersion?: string | null,
      associatedExternalTawk_id?: string | null,
      repliesCount: number,
      likesCount: number,
      associatedColorHue?: number | null,
      updatedAt: string,
    } | null,
    updatedAt: string,
  } | null,
};

export type DeletePostLikeMutationVariables = {
  input: DeletePostLikeInput,
  condition?: ModelPostLikeConditionInput | null,
};

export type DeletePostLikeMutation = {
  deletePostLike?:  {
    __typename: "PostLike",
    ownerSub: string,
    actor:  {
      __typename: "User",
      sub: string,
      phoneNumber?: string | null,
      identityId?: string | null,
      lastMigrationNumber?: number | null,
      name?: string | null,
      bio?: string | null,
      userHandle_standardForm?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    createdAt: string,
    postLiked_id: string,
    postLiked?:  {
      __typename: "Post",
      id: string,
      ownerSub: string,
      createdAt: string,
      text: string,
      footnote?: string | null,
      replyingToPost_id?: string | null,
      threadRootPost_id?: string | null,
      repostedPost_id?: string | null,
      associatedTawk_localId?: string | null,
      associatedTawk_tawkVersion?: string | null,
      associatedExternalTawk_id?: string | null,
      repliesCount: number,
      likesCount: number,
      associatedColorHue?: number | null,
      updatedAt: string,
    } | null,
    updatedAt: string,
  } | null,
};

export type CreatePostClapMutationVariables = {
  input: CreatePostClapInput,
  condition?: ModelPostClapConditionInput | null,
};

export type CreatePostClapMutation = {
  createPostClap?:  {
    __typename: "PostClap",
    id: string,
    ownerSub: string,
    actor:  {
      __typename: "User",
      sub: string,
      phoneNumber?: string | null,
      identityId?: string | null,
      lastMigrationNumber?: number | null,
      name?: string | null,
      bio?: string | null,
      userHandle_standardForm?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    createdAt: string,
    timestampRelativeToContext: number,
    contextPost_id?: string | null,
    contextPost?:  {
      __typename: "Post",
      id: string,
      ownerSub: string,
      createdAt: string,
      text: string,
      footnote?: string | null,
      replyingToPost_id?: string | null,
      threadRootPost_id?: string | null,
      repostedPost_id?: string | null,
      associatedTawk_localId?: string | null,
      associatedTawk_tawkVersion?: string | null,
      associatedExternalTawk_id?: string | null,
      repliesCount: number,
      likesCount: number,
      associatedColorHue?: number | null,
      updatedAt: string,
    } | null,
    contextRssItem?:  {
      __typename: "RssItemPlayingContext",
      audioUrl: string,
      title: string,
      originName: string,
      createdAt?: string | null,
      rssPageUrl: string,
      itemDurationInSeconds?: number | null,
      originProfileLikePictureUrl?: string | null,
    } | null,
    updatedAt: string,
  } | null,
};

export type UpdatePostClapMutationVariables = {
  input: UpdatePostClapInput,
  condition?: ModelPostClapConditionInput | null,
};

export type UpdatePostClapMutation = {
  updatePostClap?:  {
    __typename: "PostClap",
    id: string,
    ownerSub: string,
    actor:  {
      __typename: "User",
      sub: string,
      phoneNumber?: string | null,
      identityId?: string | null,
      lastMigrationNumber?: number | null,
      name?: string | null,
      bio?: string | null,
      userHandle_standardForm?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    createdAt: string,
    timestampRelativeToContext: number,
    contextPost_id?: string | null,
    contextPost?:  {
      __typename: "Post",
      id: string,
      ownerSub: string,
      createdAt: string,
      text: string,
      footnote?: string | null,
      replyingToPost_id?: string | null,
      threadRootPost_id?: string | null,
      repostedPost_id?: string | null,
      associatedTawk_localId?: string | null,
      associatedTawk_tawkVersion?: string | null,
      associatedExternalTawk_id?: string | null,
      repliesCount: number,
      likesCount: number,
      associatedColorHue?: number | null,
      updatedAt: string,
    } | null,
    contextRssItem?:  {
      __typename: "RssItemPlayingContext",
      audioUrl: string,
      title: string,
      originName: string,
      createdAt?: string | null,
      rssPageUrl: string,
      itemDurationInSeconds?: number | null,
      originProfileLikePictureUrl?: string | null,
    } | null,
    updatedAt: string,
  } | null,
};

export type DeletePostClapMutationVariables = {
  input: DeletePostClapInput,
  condition?: ModelPostClapConditionInput | null,
};

export type DeletePostClapMutation = {
  deletePostClap?:  {
    __typename: "PostClap",
    id: string,
    ownerSub: string,
    actor:  {
      __typename: "User",
      sub: string,
      phoneNumber?: string | null,
      identityId?: string | null,
      lastMigrationNumber?: number | null,
      name?: string | null,
      bio?: string | null,
      userHandle_standardForm?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    createdAt: string,
    timestampRelativeToContext: number,
    contextPost_id?: string | null,
    contextPost?:  {
      __typename: "Post",
      id: string,
      ownerSub: string,
      createdAt: string,
      text: string,
      footnote?: string | null,
      replyingToPost_id?: string | null,
      threadRootPost_id?: string | null,
      repostedPost_id?: string | null,
      associatedTawk_localId?: string | null,
      associatedTawk_tawkVersion?: string | null,
      associatedExternalTawk_id?: string | null,
      repliesCount: number,
      likesCount: number,
      associatedColorHue?: number | null,
      updatedAt: string,
    } | null,
    contextRssItem?:  {
      __typename: "RssItemPlayingContext",
      audioUrl: string,
      title: string,
      originName: string,
      createdAt?: string | null,
      rssPageUrl: string,
      itemDurationInSeconds?: number | null,
      originProfileLikePictureUrl?: string | null,
    } | null,
    updatedAt: string,
  } | null,
};

export type CreatePostReportMutationVariables = {
  input: CreatePostReportInput,
  condition?: ModelPostReportConditionInput | null,
};

export type CreatePostReportMutation = {
  createPostReport?:  {
    __typename: "PostReport",
    id: string,
    ownerSub: string,
    reporter:  {
      __typename: "User",
      sub: string,
      phoneNumber?: string | null,
      identityId?: string | null,
      lastMigrationNumber?: number | null,
      name?: string | null,
      bio?: string | null,
      userHandle_standardForm?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    text: string,
    kind: PostReport_Kind,
    reportedPost_id?: string | null,
    reportedPost?:  {
      __typename: "Post",
      id: string,
      ownerSub: string,
      createdAt: string,
      text: string,
      footnote?: string | null,
      replyingToPost_id?: string | null,
      threadRootPost_id?: string | null,
      repostedPost_id?: string | null,
      associatedTawk_localId?: string | null,
      associatedTawk_tawkVersion?: string | null,
      associatedExternalTawk_id?: string | null,
      repliesCount: number,
      likesCount: number,
      associatedColorHue?: number | null,
      updatedAt: string,
    } | null,
    reportedPostCollection_id?: string | null,
    reportedPostCollection?:  {
      __typename: "PostCollection",
      id: string,
      ownerSub: string,
      name: string,
      description: string,
      emoji?: string | null,
      createdAt: string,
      updatedAt: string,
      defaultSortOrder?: Playlist_SortOrder | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdatePostReportMutationVariables = {
  input: UpdatePostReportInput,
  condition?: ModelPostReportConditionInput | null,
};

export type UpdatePostReportMutation = {
  updatePostReport?:  {
    __typename: "PostReport",
    id: string,
    ownerSub: string,
    reporter:  {
      __typename: "User",
      sub: string,
      phoneNumber?: string | null,
      identityId?: string | null,
      lastMigrationNumber?: number | null,
      name?: string | null,
      bio?: string | null,
      userHandle_standardForm?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    text: string,
    kind: PostReport_Kind,
    reportedPost_id?: string | null,
    reportedPost?:  {
      __typename: "Post",
      id: string,
      ownerSub: string,
      createdAt: string,
      text: string,
      footnote?: string | null,
      replyingToPost_id?: string | null,
      threadRootPost_id?: string | null,
      repostedPost_id?: string | null,
      associatedTawk_localId?: string | null,
      associatedTawk_tawkVersion?: string | null,
      associatedExternalTawk_id?: string | null,
      repliesCount: number,
      likesCount: number,
      associatedColorHue?: number | null,
      updatedAt: string,
    } | null,
    reportedPostCollection_id?: string | null,
    reportedPostCollection?:  {
      __typename: "PostCollection",
      id: string,
      ownerSub: string,
      name: string,
      description: string,
      emoji?: string | null,
      createdAt: string,
      updatedAt: string,
      defaultSortOrder?: Playlist_SortOrder | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeletePostReportMutationVariables = {
  input: DeletePostReportInput,
  condition?: ModelPostReportConditionInput | null,
};

export type DeletePostReportMutation = {
  deletePostReport?:  {
    __typename: "PostReport",
    id: string,
    ownerSub: string,
    reporter:  {
      __typename: "User",
      sub: string,
      phoneNumber?: string | null,
      identityId?: string | null,
      lastMigrationNumber?: number | null,
      name?: string | null,
      bio?: string | null,
      userHandle_standardForm?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    text: string,
    kind: PostReport_Kind,
    reportedPost_id?: string | null,
    reportedPost?:  {
      __typename: "Post",
      id: string,
      ownerSub: string,
      createdAt: string,
      text: string,
      footnote?: string | null,
      replyingToPost_id?: string | null,
      threadRootPost_id?: string | null,
      repostedPost_id?: string | null,
      associatedTawk_localId?: string | null,
      associatedTawk_tawkVersion?: string | null,
      associatedExternalTawk_id?: string | null,
      repliesCount: number,
      likesCount: number,
      associatedColorHue?: number | null,
      updatedAt: string,
    } | null,
    reportedPostCollection_id?: string | null,
    reportedPostCollection?:  {
      __typename: "PostCollection",
      id: string,
      ownerSub: string,
      name: string,
      description: string,
      emoji?: string | null,
      createdAt: string,
      updatedAt: string,
      defaultSortOrder?: Playlist_SortOrder | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateUserFollowMutationVariables = {
  input: CreateUserFollowInput,
  condition?: ModelUserFollowConditionInput | null,
};

export type CreateUserFollowMutation = {
  createUserFollow?:  {
    __typename: "UserFollow",
    ownerSub: string,
    following:  {
      __typename: "User",
      sub: string,
      phoneNumber?: string | null,
      identityId?: string | null,
      lastMigrationNumber?: number | null,
      name?: string | null,
      bio?: string | null,
      userHandle_standardForm?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    followed_sub: string,
    followed:  {
      __typename: "User",
      sub: string,
      phoneNumber?: string | null,
      identityId?: string | null,
      lastMigrationNumber?: number | null,
      name?: string | null,
      bio?: string | null,
      userHandle_standardForm?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateUserFollowMutationVariables = {
  input: UpdateUserFollowInput,
  condition?: ModelUserFollowConditionInput | null,
};

export type UpdateUserFollowMutation = {
  updateUserFollow?:  {
    __typename: "UserFollow",
    ownerSub: string,
    following:  {
      __typename: "User",
      sub: string,
      phoneNumber?: string | null,
      identityId?: string | null,
      lastMigrationNumber?: number | null,
      name?: string | null,
      bio?: string | null,
      userHandle_standardForm?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    followed_sub: string,
    followed:  {
      __typename: "User",
      sub: string,
      phoneNumber?: string | null,
      identityId?: string | null,
      lastMigrationNumber?: number | null,
      name?: string | null,
      bio?: string | null,
      userHandle_standardForm?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteUserFollowMutationVariables = {
  input: DeleteUserFollowInput,
  condition?: ModelUserFollowConditionInput | null,
};

export type DeleteUserFollowMutation = {
  deleteUserFollow?:  {
    __typename: "UserFollow",
    ownerSub: string,
    following:  {
      __typename: "User",
      sub: string,
      phoneNumber?: string | null,
      identityId?: string | null,
      lastMigrationNumber?: number | null,
      name?: string | null,
      bio?: string | null,
      userHandle_standardForm?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    followed_sub: string,
    followed:  {
      __typename: "User",
      sub: string,
      phoneNumber?: string | null,
      identityId?: string | null,
      lastMigrationNumber?: number | null,
      name?: string | null,
      bio?: string | null,
      userHandle_standardForm?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateUserBlockingRelationshipMutationVariables = {
  input: CreateUserBlockingRelationshipInput,
  condition?: ModelUserBlockingRelationshipConditionInput | null,
};

export type CreateUserBlockingRelationshipMutation = {
  createUserBlockingRelationship?:  {
    __typename: "UserBlockingRelationship",
    ownerSub: string,
    blocker:  {
      __typename: "User",
      sub: string,
      phoneNumber?: string | null,
      identityId?: string | null,
      lastMigrationNumber?: number | null,
      name?: string | null,
      bio?: string | null,
      userHandle_standardForm?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    blocked_sub: string,
    blocked:  {
      __typename: "User",
      sub: string,
      phoneNumber?: string | null,
      identityId?: string | null,
      lastMigrationNumber?: number | null,
      name?: string | null,
      bio?: string | null,
      userHandle_standardForm?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateUserBlockingRelationshipMutationVariables = {
  input: UpdateUserBlockingRelationshipInput,
  condition?: ModelUserBlockingRelationshipConditionInput | null,
};

export type UpdateUserBlockingRelationshipMutation = {
  updateUserBlockingRelationship?:  {
    __typename: "UserBlockingRelationship",
    ownerSub: string,
    blocker:  {
      __typename: "User",
      sub: string,
      phoneNumber?: string | null,
      identityId?: string | null,
      lastMigrationNumber?: number | null,
      name?: string | null,
      bio?: string | null,
      userHandle_standardForm?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    blocked_sub: string,
    blocked:  {
      __typename: "User",
      sub: string,
      phoneNumber?: string | null,
      identityId?: string | null,
      lastMigrationNumber?: number | null,
      name?: string | null,
      bio?: string | null,
      userHandle_standardForm?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteUserBlockingRelationshipMutationVariables = {
  input: DeleteUserBlockingRelationshipInput,
  condition?: ModelUserBlockingRelationshipConditionInput | null,
};

export type DeleteUserBlockingRelationshipMutation = {
  deleteUserBlockingRelationship?:  {
    __typename: "UserBlockingRelationship",
    ownerSub: string,
    blocker:  {
      __typename: "User",
      sub: string,
      phoneNumber?: string | null,
      identityId?: string | null,
      lastMigrationNumber?: number | null,
      name?: string | null,
      bio?: string | null,
      userHandle_standardForm?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    blocked_sub: string,
    blocked:  {
      __typename: "User",
      sub: string,
      phoneNumber?: string | null,
      identityId?: string | null,
      lastMigrationNumber?: number | null,
      name?: string | null,
      bio?: string | null,
      userHandle_standardForm?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreatePlayEventMutationVariables = {
  input: CreatePlayEventInput,
  condition?: ModelPlayEventConditionInput | null,
};

export type CreatePlayEventMutation = {
  createPlayEvent?:  {
    __typename: "PlayEvent",
    id: string,
    ownerSub: string,
    playedBy:  {
      __typename: "User",
      sub: string,
      phoneNumber?: string | null,
      identityId?: string | null,
      lastMigrationNumber?: number | null,
      name?: string | null,
      bio?: string | null,
      userHandle_standardForm?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    startTime: number,
    endTime: number,
    duration: number,
    contextPost_id?: string | null,
    contextPost?:  {
      __typename: "Post",
      id: string,
      ownerSub: string,
      createdAt: string,
      text: string,
      footnote?: string | null,
      replyingToPost_id?: string | null,
      threadRootPost_id?: string | null,
      repostedPost_id?: string | null,
      associatedTawk_localId?: string | null,
      associatedTawk_tawkVersion?: string | null,
      associatedExternalTawk_id?: string | null,
      repliesCount: number,
      likesCount: number,
      associatedColorHue?: number | null,
      updatedAt: string,
    } | null,
    contextRssItem?:  {
      __typename: "RssItemPlayingContext",
      audioUrl: string,
      title: string,
      originName: string,
      createdAt?: string | null,
      rssPageUrl: string,
      itemDurationInSeconds?: number | null,
      originProfileLikePictureUrl?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdatePlayEventMutationVariables = {
  input: UpdatePlayEventInput,
  condition?: ModelPlayEventConditionInput | null,
};

export type UpdatePlayEventMutation = {
  updatePlayEvent?:  {
    __typename: "PlayEvent",
    id: string,
    ownerSub: string,
    playedBy:  {
      __typename: "User",
      sub: string,
      phoneNumber?: string | null,
      identityId?: string | null,
      lastMigrationNumber?: number | null,
      name?: string | null,
      bio?: string | null,
      userHandle_standardForm?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    startTime: number,
    endTime: number,
    duration: number,
    contextPost_id?: string | null,
    contextPost?:  {
      __typename: "Post",
      id: string,
      ownerSub: string,
      createdAt: string,
      text: string,
      footnote?: string | null,
      replyingToPost_id?: string | null,
      threadRootPost_id?: string | null,
      repostedPost_id?: string | null,
      associatedTawk_localId?: string | null,
      associatedTawk_tawkVersion?: string | null,
      associatedExternalTawk_id?: string | null,
      repliesCount: number,
      likesCount: number,
      associatedColorHue?: number | null,
      updatedAt: string,
    } | null,
    contextRssItem?:  {
      __typename: "RssItemPlayingContext",
      audioUrl: string,
      title: string,
      originName: string,
      createdAt?: string | null,
      rssPageUrl: string,
      itemDurationInSeconds?: number | null,
      originProfileLikePictureUrl?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeletePlayEventMutationVariables = {
  input: DeletePlayEventInput,
  condition?: ModelPlayEventConditionInput | null,
};

export type DeletePlayEventMutation = {
  deletePlayEvent?:  {
    __typename: "PlayEvent",
    id: string,
    ownerSub: string,
    playedBy:  {
      __typename: "User",
      sub: string,
      phoneNumber?: string | null,
      identityId?: string | null,
      lastMigrationNumber?: number | null,
      name?: string | null,
      bio?: string | null,
      userHandle_standardForm?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    startTime: number,
    endTime: number,
    duration: number,
    contextPost_id?: string | null,
    contextPost?:  {
      __typename: "Post",
      id: string,
      ownerSub: string,
      createdAt: string,
      text: string,
      footnote?: string | null,
      replyingToPost_id?: string | null,
      threadRootPost_id?: string | null,
      repostedPost_id?: string | null,
      associatedTawk_localId?: string | null,
      associatedTawk_tawkVersion?: string | null,
      associatedExternalTawk_id?: string | null,
      repliesCount: number,
      likesCount: number,
      associatedColorHue?: number | null,
      updatedAt: string,
    } | null,
    contextRssItem?:  {
      __typename: "RssItemPlayingContext",
      audioUrl: string,
      title: string,
      originName: string,
      createdAt?: string | null,
      rssPageUrl: string,
      itemDurationInSeconds?: number | null,
      originProfileLikePictureUrl?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreatePostCollectionMutationVariables = {
  input: CreatePostCollectionInput,
  condition?: ModelPostCollectionConditionInput | null,
};

export type CreatePostCollectionMutation = {
  createPostCollection?:  {
    __typename: "PostCollection",
    id: string,
    ownerSub: string,
    author:  {
      __typename: "User",
      sub: string,
      phoneNumber?: string | null,
      identityId?: string | null,
      lastMigrationNumber?: number | null,
      name?: string | null,
      bio?: string | null,
      userHandle_standardForm?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    name: string,
    description: string,
    emoji?: string | null,
    color?:  {
      __typename: "Color",
      red: number,
      green: number,
      blue: number,
    } | null,
    createdAt: string,
    updatedAt: string,
    memberships?:  {
      __typename: "ModelPostCollectionMembershipConnection",
      nextToken?: string | null,
    } | null,
    followers?:  {
      __typename: "ModelPostCollectionFollowRelationConnection",
      nextToken?: string | null,
    } | null,
    defaultSortOrder?: Playlist_SortOrder | null,
  } | null,
};

export type UpdatePostCollectionMutationVariables = {
  input: UpdatePostCollectionInput,
  condition?: ModelPostCollectionConditionInput | null,
};

export type UpdatePostCollectionMutation = {
  updatePostCollection?:  {
    __typename: "PostCollection",
    id: string,
    ownerSub: string,
    author:  {
      __typename: "User",
      sub: string,
      phoneNumber?: string | null,
      identityId?: string | null,
      lastMigrationNumber?: number | null,
      name?: string | null,
      bio?: string | null,
      userHandle_standardForm?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    name: string,
    description: string,
    emoji?: string | null,
    color?:  {
      __typename: "Color",
      red: number,
      green: number,
      blue: number,
    } | null,
    createdAt: string,
    updatedAt: string,
    memberships?:  {
      __typename: "ModelPostCollectionMembershipConnection",
      nextToken?: string | null,
    } | null,
    followers?:  {
      __typename: "ModelPostCollectionFollowRelationConnection",
      nextToken?: string | null,
    } | null,
    defaultSortOrder?: Playlist_SortOrder | null,
  } | null,
};

export type DeletePostCollectionMutationVariables = {
  input: DeletePostCollectionInput,
  condition?: ModelPostCollectionConditionInput | null,
};

export type DeletePostCollectionMutation = {
  deletePostCollection?:  {
    __typename: "PostCollection",
    id: string,
    ownerSub: string,
    author:  {
      __typename: "User",
      sub: string,
      phoneNumber?: string | null,
      identityId?: string | null,
      lastMigrationNumber?: number | null,
      name?: string | null,
      bio?: string | null,
      userHandle_standardForm?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    name: string,
    description: string,
    emoji?: string | null,
    color?:  {
      __typename: "Color",
      red: number,
      green: number,
      blue: number,
    } | null,
    createdAt: string,
    updatedAt: string,
    memberships?:  {
      __typename: "ModelPostCollectionMembershipConnection",
      nextToken?: string | null,
    } | null,
    followers?:  {
      __typename: "ModelPostCollectionFollowRelationConnection",
      nextToken?: string | null,
    } | null,
    defaultSortOrder?: Playlist_SortOrder | null,
  } | null,
};

export type CreatePostCollectionMembershipMutationVariables = {
  input: CreatePostCollectionMembershipInput,
  condition?: ModelPostCollectionMembershipConditionInput | null,
};

export type CreatePostCollectionMembershipMutation = {
  createPostCollectionMembership?:  {
    __typename: "PostCollectionMembership",
    ownerSub: string,
    author:  {
      __typename: "User",
      sub: string,
      phoneNumber?: string | null,
      identityId?: string | null,
      lastMigrationNumber?: number | null,
      name?: string | null,
      bio?: string | null,
      userHandle_standardForm?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    postCollection_id: string,
    postCollection:  {
      __typename: "PostCollection",
      id: string,
      ownerSub: string,
      name: string,
      description: string,
      emoji?: string | null,
      createdAt: string,
      updatedAt: string,
      defaultSortOrder?: Playlist_SortOrder | null,
    },
    post_id: string,
    post?:  {
      __typename: "Post",
      id: string,
      ownerSub: string,
      createdAt: string,
      text: string,
      footnote?: string | null,
      replyingToPost_id?: string | null,
      threadRootPost_id?: string | null,
      repostedPost_id?: string | null,
      associatedTawk_localId?: string | null,
      associatedTawk_tawkVersion?: string | null,
      associatedExternalTawk_id?: string | null,
      repliesCount: number,
      likesCount: number,
      associatedColorHue?: number | null,
      updatedAt: string,
    } | null,
    createdAt: string,
    rank: number,
    updatedAt: string,
  } | null,
};

export type UpdatePostCollectionMembershipMutationVariables = {
  input: UpdatePostCollectionMembershipInput,
  condition?: ModelPostCollectionMembershipConditionInput | null,
};

export type UpdatePostCollectionMembershipMutation = {
  updatePostCollectionMembership?:  {
    __typename: "PostCollectionMembership",
    ownerSub: string,
    author:  {
      __typename: "User",
      sub: string,
      phoneNumber?: string | null,
      identityId?: string | null,
      lastMigrationNumber?: number | null,
      name?: string | null,
      bio?: string | null,
      userHandle_standardForm?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    postCollection_id: string,
    postCollection:  {
      __typename: "PostCollection",
      id: string,
      ownerSub: string,
      name: string,
      description: string,
      emoji?: string | null,
      createdAt: string,
      updatedAt: string,
      defaultSortOrder?: Playlist_SortOrder | null,
    },
    post_id: string,
    post?:  {
      __typename: "Post",
      id: string,
      ownerSub: string,
      createdAt: string,
      text: string,
      footnote?: string | null,
      replyingToPost_id?: string | null,
      threadRootPost_id?: string | null,
      repostedPost_id?: string | null,
      associatedTawk_localId?: string | null,
      associatedTawk_tawkVersion?: string | null,
      associatedExternalTawk_id?: string | null,
      repliesCount: number,
      likesCount: number,
      associatedColorHue?: number | null,
      updatedAt: string,
    } | null,
    createdAt: string,
    rank: number,
    updatedAt: string,
  } | null,
};

export type DeletePostCollectionMembershipMutationVariables = {
  input: DeletePostCollectionMembershipInput,
  condition?: ModelPostCollectionMembershipConditionInput | null,
};

export type DeletePostCollectionMembershipMutation = {
  deletePostCollectionMembership?:  {
    __typename: "PostCollectionMembership",
    ownerSub: string,
    author:  {
      __typename: "User",
      sub: string,
      phoneNumber?: string | null,
      identityId?: string | null,
      lastMigrationNumber?: number | null,
      name?: string | null,
      bio?: string | null,
      userHandle_standardForm?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    postCollection_id: string,
    postCollection:  {
      __typename: "PostCollection",
      id: string,
      ownerSub: string,
      name: string,
      description: string,
      emoji?: string | null,
      createdAt: string,
      updatedAt: string,
      defaultSortOrder?: Playlist_SortOrder | null,
    },
    post_id: string,
    post?:  {
      __typename: "Post",
      id: string,
      ownerSub: string,
      createdAt: string,
      text: string,
      footnote?: string | null,
      replyingToPost_id?: string | null,
      threadRootPost_id?: string | null,
      repostedPost_id?: string | null,
      associatedTawk_localId?: string | null,
      associatedTawk_tawkVersion?: string | null,
      associatedExternalTawk_id?: string | null,
      repliesCount: number,
      likesCount: number,
      associatedColorHue?: number | null,
      updatedAt: string,
    } | null,
    createdAt: string,
    rank: number,
    updatedAt: string,
  } | null,
};

export type CreatePostCollectionFollowRelationMutationVariables = {
  input: CreatePostCollectionFollowRelationInput,
  condition?: ModelPostCollectionFollowRelationConditionInput | null,
};

export type CreatePostCollectionFollowRelationMutation = {
  createPostCollectionFollowRelation?:  {
    __typename: "PostCollectionFollowRelation",
    ownerSub: string,
    follower:  {
      __typename: "User",
      sub: string,
      phoneNumber?: string | null,
      identityId?: string | null,
      lastMigrationNumber?: number | null,
      name?: string | null,
      bio?: string | null,
      userHandle_standardForm?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    postCollection_id: string,
    postCollection:  {
      __typename: "PostCollection",
      id: string,
      ownerSub: string,
      name: string,
      description: string,
      emoji?: string | null,
      createdAt: string,
      updatedAt: string,
      defaultSortOrder?: Playlist_SortOrder | null,
    },
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdatePostCollectionFollowRelationMutationVariables = {
  input: UpdatePostCollectionFollowRelationInput,
  condition?: ModelPostCollectionFollowRelationConditionInput | null,
};

export type UpdatePostCollectionFollowRelationMutation = {
  updatePostCollectionFollowRelation?:  {
    __typename: "PostCollectionFollowRelation",
    ownerSub: string,
    follower:  {
      __typename: "User",
      sub: string,
      phoneNumber?: string | null,
      identityId?: string | null,
      lastMigrationNumber?: number | null,
      name?: string | null,
      bio?: string | null,
      userHandle_standardForm?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    postCollection_id: string,
    postCollection:  {
      __typename: "PostCollection",
      id: string,
      ownerSub: string,
      name: string,
      description: string,
      emoji?: string | null,
      createdAt: string,
      updatedAt: string,
      defaultSortOrder?: Playlist_SortOrder | null,
    },
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeletePostCollectionFollowRelationMutationVariables = {
  input: DeletePostCollectionFollowRelationInput,
  condition?: ModelPostCollectionFollowRelationConditionInput | null,
};

export type DeletePostCollectionFollowRelationMutation = {
  deletePostCollectionFollowRelation?:  {
    __typename: "PostCollectionFollowRelation",
    ownerSub: string,
    follower:  {
      __typename: "User",
      sub: string,
      phoneNumber?: string | null,
      identityId?: string | null,
      lastMigrationNumber?: number | null,
      name?: string | null,
      bio?: string | null,
      userHandle_standardForm?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    postCollection_id: string,
    postCollection:  {
      __typename: "PostCollection",
      id: string,
      ownerSub: string,
      name: string,
      description: string,
      emoji?: string | null,
      createdAt: string,
      updatedAt: string,
      defaultSortOrder?: Playlist_SortOrder | null,
    },
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateCommunityMutationVariables = {
  input: CreateCommunityInput,
  condition?: ModelCommunityConditionInput | null,
};

export type CreateCommunityMutation = {
  createCommunity?:  {
    __typename: "Community",
    ownerSub: string,
    creator:  {
      __typename: "User",
      sub: string,
      phoneNumber?: string | null,
      identityId?: string | null,
      lastMigrationNumber?: number | null,
      name?: string | null,
      bio?: string | null,
      userHandle_standardForm?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    shortName: string,
    postAssociations?:  {
      __typename: "ModelCommunityPostAssociationConnection",
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
    creatorSub?: string | null,
  } | null,
};

export type UpdateCommunityMutationVariables = {
  input: UpdateCommunityInput,
  condition?: ModelCommunityConditionInput | null,
};

export type UpdateCommunityMutation = {
  updateCommunity?:  {
    __typename: "Community",
    ownerSub: string,
    creator:  {
      __typename: "User",
      sub: string,
      phoneNumber?: string | null,
      identityId?: string | null,
      lastMigrationNumber?: number | null,
      name?: string | null,
      bio?: string | null,
      userHandle_standardForm?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    shortName: string,
    postAssociations?:  {
      __typename: "ModelCommunityPostAssociationConnection",
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
    creatorSub?: string | null,
  } | null,
};

export type DeleteCommunityMutationVariables = {
  input: DeleteCommunityInput,
  condition?: ModelCommunityConditionInput | null,
};

export type DeleteCommunityMutation = {
  deleteCommunity?:  {
    __typename: "Community",
    ownerSub: string,
    creator:  {
      __typename: "User",
      sub: string,
      phoneNumber?: string | null,
      identityId?: string | null,
      lastMigrationNumber?: number | null,
      name?: string | null,
      bio?: string | null,
      userHandle_standardForm?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    shortName: string,
    postAssociations?:  {
      __typename: "ModelCommunityPostAssociationConnection",
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
    creatorSub?: string | null,
  } | null,
};

export type CreateCommunityPostAssociationMutationVariables = {
  input: CreateCommunityPostAssociationInput,
  condition?: ModelCommunityPostAssociationConditionInput | null,
};

export type CreateCommunityPostAssociationMutation = {
  createCommunityPostAssociation?:  {
    __typename: "CommunityPostAssociation",
    id: string,
    ownerSub: string,
    author:  {
      __typename: "User",
      sub: string,
      phoneNumber?: string | null,
      identityId?: string | null,
      lastMigrationNumber?: number | null,
      name?: string | null,
      bio?: string | null,
      userHandle_standardForm?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    community_shortName: string,
    community:  {
      __typename: "Community",
      ownerSub: string,
      shortName: string,
      createdAt: string,
      updatedAt: string,
      creatorSub?: string | null,
    },
    associatedPost_id: string,
    associatedPost:  {
      __typename: "Post",
      id: string,
      ownerSub: string,
      createdAt: string,
      text: string,
      footnote?: string | null,
      replyingToPost_id?: string | null,
      threadRootPost_id?: string | null,
      repostedPost_id?: string | null,
      associatedTawk_localId?: string | null,
      associatedTawk_tawkVersion?: string | null,
      associatedExternalTawk_id?: string | null,
      repliesCount: number,
      likesCount: number,
      associatedColorHue?: number | null,
      updatedAt: string,
    },
    createdAt?: string | null,
    updatedAt?: string | null,
    communityPostAssociationsId: string,
  } | null,
};

export type UpdateCommunityPostAssociationMutationVariables = {
  input: UpdateCommunityPostAssociationInput,
  condition?: ModelCommunityPostAssociationConditionInput | null,
};

export type UpdateCommunityPostAssociationMutation = {
  updateCommunityPostAssociation?:  {
    __typename: "CommunityPostAssociation",
    id: string,
    ownerSub: string,
    author:  {
      __typename: "User",
      sub: string,
      phoneNumber?: string | null,
      identityId?: string | null,
      lastMigrationNumber?: number | null,
      name?: string | null,
      bio?: string | null,
      userHandle_standardForm?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    community_shortName: string,
    community:  {
      __typename: "Community",
      ownerSub: string,
      shortName: string,
      createdAt: string,
      updatedAt: string,
      creatorSub?: string | null,
    },
    associatedPost_id: string,
    associatedPost:  {
      __typename: "Post",
      id: string,
      ownerSub: string,
      createdAt: string,
      text: string,
      footnote?: string | null,
      replyingToPost_id?: string | null,
      threadRootPost_id?: string | null,
      repostedPost_id?: string | null,
      associatedTawk_localId?: string | null,
      associatedTawk_tawkVersion?: string | null,
      associatedExternalTawk_id?: string | null,
      repliesCount: number,
      likesCount: number,
      associatedColorHue?: number | null,
      updatedAt: string,
    },
    createdAt?: string | null,
    updatedAt?: string | null,
    communityPostAssociationsId: string,
  } | null,
};

export type DeleteCommunityPostAssociationMutationVariables = {
  input: DeleteCommunityPostAssociationInput,
  condition?: ModelCommunityPostAssociationConditionInput | null,
};

export type DeleteCommunityPostAssociationMutation = {
  deleteCommunityPostAssociation?:  {
    __typename: "CommunityPostAssociation",
    id: string,
    ownerSub: string,
    author:  {
      __typename: "User",
      sub: string,
      phoneNumber?: string | null,
      identityId?: string | null,
      lastMigrationNumber?: number | null,
      name?: string | null,
      bio?: string | null,
      userHandle_standardForm?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    community_shortName: string,
    community:  {
      __typename: "Community",
      ownerSub: string,
      shortName: string,
      createdAt: string,
      updatedAt: string,
      creatorSub?: string | null,
    },
    associatedPost_id: string,
    associatedPost:  {
      __typename: "Post",
      id: string,
      ownerSub: string,
      createdAt: string,
      text: string,
      footnote?: string | null,
      replyingToPost_id?: string | null,
      threadRootPost_id?: string | null,
      repostedPost_id?: string | null,
      associatedTawk_localId?: string | null,
      associatedTawk_tawkVersion?: string | null,
      associatedExternalTawk_id?: string | null,
      repliesCount: number,
      likesCount: number,
      associatedColorHue?: number | null,
      updatedAt: string,
    },
    createdAt?: string | null,
    updatedAt?: string | null,
    communityPostAssociationsId: string,
  } | null,
};

export type NewsfeedItemsQueryVariables = {
  userSub?: string | null,
  nextToken?: string | null,
};

export type NewsfeedItemsQuery = {
  newsfeedItems:  {
    __typename: "NewsfeedItemsConnection",
    items:  Array<( {
        __typename: "NewsfeedItem_Post",
        keyDict: string,
      } | {
        __typename: "NewsfeedItem_PostLike",
        keyDict: string,
      } | {
        __typename: "NewsfeedItem_FeaturedPostCollections",
        title: string,
      } | {
        __typename: "NewsfeedItem_PostAggregation",
      }
    ) | null >,
    nextToken?: string | null,
  },
};

export type FeedItemsV2QueryVariables = {
  userSub?: string | null,
  nextToken?: string | null,
};

export type FeedItemsV2Query = {
  feedItemsV2:  {
    __typename: "FeedItemsConnection_V2",
    nextToken?: string | null,
  },
};

export type NotificationNewsfeedItemsQueryVariables = {
  nextToken?: string | null,
};

export type NotificationNewsfeedItemsQuery = {
  notificationNewsfeedItems:  {
    __typename: "UserNotificationConnection",
    nextToken?: string | null,
  },
};

export type UsersCorrespondingToContactsQueryVariables = {
  input: ContactFinderInput,
};

export type UsersCorrespondingToContactsQuery = {
  usersCorrespondingToContacts:  Array< {
    __typename: "User",
    sub: string,
    phoneNumber?: string | null,
    identityId?: string | null,
    lastMigrationNumber?: number | null,
    name?: string | null,
    bio?: string | null,
    profilePhoto:  {
      __typename: "CloudinaryResource",
      publicId: string,
    },
    userHandle?:  {
      __typename: "UserHandle",
      ownerSub: string,
      standardForm: string,
      renderedForm: string,
      createdAt: string,
      updatedAt: string,
    } | null,
    userHandle_standardForm?: string | null,
    posts?:  {
      __typename: "ModelPostConnection",
      nextToken?: string | null,
    } | null,
    following?:  {
      __typename: "ModelUserFollowConnection",
      nextToken?: string | null,
    } | null,
    followers?:  {
      __typename: "ModelUserFollowConnection",
      nextToken?: string | null,
    } | null,
    postCollections?:  {
      __typename: "ModelPostCollectionConnection",
      nextToken?: string | null,
    } | null,
    followedPostCollections?:  {
      __typename: "ModelPostCollectionFollowRelationConnection",
      nextToken?: string | null,
    } | null,
    signupCodes?:  {
      __typename: "ModelSignupCodeUserAssociationConnection",
      nextToken?: string | null,
    } | null,
    playEvents?:  {
      __typename: "ModelPlayEventConnection",
      nextToken?: string | null,
    } | null,
    blocked?:  {
      __typename: "ModelUserBlockingRelationshipConnection",
      nextToken?: string | null,
    } | null,
    blockers?:  {
      __typename: "ModelUserBlockingRelationshipConnection",
      nextToken?: string | null,
    } | null,
    automaticallyFollowedByNewMembersIn?:  {
      __typename: "ModelSignupCodeUsersWhichNewMembersAutomaticallyFollowAssociationConnection",
      nextToken?: string | null,
    } | null,
    automaticallyFollowsNewMembersIn?:  {
      __typename: "ModelSignupCodeUsersWhichAutomaticallyFollowNewMembersAssociationConnection",
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } >,
};

export type GetUserQueryVariables = {
  sub: string,
};

export type GetUserQuery = {
  getUser?:  {
    __typename: "User",
    sub: string,
    phoneNumber?: string | null,
    identityId?: string | null,
    lastMigrationNumber?: number | null,
    name?: string | null,
    bio?: string | null,
    profilePhoto:  {
      __typename: "CloudinaryResource",
      publicId: string,
    },
    userHandle?:  {
      __typename: "UserHandle",
      ownerSub: string,
      standardForm: string,
      renderedForm: string,
      createdAt: string,
      updatedAt: string,
    } | null,
    userHandle_standardForm?: string | null,
    posts?:  {
      __typename: "ModelPostConnection",
      nextToken?: string | null,
    } | null,
    following?:  {
      __typename: "ModelUserFollowConnection",
      nextToken?: string | null,
    } | null,
    followers?:  {
      __typename: "ModelUserFollowConnection",
      nextToken?: string | null,
    } | null,
    postCollections?:  {
      __typename: "ModelPostCollectionConnection",
      nextToken?: string | null,
    } | null,
    followedPostCollections?:  {
      __typename: "ModelPostCollectionFollowRelationConnection",
      nextToken?: string | null,
    } | null,
    signupCodes?:  {
      __typename: "ModelSignupCodeUserAssociationConnection",
      nextToken?: string | null,
    } | null,
    playEvents?:  {
      __typename: "ModelPlayEventConnection",
      nextToken?: string | null,
    } | null,
    blocked?:  {
      __typename: "ModelUserBlockingRelationshipConnection",
      nextToken?: string | null,
    } | null,
    blockers?:  {
      __typename: "ModelUserBlockingRelationshipConnection",
      nextToken?: string | null,
    } | null,
    automaticallyFollowedByNewMembersIn?:  {
      __typename: "ModelSignupCodeUsersWhichNewMembersAutomaticallyFollowAssociationConnection",
      nextToken?: string | null,
    } | null,
    automaticallyFollowsNewMembersIn?:  {
      __typename: "ModelSignupCodeUsersWhichAutomaticallyFollowNewMembersAssociationConnection",
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListUsersQueryVariables = {
  sub?: string | null,
  filter?: ModelUserFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListUsersQuery = {
  listUsers?:  {
    __typename: "ModelUserConnection",
    items:  Array< {
      __typename: "User",
      sub: string,
      phoneNumber?: string | null,
      identityId?: string | null,
      lastMigrationNumber?: number | null,
      name?: string | null,
      bio?: string | null,
      userHandle_standardForm?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type UserByPhoneNumberQueryVariables = {
  phoneNumber: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelUserFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type UserByPhoneNumberQuery = {
  userByPhoneNumber?:  {
    __typename: "ModelUserConnection",
    items:  Array< {
      __typename: "User",
      sub: string,
      phoneNumber?: string | null,
      identityId?: string | null,
      lastMigrationNumber?: number | null,
      name?: string | null,
      bio?: string | null,
      userHandle_standardForm?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type UserByIdentityIdQueryVariables = {
  identityId: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelUserFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type UserByIdentityIdQuery = {
  userByIdentityId?:  {
    __typename: "ModelUserConnection",
    items:  Array< {
      __typename: "User",
      sub: string,
      phoneNumber?: string | null,
      identityId?: string | null,
      lastMigrationNumber?: number | null,
      name?: string | null,
      bio?: string | null,
      userHandle_standardForm?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type SearchUsersQueryVariables = {
  filter?: SearchableUserFilterInput | null,
  sort?: Array< SearchableUserSortInput | null > | null,
  limit?: number | null,
  nextToken?: string | null,
  from?: number | null,
  aggregates?: Array< SearchableUserAggregationInput | null > | null,
};

export type SearchUsersQuery = {
  searchUsers?:  {
    __typename: "SearchableUserConnection",
    items:  Array< {
      __typename: "User",
      sub: string,
      phoneNumber?: string | null,
      identityId?: string | null,
      lastMigrationNumber?: number | null,
      name?: string | null,
      bio?: string | null,
      userHandle_standardForm?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
    total?: number | null,
    aggregateItems:  Array< {
      __typename: "SearchableAggregateResult",
      name: string,
      result: ( {
          __typename: "SearchableAggregateScalarResult",
          value: number,
        } | {
          __typename: "SearchableAggregateBucketResult",
          buckets?:  Array< {
            __typename: string,
            key: string,
            doc_count: number,
          } | null > | null,
        }
      ) | null,
    } | null >,
  } | null,
};

export type GetUserDisplayNameQueryVariables = {
  displayName: string,
};

export type GetUserDisplayNameQuery = {
  getUserDisplayName?:  {
    __typename: "UserDisplayName",
    displayName: string,
    ownerSub: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListUserDisplayNamesQueryVariables = {
  displayName?: string | null,
  filter?: ModelUserDisplayNameFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListUserDisplayNamesQuery = {
  listUserDisplayNames?:  {
    __typename: "ModelUserDisplayNameConnection",
    items:  Array< {
      __typename: "UserDisplayName",
      displayName: string,
      ownerSub: string,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetUserHandleQueryVariables = {
  standardForm: string,
};

export type GetUserHandleQuery = {
  getUserHandle?:  {
    __typename: "UserHandle",
    ownerSub: string,
    owner:  {
      __typename: "User",
      sub: string,
      phoneNumber?: string | null,
      identityId?: string | null,
      lastMigrationNumber?: number | null,
      name?: string | null,
      bio?: string | null,
      userHandle_standardForm?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    standardForm: string,
    renderedForm: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListUserHandlesQueryVariables = {
  standardForm?: string | null,
  filter?: ModelUserHandleFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListUserHandlesQuery = {
  listUserHandles?:  {
    __typename: "ModelUserHandleConnection",
    items:  Array< {
      __typename: "UserHandle",
      ownerSub: string,
      standardForm: string,
      renderedForm: string,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type SearchUserHandlesQueryVariables = {
  filter?: SearchableUserHandleFilterInput | null,
  sort?: Array< SearchableUserHandleSortInput | null > | null,
  limit?: number | null,
  nextToken?: string | null,
  from?: number | null,
  aggregates?: Array< SearchableUserHandleAggregationInput | null > | null,
};

export type SearchUserHandlesQuery = {
  searchUserHandles?:  {
    __typename: "SearchableUserHandleConnection",
    items:  Array< {
      __typename: "UserHandle",
      ownerSub: string,
      standardForm: string,
      renderedForm: string,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
    total?: number | null,
    aggregateItems:  Array< {
      __typename: "SearchableAggregateResult",
      name: string,
      result: ( {
          __typename: "SearchableAggregateScalarResult",
          value: number,
        } | {
          __typename: "SearchableAggregateBucketResult",
          buckets?:  Array< {
            __typename: string,
            key: string,
            doc_count: number,
          } | null > | null,
        }
      ) | null,
    } | null >,
  } | null,
};

export type GetPostQueryVariables = {
  id: string,
};

export type GetPostQuery = {
  getPost?:  {
    __typename: "Post",
    id: string,
    ownerSub: string,
    author:  {
      __typename: "User",
      sub: string,
      phoneNumber?: string | null,
      identityId?: string | null,
      lastMigrationNumber?: number | null,
      name?: string | null,
      bio?: string | null,
      userHandle_standardForm?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    createdAt: string,
    text: string,
    footnote?: string | null,
    replyingToPost?:  {
      __typename: "Post",
      id: string,
      ownerSub: string,
      createdAt: string,
      text: string,
      footnote?: string | null,
      replyingToPost_id?: string | null,
      threadRootPost_id?: string | null,
      repostedPost_id?: string | null,
      associatedTawk_localId?: string | null,
      associatedTawk_tawkVersion?: string | null,
      associatedExternalTawk_id?: string | null,
      repliesCount: number,
      likesCount: number,
      associatedColorHue?: number | null,
      updatedAt: string,
    } | null,
    replyingToPost_id?: string | null,
    threadRootPost?:  {
      __typename: "Post",
      id: string,
      ownerSub: string,
      createdAt: string,
      text: string,
      footnote?: string | null,
      replyingToPost_id?: string | null,
      threadRootPost_id?: string | null,
      repostedPost_id?: string | null,
      associatedTawk_localId?: string | null,
      associatedTawk_tawkVersion?: string | null,
      associatedExternalTawk_id?: string | null,
      repliesCount: number,
      likesCount: number,
      associatedColorHue?: number | null,
      updatedAt: string,
    } | null,
    threadRootPost_id?: string | null,
    repostedPost?:  {
      __typename: "Post",
      id: string,
      ownerSub: string,
      createdAt: string,
      text: string,
      footnote?: string | null,
      replyingToPost_id?: string | null,
      threadRootPost_id?: string | null,
      repostedPost_id?: string | null,
      associatedTawk_localId?: string | null,
      associatedTawk_tawkVersion?: string | null,
      associatedExternalTawk_id?: string | null,
      repliesCount: number,
      likesCount: number,
      associatedColorHue?: number | null,
      updatedAt: string,
    } | null,
    repostedPost_id?: string | null,
    repostedTimeRange?:  {
      __typename: "ClipTimeRange",
      startTime: number,
      endTime: number,
    } | null,
    associatedTawk_localId?: string | null,
    associatedTawk_tawkVersion?: string | null,
    associatedTawk?:  {
      __typename: "TawkCandidate",
      ownerSub: string,
      createdAt: string,
      localId: string,
      tawkVersion: string,
      title?: string | null,
      duration?: number | null,
      updatedAt: string,
    } | null,
    associatedExternalTawk_id?: string | null,
    associatedExternalTawk?:  {
      __typename: "ExternalTawk",
      id: string,
      inserter_sub: string,
      title: string,
      audioFileUrl: string,
      duration: number,
      originUrl: string,
      originKind: ExternalTawk_OriginKind,
      originName: string,
      originCreatedAt: string,
      createdAt: string,
      updatedAt: string,
    } | null,
    replies?:  {
      __typename: "ModelPostConnection",
      nextToken?: string | null,
    } | null,
    repliesCount: number,
    reposts?:  {
      __typename: "ModelPostConnection",
      nextToken?: string | null,
    } | null,
    likes?:  {
      __typename: "ModelPostLikeConnection",
      nextToken?: string | null,
    } | null,
    likesCount: number,
    claps?:  {
      __typename: "ModelPostClapConnection",
      nextToken?: string | null,
    } | null,
    associatedColorHue?: number | null,
    updatedAt: string,
  } | null,
};

export type ListPostsQueryVariables = {
  filter?: ModelPostFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListPostsQuery = {
  listPosts?:  {
    __typename: "ModelPostConnection",
    items:  Array< {
      __typename: "Post",
      id: string,
      ownerSub: string,
      createdAt: string,
      text: string,
      footnote?: string | null,
      replyingToPost_id?: string | null,
      threadRootPost_id?: string | null,
      repostedPost_id?: string | null,
      associatedTawk_localId?: string | null,
      associatedTawk_tawkVersion?: string | null,
      associatedExternalTawk_id?: string | null,
      repliesCount: number,
      likesCount: number,
      associatedColorHue?: number | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type SearchPostsQueryVariables = {
  filter?: SearchablePostFilterInput | null,
  sort?: Array< SearchablePostSortInput | null > | null,
  limit?: number | null,
  nextToken?: string | null,
  from?: number | null,
  aggregates?: Array< SearchablePostAggregationInput | null > | null,
};

export type SearchPostsQuery = {
  searchPosts?:  {
    __typename: "SearchablePostConnection",
    items:  Array< {
      __typename: "Post",
      id: string,
      ownerSub: string,
      createdAt: string,
      text: string,
      footnote?: string | null,
      replyingToPost_id?: string | null,
      threadRootPost_id?: string | null,
      repostedPost_id?: string | null,
      associatedTawk_localId?: string | null,
      associatedTawk_tawkVersion?: string | null,
      associatedExternalTawk_id?: string | null,
      repliesCount: number,
      likesCount: number,
      associatedColorHue?: number | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
    total?: number | null,
    aggregateItems:  Array< {
      __typename: "SearchableAggregateResult",
      name: string,
      result: ( {
          __typename: "SearchableAggregateScalarResult",
          value: number,
        } | {
          __typename: "SearchableAggregateBucketResult",
          buckets?:  Array< {
            __typename: string,
            key: string,
            doc_count: number,
          } | null > | null,
        }
      ) | null,
    } | null >,
  } | null,
};

export type GetExternalTawkQueryVariables = {
  id: string,
};

export type GetExternalTawkQuery = {
  getExternalTawk?:  {
    __typename: "ExternalTawk",
    id: string,
    inserter_sub: string,
    inserter:  {
      __typename: "User",
      sub: string,
      phoneNumber?: string | null,
      identityId?: string | null,
      lastMigrationNumber?: number | null,
      name?: string | null,
      bio?: string | null,
      userHandle_standardForm?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    title: string,
    audioFileUrl: string,
    duration: number,
    originUrl: string,
    originKind: ExternalTawk_OriginKind,
    originName: string,
    originCreatedAt: string,
    picture:  {
      __typename: "GenericImage",
      imageUrl: string,
    },
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListExternalTawksQueryVariables = {
  filter?: ModelExternalTawkFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListExternalTawksQuery = {
  listExternalTawks?:  {
    __typename: "ModelExternalTawkConnection",
    items:  Array< {
      __typename: "ExternalTawk",
      id: string,
      inserter_sub: string,
      title: string,
      audioFileUrl: string,
      duration: number,
      originUrl: string,
      originKind: ExternalTawk_OriginKind,
      originName: string,
      originCreatedAt: string,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type SearchExternalTawksQueryVariables = {
  filter?: SearchableExternalTawkFilterInput | null,
  sort?: Array< SearchableExternalTawkSortInput | null > | null,
  limit?: number | null,
  nextToken?: string | null,
  from?: number | null,
  aggregates?: Array< SearchableExternalTawkAggregationInput | null > | null,
};

export type SearchExternalTawksQuery = {
  searchExternalTawks?:  {
    __typename: "SearchableExternalTawkConnection",
    items:  Array< {
      __typename: "ExternalTawk",
      id: string,
      inserter_sub: string,
      title: string,
      audioFileUrl: string,
      duration: number,
      originUrl: string,
      originKind: ExternalTawk_OriginKind,
      originName: string,
      originCreatedAt: string,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
    total?: number | null,
    aggregateItems:  Array< {
      __typename: "SearchableAggregateResult",
      name: string,
      result: ( {
          __typename: "SearchableAggregateScalarResult",
          value: number,
        } | {
          __typename: "SearchableAggregateBucketResult",
          buckets?:  Array< {
            __typename: string,
            key: string,
            doc_count: number,
          } | null > | null,
        }
      ) | null,
    } | null >,
  } | null,
};

export type GetSignupCodeQueryVariables = {
  codeName: string,
};

export type GetSignupCodeQuery = {
  getSignupCode?:  {
    __typename: "SignupCode",
    codeName: string,
    createdAt: string,
    users?:  {
      __typename: "ModelSignupCodeUserAssociationConnection",
      nextToken?: string | null,
    } | null,
    stations?:  Array< {
      __typename: "SerializableRadioStation_Workaround",
      refreshId: string,
    } | null > | null,
    usersToAutomaticallyFollow?:  {
      __typename: "ModelSignupCodeUsersWhichNewMembersAutomaticallyFollowAssociationConnection",
      nextToken?: string | null,
    } | null,
    usersWhoAutomaticallyFollowNewMembers?:  {
      __typename: "ModelSignupCodeUsersWhichAutomaticallyFollowNewMembersAssociationConnection",
      nextToken?: string | null,
    } | null,
    updatedAt: string,
  } | null,
};

export type ListSignupCodesQueryVariables = {
  codeName?: string | null,
  filter?: ModelSignupCodeFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListSignupCodesQuery = {
  listSignupCodes?:  {
    __typename: "ModelSignupCodeConnection",
    items:  Array< {
      __typename: "SignupCode",
      codeName: string,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type SearchSignupCodesQueryVariables = {
  filter?: SearchableSignupCodeFilterInput | null,
  sort?: Array< SearchableSignupCodeSortInput | null > | null,
  limit?: number | null,
  nextToken?: string | null,
  from?: number | null,
  aggregates?: Array< SearchableSignupCodeAggregationInput | null > | null,
};

export type SearchSignupCodesQuery = {
  searchSignupCodes?:  {
    __typename: "SearchableSignupCodeConnection",
    items:  Array< {
      __typename: "SignupCode",
      codeName: string,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
    total?: number | null,
    aggregateItems:  Array< {
      __typename: "SearchableAggregateResult",
      name: string,
      result: ( {
          __typename: "SearchableAggregateScalarResult",
          value: number,
        } | {
          __typename: "SearchableAggregateBucketResult",
          buckets?:  Array< {
            __typename: string,
            key: string,
            doc_count: number,
          } | null > | null,
        }
      ) | null,
    } | null >,
  } | null,
};

export type GetSignupCodeUsersWhichNewMembersAutomaticallyFollowAssociationQueryVariables = {
  code_codeName: string,
  user_sub: string,
};

export type GetSignupCodeUsersWhichNewMembersAutomaticallyFollowAssociationQuery = {
  getSignupCodeUsersWhichNewMembersAutomaticallyFollowAssociation?:  {
    __typename: "SignupCodeUsersWhichNewMembersAutomaticallyFollowAssociation",
    code_codeName: string,
    code?:  {
      __typename: "SignupCode",
      codeName: string,
      createdAt: string,
      updatedAt: string,
    } | null,
    user_sub: string,
    user:  {
      __typename: "User",
      sub: string,
      phoneNumber?: string | null,
      identityId?: string | null,
      lastMigrationNumber?: number | null,
      name?: string | null,
      bio?: string | null,
      userHandle_standardForm?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListSignupCodeUsersWhichNewMembersAutomaticallyFollowAssociationsQueryVariables = {
  code_codeName?: string | null,
  user_sub?: ModelStringKeyConditionInput | null,
  filter?: ModelSignupCodeUsersWhichNewMembersAutomaticallyFollowAssociationFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListSignupCodeUsersWhichNewMembersAutomaticallyFollowAssociationsQuery = {
  listSignupCodeUsersWhichNewMembersAutomaticallyFollowAssociations?:  {
    __typename: "ModelSignupCodeUsersWhichNewMembersAutomaticallyFollowAssociationConnection",
    items:  Array< {
      __typename: "SignupCodeUsersWhichNewMembersAutomaticallyFollowAssociation",
      code_codeName: string,
      user_sub: string,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type SearchSignupCodeUsersWhichNewMembersAutomaticallyFollowAssociationsQueryVariables = {
  filter?: SearchableSignupCodeUsersWhichNewMembersAutomaticallyFollowAssociationFilterInput | null,
  sort?: Array< SearchableSignupCodeUsersWhichNewMembersAutomaticallyFollowAssociationSortInput | null > | null,
  limit?: number | null,
  nextToken?: string | null,
  from?: number | null,
  aggregates?: Array< SearchableSignupCodeUsersWhichNewMembersAutomaticallyFollowAssociationAggregationInput | null > | null,
};

export type SearchSignupCodeUsersWhichNewMembersAutomaticallyFollowAssociationsQuery = {
  searchSignupCodeUsersWhichNewMembersAutomaticallyFollowAssociations?:  {
    __typename: "SearchableSignupCodeUsersWhichNewMembersAutomaticallyFollowAssociationConnection",
    items:  Array< {
      __typename: "SignupCodeUsersWhichNewMembersAutomaticallyFollowAssociation",
      code_codeName: string,
      user_sub: string,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
    total?: number | null,
    aggregateItems:  Array< {
      __typename: "SearchableAggregateResult",
      name: string,
      result: ( {
          __typename: "SearchableAggregateScalarResult",
          value: number,
        } | {
          __typename: "SearchableAggregateBucketResult",
          buckets?:  Array< {
            __typename: string,
            key: string,
            doc_count: number,
          } | null > | null,
        }
      ) | null,
    } | null >,
  } | null,
};

export type GetSignupCodeUsersWhichAutomaticallyFollowNewMembersAssociationQueryVariables = {
  code_codeName: string,
  user_sub: string,
};

export type GetSignupCodeUsersWhichAutomaticallyFollowNewMembersAssociationQuery = {
  getSignupCodeUsersWhichAutomaticallyFollowNewMembersAssociation?:  {
    __typename: "SignupCodeUsersWhichAutomaticallyFollowNewMembersAssociation",
    code_codeName: string,
    code?:  {
      __typename: "SignupCode",
      codeName: string,
      createdAt: string,
      updatedAt: string,
    } | null,
    user_sub: string,
    user:  {
      __typename: "User",
      sub: string,
      phoneNumber?: string | null,
      identityId?: string | null,
      lastMigrationNumber?: number | null,
      name?: string | null,
      bio?: string | null,
      userHandle_standardForm?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListSignupCodeUsersWhichAutomaticallyFollowNewMembersAssociationsQueryVariables = {
  code_codeName?: string | null,
  user_sub?: ModelStringKeyConditionInput | null,
  filter?: ModelSignupCodeUsersWhichAutomaticallyFollowNewMembersAssociationFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListSignupCodeUsersWhichAutomaticallyFollowNewMembersAssociationsQuery = {
  listSignupCodeUsersWhichAutomaticallyFollowNewMembersAssociations?:  {
    __typename: "ModelSignupCodeUsersWhichAutomaticallyFollowNewMembersAssociationConnection",
    items:  Array< {
      __typename: "SignupCodeUsersWhichAutomaticallyFollowNewMembersAssociation",
      code_codeName: string,
      user_sub: string,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type SearchSignupCodeUsersWhichAutomaticallyFollowNewMembersAssociationsQueryVariables = {
  filter?: SearchableSignupCodeUsersWhichAutomaticallyFollowNewMembersAssociationFilterInput | null,
  sort?: Array< SearchableSignupCodeUsersWhichAutomaticallyFollowNewMembersAssociationSortInput | null > | null,
  limit?: number | null,
  nextToken?: string | null,
  from?: number | null,
  aggregates?: Array< SearchableSignupCodeUsersWhichAutomaticallyFollowNewMembersAssociationAggregationInput | null > | null,
};

export type SearchSignupCodeUsersWhichAutomaticallyFollowNewMembersAssociationsQuery = {
  searchSignupCodeUsersWhichAutomaticallyFollowNewMembersAssociations?:  {
    __typename: "SearchableSignupCodeUsersWhichAutomaticallyFollowNewMembersAssociationConnection",
    items:  Array< {
      __typename: "SignupCodeUsersWhichAutomaticallyFollowNewMembersAssociation",
      code_codeName: string,
      user_sub: string,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
    total?: number | null,
    aggregateItems:  Array< {
      __typename: "SearchableAggregateResult",
      name: string,
      result: ( {
          __typename: "SearchableAggregateScalarResult",
          value: number,
        } | {
          __typename: "SearchableAggregateBucketResult",
          buckets?:  Array< {
            __typename: string,
            key: string,
            doc_count: number,
          } | null > | null,
        }
      ) | null,
    } | null >,
  } | null,
};

export type GetSignupCodeUserAssociationQueryVariables = {
  ownerSub: string,
  code_codeName: string,
};

export type GetSignupCodeUserAssociationQuery = {
  getSignupCodeUserAssociation?:  {
    __typename: "SignupCodeUserAssociation",
    ownerSub: string,
    user:  {
      __typename: "User",
      sub: string,
      phoneNumber?: string | null,
      identityId?: string | null,
      lastMigrationNumber?: number | null,
      name?: string | null,
      bio?: string | null,
      userHandle_standardForm?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    code_codeName: string,
    code?:  {
      __typename: "SignupCode",
      codeName: string,
      createdAt: string,
      updatedAt: string,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListSignupCodeUserAssociationsQueryVariables = {
  ownerSub?: string | null,
  code_codeName?: ModelStringKeyConditionInput | null,
  filter?: ModelSignupCodeUserAssociationFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListSignupCodeUserAssociationsQuery = {
  listSignupCodeUserAssociations?:  {
    __typename: "ModelSignupCodeUserAssociationConnection",
    items:  Array< {
      __typename: "SignupCodeUserAssociation",
      ownerSub: string,
      code_codeName: string,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type SearchSignupCodeUserAssociationsQueryVariables = {
  filter?: SearchableSignupCodeUserAssociationFilterInput | null,
  sort?: Array< SearchableSignupCodeUserAssociationSortInput | null > | null,
  limit?: number | null,
  nextToken?: string | null,
  from?: number | null,
  aggregates?: Array< SearchableSignupCodeUserAssociationAggregationInput | null > | null,
};

export type SearchSignupCodeUserAssociationsQuery = {
  searchSignupCodeUserAssociations?:  {
    __typename: "SearchableSignupCodeUserAssociationConnection",
    items:  Array< {
      __typename: "SignupCodeUserAssociation",
      ownerSub: string,
      code_codeName: string,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
    total?: number | null,
    aggregateItems:  Array< {
      __typename: "SearchableAggregateResult",
      name: string,
      result: ( {
          __typename: "SearchableAggregateScalarResult",
          value: number,
        } | {
          __typename: "SearchableAggregateBucketResult",
          buckets?:  Array< {
            __typename: string,
            key: string,
            doc_count: number,
          } | null > | null,
        }
      ) | null,
    } | null >,
  } | null,
};

export type GetTawkCandidateQueryVariables = {
  ownerSub: string,
  localId: string,
  tawkVersion: string,
};

export type GetTawkCandidateQuery = {
  getTawkCandidate?:  {
    __typename: "TawkCandidate",
    ownerSub: string,
    author:  {
      __typename: "User",
      sub: string,
      phoneNumber?: string | null,
      identityId?: string | null,
      lastMigrationNumber?: number | null,
      name?: string | null,
      bio?: string | null,
      userHandle_standardForm?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    createdAt: string,
    localId: string,
    tawkVersion: string,
    title?: string | null,
    rawAudio:  {
      __typename: "CloudinaryResource",
      publicId: string,
    },
    processedAudio?:  {
      __typename: "CloudinaryResource",
      publicId: string,
    } | null,
    generatedVideo?:  {
      __typename: "CloudinaryResource",
      publicId: string,
    } | null,
    duration?: number | null,
    updatedAt: string,
  } | null,
};

export type ListTawkCandidatesQueryVariables = {
  ownerSub?: string | null,
  localIdTawkVersion?: ModelTawkCandidatePrimaryCompositeKeyConditionInput | null,
  filter?: ModelTawkCandidateFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListTawkCandidatesQuery = {
  listTawkCandidates?:  {
    __typename: "ModelTawkCandidateConnection",
    items:  Array< {
      __typename: "TawkCandidate",
      ownerSub: string,
      createdAt: string,
      localId: string,
      tawkVersion: string,
      title?: string | null,
      duration?: number | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetPostLikeQueryVariables = {
  ownerSub: string,
  postLiked_id: string,
};

export type GetPostLikeQuery = {
  getPostLike?:  {
    __typename: "PostLike",
    ownerSub: string,
    actor:  {
      __typename: "User",
      sub: string,
      phoneNumber?: string | null,
      identityId?: string | null,
      lastMigrationNumber?: number | null,
      name?: string | null,
      bio?: string | null,
      userHandle_standardForm?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    createdAt: string,
    postLiked_id: string,
    postLiked?:  {
      __typename: "Post",
      id: string,
      ownerSub: string,
      createdAt: string,
      text: string,
      footnote?: string | null,
      replyingToPost_id?: string | null,
      threadRootPost_id?: string | null,
      repostedPost_id?: string | null,
      associatedTawk_localId?: string | null,
      associatedTawk_tawkVersion?: string | null,
      associatedExternalTawk_id?: string | null,
      repliesCount: number,
      likesCount: number,
      associatedColorHue?: number | null,
      updatedAt: string,
    } | null,
    updatedAt: string,
  } | null,
};

export type ListPostLikesQueryVariables = {
  ownerSub?: string | null,
  postLiked_id?: ModelIDKeyConditionInput | null,
  filter?: ModelPostLikeFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListPostLikesQuery = {
  listPostLikes?:  {
    __typename: "ModelPostLikeConnection",
    items:  Array< {
      __typename: "PostLike",
      ownerSub: string,
      createdAt: string,
      postLiked_id: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type SearchPostLikesQueryVariables = {
  filter?: SearchablePostLikeFilterInput | null,
  sort?: Array< SearchablePostLikeSortInput | null > | null,
  limit?: number | null,
  nextToken?: string | null,
  from?: number | null,
  aggregates?: Array< SearchablePostLikeAggregationInput | null > | null,
};

export type SearchPostLikesQuery = {
  searchPostLikes?:  {
    __typename: "SearchablePostLikeConnection",
    items:  Array< {
      __typename: "PostLike",
      ownerSub: string,
      createdAt: string,
      postLiked_id: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
    total?: number | null,
    aggregateItems:  Array< {
      __typename: "SearchableAggregateResult",
      name: string,
      result: ( {
          __typename: "SearchableAggregateScalarResult",
          value: number,
        } | {
          __typename: "SearchableAggregateBucketResult",
          buckets?:  Array< {
            __typename: string,
            key: string,
            doc_count: number,
          } | null > | null,
        }
      ) | null,
    } | null >,
  } | null,
};

export type GetPostClapQueryVariables = {
  id: string,
};

export type GetPostClapQuery = {
  getPostClap?:  {
    __typename: "PostClap",
    id: string,
    ownerSub: string,
    actor:  {
      __typename: "User",
      sub: string,
      phoneNumber?: string | null,
      identityId?: string | null,
      lastMigrationNumber?: number | null,
      name?: string | null,
      bio?: string | null,
      userHandle_standardForm?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    createdAt: string,
    timestampRelativeToContext: number,
    contextPost_id?: string | null,
    contextPost?:  {
      __typename: "Post",
      id: string,
      ownerSub: string,
      createdAt: string,
      text: string,
      footnote?: string | null,
      replyingToPost_id?: string | null,
      threadRootPost_id?: string | null,
      repostedPost_id?: string | null,
      associatedTawk_localId?: string | null,
      associatedTawk_tawkVersion?: string | null,
      associatedExternalTawk_id?: string | null,
      repliesCount: number,
      likesCount: number,
      associatedColorHue?: number | null,
      updatedAt: string,
    } | null,
    contextRssItem?:  {
      __typename: "RssItemPlayingContext",
      audioUrl: string,
      title: string,
      originName: string,
      createdAt?: string | null,
      rssPageUrl: string,
      itemDurationInSeconds?: number | null,
      originProfileLikePictureUrl?: string | null,
    } | null,
    updatedAt: string,
  } | null,
};

export type ListPostClapsQueryVariables = {
  filter?: ModelPostClapFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListPostClapsQuery = {
  listPostClaps?:  {
    __typename: "ModelPostClapConnection",
    items:  Array< {
      __typename: "PostClap",
      id: string,
      ownerSub: string,
      createdAt: string,
      timestampRelativeToContext: number,
      contextPost_id?: string | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type SearchPostClapsQueryVariables = {
  filter?: SearchablePostClapFilterInput | null,
  sort?: Array< SearchablePostClapSortInput | null > | null,
  limit?: number | null,
  nextToken?: string | null,
  from?: number | null,
  aggregates?: Array< SearchablePostClapAggregationInput | null > | null,
};

export type SearchPostClapsQuery = {
  searchPostClaps?:  {
    __typename: "SearchablePostClapConnection",
    items:  Array< {
      __typename: "PostClap",
      id: string,
      ownerSub: string,
      createdAt: string,
      timestampRelativeToContext: number,
      contextPost_id?: string | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
    total?: number | null,
    aggregateItems:  Array< {
      __typename: "SearchableAggregateResult",
      name: string,
      result: ( {
          __typename: "SearchableAggregateScalarResult",
          value: number,
        } | {
          __typename: "SearchableAggregateBucketResult",
          buckets?:  Array< {
            __typename: string,
            key: string,
            doc_count: number,
          } | null > | null,
        }
      ) | null,
    } | null >,
  } | null,
};

export type GetPostReportQueryVariables = {
  id: string,
};

export type GetPostReportQuery = {
  getPostReport?:  {
    __typename: "PostReport",
    id: string,
    ownerSub: string,
    reporter:  {
      __typename: "User",
      sub: string,
      phoneNumber?: string | null,
      identityId?: string | null,
      lastMigrationNumber?: number | null,
      name?: string | null,
      bio?: string | null,
      userHandle_standardForm?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    text: string,
    kind: PostReport_Kind,
    reportedPost_id?: string | null,
    reportedPost?:  {
      __typename: "Post",
      id: string,
      ownerSub: string,
      createdAt: string,
      text: string,
      footnote?: string | null,
      replyingToPost_id?: string | null,
      threadRootPost_id?: string | null,
      repostedPost_id?: string | null,
      associatedTawk_localId?: string | null,
      associatedTawk_tawkVersion?: string | null,
      associatedExternalTawk_id?: string | null,
      repliesCount: number,
      likesCount: number,
      associatedColorHue?: number | null,
      updatedAt: string,
    } | null,
    reportedPostCollection_id?: string | null,
    reportedPostCollection?:  {
      __typename: "PostCollection",
      id: string,
      ownerSub: string,
      name: string,
      description: string,
      emoji?: string | null,
      createdAt: string,
      updatedAt: string,
      defaultSortOrder?: Playlist_SortOrder | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListPostReportsQueryVariables = {
  filter?: ModelPostReportFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListPostReportsQuery = {
  listPostReports?:  {
    __typename: "ModelPostReportConnection",
    items:  Array< {
      __typename: "PostReport",
      id: string,
      ownerSub: string,
      text: string,
      kind: PostReport_Kind,
      reportedPost_id?: string | null,
      reportedPostCollection_id?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type SearchPostReportsQueryVariables = {
  filter?: SearchablePostReportFilterInput | null,
  sort?: Array< SearchablePostReportSortInput | null > | null,
  limit?: number | null,
  nextToken?: string | null,
  from?: number | null,
  aggregates?: Array< SearchablePostReportAggregationInput | null > | null,
};

export type SearchPostReportsQuery = {
  searchPostReports?:  {
    __typename: "SearchablePostReportConnection",
    items:  Array< {
      __typename: "PostReport",
      id: string,
      ownerSub: string,
      text: string,
      kind: PostReport_Kind,
      reportedPost_id?: string | null,
      reportedPostCollection_id?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
    total?: number | null,
    aggregateItems:  Array< {
      __typename: "SearchableAggregateResult",
      name: string,
      result: ( {
          __typename: "SearchableAggregateScalarResult",
          value: number,
        } | {
          __typename: "SearchableAggregateBucketResult",
          buckets?:  Array< {
            __typename: string,
            key: string,
            doc_count: number,
          } | null > | null,
        }
      ) | null,
    } | null >,
  } | null,
};

export type GetUserFollowQueryVariables = {
  ownerSub: string,
  followed_sub: string,
};

export type GetUserFollowQuery = {
  getUserFollow?:  {
    __typename: "UserFollow",
    ownerSub: string,
    following:  {
      __typename: "User",
      sub: string,
      phoneNumber?: string | null,
      identityId?: string | null,
      lastMigrationNumber?: number | null,
      name?: string | null,
      bio?: string | null,
      userHandle_standardForm?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    followed_sub: string,
    followed:  {
      __typename: "User",
      sub: string,
      phoneNumber?: string | null,
      identityId?: string | null,
      lastMigrationNumber?: number | null,
      name?: string | null,
      bio?: string | null,
      userHandle_standardForm?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListUserFollowsQueryVariables = {
  ownerSub?: string | null,
  followed_sub?: ModelStringKeyConditionInput | null,
  filter?: ModelUserFollowFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListUserFollowsQuery = {
  listUserFollows?:  {
    __typename: "ModelUserFollowConnection",
    items:  Array< {
      __typename: "UserFollow",
      ownerSub: string,
      followed_sub: string,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type SearchUserFollowsQueryVariables = {
  filter?: SearchableUserFollowFilterInput | null,
  sort?: Array< SearchableUserFollowSortInput | null > | null,
  limit?: number | null,
  nextToken?: string | null,
  from?: number | null,
  aggregates?: Array< SearchableUserFollowAggregationInput | null > | null,
};

export type SearchUserFollowsQuery = {
  searchUserFollows?:  {
    __typename: "SearchableUserFollowConnection",
    items:  Array< {
      __typename: "UserFollow",
      ownerSub: string,
      followed_sub: string,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
    total?: number | null,
    aggregateItems:  Array< {
      __typename: "SearchableAggregateResult",
      name: string,
      result: ( {
          __typename: "SearchableAggregateScalarResult",
          value: number,
        } | {
          __typename: "SearchableAggregateBucketResult",
          buckets?:  Array< {
            __typename: string,
            key: string,
            doc_count: number,
          } | null > | null,
        }
      ) | null,
    } | null >,
  } | null,
};

export type GetUserBlockingRelationshipQueryVariables = {
  ownerSub: string,
  blocked_sub: string,
};

export type GetUserBlockingRelationshipQuery = {
  getUserBlockingRelationship?:  {
    __typename: "UserBlockingRelationship",
    ownerSub: string,
    blocker:  {
      __typename: "User",
      sub: string,
      phoneNumber?: string | null,
      identityId?: string | null,
      lastMigrationNumber?: number | null,
      name?: string | null,
      bio?: string | null,
      userHandle_standardForm?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    blocked_sub: string,
    blocked:  {
      __typename: "User",
      sub: string,
      phoneNumber?: string | null,
      identityId?: string | null,
      lastMigrationNumber?: number | null,
      name?: string | null,
      bio?: string | null,
      userHandle_standardForm?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListUserBlockingRelationshipsQueryVariables = {
  ownerSub?: string | null,
  blocked_sub?: ModelStringKeyConditionInput | null,
  filter?: ModelUserBlockingRelationshipFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListUserBlockingRelationshipsQuery = {
  listUserBlockingRelationships?:  {
    __typename: "ModelUserBlockingRelationshipConnection",
    items:  Array< {
      __typename: "UserBlockingRelationship",
      ownerSub: string,
      blocked_sub: string,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type SearchUserBlockingRelationshipsQueryVariables = {
  filter?: SearchableUserBlockingRelationshipFilterInput | null,
  sort?: Array< SearchableUserBlockingRelationshipSortInput | null > | null,
  limit?: number | null,
  nextToken?: string | null,
  from?: number | null,
  aggregates?: Array< SearchableUserBlockingRelationshipAggregationInput | null > | null,
};

export type SearchUserBlockingRelationshipsQuery = {
  searchUserBlockingRelationships?:  {
    __typename: "SearchableUserBlockingRelationshipConnection",
    items:  Array< {
      __typename: "UserBlockingRelationship",
      ownerSub: string,
      blocked_sub: string,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
    total?: number | null,
    aggregateItems:  Array< {
      __typename: "SearchableAggregateResult",
      name: string,
      result: ( {
          __typename: "SearchableAggregateScalarResult",
          value: number,
        } | {
          __typename: "SearchableAggregateBucketResult",
          buckets?:  Array< {
            __typename: string,
            key: string,
            doc_count: number,
          } | null > | null,
        }
      ) | null,
    } | null >,
  } | null,
};

export type GetPlayEventQueryVariables = {
  id: string,
};

export type GetPlayEventQuery = {
  getPlayEvent?:  {
    __typename: "PlayEvent",
    id: string,
    ownerSub: string,
    playedBy:  {
      __typename: "User",
      sub: string,
      phoneNumber?: string | null,
      identityId?: string | null,
      lastMigrationNumber?: number | null,
      name?: string | null,
      bio?: string | null,
      userHandle_standardForm?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    startTime: number,
    endTime: number,
    duration: number,
    contextPost_id?: string | null,
    contextPost?:  {
      __typename: "Post",
      id: string,
      ownerSub: string,
      createdAt: string,
      text: string,
      footnote?: string | null,
      replyingToPost_id?: string | null,
      threadRootPost_id?: string | null,
      repostedPost_id?: string | null,
      associatedTawk_localId?: string | null,
      associatedTawk_tawkVersion?: string | null,
      associatedExternalTawk_id?: string | null,
      repliesCount: number,
      likesCount: number,
      associatedColorHue?: number | null,
      updatedAt: string,
    } | null,
    contextRssItem?:  {
      __typename: "RssItemPlayingContext",
      audioUrl: string,
      title: string,
      originName: string,
      createdAt?: string | null,
      rssPageUrl: string,
      itemDurationInSeconds?: number | null,
      originProfileLikePictureUrl?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListPlayEventsQueryVariables = {
  filter?: ModelPlayEventFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListPlayEventsQuery = {
  listPlayEvents?:  {
    __typename: "ModelPlayEventConnection",
    items:  Array< {
      __typename: "PlayEvent",
      id: string,
      ownerSub: string,
      startTime: number,
      endTime: number,
      duration: number,
      contextPost_id?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type SearchPlayEventsQueryVariables = {
  filter?: SearchablePlayEventFilterInput | null,
  sort?: Array< SearchablePlayEventSortInput | null > | null,
  limit?: number | null,
  nextToken?: string | null,
  from?: number | null,
  aggregates?: Array< SearchablePlayEventAggregationInput | null > | null,
};

export type SearchPlayEventsQuery = {
  searchPlayEvents?:  {
    __typename: "SearchablePlayEventConnection",
    items:  Array< {
      __typename: "PlayEvent",
      id: string,
      ownerSub: string,
      startTime: number,
      endTime: number,
      duration: number,
      contextPost_id?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
    total?: number | null,
    aggregateItems:  Array< {
      __typename: "SearchableAggregateResult",
      name: string,
      result: ( {
          __typename: "SearchableAggregateScalarResult",
          value: number,
        } | {
          __typename: "SearchableAggregateBucketResult",
          buckets?:  Array< {
            __typename: string,
            key: string,
            doc_count: number,
          } | null > | null,
        }
      ) | null,
    } | null >,
  } | null,
};

export type GetPostCollectionQueryVariables = {
  id: string,
};

export type GetPostCollectionQuery = {
  getPostCollection?:  {
    __typename: "PostCollection",
    id: string,
    ownerSub: string,
    author:  {
      __typename: "User",
      sub: string,
      phoneNumber?: string | null,
      identityId?: string | null,
      lastMigrationNumber?: number | null,
      name?: string | null,
      bio?: string | null,
      userHandle_standardForm?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    name: string,
    description: string,
    emoji?: string | null,
    color?:  {
      __typename: "Color",
      red: number,
      green: number,
      blue: number,
    } | null,
    createdAt: string,
    updatedAt: string,
    memberships?:  {
      __typename: "ModelPostCollectionMembershipConnection",
      nextToken?: string | null,
    } | null,
    followers?:  {
      __typename: "ModelPostCollectionFollowRelationConnection",
      nextToken?: string | null,
    } | null,
    defaultSortOrder?: Playlist_SortOrder | null,
  } | null,
};

export type ListPostCollectionsQueryVariables = {
  filter?: ModelPostCollectionFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListPostCollectionsQuery = {
  listPostCollections?:  {
    __typename: "ModelPostCollectionConnection",
    items:  Array< {
      __typename: "PostCollection",
      id: string,
      ownerSub: string,
      name: string,
      description: string,
      emoji?: string | null,
      createdAt: string,
      updatedAt: string,
      defaultSortOrder?: Playlist_SortOrder | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type PostCollectionsByCuratorSubQueryVariables = {
  ownerSub: string,
  createdAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelPostCollectionFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type PostCollectionsByCuratorSubQuery = {
  postCollectionsByCuratorSub?:  {
    __typename: "ModelPostCollectionConnection",
    items:  Array< {
      __typename: "PostCollection",
      id: string,
      ownerSub: string,
      name: string,
      description: string,
      emoji?: string | null,
      createdAt: string,
      updatedAt: string,
      defaultSortOrder?: Playlist_SortOrder | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type SearchPostCollectionsQueryVariables = {
  filter?: SearchablePostCollectionFilterInput | null,
  sort?: Array< SearchablePostCollectionSortInput | null > | null,
  limit?: number | null,
  nextToken?: string | null,
  from?: number | null,
  aggregates?: Array< SearchablePostCollectionAggregationInput | null > | null,
};

export type SearchPostCollectionsQuery = {
  searchPostCollections?:  {
    __typename: "SearchablePostCollectionConnection",
    items:  Array< {
      __typename: "PostCollection",
      id: string,
      ownerSub: string,
      name: string,
      description: string,
      emoji?: string | null,
      createdAt: string,
      updatedAt: string,
      defaultSortOrder?: Playlist_SortOrder | null,
    } | null >,
    nextToken?: string | null,
    total?: number | null,
    aggregateItems:  Array< {
      __typename: "SearchableAggregateResult",
      name: string,
      result: ( {
          __typename: "SearchableAggregateScalarResult",
          value: number,
        } | {
          __typename: "SearchableAggregateBucketResult",
          buckets?:  Array< {
            __typename: string,
            key: string,
            doc_count: number,
          } | null > | null,
        }
      ) | null,
    } | null >,
  } | null,
};

export type GetPostCollectionMembershipQueryVariables = {
  postCollection_id: string,
  post_id: string,
};

export type GetPostCollectionMembershipQuery = {
  getPostCollectionMembership?:  {
    __typename: "PostCollectionMembership",
    ownerSub: string,
    author:  {
      __typename: "User",
      sub: string,
      phoneNumber?: string | null,
      identityId?: string | null,
      lastMigrationNumber?: number | null,
      name?: string | null,
      bio?: string | null,
      userHandle_standardForm?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    postCollection_id: string,
    postCollection:  {
      __typename: "PostCollection",
      id: string,
      ownerSub: string,
      name: string,
      description: string,
      emoji?: string | null,
      createdAt: string,
      updatedAt: string,
      defaultSortOrder?: Playlist_SortOrder | null,
    },
    post_id: string,
    post?:  {
      __typename: "Post",
      id: string,
      ownerSub: string,
      createdAt: string,
      text: string,
      footnote?: string | null,
      replyingToPost_id?: string | null,
      threadRootPost_id?: string | null,
      repostedPost_id?: string | null,
      associatedTawk_localId?: string | null,
      associatedTawk_tawkVersion?: string | null,
      associatedExternalTawk_id?: string | null,
      repliesCount: number,
      likesCount: number,
      associatedColorHue?: number | null,
      updatedAt: string,
    } | null,
    createdAt: string,
    rank: number,
    updatedAt: string,
  } | null,
};

export type ListPostCollectionMembershipsQueryVariables = {
  postCollection_id?: string | null,
  post_id?: ModelIDKeyConditionInput | null,
  filter?: ModelPostCollectionMembershipFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListPostCollectionMembershipsQuery = {
  listPostCollectionMemberships?:  {
    __typename: "ModelPostCollectionMembershipConnection",
    items:  Array< {
      __typename: "PostCollectionMembership",
      ownerSub: string,
      postCollection_id: string,
      post_id: string,
      createdAt: string,
      rank: number,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type SearchPostCollectionMembershipsQueryVariables = {
  filter?: SearchablePostCollectionMembershipFilterInput | null,
  sort?: Array< SearchablePostCollectionMembershipSortInput | null > | null,
  limit?: number | null,
  nextToken?: string | null,
  from?: number | null,
  aggregates?: Array< SearchablePostCollectionMembershipAggregationInput | null > | null,
};

export type SearchPostCollectionMembershipsQuery = {
  searchPostCollectionMemberships?:  {
    __typename: "SearchablePostCollectionMembershipConnection",
    items:  Array< {
      __typename: "PostCollectionMembership",
      ownerSub: string,
      postCollection_id: string,
      post_id: string,
      createdAt: string,
      rank: number,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
    total?: number | null,
    aggregateItems:  Array< {
      __typename: "SearchableAggregateResult",
      name: string,
      result: ( {
          __typename: "SearchableAggregateScalarResult",
          value: number,
        } | {
          __typename: "SearchableAggregateBucketResult",
          buckets?:  Array< {
            __typename: string,
            key: string,
            doc_count: number,
          } | null > | null,
        }
      ) | null,
    } | null >,
  } | null,
};

export type GetPostCollectionFollowRelationQueryVariables = {
  postCollection_id: string,
  ownerSub: string,
};

export type GetPostCollectionFollowRelationQuery = {
  getPostCollectionFollowRelation?:  {
    __typename: "PostCollectionFollowRelation",
    ownerSub: string,
    follower:  {
      __typename: "User",
      sub: string,
      phoneNumber?: string | null,
      identityId?: string | null,
      lastMigrationNumber?: number | null,
      name?: string | null,
      bio?: string | null,
      userHandle_standardForm?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    postCollection_id: string,
    postCollection:  {
      __typename: "PostCollection",
      id: string,
      ownerSub: string,
      name: string,
      description: string,
      emoji?: string | null,
      createdAt: string,
      updatedAt: string,
      defaultSortOrder?: Playlist_SortOrder | null,
    },
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListPostCollectionFollowRelationsQueryVariables = {
  postCollection_id?: string | null,
  ownerSub?: ModelStringKeyConditionInput | null,
  filter?: ModelPostCollectionFollowRelationFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListPostCollectionFollowRelationsQuery = {
  listPostCollectionFollowRelations?:  {
    __typename: "ModelPostCollectionFollowRelationConnection",
    items:  Array< {
      __typename: "PostCollectionFollowRelation",
      ownerSub: string,
      postCollection_id: string,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type SearchPostCollectionFollowRelationsQueryVariables = {
  filter?: SearchablePostCollectionFollowRelationFilterInput | null,
  sort?: Array< SearchablePostCollectionFollowRelationSortInput | null > | null,
  limit?: number | null,
  nextToken?: string | null,
  from?: number | null,
  aggregates?: Array< SearchablePostCollectionFollowRelationAggregationInput | null > | null,
};

export type SearchPostCollectionFollowRelationsQuery = {
  searchPostCollectionFollowRelations?:  {
    __typename: "SearchablePostCollectionFollowRelationConnection",
    items:  Array< {
      __typename: "PostCollectionFollowRelation",
      ownerSub: string,
      postCollection_id: string,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
    total?: number | null,
    aggregateItems:  Array< {
      __typename: "SearchableAggregateResult",
      name: string,
      result: ( {
          __typename: "SearchableAggregateScalarResult",
          value: number,
        } | {
          __typename: "SearchableAggregateBucketResult",
          buckets?:  Array< {
            __typename: string,
            key: string,
            doc_count: number,
          } | null > | null,
        }
      ) | null,
    } | null >,
  } | null,
};

export type GetCommunityQueryVariables = {
  shortName: string,
};

export type GetCommunityQuery = {
  getCommunity?:  {
    __typename: "Community",
    ownerSub: string,
    creator:  {
      __typename: "User",
      sub: string,
      phoneNumber?: string | null,
      identityId?: string | null,
      lastMigrationNumber?: number | null,
      name?: string | null,
      bio?: string | null,
      userHandle_standardForm?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    shortName: string,
    postAssociations?:  {
      __typename: "ModelCommunityPostAssociationConnection",
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
    creatorSub?: string | null,
  } | null,
};

export type ListCommunitiesQueryVariables = {
  shortName?: string | null,
  filter?: ModelCommunityFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListCommunitiesQuery = {
  listCommunities?:  {
    __typename: "ModelCommunityConnection",
    items:  Array< {
      __typename: "Community",
      ownerSub: string,
      shortName: string,
      createdAt: string,
      updatedAt: string,
      creatorSub?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type SearchCommunitiesQueryVariables = {
  filter?: SearchableCommunityFilterInput | null,
  sort?: Array< SearchableCommunitySortInput | null > | null,
  limit?: number | null,
  nextToken?: string | null,
  from?: number | null,
  aggregates?: Array< SearchableCommunityAggregationInput | null > | null,
};

export type SearchCommunitiesQuery = {
  searchCommunities?:  {
    __typename: "SearchableCommunityConnection",
    items:  Array< {
      __typename: "Community",
      ownerSub: string,
      shortName: string,
      createdAt: string,
      updatedAt: string,
      creatorSub?: string | null,
    } | null >,
    nextToken?: string | null,
    total?: number | null,
    aggregateItems:  Array< {
      __typename: "SearchableAggregateResult",
      name: string,
      result: ( {
          __typename: "SearchableAggregateScalarResult",
          value: number,
        } | {
          __typename: "SearchableAggregateBucketResult",
          buckets?:  Array< {
            __typename: string,
            key: string,
            doc_count: number,
          } | null > | null,
        }
      ) | null,
    } | null >,
  } | null,
};

export type GetCommunityPostAssociationQueryVariables = {
  id: string,
};

export type GetCommunityPostAssociationQuery = {
  getCommunityPostAssociation?:  {
    __typename: "CommunityPostAssociation",
    id: string,
    ownerSub: string,
    author:  {
      __typename: "User",
      sub: string,
      phoneNumber?: string | null,
      identityId?: string | null,
      lastMigrationNumber?: number | null,
      name?: string | null,
      bio?: string | null,
      userHandle_standardForm?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    community_shortName: string,
    community:  {
      __typename: "Community",
      ownerSub: string,
      shortName: string,
      createdAt: string,
      updatedAt: string,
      creatorSub?: string | null,
    },
    associatedPost_id: string,
    associatedPost:  {
      __typename: "Post",
      id: string,
      ownerSub: string,
      createdAt: string,
      text: string,
      footnote?: string | null,
      replyingToPost_id?: string | null,
      threadRootPost_id?: string | null,
      repostedPost_id?: string | null,
      associatedTawk_localId?: string | null,
      associatedTawk_tawkVersion?: string | null,
      associatedExternalTawk_id?: string | null,
      repliesCount: number,
      likesCount: number,
      associatedColorHue?: number | null,
      updatedAt: string,
    },
    createdAt?: string | null,
    updatedAt?: string | null,
    communityPostAssociationsId: string,
  } | null,
};

export type ListCommunityPostAssociationsQueryVariables = {
  id?: string | null,
  filter?: ModelCommunityPostAssociationFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListCommunityPostAssociationsQuery = {
  listCommunityPostAssociations?:  {
    __typename: "ModelCommunityPostAssociationConnection",
    items:  Array< {
      __typename: "CommunityPostAssociation",
      id: string,
      ownerSub: string,
      community_shortName: string,
      associatedPost_id: string,
      createdAt?: string | null,
      updatedAt?: string | null,
      communityPostAssociationsId: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type SearchCommunityPostAssociationsQueryVariables = {
  filter?: SearchableCommunityPostAssociationFilterInput | null,
  sort?: Array< SearchableCommunityPostAssociationSortInput | null > | null,
  limit?: number | null,
  nextToken?: string | null,
  from?: number | null,
  aggregates?: Array< SearchableCommunityPostAssociationAggregationInput | null > | null,
};

export type SearchCommunityPostAssociationsQuery = {
  searchCommunityPostAssociations?:  {
    __typename: "SearchableCommunityPostAssociationConnection",
    items:  Array< {
      __typename: "CommunityPostAssociation",
      id: string,
      ownerSub: string,
      community_shortName: string,
      associatedPost_id: string,
      createdAt?: string | null,
      updatedAt?: string | null,
      communityPostAssociationsId: string,
    } | null >,
    nextToken?: string | null,
    total?: number | null,
    aggregateItems:  Array< {
      __typename: "SearchableAggregateResult",
      name: string,
      result: ( {
          __typename: "SearchableAggregateScalarResult",
          value: number,
        } | {
          __typename: "SearchableAggregateBucketResult",
          buckets?:  Array< {
            __typename: string,
            key: string,
            doc_count: number,
          } | null > | null,
        }
      ) | null,
    } | null >,
  } | null,
};

export type OnCreatePostCollectionMembershipSubscriptionVariables = {
  ownerSub?: string | null,
};

export type OnCreatePostCollectionMembershipSubscription = {
  onCreatePostCollectionMembership?:  {
    __typename: "PostCollectionMembership",
    ownerSub: string,
    author:  {
      __typename: "User",
      sub: string,
      phoneNumber?: string | null,
      identityId?: string | null,
      lastMigrationNumber?: number | null,
      name?: string | null,
      bio?: string | null,
      userHandle_standardForm?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    postCollection_id: string,
    postCollection:  {
      __typename: "PostCollection",
      id: string,
      ownerSub: string,
      name: string,
      description: string,
      emoji?: string | null,
      createdAt: string,
      updatedAt: string,
      defaultSortOrder?: Playlist_SortOrder | null,
    },
    post_id: string,
    post?:  {
      __typename: "Post",
      id: string,
      ownerSub: string,
      createdAt: string,
      text: string,
      footnote?: string | null,
      replyingToPost_id?: string | null,
      threadRootPost_id?: string | null,
      repostedPost_id?: string | null,
      associatedTawk_localId?: string | null,
      associatedTawk_tawkVersion?: string | null,
      associatedExternalTawk_id?: string | null,
      repliesCount: number,
      likesCount: number,
      associatedColorHue?: number | null,
      updatedAt: string,
    } | null,
    createdAt: string,
    rank: number,
    updatedAt: string,
  } | null,
};

export type OnUpdatePostCollectionMembershipSubscriptionVariables = {
  ownerSub?: string | null,
};

export type OnUpdatePostCollectionMembershipSubscription = {
  onUpdatePostCollectionMembership?:  {
    __typename: "PostCollectionMembership",
    ownerSub: string,
    author:  {
      __typename: "User",
      sub: string,
      phoneNumber?: string | null,
      identityId?: string | null,
      lastMigrationNumber?: number | null,
      name?: string | null,
      bio?: string | null,
      userHandle_standardForm?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    postCollection_id: string,
    postCollection:  {
      __typename: "PostCollection",
      id: string,
      ownerSub: string,
      name: string,
      description: string,
      emoji?: string | null,
      createdAt: string,
      updatedAt: string,
      defaultSortOrder?: Playlist_SortOrder | null,
    },
    post_id: string,
    post?:  {
      __typename: "Post",
      id: string,
      ownerSub: string,
      createdAt: string,
      text: string,
      footnote?: string | null,
      replyingToPost_id?: string | null,
      threadRootPost_id?: string | null,
      repostedPost_id?: string | null,
      associatedTawk_localId?: string | null,
      associatedTawk_tawkVersion?: string | null,
      associatedExternalTawk_id?: string | null,
      repliesCount: number,
      likesCount: number,
      associatedColorHue?: number | null,
      updatedAt: string,
    } | null,
    createdAt: string,
    rank: number,
    updatedAt: string,
  } | null,
};

export type OnDeletePostCollectionMembershipSubscriptionVariables = {
  ownerSub?: string | null,
};

export type OnDeletePostCollectionMembershipSubscription = {
  onDeletePostCollectionMembership?:  {
    __typename: "PostCollectionMembership",
    ownerSub: string,
    author:  {
      __typename: "User",
      sub: string,
      phoneNumber?: string | null,
      identityId?: string | null,
      lastMigrationNumber?: number | null,
      name?: string | null,
      bio?: string | null,
      userHandle_standardForm?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    postCollection_id: string,
    postCollection:  {
      __typename: "PostCollection",
      id: string,
      ownerSub: string,
      name: string,
      description: string,
      emoji?: string | null,
      createdAt: string,
      updatedAt: string,
      defaultSortOrder?: Playlist_SortOrder | null,
    },
    post_id: string,
    post?:  {
      __typename: "Post",
      id: string,
      ownerSub: string,
      createdAt: string,
      text: string,
      footnote?: string | null,
      replyingToPost_id?: string | null,
      threadRootPost_id?: string | null,
      repostedPost_id?: string | null,
      associatedTawk_localId?: string | null,
      associatedTawk_tawkVersion?: string | null,
      associatedExternalTawk_id?: string | null,
      repliesCount: number,
      likesCount: number,
      associatedColorHue?: number | null,
      updatedAt: string,
    } | null,
    createdAt: string,
    rank: number,
    updatedAt: string,
  } | null,
};

export type OnCreatePostCollectionFollowRelationSubscriptionVariables = {
  ownerSub?: string | null,
};

export type OnCreatePostCollectionFollowRelationSubscription = {
  onCreatePostCollectionFollowRelation?:  {
    __typename: "PostCollectionFollowRelation",
    ownerSub: string,
    follower:  {
      __typename: "User",
      sub: string,
      phoneNumber?: string | null,
      identityId?: string | null,
      lastMigrationNumber?: number | null,
      name?: string | null,
      bio?: string | null,
      userHandle_standardForm?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    postCollection_id: string,
    postCollection:  {
      __typename: "PostCollection",
      id: string,
      ownerSub: string,
      name: string,
      description: string,
      emoji?: string | null,
      createdAt: string,
      updatedAt: string,
      defaultSortOrder?: Playlist_SortOrder | null,
    },
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdatePostCollectionFollowRelationSubscriptionVariables = {
  ownerSub?: string | null,
};

export type OnUpdatePostCollectionFollowRelationSubscription = {
  onUpdatePostCollectionFollowRelation?:  {
    __typename: "PostCollectionFollowRelation",
    ownerSub: string,
    follower:  {
      __typename: "User",
      sub: string,
      phoneNumber?: string | null,
      identityId?: string | null,
      lastMigrationNumber?: number | null,
      name?: string | null,
      bio?: string | null,
      userHandle_standardForm?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    postCollection_id: string,
    postCollection:  {
      __typename: "PostCollection",
      id: string,
      ownerSub: string,
      name: string,
      description: string,
      emoji?: string | null,
      createdAt: string,
      updatedAt: string,
      defaultSortOrder?: Playlist_SortOrder | null,
    },
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeletePostCollectionFollowRelationSubscriptionVariables = {
  ownerSub?: string | null,
};

export type OnDeletePostCollectionFollowRelationSubscription = {
  onDeletePostCollectionFollowRelation?:  {
    __typename: "PostCollectionFollowRelation",
    ownerSub: string,
    follower:  {
      __typename: "User",
      sub: string,
      phoneNumber?: string | null,
      identityId?: string | null,
      lastMigrationNumber?: number | null,
      name?: string | null,
      bio?: string | null,
      userHandle_standardForm?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    postCollection_id: string,
    postCollection:  {
      __typename: "PostCollection",
      id: string,
      ownerSub: string,
      name: string,
      description: string,
      emoji?: string | null,
      createdAt: string,
      updatedAt: string,
      defaultSortOrder?: Playlist_SortOrder | null,
    },
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateCommunitySubscriptionVariables = {
  creatorSub?: string | null,
};

export type OnCreateCommunitySubscription = {
  onCreateCommunity?:  {
    __typename: "Community",
    ownerSub: string,
    creator:  {
      __typename: "User",
      sub: string,
      phoneNumber?: string | null,
      identityId?: string | null,
      lastMigrationNumber?: number | null,
      name?: string | null,
      bio?: string | null,
      userHandle_standardForm?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    shortName: string,
    postAssociations?:  {
      __typename: "ModelCommunityPostAssociationConnection",
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
    creatorSub?: string | null,
  } | null,
};

export type OnUpdateCommunitySubscriptionVariables = {
  creatorSub?: string | null,
};

export type OnUpdateCommunitySubscription = {
  onUpdateCommunity?:  {
    __typename: "Community",
    ownerSub: string,
    creator:  {
      __typename: "User",
      sub: string,
      phoneNumber?: string | null,
      identityId?: string | null,
      lastMigrationNumber?: number | null,
      name?: string | null,
      bio?: string | null,
      userHandle_standardForm?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    shortName: string,
    postAssociations?:  {
      __typename: "ModelCommunityPostAssociationConnection",
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
    creatorSub?: string | null,
  } | null,
};

export type OnDeleteCommunitySubscriptionVariables = {
  creatorSub?: string | null,
};

export type OnDeleteCommunitySubscription = {
  onDeleteCommunity?:  {
    __typename: "Community",
    ownerSub: string,
    creator:  {
      __typename: "User",
      sub: string,
      phoneNumber?: string | null,
      identityId?: string | null,
      lastMigrationNumber?: number | null,
      name?: string | null,
      bio?: string | null,
      userHandle_standardForm?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    shortName: string,
    postAssociations?:  {
      __typename: "ModelCommunityPostAssociationConnection",
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
    creatorSub?: string | null,
  } | null,
};

export type OnCreateCommunityPostAssociationSubscriptionVariables = {
  ownerSub?: string | null,
};

export type OnCreateCommunityPostAssociationSubscription = {
  onCreateCommunityPostAssociation?:  {
    __typename: "CommunityPostAssociation",
    id: string,
    ownerSub: string,
    author:  {
      __typename: "User",
      sub: string,
      phoneNumber?: string | null,
      identityId?: string | null,
      lastMigrationNumber?: number | null,
      name?: string | null,
      bio?: string | null,
      userHandle_standardForm?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    community_shortName: string,
    community:  {
      __typename: "Community",
      ownerSub: string,
      shortName: string,
      createdAt: string,
      updatedAt: string,
      creatorSub?: string | null,
    },
    associatedPost_id: string,
    associatedPost:  {
      __typename: "Post",
      id: string,
      ownerSub: string,
      createdAt: string,
      text: string,
      footnote?: string | null,
      replyingToPost_id?: string | null,
      threadRootPost_id?: string | null,
      repostedPost_id?: string | null,
      associatedTawk_localId?: string | null,
      associatedTawk_tawkVersion?: string | null,
      associatedExternalTawk_id?: string | null,
      repliesCount: number,
      likesCount: number,
      associatedColorHue?: number | null,
      updatedAt: string,
    },
    createdAt?: string | null,
    updatedAt?: string | null,
    communityPostAssociationsId: string,
  } | null,
};

export type OnUpdateCommunityPostAssociationSubscriptionVariables = {
  ownerSub?: string | null,
};

export type OnUpdateCommunityPostAssociationSubscription = {
  onUpdateCommunityPostAssociation?:  {
    __typename: "CommunityPostAssociation",
    id: string,
    ownerSub: string,
    author:  {
      __typename: "User",
      sub: string,
      phoneNumber?: string | null,
      identityId?: string | null,
      lastMigrationNumber?: number | null,
      name?: string | null,
      bio?: string | null,
      userHandle_standardForm?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    community_shortName: string,
    community:  {
      __typename: "Community",
      ownerSub: string,
      shortName: string,
      createdAt: string,
      updatedAt: string,
      creatorSub?: string | null,
    },
    associatedPost_id: string,
    associatedPost:  {
      __typename: "Post",
      id: string,
      ownerSub: string,
      createdAt: string,
      text: string,
      footnote?: string | null,
      replyingToPost_id?: string | null,
      threadRootPost_id?: string | null,
      repostedPost_id?: string | null,
      associatedTawk_localId?: string | null,
      associatedTawk_tawkVersion?: string | null,
      associatedExternalTawk_id?: string | null,
      repliesCount: number,
      likesCount: number,
      associatedColorHue?: number | null,
      updatedAt: string,
    },
    createdAt?: string | null,
    updatedAt?: string | null,
    communityPostAssociationsId: string,
  } | null,
};

export type OnDeleteCommunityPostAssociationSubscriptionVariables = {
  ownerSub?: string | null,
};

export type OnDeleteCommunityPostAssociationSubscription = {
  onDeleteCommunityPostAssociation?:  {
    __typename: "CommunityPostAssociation",
    id: string,
    ownerSub: string,
    author:  {
      __typename: "User",
      sub: string,
      phoneNumber?: string | null,
      identityId?: string | null,
      lastMigrationNumber?: number | null,
      name?: string | null,
      bio?: string | null,
      userHandle_standardForm?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    community_shortName: string,
    community:  {
      __typename: "Community",
      ownerSub: string,
      shortName: string,
      createdAt: string,
      updatedAt: string,
      creatorSub?: string | null,
    },
    associatedPost_id: string,
    associatedPost:  {
      __typename: "Post",
      id: string,
      ownerSub: string,
      createdAt: string,
      text: string,
      footnote?: string | null,
      replyingToPost_id?: string | null,
      threadRootPost_id?: string | null,
      repostedPost_id?: string | null,
      associatedTawk_localId?: string | null,
      associatedTawk_tawkVersion?: string | null,
      associatedExternalTawk_id?: string | null,
      repliesCount: number,
      likesCount: number,
      associatedColorHue?: number | null,
      updatedAt: string,
    },
    createdAt?: string | null,
    updatedAt?: string | null,
    communityPostAssociationsId: string,
  } | null,
};

export type GetUserFieldsFragment = {
  __typename: "User",
  name?: string | null,
  sub: string,
  userHandle?:  {
    __typename: "UserHandle",
    renderedForm: string,
  } | null,
  profilePhoto:  {
    __typename: "CloudinaryResource",
    publicId: string,
  },
};

export type GetAssociatedTawkInfoFragment = {
  __typename: "TawkCandidate",
  title?: string | null,
  generatedVideo?:  {
    __typename: "CloudinaryResource",
    publicId: string,
  } | null,
};

export type GetRepostedTawkInfoFragment = {
  __typename: "Post",
  repostedPost_id?: string | null,
  repostedTimeRange?:  {
    __typename: "ClipTimeRange",
    endTime: number,
    startTime: number,
  } | null,
};

export type GetClipPostInfoFragment = {
  __typename: "Post",
  id: string,
  createdAt: string,
  text: string,
  author:  {
    __typename: "User",
    name?: string | null,
    sub: string,
    userHandle?:  {
      __typename: "UserHandle",
      renderedForm: string,
    } | null,
    profilePhoto:  {
      __typename: "CloudinaryResource",
      publicId: string,
    },
  },
  associatedTawk?:  {
    __typename: "TawkCandidate",
    title?: string | null,
    generatedVideo?:  {
      __typename: "CloudinaryResource",
      publicId: string,
    } | null,
  } | null,
};

export type PostInfoFragment = {
  __typename: "Post",
  createdAt: string,
  text: string,
  associatedTawk?:  {
    __typename: "TawkCandidate",
    title?: string | null,
    createdAt: string,
    generatedVideo?:  {
      __typename: "CloudinaryResource",
      publicId: string,
    } | null,
    rawAudio:  {
      __typename: "CloudinaryResource",
      publicId: string,
    },
  } | null,
  author:  {
    __typename: "User",
    name?: string | null,
    sub: string,
    userHandle?:  {
      __typename: "UserHandle",
      renderedForm: string,
    } | null,
    profilePhoto:  {
      __typename: "CloudinaryResource",
      publicId: string,
    },
  },
  likesCount: number,
  repliesCount: number,
  id: string,
  repostedPost_id?: string | null,
  repostedTimeRange?:  {
    __typename: "ClipTimeRange",
    endTime: number,
    startTime: number,
  } | null,
  repostedPost?:  {
    __typename: "Post",
    id: string,
    createdAt: string,
    text: string,
    author:  {
      __typename: "User",
      name?: string | null,
      sub: string,
      userHandle?:  {
        __typename: "UserHandle",
        renderedForm: string,
      } | null,
      profilePhoto:  {
        __typename: "CloudinaryResource",
        publicId: string,
      },
    },
    associatedTawk?:  {
      __typename: "TawkCandidate",
      title?: string | null,
      generatedVideo?:  {
        __typename: "CloudinaryResource",
        publicId: string,
      } | null,
    } | null,
  } | null,
};

export type PostCollectionInfoFragment = {
  __typename: "PostCollection",
  id: string,
  description: string,
  name: string,
  updatedAt: string,
  author:  {
    __typename: "User",
    name?: string | null,
    sub: string,
    userHandle?:  {
      __typename: "UserHandle",
      renderedForm: string,
    } | null,
    profilePhoto:  {
      __typename: "CloudinaryResource",
      publicId: string,
    },
  },
  color?:  {
    __typename: "Color",
    blue: number,
    green: number,
    red: number,
  } | null,
  emoji?: string | null,
  memberships?:  {
    __typename: "ModelPostCollectionMembershipConnection",
    items:  Array< {
      __typename: "PostCollectionMembership",
      post?:  {
        __typename: "Post",
        createdAt: string,
        text: string,
        associatedTawk?:  {
          __typename: "TawkCandidate",
          title?: string | null,
          createdAt: string,
          generatedVideo?:  {
            __typename: "CloudinaryResource",
            publicId: string,
          } | null,
          rawAudio:  {
            __typename: "CloudinaryResource",
            publicId: string,
          },
        } | null,
        author:  {
          __typename: "User",
          name?: string | null,
          sub: string,
          userHandle?:  {
            __typename: "UserHandle",
            renderedForm: string,
          } | null,
          profilePhoto:  {
            __typename: "CloudinaryResource",
            publicId: string,
          },
        },
        likesCount: number,
        repliesCount: number,
        id: string,
        repostedPost_id?: string | null,
        repostedTimeRange?:  {
          __typename: "ClipTimeRange",
          endTime: number,
          startTime: number,
        } | null,
        repostedPost?:  {
          __typename: "Post",
          id: string,
          createdAt: string,
          text: string,
          author:  {
            __typename: "User",
            name?: string | null,
            sub: string,
            userHandle?:  {
              __typename: "UserHandle",
              renderedForm: string,
            } | null,
            profilePhoto:  {
              __typename: "CloudinaryResource",
              publicId: string,
            },
          },
          associatedTawk?:  {
            __typename: "TawkCandidate",
            title?: string | null,
            generatedVideo?:  {
              __typename: "CloudinaryResource",
              publicId: string,
            } | null,
          } | null,
        } | null,
      } | null,
    } | null >,
  } | null,
};

export type CloudinaryResourceInfoFragment = {
  __typename: "CloudinaryResource",
  publicId: string,
};

export type UserInfoV2Fragment = {
  __typename: "User",
  sub: string,
  name?: string | null,
  bio?: string | null,
  userHandle?:  {
    __typename: "UserHandle",
    standardForm: string,
    renderedForm: string,
  } | null,
  profilePhoto:  {
    __typename: "CloudinaryResource",
    publicId: string,
  },
};

export type TawkInfoV2Fragment = {
  __typename: "TawkCandidate",
  ownerSub: string,
  localId: string,
  tawkVersion: string,
  title?: string | null,
  createdAt: string,
  author:  {
    __typename: "User",
    sub: string,
    name?: string | null,
    bio?: string | null,
    userHandle?:  {
      __typename: "UserHandle",
      standardForm: string,
      renderedForm: string,
    } | null,
    profilePhoto:  {
      __typename: "CloudinaryResource",
      publicId: string,
    },
  },
  duration?: number | null,
  rawAudio:  {
    __typename: "CloudinaryResource",
    publicId: string,
  },
  processedAudio?:  {
    __typename: "CloudinaryResource",
    publicId: string,
  } | null,
  generatedVideo?:  {
    __typename: "CloudinaryResource",
    publicId: string,
  } | null,
};

export type GenericImageInfoFragment = {
  __typename: "GenericImage",
  imageUrl: string,
  cloudinaryImage?:  {
    __typename: "CloudinaryResource",
    publicId: string,
  } | null,
};

export type ExternalTawkInfoFragment = {
  __typename: "ExternalTawk",
  id: string,
  inserter_sub: string,
  inserter:  {
    __typename: "User",
    sub: string,
    name?: string | null,
    bio?: string | null,
    userHandle?:  {
      __typename: "UserHandle",
      standardForm: string,
      renderedForm: string,
    } | null,
    profilePhoto:  {
      __typename: "CloudinaryResource",
      publicId: string,
    },
  },
  title: string,
  audioFileUrl: string,
  duration: number,
  originUrl: string,
  originKind: ExternalTawk_OriginKind,
  originName: string,
  originCreatedAt: string,
  picture:  {
    __typename: "GenericImage",
    imageUrl: string,
    cloudinaryImage?:  {
      __typename: "CloudinaryResource",
      publicId: string,
    } | null,
  },
  createdAt: string,
};

export type PostInfoV2NonRecursiveFragment = {
  __typename: "Post",
  createdAt: string,
  text: string,
  associatedTawk?:  {
    __typename: "TawkCandidate",
    ownerSub: string,
    localId: string,
    tawkVersion: string,
    title?: string | null,
    createdAt: string,
    author:  {
      __typename: "User",
      sub: string,
      name?: string | null,
      bio?: string | null,
      userHandle?:  {
        __typename: "UserHandle",
        standardForm: string,
        renderedForm: string,
      } | null,
      profilePhoto:  {
        __typename: "CloudinaryResource",
        publicId: string,
      },
    },
    duration?: number | null,
    rawAudio:  {
      __typename: "CloudinaryResource",
      publicId: string,
    },
    processedAudio?:  {
      __typename: "CloudinaryResource",
      publicId: string,
    } | null,
    generatedVideo?:  {
      __typename: "CloudinaryResource",
      publicId: string,
    } | null,
  } | null,
  associatedExternalTawk?:  {
    __typename: "ExternalTawk",
    id: string,
    inserter_sub: string,
    inserter:  {
      __typename: "User",
      sub: string,
      name?: string | null,
      bio?: string | null,
      userHandle?:  {
        __typename: "UserHandle",
        standardForm: string,
        renderedForm: string,
      } | null,
      profilePhoto:  {
        __typename: "CloudinaryResource",
        publicId: string,
      },
    },
    title: string,
    audioFileUrl: string,
    duration: number,
    originUrl: string,
    originKind: ExternalTawk_OriginKind,
    originName: string,
    originCreatedAt: string,
    picture:  {
      __typename: "GenericImage",
      imageUrl: string,
      cloudinaryImage?:  {
        __typename: "CloudinaryResource",
        publicId: string,
      } | null,
    },
    createdAt: string,
  } | null,
  author:  {
    __typename: "User",
    name?: string | null,
    sub: string,
    userHandle?:  {
      __typename: "UserHandle",
      renderedForm: string,
    } | null,
    profilePhoto:  {
      __typename: "CloudinaryResource",
      publicId: string,
    },
  },
  likesCount: number,
  repliesCount: number,
  id: string,
  repostedPost_id?: string | null,
  repostedTimeRange?:  {
    __typename: "ClipTimeRange",
    endTime: number,
    startTime: number,
  } | null,
  repostedPost?:  {
    __typename: "Post",
    id: string,
    createdAt: string,
    text: string,
    author:  {
      __typename: "User",
      name?: string | null,
      sub: string,
      userHandle?:  {
        __typename: "UserHandle",
        renderedForm: string,
      } | null,
      profilePhoto:  {
        __typename: "CloudinaryResource",
        publicId: string,
      },
    },
    associatedTawk?:  {
      __typename: "TawkCandidate",
      title?: string | null,
      generatedVideo?:  {
        __typename: "CloudinaryResource",
        publicId: string,
      } | null,
    } | null,
  } | null,
  associatedColorHue?: number | null,
  footnote?: string | null,
};

export type PostInfoV2Fragment = {
  __typename: "Post",
  createdAt: string,
  text: string,
  associatedTawk?:  {
    __typename: "TawkCandidate",
    ownerSub: string,
    localId: string,
    tawkVersion: string,
    title?: string | null,
    createdAt: string,
    author:  {
      __typename: "User",
      sub: string,
      name?: string | null,
      bio?: string | null,
      userHandle?:  {
        __typename: "UserHandle",
        standardForm: string,
        renderedForm: string,
      } | null,
      profilePhoto:  {
        __typename: "CloudinaryResource",
        publicId: string,
      },
    },
    duration?: number | null,
    rawAudio:  {
      __typename: "CloudinaryResource",
      publicId: string,
    },
    processedAudio?:  {
      __typename: "CloudinaryResource",
      publicId: string,
    } | null,
    generatedVideo?:  {
      __typename: "CloudinaryResource",
      publicId: string,
    } | null,
  } | null,
  associatedExternalTawk?:  {
    __typename: "ExternalTawk",
    id: string,
    inserter_sub: string,
    inserter:  {
      __typename: "User",
      sub: string,
      name?: string | null,
      bio?: string | null,
      userHandle?:  {
        __typename: "UserHandle",
        standardForm: string,
        renderedForm: string,
      } | null,
      profilePhoto:  {
        __typename: "CloudinaryResource",
        publicId: string,
      },
    },
    title: string,
    audioFileUrl: string,
    duration: number,
    originUrl: string,
    originKind: ExternalTawk_OriginKind,
    originName: string,
    originCreatedAt: string,
    picture:  {
      __typename: "GenericImage",
      imageUrl: string,
      cloudinaryImage?:  {
        __typename: "CloudinaryResource",
        publicId: string,
      } | null,
    },
    createdAt: string,
  } | null,
  author:  {
    __typename: "User",
    name?: string | null,
    sub: string,
    userHandle?:  {
      __typename: "UserHandle",
      renderedForm: string,
    } | null,
    profilePhoto:  {
      __typename: "CloudinaryResource",
      publicId: string,
    },
  },
  likesCount: number,
  repliesCount: number,
  id: string,
  repostedPost_id?: string | null,
  repostedTimeRange?:  {
    __typename: "ClipTimeRange",
    endTime: number,
    startTime: number,
  } | null,
  repostedPost?:  {
    __typename: "Post",
    id: string,
    createdAt: string,
    text: string,
    author:  {
      __typename: "User",
      name?: string | null,
      sub: string,
      userHandle?:  {
        __typename: "UserHandle",
        renderedForm: string,
      } | null,
      profilePhoto:  {
        __typename: "CloudinaryResource",
        publicId: string,
      },
    },
    associatedTawk?:  {
      __typename: "TawkCandidate",
      title?: string | null,
      generatedVideo?:  {
        __typename: "CloudinaryResource",
        publicId: string,
      } | null,
      ownerSub: string,
      localId: string,
      tawkVersion: string,
      createdAt: string,
      author:  {
        __typename: "User",
        sub: string,
        name?: string | null,
        bio?: string | null,
        userHandle?:  {
          __typename: "UserHandle",
          standardForm: string,
          renderedForm: string,
        } | null,
        profilePhoto:  {
          __typename: "CloudinaryResource",
          publicId: string,
        },
      },
      duration?: number | null,
      rawAudio:  {
        __typename: "CloudinaryResource",
        publicId: string,
      },
      processedAudio?:  {
        __typename: "CloudinaryResource",
        publicId: string,
      } | null,
    } | null,
    associatedExternalTawk?:  {
      __typename: "ExternalTawk",
      id: string,
      inserter_sub: string,
      inserter:  {
        __typename: "User",
        sub: string,
        name?: string | null,
        bio?: string | null,
        userHandle?:  {
          __typename: "UserHandle",
          standardForm: string,
          renderedForm: string,
        } | null,
        profilePhoto:  {
          __typename: "CloudinaryResource",
          publicId: string,
        },
      },
      title: string,
      audioFileUrl: string,
      duration: number,
      originUrl: string,
      originKind: ExternalTawk_OriginKind,
      originName: string,
      originCreatedAt: string,
      picture:  {
        __typename: "GenericImage",
        imageUrl: string,
        cloudinaryImage?:  {
          __typename: "CloudinaryResource",
          publicId: string,
        } | null,
      },
      createdAt: string,
    } | null,
    likesCount: number,
    repliesCount: number,
    repostedPost_id?: string | null,
    repostedTimeRange?:  {
      __typename: "ClipTimeRange",
      endTime: number,
      startTime: number,
    } | null,
    repostedPost?:  {
      __typename: "Post",
      id: string,
      createdAt: string,
      text: string,
      author:  {
        __typename: "User",
        name?: string | null,
        sub: string,
        userHandle?:  {
          __typename: "UserHandle",
          renderedForm: string,
        } | null,
        profilePhoto:  {
          __typename: "CloudinaryResource",
          publicId: string,
        },
      },
      associatedTawk?:  {
        __typename: "TawkCandidate",
        title?: string | null,
        generatedVideo?:  {
          __typename: "CloudinaryResource",
          publicId: string,
        } | null,
      } | null,
    } | null,
    associatedColorHue?: number | null,
    footnote?: string | null,
  } | null,
  associatedColorHue?: number | null,
  footnote?: string | null,
};

export type PostInfoV2WithDerivativesFragment = {
  __typename: "Post",
  createdAt: string,
  text: string,
  associatedTawk?:  {
    __typename: "TawkCandidate",
    ownerSub: string,
    localId: string,
    tawkVersion: string,
    title?: string | null,
    createdAt: string,
    author:  {
      __typename: "User",
      sub: string,
      name?: string | null,
      bio?: string | null,
      userHandle?:  {
        __typename: "UserHandle",
        standardForm: string,
        renderedForm: string,
      } | null,
      profilePhoto:  {
        __typename: "CloudinaryResource",
        publicId: string,
      },
    },
    duration?: number | null,
    rawAudio:  {
      __typename: "CloudinaryResource",
      publicId: string,
    },
    processedAudio?:  {
      __typename: "CloudinaryResource",
      publicId: string,
    } | null,
    generatedVideo?:  {
      __typename: "CloudinaryResource",
      publicId: string,
    } | null,
  } | null,
  associatedExternalTawk?:  {
    __typename: "ExternalTawk",
    id: string,
    inserter_sub: string,
    inserter:  {
      __typename: "User",
      sub: string,
      name?: string | null,
      bio?: string | null,
      userHandle?:  {
        __typename: "UserHandle",
        standardForm: string,
        renderedForm: string,
      } | null,
      profilePhoto:  {
        __typename: "CloudinaryResource",
        publicId: string,
      },
    },
    title: string,
    audioFileUrl: string,
    duration: number,
    originUrl: string,
    originKind: ExternalTawk_OriginKind,
    originName: string,
    originCreatedAt: string,
    picture:  {
      __typename: "GenericImage",
      imageUrl: string,
      cloudinaryImage?:  {
        __typename: "CloudinaryResource",
        publicId: string,
      } | null,
    },
    createdAt: string,
  } | null,
  author:  {
    __typename: "User",
    name?: string | null,
    sub: string,
    userHandle?:  {
      __typename: "UserHandle",
      renderedForm: string,
    } | null,
    profilePhoto:  {
      __typename: "CloudinaryResource",
      publicId: string,
    },
  },
  likesCount: number,
  repliesCount: number,
  id: string,
  repostedPost_id?: string | null,
  repostedTimeRange?:  {
    __typename: "ClipTimeRange",
    endTime: number,
    startTime: number,
  } | null,
  repostedPost?:  {
    __typename: "Post",
    id: string,
    createdAt: string,
    text: string,
    author:  {
      __typename: "User",
      name?: string | null,
      sub: string,
      userHandle?:  {
        __typename: "UserHandle",
        renderedForm: string,
      } | null,
      profilePhoto:  {
        __typename: "CloudinaryResource",
        publicId: string,
      },
    },
    associatedTawk?:  {
      __typename: "TawkCandidate",
      title?: string | null,
      generatedVideo?:  {
        __typename: "CloudinaryResource",
        publicId: string,
      } | null,
      ownerSub: string,
      localId: string,
      tawkVersion: string,
      createdAt: string,
      author:  {
        __typename: "User",
        sub: string,
        name?: string | null,
        bio?: string | null,
        userHandle?:  {
          __typename: "UserHandle",
          standardForm: string,
          renderedForm: string,
        } | null,
        profilePhoto:  {
          __typename: "CloudinaryResource",
          publicId: string,
        },
      },
      duration?: number | null,
      rawAudio:  {
        __typename: "CloudinaryResource",
        publicId: string,
      },
      processedAudio?:  {
        __typename: "CloudinaryResource",
        publicId: string,
      } | null,
    } | null,
    associatedExternalTawk?:  {
      __typename: "ExternalTawk",
      id: string,
      inserter_sub: string,
      inserter:  {
        __typename: "User",
        sub: string,
        name?: string | null,
        bio?: string | null,
        userHandle?:  {
          __typename: "UserHandle",
          standardForm: string,
          renderedForm: string,
        } | null,
        profilePhoto:  {
          __typename: "CloudinaryResource",
          publicId: string,
        },
      },
      title: string,
      audioFileUrl: string,
      duration: number,
      originUrl: string,
      originKind: ExternalTawk_OriginKind,
      originName: string,
      originCreatedAt: string,
      picture:  {
        __typename: "GenericImage",
        imageUrl: string,
        cloudinaryImage?:  {
          __typename: "CloudinaryResource",
          publicId: string,
        } | null,
      },
      createdAt: string,
    } | null,
    likesCount: number,
    repliesCount: number,
    repostedPost_id?: string | null,
    repostedTimeRange?:  {
      __typename: "ClipTimeRange",
      endTime: number,
      startTime: number,
    } | null,
    repostedPost?:  {
      __typename: "Post",
      id: string,
      createdAt: string,
      text: string,
      author:  {
        __typename: "User",
        name?: string | null,
        sub: string,
        userHandle?:  {
          __typename: "UserHandle",
          renderedForm: string,
        } | null,
        profilePhoto:  {
          __typename: "CloudinaryResource",
          publicId: string,
        },
      },
      associatedTawk?:  {
        __typename: "TawkCandidate",
        title?: string | null,
        generatedVideo?:  {
          __typename: "CloudinaryResource",
          publicId: string,
        } | null,
      } | null,
    } | null,
    associatedColorHue?: number | null,
    footnote?: string | null,
  } | null,
  associatedColorHue?: number | null,
  footnote?: string | null,
  replies?:  {
    __typename: "ModelPostConnection",
    items:  Array< {
      __typename: "Post",
      createdAt: string,
      text: string,
      associatedTawk?:  {
        __typename: "TawkCandidate",
        ownerSub: string,
        localId: string,
        tawkVersion: string,
        title?: string | null,
        createdAt: string,
        author:  {
          __typename: "User",
          sub: string,
          name?: string | null,
          bio?: string | null,
          userHandle?:  {
            __typename: "UserHandle",
            standardForm: string,
            renderedForm: string,
          } | null,
          profilePhoto:  {
            __typename: "CloudinaryResource",
            publicId: string,
          },
        },
        duration?: number | null,
        rawAudio:  {
          __typename: "CloudinaryResource",
          publicId: string,
        },
        processedAudio?:  {
          __typename: "CloudinaryResource",
          publicId: string,
        } | null,
        generatedVideo?:  {
          __typename: "CloudinaryResource",
          publicId: string,
        } | null,
      } | null,
      associatedExternalTawk?:  {
        __typename: "ExternalTawk",
        id: string,
        inserter_sub: string,
        inserter:  {
          __typename: "User",
          sub: string,
          name?: string | null,
          bio?: string | null,
          userHandle?:  {
            __typename: "UserHandle",
            standardForm: string,
            renderedForm: string,
          } | null,
          profilePhoto:  {
            __typename: "CloudinaryResource",
            publicId: string,
          },
        },
        title: string,
        audioFileUrl: string,
        duration: number,
        originUrl: string,
        originKind: ExternalTawk_OriginKind,
        originName: string,
        originCreatedAt: string,
        picture:  {
          __typename: "GenericImage",
          imageUrl: string,
          cloudinaryImage?:  {
            __typename: "CloudinaryResource",
            publicId: string,
          } | null,
        },
        createdAt: string,
      } | null,
      author:  {
        __typename: "User",
        name?: string | null,
        sub: string,
        userHandle?:  {
          __typename: "UserHandle",
          renderedForm: string,
        } | null,
        profilePhoto:  {
          __typename: "CloudinaryResource",
          publicId: string,
        },
      },
      likesCount: number,
      repliesCount: number,
      id: string,
      repostedPost_id?: string | null,
      repostedTimeRange?:  {
        __typename: "ClipTimeRange",
        endTime: number,
        startTime: number,
      } | null,
      repostedPost?:  {
        __typename: "Post",
        id: string,
        createdAt: string,
        text: string,
        author:  {
          __typename: "User",
          name?: string | null,
          sub: string,
          userHandle?:  {
            __typename: "UserHandle",
            renderedForm: string,
          } | null,
          profilePhoto:  {
            __typename: "CloudinaryResource",
            publicId: string,
          },
        },
        associatedTawk?:  {
          __typename: "TawkCandidate",
          title?: string | null,
          generatedVideo?:  {
            __typename: "CloudinaryResource",
            publicId: string,
          } | null,
          ownerSub: string,
          localId: string,
          tawkVersion: string,
          createdAt: string,
          author:  {
            __typename: "User",
            sub: string,
            name?: string | null,
            bio?: string | null,
            userHandle?:  {
              __typename: "UserHandle",
              standardForm: string,
              renderedForm: string,
            } | null,
            profilePhoto:  {
              __typename: "CloudinaryResource",
              publicId: string,
            },
          },
          duration?: number | null,
          rawAudio:  {
            __typename: "CloudinaryResource",
            publicId: string,
          },
          processedAudio?:  {
            __typename: "CloudinaryResource",
            publicId: string,
          } | null,
        } | null,
        associatedExternalTawk?:  {
          __typename: "ExternalTawk",
          id: string,
          inserter_sub: string,
          inserter:  {
            __typename: "User",
            sub: string,
            name?: string | null,
            bio?: string | null,
            userHandle?:  {
              __typename: "UserHandle",
              standardForm: string,
              renderedForm: string,
            } | null,
            profilePhoto:  {
              __typename: "CloudinaryResource",
              publicId: string,
            },
          },
          title: string,
          audioFileUrl: string,
          duration: number,
          originUrl: string,
          originKind: ExternalTawk_OriginKind,
          originName: string,
          originCreatedAt: string,
          picture:  {
            __typename: "GenericImage",
            imageUrl: string,
            cloudinaryImage?:  {
              __typename: "CloudinaryResource",
              publicId: string,
            } | null,
          },
          createdAt: string,
        } | null,
        likesCount: number,
        repliesCount: number,
        repostedPost_id?: string | null,
        repostedTimeRange?:  {
          __typename: "ClipTimeRange",
          endTime: number,
          startTime: number,
        } | null,
        repostedPost?:  {
          __typename: "Post",
          id: string,
          createdAt: string,
          text: string,
          author:  {
            __typename: "User",
            name?: string | null,
            sub: string,
            userHandle?:  {
              __typename: "UserHandle",
              renderedForm: string,
            } | null,
            profilePhoto:  {
              __typename: "CloudinaryResource",
              publicId: string,
            },
          },
          associatedTawk?:  {
            __typename: "TawkCandidate",
            title?: string | null,
            generatedVideo?:  {
              __typename: "CloudinaryResource",
              publicId: string,
            } | null,
          } | null,
        } | null,
        associatedColorHue?: number | null,
        footnote?: string | null,
      } | null,
      associatedColorHue?: number | null,
      footnote?: string | null,
    } | null >,
  } | null,
  reposts?:  {
    __typename: "ModelPostConnection",
    items:  Array< {
      __typename: "Post",
      createdAt: string,
      text: string,
      associatedTawk?:  {
        __typename: "TawkCandidate",
        ownerSub: string,
        localId: string,
        tawkVersion: string,
        title?: string | null,
        createdAt: string,
        author:  {
          __typename: "User",
          sub: string,
          name?: string | null,
          bio?: string | null,
          userHandle?:  {
            __typename: "UserHandle",
            standardForm: string,
            renderedForm: string,
          } | null,
          profilePhoto:  {
            __typename: "CloudinaryResource",
            publicId: string,
          },
        },
        duration?: number | null,
        rawAudio:  {
          __typename: "CloudinaryResource",
          publicId: string,
        },
        processedAudio?:  {
          __typename: "CloudinaryResource",
          publicId: string,
        } | null,
        generatedVideo?:  {
          __typename: "CloudinaryResource",
          publicId: string,
        } | null,
      } | null,
      associatedExternalTawk?:  {
        __typename: "ExternalTawk",
        id: string,
        inserter_sub: string,
        inserter:  {
          __typename: "User",
          sub: string,
          name?: string | null,
          bio?: string | null,
          userHandle?:  {
            __typename: "UserHandle",
            standardForm: string,
            renderedForm: string,
          } | null,
          profilePhoto:  {
            __typename: "CloudinaryResource",
            publicId: string,
          },
        },
        title: string,
        audioFileUrl: string,
        duration: number,
        originUrl: string,
        originKind: ExternalTawk_OriginKind,
        originName: string,
        originCreatedAt: string,
        picture:  {
          __typename: "GenericImage",
          imageUrl: string,
          cloudinaryImage?:  {
            __typename: "CloudinaryResource",
            publicId: string,
          } | null,
        },
        createdAt: string,
      } | null,
      author:  {
        __typename: "User",
        name?: string | null,
        sub: string,
        userHandle?:  {
          __typename: "UserHandle",
          renderedForm: string,
        } | null,
        profilePhoto:  {
          __typename: "CloudinaryResource",
          publicId: string,
        },
      },
      likesCount: number,
      repliesCount: number,
      id: string,
      repostedPost_id?: string | null,
      repostedTimeRange?:  {
        __typename: "ClipTimeRange",
        endTime: number,
        startTime: number,
      } | null,
      repostedPost?:  {
        __typename: "Post",
        id: string,
        createdAt: string,
        text: string,
        author:  {
          __typename: "User",
          name?: string | null,
          sub: string,
          userHandle?:  {
            __typename: "UserHandle",
            renderedForm: string,
          } | null,
          profilePhoto:  {
            __typename: "CloudinaryResource",
            publicId: string,
          },
        },
        associatedTawk?:  {
          __typename: "TawkCandidate",
          title?: string | null,
          generatedVideo?:  {
            __typename: "CloudinaryResource",
            publicId: string,
          } | null,
          ownerSub: string,
          localId: string,
          tawkVersion: string,
          createdAt: string,
          author:  {
            __typename: "User",
            sub: string,
            name?: string | null,
            bio?: string | null,
            userHandle?:  {
              __typename: "UserHandle",
              standardForm: string,
              renderedForm: string,
            } | null,
            profilePhoto:  {
              __typename: "CloudinaryResource",
              publicId: string,
            },
          },
          duration?: number | null,
          rawAudio:  {
            __typename: "CloudinaryResource",
            publicId: string,
          },
          processedAudio?:  {
            __typename: "CloudinaryResource",
            publicId: string,
          } | null,
        } | null,
        associatedExternalTawk?:  {
          __typename: "ExternalTawk",
          id: string,
          inserter_sub: string,
          inserter:  {
            __typename: "User",
            sub: string,
            name?: string | null,
            bio?: string | null,
            userHandle?:  {
              __typename: "UserHandle",
              standardForm: string,
              renderedForm: string,
            } | null,
            profilePhoto:  {
              __typename: "CloudinaryResource",
              publicId: string,
            },
          },
          title: string,
          audioFileUrl: string,
          duration: number,
          originUrl: string,
          originKind: ExternalTawk_OriginKind,
          originName: string,
          originCreatedAt: string,
          picture:  {
            __typename: "GenericImage",
            imageUrl: string,
            cloudinaryImage?:  {
              __typename: "CloudinaryResource",
              publicId: string,
            } | null,
          },
          createdAt: string,
        } | null,
        likesCount: number,
        repliesCount: number,
        repostedPost_id?: string | null,
        repostedTimeRange?:  {
          __typename: "ClipTimeRange",
          endTime: number,
          startTime: number,
        } | null,
        repostedPost?:  {
          __typename: "Post",
          id: string,
          createdAt: string,
          text: string,
          author:  {
            __typename: "User",
            name?: string | null,
            sub: string,
            userHandle?:  {
              __typename: "UserHandle",
              renderedForm: string,
            } | null,
            profilePhoto:  {
              __typename: "CloudinaryResource",
              publicId: string,
            },
          },
          associatedTawk?:  {
            __typename: "TawkCandidate",
            title?: string | null,
            generatedVideo?:  {
              __typename: "CloudinaryResource",
              publicId: string,
            } | null,
          } | null,
        } | null,
        associatedColorHue?: number | null,
        footnote?: string | null,
      } | null,
      associatedColorHue?: number | null,
      footnote?: string | null,
    } | null >,
  } | null,
};

export type PostCollectionInfoV2Fragment = {
  __typename: "PostCollection",
  id: string,
  description: string,
  name: string,
  updatedAt: string,
  author:  {
    __typename: "User",
    sub: string,
    name?: string | null,
    bio?: string | null,
    userHandle?:  {
      __typename: "UserHandle",
      standardForm: string,
      renderedForm: string,
    } | null,
    profilePhoto:  {
      __typename: "CloudinaryResource",
      publicId: string,
    },
  },
  defaultSortOrder?: Playlist_SortOrder | null,
};
